//this function conut how many element there are in pdp and updates number in filter section
$plpSearchObj.countData = function(elem, callback) {
    $plpSearchObj.queryParams = queryParams;
	$plpSearchObj.queryParams['categoryId'] = document.querySelector('meta[name="pageId"]').getAttribute('content');
	$plpSearchObj.queryParams['pageNumber'] = $plpSearchObj.currentPage;
	$plpSearchObj.queryParams['pageSize'] = $plpSearchObj.itemsFromServer;
    var facetArr = [];
    var queryString = window.location.search.substr(1);
    if (queryString.trim() != "") {
        var parameters = queryString.split('&');
        $.each(parameters, function(i,el){
       	 	var facetKey = el.split('=')[0];
       	 	if (facetKey.startsWith('facet')) {
       	 		var facetValue = el.split('=')[1];
       	 		facetArr.push(facetValue);
       	 	}
        });
    }
    $plpSearchObj.queryParams['facet'] = facetArr;
    var countQueryParams = $.extend({},$plpSearchObj.queryParams);
    delete countQueryParams['isForPLP'];
    countQueryParams['isForPLPFilters'] = true;

    /* Because count on search view needs LUX_findProductsBySearchTerm */
    if (getUrlParameter('searchTerm') == null) {
        if (isPriceOrdering()) {
        	countQueryParams['profileName'] = 'LUX_findProductsByCategory';
        } else {
        	countQueryParams['profileName'] = defaultSearchProfile;
        }
        countQueryParams['profileName'] = countQueryParams['profileName'].replace('find','count');
    }

    $.ajax({
        url: $plpSearchObj.productsServiceUrl(),
        type: 'GET',
        data: $.param(countQueryParams,true),
        success: function(data) {
        	$plpSearchObj.resultCount = data.recordSetTotal;
            //This code checks every facet and adds or removes the disabled class when the filter count is 0 or more
            $('.facet__apply-number').text($plpSearchObj.resultCount);

            if (typeof callback == 'function') {
                callback();
            }

            $("#productsFacets div:not(#section_SORT_BY) ul.facet__options li").each(function(i,e) {
            	toggleFilter(e,data);
            });
            checkFacetsAndSearch(elem);
        },
        error: function(error) {
            return error;
        },
        beforeSend: function(jqXHR, settings) {
            //  Security check, if true then stop the request and show 0 results
            if (settings.url.indexOf('TopCategoriesDisplay') > -1) {

                $plpSearchObj.resultCount = 0;
                $('.facet__apply-number').text($plpSearchObj.resultCount);

                if (typeof callback == 'function') {
                    callback();
                }

                $("#productsFacets div:not(#section_SORT_BY) ul.facet__options li").each(function(i,e) {
                    toggleFilter(e,data);
                });
                checkFacetsAndSearch(elem);

                return false;
            }
        }
    });
};

// initial cursor on espot in plp 
var EditorialCursor = {
	isInitialized: false,
    initCursor: function (cursorClass) {
    	if(!EditorialCursor.isInitialized) {
    		//initialize cursor just once
    		EditorialCursor.isInitialized = true;

			$('.editorial-content-custom-cursor[data-cursor-editorial="' + cursorClass + '"]').css({
				'cursor': 'none'
			});
			EditorialCursor.deleteCursor();
			EditorialCursor.changeCursorMouseMove(cursorClass);
		}

    },
    deleteCursor: function () {
        $('html').css({
            'cursor': ''
        });
        $('.editorial-cursor-dark').css({
            'opacity': '0'
        });
        $('.editorial-cursor-dark > div').css({
            'transform': 'scale(0)'
        });
    },
    changeCursorMouseMove: function (cursorClass) {
        $('.editorial-content-custom-cursor[data-cursor-editorial="' + cursorClass + '"]').mousemove(function (e) {
            var leftEspot = $(this).parent().parent();
            var cursor = $(leftEspot).find("." + cursorClass);
            var divCursor = $(leftEspot).find('.' + cursorClass + ' > div');
            $(cursor).css({
                'position': 'fixed',
                'opacity': '1',
                'user-select': 'none',
                'top': e.clientY + -50 + 'px',
                'left': e.clientX + -50 + 'px'
            });
            $(divCursor).css({
                'transform': 'scale(1)'
            });

        });

    }
}


function createAttrValIdentifierObject(catalogEntryGroupView){
    var attrValIdentifierObject =  [];
    $.each( catalogEntryGroupView, function( key, items) {
        $.each( items, function( a, item) {
            $.each( item.attributes, function( a, attribute) {
                if(attribute.identifier == 'GEO_FIT' || attribute.identifier == 'FRAME_FIT'){
                    $.each(attribute.values, function( i, attributeInfo) {
                        var key = attribute.identifier +'_'+attributeInfo.value.toString().toLowerCase();
                        attrValIdentifierObject[key] = attributeInfo.identifier;
                        
                    });
                }
            });
        });
      });
    return attrValIdentifierObject;
}


/**
 * @function facetAccordion
 * @desc Funtion that puts facets into accordion
 */

 function facetAccordion() {
	$("div.facet__filter-wrapper:not([id^='section_SORT_BY'],[id^='section_FILTER_BY'])").accordion({collapsible: true});
}


/**
 * @function checkFilters
 * @desc This function control for filters, check if they are selected or deselected
 * @param {object} data - info for current filter selected
 */
 function checkFilters(data){

    index = -1;
    facet = data.facet;
    facetName = data.facetName,
    facetGroup = data.facetGroup;

    if(!emptyFilters) {
        queryFilters.push(data);
        emptyFilters = false;
    }

    for (var i = 0; i < queryFilters.length; i++) {
        if (queryFilters[i].facetName == facetName) {
            index = i;
            break;
        }
    }

    if ( index === -1 && facetGroup == undefined) {
        queryFilters.push(data);
    }else if( facetGroup == undefined) {
        queryFilters.splice(index, 1);
        if(queryFilters.length == 0){
            emptyFilters = true;
        }
    }
}


/**
 * @function checkFacetsAndSearch
 * @desc Check if facet elemens are selected and make a ajax call to get all elements if its in desktop
 * @param {element} elem - selected element
 */
 function checkFacetsAndSearch(elem) {
    if (elem != null) {
        var data = $(elem).data();
        if(data.facetGroup !== "sortBy") {
            checkFilters(data);
        } else {
            queryOrderBy = [];
            queryOrderBy.push(data);
        }
    }
}


/**
 * @function viewMore
 * @desc Example function to add some elements inside grid
 * @param {boolean} remove - conditional to remove the last facets
 */
 function viewMore() {
    $plpSearchObj.viewMoreSearchCount = 0;
    $plpSearchObj.viewMoreSearchStartIndex = 0;
	var scrollPosition = $(window).scrollTop();
	$plpSearchObj.getData(true, function() {
        $("html").scrollTop(scrollPosition);

        setTimeout(function(){
            $("html").scrollTop(scrollPosition + 20);
        }, 200)
	});
}


/**
 * @function addToSelectedFacets
 * @desc This function is used to select a facet and all of this functionality
 * @param {element} elem - selected facet
 */
 function addToSelectedFacets(elem) {
    // var filterAttrName = "";

    if($plpSearchObj.selectedFilterGroup === undefined) {
        $plpSearchObj.selectedFilterGroup = [];
    }

    var idFieldSet = $(elem).closest("fieldset").attr('id');
    $plpSearchObj.lastOpenFilterGroup = "";
    // Change the elem class and filter name
    elem.parentElement.classList.toggle('selected');

    facetCounter = elem.parentElement.parentElement.parentElement.querySelector('.facet__title .facet_counter').getAttribute('data-facet-counter') || 0;
    // If a facet is selected, import it to the data
    if(elem.parentElement.classList.contains('selected')) {
        facetCounter++;
        selectedFacets[elem.getAttribute('data-facet')] = elem.getAttribute('data-facet-name');
        if($plpSearchObj.selectedFilterGroup.indexOf(idFieldSet) === -1) $plpSearchObj.selectedFilterGroup.push(idFieldSet)
    } else {
        facetCounter--;
        // If a facet is removed from selection, remove it from the data
        var selectedElem = "";

        selectedElem = elem.getAttribute('data-facet-name');
        delete selectedFacets[elem.getAttribute('data-facet')];
    }
    
    var facetCounterElement = $(elem.parentElement.parentElement.parentElement).find('.facet__title > .facet_counter');
    setFacetsCounters(facetCounterElement, facetCounter);
    
    applyFilters();
    $plpSearchObj.countData(elem, null);
    getCurrentPagePLP();
}


/**
 * @function applyFilters
 * @desc This function is used to apply all selected filters
 */
 function applyFilters() {
    var facets = [];
    for (var dataFacet in selectedFacets) {
        facets.push("facet=" + dataFacet);
    }
    //HB-5374
    if (pageType == "Search") {
    	var tempUrl = removeParam("facet",window.location.href);
    	var queryString = tempUrl + '&'+facets.join('&'); //aggiungi il filtro all'url corrente
    	window.history.replaceState(null, null, queryString);
    }
    else {
    	var queryString = getUrlParameter('searchTerm') == null ? facets.join('&') : facets.join('&')+'&searchTerm='+getUrlParameter('searchTerm');
    	window.history.pushState(null, null, '?' + queryString);
    }
}

function ajaxCallCount(callback, elem, parameters) {
    if ($('.facet__apply-number').text() === '') {
        $plpSearchObj.countData(elem, function(){
            callback(parameters)
        });
    } else {
        callback(parameters);
    }
}

/**
 * @function setSortBy
 * @desc This function is used to set the order by and all of this functionality
 *
 * @param {element} elem - selected element
 */
function setSortBy(elem) {
    // resetting "selected" elements
    var sortByElems = elem.parentNode.parentNode.querySelectorAll('li');
    sortByElems.forEach(function(sortByelem) {
        sortByelem.classList.remove('selected');
    });
    
    elem.parentElement.classList.add('selected');

    // getting selected radio button
    var selectedFacet = document.querySelector('input[name="sortByRadioGroup"]:checked');
    selectedFacetsData["orderBy"] = selectedFacet.getAttribute('data-facet');

    $('.facet__apply-button').off('click').on('click', function() {
        resetGridList();
        ajaxCallFacet(callbackSortBy, elem, false);
        $plpSearchObj.isFilterPanel = true; // set when using filterpanel
    });
}

/**
 * @function clearAllFacets
 * @desc This funtion clear all selected facets
 */
 function clearAllFacets() {
	 // Begin HB-12529
	delete selectedFacetsData["orderBy"];
	// End HB-12529
    isFacetApplied = false;
    countSelectedFacets = 0;
    
    var newState = document.location.href.replace(location.search, '');
    if (getUrlParameter('searchTerm') != null) {
        var newUrlWhitoutFacet = '?storeId='+WCParamJS.storeId+'&catalogId='+ WCParamJS.catalogId + '&langId='+ WCParamJS.langId + '&searchTerm=' + getUrlParameter('searchTerm');   
        newState = document.location.href.replace(location.search,newUrlWhitoutFacet);
    }
    history.pushState(null, '', newState);
    setDefaultSortBy(defaultOrderBy, false);
    selectedFacetsData = {
        storeId : WCParamJS.storeId,
        catalogId: WCParamJS.catalogId,
        fromPage: 'catalogEntryList',
        beginIndex: '0',
        responseFormat: 'json',
        orderBy: defaultOrderBy,
        categoryId: document.querySelector('meta[name="pageId"]').getAttribute('content')
    };

    //Reset filters
    selectedFacets = {};
    queryFilters = [],
    queryOrderBy = [],
    emptyFilters = true,
    emptyOrderBy = true;

    resetGridList();
    $plpSearchObj.isFilterPanel = true;
    
    var scrollPosition = $(window).scrollTop();
    $plpSearchObj.getData(false, function() {
        $("html").scrollTop(scrollPosition);
        
        $plpSearchObj.lastIndex = Object.getOwnPropertyNames($plpSearchObj.items).length//workaround  to set correct last index after clean all
        $plpSearchObj.lastIndexbkp = $plpSearchObj.lastIndex

        setTimeout(function(){
            $("html").scrollTop(scrollPosition + 20);
        }, 200)
	});

    getCurrentPagePLP();
}

/**
 * @function adaptColor
 * @desc This funtion gets the background color and verify if the color that we need to use over the background color
 *
 * @param {element} selector - element that have the facet background-color
 */
 function adaptColor(selector) {
    var elem = $(selector);
    var rgb = elem.css("background-color");
    if(elem.attr("style").search("background-color") > -1 && elem[0].style.backgroundColor == "") {
        rgb = 'rgb(255, 255, 255)';
    }

    if (rgb.match(/^rgb/)) {
      var a = rgb.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/),
        r = a[1],
        g = a[2],
        b = a[3];
    }
    var hsp = Math.sqrt(
      0.299 * (r * r) +
      0.587 * (g * g) +
      0.114 * (b * b)
    );
    if (hsp > 150) {
      elem.parent().addClass('dark');
    } else {
      elem.parent().addClass('light');
    }
};

/**
 * @function saveCurrentPosition
 * @desc This function saves the position of the selected product in PLP
 */ 
 function saveCurrentPosition() {
    sessionStorage.pageY = $(window).scrollTop();
    sessionStorage.plpTitle = pageSection_1;
    sessionStorage.itemsToLoad = $plpSearchObj.lastIndex;
    sessionStorage.backItemsPerPage = $plpSearchObj.viewIndex;
    sessionStorage.middleEspotHeight = $('#X_PLP_MiddleBanner').height();
}


function resetGridList() {
    $('#plp_grid').empty();

    for(var i = 0; i  < $plpSearchObj.itemsFromServer; i++) {
        var createDOMLi = document.createElement('li');
        createDOMLi.classList.add('product');
        createDOMLi.classList.add('plp-grid-skeleton');
        $('#plp_grid').append(createDOMLi);
    }
}


window.addEventListener('load', (event) => {

    //START FILTER SECTION
    var blockFilter = document.querySelector('.block-filter');
            // Show the filter menu
            if (document.querySelector('.plp-filter-button')) {
                document.querySelector('.plp-filter-button').addEventListener('click', function(e) {
                    blockFilter.classList.toggle('opend');
                    $('.facet__fade').addClass('fade');
                    $('.facet__fade').show();
                    $('.facet').addClass('opend');
                    $('[class^="facet"]').find('[onclick]').attr("tabindex", "0");
                    if (isPersol){
                        var bannerHeight = $(".ct-promo-banner").height();
                        $('.facet.opend').css("top",bannerHeight);
                        $('.facet.opend').css("height",'calc(100% - '+ bannerHeight + 'px)');
                    }
                    $('.facet__content').css('visibility','visible');
                    $('.facet__content').css('opacity','1');
                    $('body').addClass('no-scroll');
                    $('body, html').css('height', '100%');
                    facetAccordion();
                    if($('.facet').hasClass('opend')) {
                        $("#focus-fix").focus();
                        if(document.querySelectorAll('.trending').length != 0 && document.querySelectorAll('.seenOn').length != 0 ) {
                            var trendNow = document.querySelector('.trending');
                            var seenOn = document.querySelector('.seenOn .facet__filter-select');
                            seenOn.insertBefore(trendNow, seenOn.lastChild);
                        }
                        document.querySelector('.facet__fade').classList.add('show');
                        var ulGrid = document.querySelector('#plp_grid');
                        // Add filter-opend class to grid to change from 4 columns to 3 if it's in desktop
                        if(window.innerWidth >= 1024) {
                            ulGrid.classList.add('filter-opend');
                        } else {
                            document.querySelector('html').setAttribute("style", "overflow: hidden;");
                            document.querySelector('body').setAttribute("style", "position: static; overflow: hidden");
                        }
    
                        if(countSelectedFacets >= 1) {
                            document.querySelector('.facet__widget').classList.add('active');           // This setTimeout wait the facet menu transition finish when it opens
                            setTimeout(function() {
                                document.querySelector('.facet__apply').classList.add('show');
                            }, 500);
                        }
    
                        if(previousFilter) {
                            for(var param in previousFilter) {
                                if(param.includes("orderBy")) {
                                    if(selectedFacetsData.hasOwnProperty("orderBy")) {
                                        delete selectedFacetsData["orderBy"];
                                    }
                                    selectedFacetsData[param] = previousFilter[param];
                                    var selectedSort = document.querySelector('.facet__sortBy li a[data-facet = "' + previousFilter[param] + '"]');
                                    selectedSort.parentElement.classList.add('selected');
                                    var sortValue = selectedSort.getAttribute('data-facet-name');
                                    document.querySelector('.facet__apply').classList.add('show');
                                    document.querySelector('.facet__widget').classList.add('active');
                                    countSelectedFacets++;
                                }
                            }
                        }
                    } else {
                        closeFilterMenu();
                    }
    
                });
                document.querySelector('.plp-filter-button').addEventListener('focus', function(){
                    $('[class^="facet"]').find('[onclick]').attr("tabindex", "-1");
                })
            }
    
        //Close the filter menu if you click in close button
        if (document.querySelector('.facet__close_icon')) {
            document.querySelector('.facet__close_icon').addEventListener('click', function() {
            	if ($plpSearchObj.resultCount >= 1){
            		$(".grid.product-list .grid-item a")[0].focus();
            	}
                closeFilterMenu();
            });
        }
        // 
        
        //Close the filter menu if you click in the fade div
        if (document.querySelector('.facet__fade')) {
            document.querySelector('.facet__fade').addEventListener('click', function() {
                $plpSearchObj.viewIndex = 0;
                $plpSearchObj.lastIndex = 0;
                $plpSearchObj.resultCount = 0;
            	$plpSearchObj.getData(false, function() {
            		$plpSearchObj.busy = false;
                	createNewTileProducts(0,$plpSearchObj.itemsPerPage);
            	});
                $plpSearchObj.busy = true;
            });
        }


        
        //Prevent page scroll when scrolling facets
        $('.facet__wrapper').on( 'mousewheel DOMMouseScroll', function (e) {
            var delta = e.wheelDelta || (e.originalEvent && e.originalEvent.wheelDelta) || -e.detail,
            bottomOverflow = this.scrollTop + $(this).outerHeight() - this.scrollHeight >= 0,
            topOverflow = this.scrollTop <= 0;

            if ((delta < 0 && bottomOverflow) || (delta > 0 && topOverflow)) {
                e.preventDefault();
            }
        });

        if(document.querySelectorAll('.facet__filter-trigger').length > 0) {
            document.querySelector('.facet__filter-trigger').addEventListener("click", function(e) {
                this.classList.toggle('selected');
                addToSelectedFacets(this);
                $('.facet__filter-button.spanacce.facet__filter-true').get(0).click();
            });
        }


    // END FILTER SECTION

    //Apply facets when you click the apply button
            $('.facet__apply-button').off('click').on('click',function(){
                $plpSearchObj.viewIndex = 0;
                $plpSearchObj.lastIndex = 0;
                $plpSearchObj.resultCount = 0;
                
                    $plpSearchObj.isFilterPanel = true;
                
                $plpSearchObj.getData(false, function() {
                    $plpSearchObj.busy = false;

                    resetGridList();

                    createNewTileProducts(0,$plpSearchObj.itemsPerPage);
                });
                $plpSearchObj.busy = true;
            });
});


function applyHighPrescriptionFilter(){
    var newParameters = $("#filtersContainer [data-facet-name-en='" + "Strong Prescription" +"']")[0];
    addToSelectedFacets(newParameters);
    $('.facet__apply-button').click();
}

//init close button X_PLP_PromoBanner

$("#X_PLP_PromoBanner .promo-banner .ct-plp-callout--close").click(function () {
        
    $("#X_PLP_PromoBanner .promo-banner").addClass("promoHidden");
});

$("[id^=X_PLP_PromoBanner_mobile] .promo-banner .ct-plp-callout--close").click(function () {
    $("[id^=X_PLP_PromoBanner] .promo-banner").addClass("promoHidden");
    manageScrollBehaviourPLP();
});
/**
* @fileOverview This javascript contains javascript functions used by the newsletter function
*/

NewsLetterJS={
        
    version: "Common Implementation v0.01",
	/** language ID to be used, default to -1 (English) */
	langId: "-1",
	
	/** store ID to be used */
	storeId: "",
	
	/** store Name to be used */
	appName :"",
	/** catalog ID to be used */
	catalogId: "",
	
	email :"",
	
	formId:"",
	
	/** 
	* Sets common parameters used by this javascript object
	* @param {String} langId language ID to use
	* @param {String} storeId store ID to use

	*/	
	setCommonParameters:function(langId,storeId,catalogId,appName){
		this.langId = langId;
		this.storeId = storeId;
		this.catalogId = catalogId;
        this.appName = appName;
	},
	
	updateParamObject:function(params, key, value, index){
		if(params == null){
			params = [];
		}

		if(index != null && index !== "" && index !== -1){
			//overwrite the old value at specified index
			params[key+"_"+index] = value;
		}else if(index === -1){
			var i = 1;
			while(params[key + "_" + i] != null){
				i++;
			}
			params[key + "_" + i] = value;
		}else{
			params[key] = value;
		}
		return params;
	},
	
	/**
	* This function clears all the input fields of the form passed in by parameter
	* @param {String} formName The name of the form containing the input fields.	
	*/
	 clearForm:function(formName){
		var form = document.forms[formName];
		for(var i=0; i<form.elements.length; i++) {
			if (form.elements[i].type == "text") {
				form.elements[i].value = "";
			}
		}
	},
	
	/**
	 * submitting to newsletter after checking email param
	 */
	subscribeToNewsLetter:function(formName, page){
		if(this.validateSubscriptionParams(formName)){
            var zipcode = '';  
            var firstName = '';
            var lastName = '';
            var gender = '';
            var dateOfBirth = '';
            var promo = false;
            var primaryNewsLetterFlow=true;
		    this.formId = formName;
		    emailInput = document.querySelector("form[name="+formName+"] #newsletterPopupEmail");
		    if (formName == "newsLetterForm") {
		        emailInput = document.querySelector("form[name="+formName+"] #newsletterEmail");
		        if (isCarol) {
		            emailInput.parentElement.classList.remove("errorGeneric");
	                emailInput.parentElement.classList.remove("errorDuplicate");
		        }
            }
            if(formName == "newsLetterFormLandingPage" && isOliver) {
                emailInput = document.querySelector("form[name="+formName+"] #newsletterEmailLandingPage");
                if(countryCode == 'US' || countryCode == 'CA') {
                	zipcode = document.querySelector("form[name="+formName+"] #newsletterZipcodeLandingPage").value;
                }
                firstName = document.querySelector("form[name="+formName+"] #newsletterFirstNameLandingPage").value;
            	lastName = document.querySelector("form[name="+formName+"] #newsletterLastNameLandingPage").value;
            	gender = document.querySelector("form[name="+formName+"] #newsletterGenderLandingPage").value;
            	dateOfBirth = document.querySelector("form[name="+formName+"] #newsletterBirthdayLandingPage").value;
            } else if (formName == "newsLetterFormPromoLandingPage"){
            	emailInput = document.querySelector("form[name="+formName+"] #newsletterEmailLandingPage");
            	firstName = document.querySelector("form[name="+formName+"] #newsletterFirstNameLandingPage").value;
            	lastName = document.querySelector("form[name="+formName+"] #newsletterLastNameLandingPage").value;
            	gender = document.querySelector("form[name="+formName+"] #newsletterGenderLandingPage").value;
            	dateOfBirth = document.querySelector("form[name="+formName+"] #newsletterBirthdayLandingPage").value;
            	promo = true;
            } //#EMAIL_ME# 
            else if (formName == "newsLetterForm_emailme") { 
		        emailInput = document.querySelector("form[name="+formName+"] #input_Emailme");
			} //#EMAIL_ME#
		    this.email = emailInput.value.toLowerCase();
		    
		    var cidCookie = null;
	        
	        if(document.cookie.includes('X_WC_CID')){
	        	cidCookie = $.cookie("X_WC_CID");
	        }
		    
			var params = {
				storeId: this.storeId,
				langId : this.langId,
				email: this.email,
                zipCode: zipcode,
                promo: promo,
                pageIdentifier: page,
                firstName: firstName,
                lastName: lastName,
                gender: gender,
                dob: dateOfBirth,
                primaryNewsLetterFlow:primaryNewsLetterFlow,
                cid: cidCookie
			}
            if(typeof updateDuplicate != 'undefined' && updateDuplicate == 'true')
                params.update = updateDuplicate

		 	cursor_wait();
		 	wcService.invoke("JoinNewsletterService", params);
		 	
		 	if(formName=="newsletterPopupForm"){
		 		setCookie("WELCOME_STICKY_SHOWN_"+this.appName,true,{expires: 10000,path: "/", domain: cookieDomain});
		 	}
		}
		
	},

    validateSubscriptionParams: function(formName) {
        this.cleanErrors(formName); 
        var namePattern = /[A-Za-z]/;
        var isValid = true; //we use this variable to check all fields and show,eventually, all errors

        /*EMAIL VALDATION - MANDATORY*/
        var emailInput = $("form[name="+formName+"] [name='EMAIL']");
        if (!emailInput.val()) { //empty or undefined
            this.toggleFormError('EMAIL','EMPTY',formName);
            isValid = false;
        } else if (emailInput.length > 0 && !AddressHelper.validateEmail(emailInput.get(0))) {
            this.toggleFormError('EMAIL','INVALID',formName);
            isValid = false;
        }
        
        /*FIRSTNAME VALDATION*/
        var firstNameInput = $("form[name="+formName+"] [name='NAME'],form[name="+formName+"] [name='FIRSTNAME']");
        if (firstNameInput.length > 0 && needsValidation(firstNameInput)) { //if fild not available or disabled do not check
            var firstNameValue = firstNameInput.val();
            if (!firstNameValue) {
                this.toggleFormError('NAME','EMPTY',formName);  
                isValid = false; 
            } else if (!namePattern.test(firstNameValue)){
                this.toggleFormError('NAME','INVALID',formName);  
                isValid = false;
            }
        }

        /*LASTNAME VALIDATION*/
        var lastNameInput = $("form[name="+formName+"] [name='LASTNAME']");
        if (lastNameInput.length > 0 && needsValidation(lastNameInput)) { //if fild not available or disabled do not check
            var lastNameValue = lastNameInput.val();
            if (!lastNameValue) {
                this.toggleFormError('LASTNAME','EMPTY',formName);  
                isValid = false; 
            } else if (!namePattern.test(lastNameValue)){
                this.toggleFormError('LASTNAME','INVALID',formName);  
                isValid = false;
            }
        }

        /*GENDER VALIDATION*/
        var genderInput = $("form[name="+formName+"] [name='gender']");
        if (genderInput.length > 0 && needsValidation(genderInput)) { //if fild not available or disabled do not check
            var genderSelected = genderInput.find('option:selected').val();

            if(!genderSelected) {
                this.toggleFormError('GENDER','EMPTY',formName);  
                isValid = false;
            } 
        }
       
        /*BIRTHDAY VALIDATION*/
        var birthdayInput = $("form[name="+formName+"] [name='BIRTHDAY']");
        if (birthdayInput.length > 0 && needsValidation(birthdayInput)) { //if fild not available or disabled do not check
            var  dateOfBirth = birthdayInput.val();
            // Variables for birthday validation
            var birthdayDate = new Date(dateOfBirth);
            var birthdayYear = birthdayDate.getFullYear();
            var currentYear = new Date().getFullYear();
            var maxAge = currentYear - birthdayYear;

            if (dateOfBirth == '') {
                this.toggleFormError('BIRTHDAY','EMPTY',formName);   
                isValid = false;
            } else if (maxAge > 100 || maxAge < 16 || birthdayYear >= currentYear){
                this.toggleFormError('BIRTHDAY','INVALID',formName);  
                isValid = false;
            }
        }

         /*ZIPCODE VALIDATION*/
         var zipCodeInput = $("form[name="+formName+"] [name='ZIPCODE']");
         if (zipCodeInput.length > 0 && needsValidation(zipCodeInput)) { //if fild not available or disabled do not check
            var  zipCodeValue = zipCodeInput.val();
            var zipCodeRegexp = AddressHelper.getZipCodeRegexpForCurrentCountryCode();
            
            if (!zipCodeRegexp.test(zipCodeValue)){
                this.toggleFormError('ZIPCODE','INVALID',formName);  
                isValid = false;
            }
         }

                 
        return isValid;
    },

    toggleFormError: function(element,error, formName) {
        switch(formName) {
            case 'newsLetterFormPromoLandingPage' : case 'newsLetterFormLandingPage': {
                switch(element) {
                    case 'EMAIL': {
                        $("#mce-error-response-landingpage--email").show();
                        $("#mce-error-response-landingpage--email").children().hide();
                        $("#newsletterEmailForm input").css('border','solid 1px red');
                        if(error=='EMPTY'){ 
                            $("#mce-error-response-landingpage--email [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }    
                        else if (error=='INVALID') { 
                            $("#mce-error-response-landingpage--email [id^=\"mce-error-response-invalid-landingpage\"]").show();
                        }
                        else console.log('NewsletterJS.toggleFormError - EMAIL CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
                    case 'NAME': {
                        $('#mce-error-response-landingpage--name').show();
                        $('#mce-error-response-landingpage--name').children().hide();
                        $('#newsletterNameForm input').css('border','solid 1px red');
        
                        if(error == 'EMPTY')  {
                            $("#mce-error-response-landingpage--name [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }
                        else if(error == 'INVALID') {
                            $('#mce-error-response-landingpage--name  [id^=\"mce-error-response-invalid-landingpage\"]').show();
                        }
                        else console.log('NewsletterJS.toggleFormError - NAME CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
                    
                    case 'LASTNAME': {
                        $('#mce-error-response-landingpage--lastname').show();
                        $('#mce-error-response-landingpage--lastname').children().hide();
                        $('#newsletterLastnameForm input').css('border','solid 1px red');
        
                        if(error == 'EMPTY')  {
                            $("#mce-error-response-landingpage--lastname [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }
                        else if(error == 'INVALID') {
                            $('#mce-error-response-landingpage--lastname [id^=\"mce-error-response-invalid-landingpage\"]').show();
                        }
                        else console.log('NewsletterJS.toggleFormError - LASTNAME CASE '+error+' NOT DEFINED');
                        
                        break;
                    } 
        
                    case 'GENDER': {
                        $('#mce-error-response-landingpage--gender').show();
                        $('#mce-error-response-landingpage--gender').children().hide();
                        $('#newsletterGenderForm select').css('border','solid 1px red');
                        $('#newsletterGenderForm select').css('margin-bottom','0');
        
                        if(error == 'EMPTY')  {
                            $("#mce-error-response-landingpage--gender [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }
                        else console.log('NewsletterJS.toggleFormError - GENDER CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
                    
                    case 'BIRTHDAY': {
                        $('#mce-error-response-landingpage--birthday').show();
                        $('#mce-error-response-landingpage--birthday').children().hide();
                        $('#newsletterBirthdayForm input').css('border','solid 1px red');
        
                        if(error == 'EMPTY')  {
                            $("#mce-error-response-landingpage--birthday [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }
                        else if(error == 'INVALID') {
                            $('#mce-error-response-landingpage--birthday [id^=\"mce-error-response-invalid-landingpage\"]').show();
                        }
                        else console.log('NewsletterJS.toggleFormError - BIRTHDAY CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
        
                    case 'ZIPCODE': {
                        $('#mce-error-response-landingpage').show();
                        $('#mce-error-response-landingpage').children().hide();
                        $('#newsletterZipCodeForm input').css('border','solid 1px red');
        
                        if(error == 'INVALID') {
                            $('#mce-error-response-zipcode-landingpage').show();
                        }
                        else console.log('NewsletterJS.toggleFormError - ZIPCODE CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
                    default: console.log('NewsletterJS.toggleFormError - '+element+' CASE  NOT DEFINED')
                }

                break;
            }
            case 'newsLetterForm_emailme' : {
                $("#mce-error-response_emailme").show();
                $("#mce-error-response_emailme").children().hide();
                if(error=='EMPTY')
                    $("#mce-error-response-empty_emailme").show();  
                else if (error=='INVALID') $("#mce-error-response-invalid_emailme").show();
                else console.log('NewsletterJS.toggleFormError - EMAILME - CASE '+error+' NOT DEFINED')
                break;
            }
            default : {
                $("#mce-error-response").show();
                $("#mce-error-response").children().hide();
                if(error=='EMPTY')
                    $("#mce-error-response-empty").show();
                else if (error=='INVALID') $("#mce-error-response-invalid").show();
                else console.log('NewsletterJS.toggleFormError - '+formName+' - CASE '+error+' NOT DEFINED');
            }
        }
    },

    cleanErrors: function(formName) {
        $("[id^=mce-error-response").hide()
        switch(formName) {
            case 'newsLetterFormPromoLandingPage' : case 'newsLetterFormLandingPage': {
                $("form[name="+formName+"] input").css('border','');
                $("form[name="+formName+"] select").css('border','');
                $("form[name="+formName+"] select").css('margin-bottom','40px');
                break;
            }
            default : {
                $("#mce-error-response").hide();
            }
        }
    },

	hideAllMessagews : function () {
	    $('#newsletterSignUpResultPopup .message-error').hide();
	    $('#newsletterSignUpResultPopup .message-duplicate').hide();
	    $('#newsletterSignUpResultPopup .message-success').hide();
	},
    handleJoinNewsletterError : function(){
        this.hideAllMessagews();
        if (this.formId == "newsLetterForm") {
            if (isCarol) {
                document.getElementById("newsletterEmail").parentElement.classList.add("errorGeneric");
            } else {
            	$('#mce-error-response').show();
            	$('#mce-error-response').children().hide();
            	$('#mce-error-response-error').show();
            }
        } else if (this.formId == "newsLetterFormLandingPage" && isOliver) {
        	$('#mce-error-response-landingpage').show();
            $('#mce-error-response-landingpage').children().hide();
            $('#mce-error-response-error-landingpage').show();
        } else {
            $('#newsletterSignUpResultPopup .message-error').show();
            $('#newsletterSignUpResultPopup').fadeIn("fast");
        }
    },  

    handleJoinNewsletterDuplicate : function(){
        this.hideAllMessagews();
        if (this.formId == "newsLetterForm") {
            if (isCarol) {
                document.getElementById("newsletterEmail").parentElement.classList.add("errorDuplicate");           
            } else if(isVogue) {                
                $('#mce-error-response').show();
                $('#mce-error-response').children().hide();
                if(window.innerWidth < 1024) {
                    $('.newsletter__title').hide();
                }
                //$('.newsletter__policy').hide();
                //$('.newsletter__form').hide();
                $('#mce-error-response-duplicate').show();
            	$('#mce-success-response').hide();
            
            } else {
            	$('#mce-error-response').show();
            	$('#mce-error-response').children().hide();
            	$('#mce-error-response-duplicate').show();
            	$('#mce-success-response').hide();
            }
        } else if (this.formId == "newsLetterFormLandingPage" && isOliver) {
        	$('#mce-error-response-landingpage--email').show();
            $('#mce-error-response-landingpage--email').children().hide();
            $('#mce-error-response-duplicate-landingpage').show();
            
        } else if (this.formId == "newsLetterFormPromoLandingPage") {
            $('#mce-error-response-landingpage--email').show();
            $('#mce-error-response-landingpage--email').children().hide();
            $('#mce-error-response-landingpage--email #mce-error-response-duplicate-landingpage').show();
        } else if(this.formId == "newsLetterForm_emailme"){ //#EMAIL_ME#
         /* email me messaggi di errore per duplicati newsletter 
            $('#mce-error-response_emailme').show();
            $('#mce-error-response_emailme').children().hide();
            $('#mce-error-response-duplicate_emailme').show();
            $('#mce-success-response_emailme').hide();*/
        } //#EMAIL_ME#
        else {
            $('#newsletterSignUpResultPopup .message-duplicate').show();
            $('#newsletterSignUpResultPopup').fadeIn("fast");
        }
    },  
    
    handleJoinNewsletterSuccess : function(){
        this.hideAllMessagews();
        
        /*if(typeof customerWeekActive != 'undefined' && customerWeekActive){
          activateCustomerWeek();
        }*/
        
        if (this.formId == "newsLetterForm") {
            if (isCarol) {
                $('#newsLetterFormDiv').hide();
                $('#newsLetterSuccessDiv').fadeIn("fast");
            } else if(isVogue) {                
                $('#mce-error-response').show();
                $('#mce-error-response').children().hide();
                $('.newsletter__policy').hide();
                $('.newsletter--form--input.input-style').hide();
                $('.button.gray-alpha.button--newsletter').hide()
                $('#mce-success-response').show();
                
            } else {
            	$('#mce-error-response').show();
            	$('#mce-error-response').children().hide();
            	$('#mce-success-response').show();
            }
        } else if (this.formId == "newsLetterFormLandingPage" && isOliver) {
            $('#mce-error-response-landingpage').show();
            $('#mce-error-response-landingpage').children().hide();
            $('#opnewsletter-success-response-landingpage').show();
            $('.newsletter__wrapper').hide();
        } else if (this.formId == "newsLetterFormPromoLandingPage"){
        	//Generic
        	 $('.newsletter-page .newsletter__form').hide();
        	 $('.newsletter_homepage-button').show();
        	 $('.newsletter__policy.no-gdpr').hide();
        	//Vogue
        	 $('#mbb-success-response-landingpage').show();
        	 $('.newsletter__title-mbb').hide();
 	         $('.newsletter__info-mbb').hide();
 	         $('.newsletter__image.newsletter-mbb_image img:nth-child(2)').hide();
             $('.newsletter__image.newsletter-mbb_image img:nth-child(3)').show();
        	//Persol
        	 $('#ponewsletter-success-response-landingpage').show();
        	 $('.newsletter__title-ponewsletter').hide();
 	         $('.newsletter__info-ponewsletter').hide();
 	         $('.newsletter__image.newsletter-ponewsletter_image img:nth-child(2)').hide();
             $('.newsletter__image.newsletter-ponewsletter_image img:nth-child(3)').show();
             $('#POnewsletterImage').hide();
             $('#POnewsletterImageMobile').hide();
             if(window.mobilecheck()){
            	 $('#POnewsletterImageMobile_TP').show();
             }
             else {
            	 $('#POnewsletterImage_TP').show();
             }

            window.scrollTo(0,0);
            if (isPersol || isVogue) {
                window.setTimeout(function(){
                    window.location.href = WCParamJS.homePageURL + ($('#redirectSunglasses').length > 0 && $('#redirectSunglasses').attr('value') != undefined && $('#redirectSunglasses').attr('value') != '' ? $('#redirectSunglasses').attr('value') : '');
                }, 3200);
            }
        } else if(this.formId == "newsLetterForm_emailme"){ //#EMAIL_ME#
            $('#mce-error-response_emailme').show();
            $('#mce-error-response_emailme').children().hide();
            $('#mce-success-response_emailme').show();
            $('#mce-error-response-duplicate_emailme').hide();//#EMAIL_ME#
        } else {
            $('#newsletterSignUpResultPopup .message-success').show();
            $('#newsletterSignUpResultPopup').fadeIn("fast");
        }

        /* START Early Access */
        if (isPersol || isVogue) { 
            if ($("#boxCheckout").length == 0){
                assignCustomerSegment();
                if (this.formId == "newsLetterForm"){
                    if (window.customerSegment != undefined && document.cookie.includes("X_WC_PR_SEGMENTS")){
                        var queryString = window.location.search;
                        var urlParams = new URLSearchParams(queryString);
                        if (!urlParams.has('promo')) {
                            if (location.href.indexOf("?") === -1){
                                window.setTimeout(function(){
                                    window.location = location.href += "?promo=" + window.customerSegment;
                                }, 2000);
                            } else {
                                window.setTimeout(function(){
                                    window.location = location.href += "&promo=" + window.customerSegment;
                                }, 2000);
                            }
                        }   
                    }
                }
            }
        }
        /* END Early Access */
    }		
},
 
/**
 * This service calls JoinNewsletterCmd to make a subscription to newsLetter
 */
wcService.declare({
	id: "JoinNewsletterService",
	actionId: "JoinNewsletterService",
	url: "JoinNewsletterService",
	formId: "",

	successHandler: function(serviceResponse) {
		localStorage.setItem('chekoutUserOptin',serviceResponse.userOptin);
		if(serviceResponse.responseMessage == 'duplicate'){
		    NewsLetterJS.handleJoinNewsletterDuplicate();
		}else if(serviceResponse.responseMessage == 'success'){
		    if(typeof utag_data !== 'undefined')
               utag_data.User_EmailOptin = serviceResponse.userOptin;
		    if(pageType!=='Delivery'){
		    	tealiumPushUserOptin(serviceResponse.userOptin,serviceResponse.email);
		    }
			NewsLetterJS.handleJoinNewsletterSuccess();
            if(isVogue){
                setCookieNlEvent();
            }
		}
		cursor_clear();
		
	},

	failureHandler: function(serviceResponse) {
	    NewsLetterJS.handleJoinNewsletterError();
	    cursor_clear();
	}
});

//  Display/undisplay Landing Page fields
function toggleLandingPageFields() {
    var landingForm = $("form[name='newsLetterFormPromoLandingPage'],form[name='newsLetterFormLandingPage']");
    if (landingForm.length > 0) {
        var formId = landingForm.attr('id')
        toggleSubscriptionForms("X_SignInForms_Info");
        if (typeof subscriptionFormsJSONData != 'undefined'){
        for (var key in subscriptionFormsJSONData) {
            var dataValue = subscriptionFormsJSONData[key];
            switch(dataValue) {
                case 'disabled','false': {
                    $("#"+formId+" #"+key+" input,#"+formId+" #"+key+" select").attr("disabled","disabled");
                    $("#"+formId+" #"+key).hide();
                    if (key == 'newsletterBirthdayForm') {
                        $('#newsletter_age-disclaimer').hide();
                    }
                    break;
                }
                case 'optional' : {
                    $("#"+formId+" #"+key+" input,#"+formId+" #"+key+" select").attr("optional","optional");
                    break;
                }
                default:{}
            }
        }
      }
    }
}

function toggleSubscriptionForms(espotName){

    var espotServiceUrl = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/espot/" + espotName+"?"+Date.now();
  
    $.ajax({
      type: "GET", 
      dataType: 'json', 
      url: espotServiceUrl,
      async: false,
      contentType: "application/json",
      success: function (data) {
        //console.log(data);
        if (data.MarketingSpotData[0].baseMarketingSpotActivityData != undefined) {
          window.subscriptionFormsJSONData = JSON.parse(data.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription[0].marketingText);
        }
      },
      error: function(data){
        console.log("Error retrieving newsletter subscription forms info");
      }
    });
}

function needsValidation(inputElement) {
    var needValidation = true;

    if(inputElement.attr('disabled'))
        needValidation = false;

    if(inputElement.attr('optional'))
        needValidation = false;

    return needValidation;
}
//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This class contains declarations of AJAX services used by the Madisons store pages.
 */

/**
 * @class This class stores common parameters needed to make the service call.
 */
ServicesDeclarationJS = {
    langId: "-1", /* language of the  store */
    storeId: "", /*numeric unique identifier of the store */
    catalogId: "", /*catalog of the store that is currently in use */

    /**
     * Sets common parameters used by the services
     * @param (int) langId The language of the store.
     * @param (int) storeId The store currently in use.
     * @param (int) catalogId The catalog of the store currently in use.
     */
    setCommonParameters:function(langId,storeId,catalogId){
            this.langId = langId;
            this.storeId = storeId;
            this.catalogId = catalogId;
    }
}

function nullCartTotalCookie(orderId){
    setCookie("WC_CartTotal_"+orderId, null, {expires: -1, path:'/', domain:cookieDomain});

    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var index = cookies[i].indexOf("=");
        var name = cookies[i].substr(0,index);
        var value = cookies[i].substr(index+1)
        name = name.replace(/^\s+|\s+$/g,"");
        value = value.replace(/^\s+|\s+$/g,"");
        if (value == orderId) {
            setCookie(name, null, {expires: -1, path:'/', domain:cookieDomain});
            break;
        }
    }
}

    /**
    * Adds an item to to the wishlist and remove the same item from the shopping
    * cart.
    * @constructor
     */
    wcService.declare({
        id: "AjaxInterestItemAddAndDeleteFromCart",
        actionId: "AjaxInterestItemAddAndDeleteFromCart",
        url: getAbsoluteURL() + "AjaxInterestItemAdd",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            //Now delete from cart..
            MessageHelper.hideAndClearMessage();
            resetRequest();
            CheckoutHelperJS.deleteFromCart(serviceResponse.orderItemId,true);
            MessageHelper.displayStatusMessage(MessageHelper.messages["WISHLIST_ADDED"]);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Add an item to a shopping cart in Ajax mode. A message is displayed after
     * the service call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxAddOrderItem",
        actionId: "AjaxAddOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemAdd",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_ADDED"]);
            cursor_clear();
            if(categoryDisplayJS){

                var attributes = document.getElementsByName("attrValue");

                var singleSKU = true;

                for(var i=0; i<attributes.length; i++){
                    if (attributes[i].options.length > 1)
                    {
                        singleSKU = false;
                    }
                }

                if (!singleSKU)
                {
                    categoryDisplayJS.selectedAttributes = [];
                    for(var i=0; i<attributes.length; i++){
                        if(attributes[i] != null){
                            attributes[i].value = "";
                        }
                    }
                }
            }
            if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
                ShipmodeSelectionExtJS.setOrderItemId((serviceResponse.orderItem != null && serviceResponse.orderItem[0].orderItemId != null) ? serviceResponse.orderItem[0].orderItemId : serviceResponse.orderItemId);
            }
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_CONTRACT_EXPIRED_GOTO_ORDER"]);
                } else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE"]);
                } else {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

   /**
   * Add an item to a shopping cart in non-Ajax mode. Upon a successful request,
   * the shopping cart page is loaded. An error message is displayed otherwise.
   * @constructor
   */
    wcService.declare({
        id: "AjaxAddOrderItem_shopCart",
        actionId: "AjaxAddOrderItem",
        url: getAbsoluteURL() + "AjaxOrderChangeServiceItemAdd",
        formId: ""

     /**
     * redirects to the shopping cart page
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            //Now delete from cart..
            document.location.href =  appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_CONTRACT_EXPIRED_GOTO_ORDER"]);
                } else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE"]);
                } else {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Remove an item from shopping cart. A message is displayed after the service
     * call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxDeleteOrderItem",
        actionId: "AjaxDeleteOrderItem",
        url: getAbsoluteURL() + "AjaxCustomRESTOrderItemDelete",
        formId: ""
    /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse, params) {
            MessageHelper.hideAndClearMessage();
            if (typeof addCheckoutLoader === 'function') {
                addCheckoutLoader();
            }
            if (typeof params.editLensesAddToCart === 'function') {
                params.editLensesAddToCart();
            } else {
                MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_REMOVEITEM"],null);
            }
            if (typeof addToCartInput !== "undefined") {
                fn_ext_genericAddToCart(addToCartInput.frameObject, addToCartInput.lensObject, addToCartInput.warrantyObject, addToCartInput.reviewObject, addToCartInput.imagery, addToCartInput.merchandisingAssociations);
            }
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            if(serviceResponse.errorCode){
                wcTopic.publish("OrderError",serviceResponse);
            }
            cursor_clear();
        }
    }),


    /**
     * Removes an item from shopping cart on the shipping & billing page. A message is displayed after the service call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxDeleteOrderItemForShippingBillingPage",
        actionId: "AjaxDeleteOrderItemForShippingBillingPage",
        url: getAbsoluteURL() + "AjaxCustomRESTOrderItemDelete",
        formId: ""

        /**
         * display a success message
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation
         */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            resetRequest();
            addCheckoutLoader();
            MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_REMOVEITEM"],null);
            /* HB-1050 :: workaround */
            if (!$("#page").hasClass("pdp")) {
            	setTimeout(function() { location.reload(); }, 500);
            }
        }

        /**
         * display an error message
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation
         */
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),


    /**
     * Remove an item from shopping cart. A message is only displayed if the service
     * call returns an error Message. It is used to remove an item from the shopping
     * cart and add the same item to the wish list.
     * @constructor
     */
    wcService.declare({
        id: "AjaxDeleteOrderItemFromCart",
        actionId: "AjaxDeleteOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
        formId: ""
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }


    }),

    /**
     * Remove an item from shopping cart.
     * Upon a successful request, this function will load the AjaxOrderItemDisplayView page or the OrderShippingBillingView page depending on what page the service was invoked from.
     * An error message will be displayed otherwise.
     * @constructor
     */
    wcService.declare({
        id: "AjaxDeleteOrderItem1",
        actionId: "AjaxDeleteOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
        formId: ""

    /**
     *redirect to the Shopping Cart Page
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_REMOVEITEM"],null);
            addCheckoutLoader();
            if (!CheckoutHelperJS.pendingOrderDetailsPage)
            {
                setDeleteCartCookie();
                if(CheckoutHelperJS.shoppingCartPage){

                    document.location.href = appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
                }else{
                    document.location.href = appendWcCommonRequestParameters("OrderShippingBillingView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&orderId=" + serviceResponse.orderId);
                }
            }
            else
            {
                cursor_clear();
            }
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),


    /**
     * This service updates an order item in the shopping cart.
     * A message is displayed after the service call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdateOrderItem",
        actionId: "AjaxUpdateOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.hideFormErrorHandle();
            cursor_clear();
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE_QTY_UPDATE"]);
                }
                else{
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            if(serviceResponse.errorCode){
                wcTopic.publish("OrderError",serviceResponse);
            }
            cursor_clear();
        }

    }),

    /**
     * Updates an order item in the shopping cart.
     * Upon a successful request, this function will load the AjaxOrderItemDisplayView page
     * An error message will be displayed otherwise.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdateOrderItem1",
        actionId: "AjaxUpdateOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
        formId: ""
    /**
     *redirect to the Shopping Cart Page
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            if (!CheckoutHelperJS.pendingOrderDetailsPage)
            {
                if(CheckoutHelperJS.shoppingCartPage){
                    document.location.href = appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
                }
            }
            else
            {
                cursor_clear();
            }
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE_QTY_UPDATE"]);
                }
                else{
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service updates shipping information (shipping mode, shipping address)
     * for a shopping cart. A message is displayed after the service call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdateOrderShippingInfo",
        actionId: "AjaxUpdateOrderShippingInfo",
        url: getAbsoluteURL() + "AjaxRESTOrderShipInfoUpdate",
        formId: ""
    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service prepares an order for submission. Upon success, it submits the order.
     * @constructor
     */
    wcService.declare({
        id: "AjaxPrepareOrderForSubmit",
        actionId: "AjaxPrepareOrderForSubmit",
        url: getAbsoluteURL() + "AjaxRESTOrderPrepare",
        formId: ""

    /**
     * On success, checkout the order by calling order submit.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            CheckoutHelperJS.setOrderPrepared("true");
            CheckoutHelperJS.checkoutOrder(CheckoutHelperJS.getSavedParameter('tempOrderId'),CheckoutHelperJS.getSavedParameter('tempUserType'),CheckoutHelperJS.getSavedParameter('tempEmailAddresses'),CheckoutHelperJS.getSavedParameter('tempIsQuote'));
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),


    /**
     * This service submits the order. Upon success, the order billing confirmation
     * page is shown. A error message is displayed otherwise.
     * @constructor
     */
    wcService.declare({
        id: "AjaxSubmitOrder",
        actionId: "AjaxSubmitOrder",
        url: getAbsoluteURL() + "AjaxRESTOrderSubmit",
        formId: ""

    /**
     *redirect to the Order Confirmation page
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            nullCartTotalCookie(serviceResponse.orderId);
            /* START - Online Return Form */
            if (typeof goToOnlineReturnTYP == 'function') {
                goToOnlineReturnTYP();
            } else {
                var shipmentTypeId = CheckoutHelperJS.getShipmentTypeId();
                document.location.href = appendWcCommonRequestParameters("OrderShippingBillingConfirmationView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&orderId=" + serviceResponse.orderId + "&shipmentTypeId=" + shipmentTypeId);
            }
            /* END - Online Return Form */
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     *
     * In case of failure, the next error messages will not be sent to Tealium: See paymentResponseCodesNotToSendToTealium set in CommonUtilities.js
     *
     */
        ,failureHandler: function(serviceResponse) {

            //NERD-727: Start the authentication session in case the card is enrolled in pyaer authentications.
            if (serviceResponse.errorMessageKey == "PLUGIN_RC_475" && $("#JWT").length > 0) {
                var url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/cart/@self/payment_instruction";
                createPaymentLoaderOverlay() //creates a dark overlay with a spinner;

                $.ajax({
                    url: url,
                    type: 'GET',
                    cache: false,
                    data: {
                        "timestamp": Date.now()
                    },
                    success: function (data) {
                        if (data != undefined) {
                            var payerAuthEnrollReply_paReq;
                            var payerAuthEnrollReply_acsURL;
                            var payerAuthEnrollReply_authenticationTransactionID;
                            $.each(data.paymentInstruction[0].protocolData, function (index, value) {
                                if (value.name == 'payerAuthEnrollReply_paReq') {
                                    payerAuthEnrollReply_paReq = value.value;
                                } else if (value.name == 'payerAuthEnrollReply_acsURL') {
                                    payerAuthEnrollReply_acsURL = value.value;
                                } else if (value.name == 'payerAuthEnrollReply_authenticationTransactionID') {
                                    payerAuthEnrollReply_authenticationTransactionID = value.value;
                                }
                            });
                            // Start the authentication session.
                            Cardinal.continue('cca',
                            {
                                "AcsUrl": payerAuthEnrollReply_acsURL,
                                "Payload": payerAuthEnrollReply_paReq
                            },
                            {
                                "OrderDetails":{
                                    "TransactionId" : payerAuthEnrollReply_authenticationTransactionID
                                }
                            });
                        }
                    },
                    error: function(data){
                        deletePaymentLoaderOverlay();

                        MessageHelper.displayErrorMessage("There was a problem while retrieving the payment data.");
                        cursor_clear();
                    }
                });
            } else if (serviceResponse.errorMessage) {
                deletePaymentLoaderOverlay();

                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                sendPaymentErrorMessageToTealium(serviceResponse.errorMessageKey, serviceResponse.errorMessage);
                cursor_clear();
            } else {
                if (serviceResponse.errorMessageKey) {
                    deletePaymentLoaderOverlay();

                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                    sendPaymentErrorMessageToTealium(serviceResponse.errorMessageKey, serviceResponse.errorMessage);
                    cursor_clear();
                }
            }
        }

    }),

    /**
     * This service submits the quote. Upon success, the quote  confirmation
     * page is shown. A error message is displayed otherwise.
     * @constructor
     */
    wcService.declare({
        id: "AjaxSubmitQuote",
        actionId: "AjaxSubmitQuote",
        url: getAbsoluteURL() + "AjaxSubmitQuote",
        formId: ""

   /**
    *redirect to the Quote Confirmation page
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation
    */
        ,successHandler: function(serviceResponse) {
            var redirectURL = "OrderShippingBillingConfirmationView?storeId=" + ServicesDeclarationJS.storeId
            + "&catalogId=" + ServicesDeclarationJS.catalogId
            + "&langId=" + ServicesDeclarationJS.langId
            + "&orderId=" + CheckoutHelperJS.getOrderId()
            + "&shipmentTypeId=" + CheckoutHelperJS.getShipmentTypeId()
            + "&isQuote=true"
            + "&quoteId=" + serviceResponse.outOrderId// outOrderId is the id of the new quote created.

            if(serviceResponse.outExternalQuoteId != undefined && serviceResponse.outExternalQuoteId != null){
                redirectURL += redirectURL + "&externalQuoteId=" + serviceResponse.outExternalQuoteId;
            }
            document.location.href = appendWcCommonRequestParameters(redirectURL);
        }

   /**
    * display an error message
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation
    */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds an address for the person. An error message is displayed
     * if the service failed.
     * @constructor
     */
    wcService.declare({
        id: "AjaxAddAddressForPerson",
        actionId: "AjaxAddAddressForPerson",
        url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            AddressHelper.updateOrderAfterAddressUpdate();
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds an address for the person. An error message is displayed
     * if the service failed.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdateAddressForPerson",
        actionId: "AjaxUpdateAddressForPerson",
        url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            AddressHelper.updateOrderAfterAddressUpdate();
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service calls AjaxRESTOrderItemUpdate to update order total after shipping address is updated in the order.
     */
    wcService.declare({
        id: "AjaxUpdateOrderAfterAddressUpdate",
        actionId: "AjaxUpdateOrderAfterAddressUpdate",
        url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds an item to the wishlist. This is different from
     * AjaxInterestItemAddAndDeleteFromCart in that this function does not remove
     * the item from the shopping cart. It is used mainly in catalog browsing.
     * @constructor
     */
    wcService.declare({
        id: "AjaxInterestItemAdd",
        actionId: "AjaxInterestItemAdd",
        url: getAbsoluteURL() + "AjaxInterestItemAdd",
        formId: ""
    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            cursor_clear();
            MessageHelper.displayStatusMessage(MessageHelper.messages["WISHLIST_ADDED"]);
            if(categoryDisplayJS)
            categoryDisplayJS.selectedAttributes = [];
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds an item to the wishlist in non-Ajax mode. Upon success,
     * the shopping cart page is displayed. This is different from
     * AjaxInterestItemAddAndDeleteFromCart in that this function does not remove
     * the item from the shopping cart. It is used mainly in catalog browsing.
     * @constructor
     */
    wcService.declare({
        id: "AjaxInterestItemAdd_shopCart",
        actionId: "AjaxInterestItemAdd",
        url: getAbsoluteURL() + "AjaxInterestItemAdd",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            document.location.href = appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

  /**
   * This service deletes an item from the wish list. An error message will be
   * displayed if the service call failed.
   */
    wcService.declare({
        id: "AjaxInterestItemDelete",
        actionId: "AjaxInterestItemDelete",
        url: getAbsoluteURL() + "AjaxInterestItemDelete",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service sends the wish list to a specified email address.
     */
    wcService.declare({
        id: "AjaxInterestItemListMessage",
        actionId: "AjaxInterestItemListMessage",
        url: getAbsoluteURL() + "AjaxInterestItemListMessage",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service applies the promotion code to the order(s).
     */
    wcService.declare({
        id: "AjaxPromotionCodeManage",
        actionId: "AjaxPromotionCodeManage",
        url: getAbsoluteURL() + "AjaxRESTPromotionCodeApply",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            var objsucces = {
                'id' : 'Event',
                'Events_DiscountApplied' : '1',
                'Order_DiscountCode':serviceResponse.promoCode,
                'Order_DiscountName':serviceResponse.promoCode
            }
            pushDiscountCode(objsucces)
            MessageHelper.hideAndClearMessage();

            /*var params = [];

            params.storeId		= ServicesDeclarationJS.storeId;
            params.catalogId	= ServicesDeclarationJS.catalogId;
            params.langId		= ServicesDeclarationJS.langId;
            params.orderItemId 	= "";
            params.orderId = serviceResponse.orderId;
            if(CheckoutHelperJS.shoppingCartPage){
                params.calculationUsage = "-1,-2,-5,-6,-7";
            }else{
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";

            wcService.invoke("AjaxUpdateOrderItem",params);*/

            /* CHECKOUT 3.0 - mustache obj for checkout summary for OP with promotion form update */
            ajaxCallCart(true);
            /* CHECKOUT 3.0 - mustache obj for checkout summary for OP with promotion form update */

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage){
                $("#promoCode").addClass("error");
                addErrorMessageToElement(document.forms.PromotionCodeForm, serviceResponse.errorMessage);
                var obj = {
                		'id' : 'Event',
                        'Events_DiscountTentative' : '1',
                		'Error_Source' : 'User', 
                		'Error_Code' : 'PromoCode -'+ (serviceResponse.errorMessage ? serviceResponse.errorMessage.trim() : ""),
                		'Order_DiscountCode':serviceResponse.errorMessageParam[0],
                        'Order_DiscountName':"",
                        'Error_Message' : 'PromoCode -'+ (serviceResponse.errorMessage ? serviceResponse.errorMessage.trim() : "")
                }
                pushDiscountCode(obj);
                restoreAjaxButton("WC_PromotionCodeDisplay_links_1");
            } else if (serviceResponse.errorMessageKey){
                $("#promoCode").addClass("error");
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                var obj = {
                		'id' : 'Event',
                        'Events_DiscountTentative' : '1', 
                		'Error_Source' : 'User', 
                		'Error_Code' : 'PromoCode -'+ serviceResponse.errorMessageKey,
                		'Order_DiscountCode':serviceResponse.errorMessageParam[0],
                        'Order_DiscountName':""
                }
                pushDiscountCode(obj);
            }
            cursor_clear();
        }

    }),

    /**
     * This service applies the promotion code to the order(s).
     */
    wcService.declare({
        id: "AjaxPromotionCodeDelete",
        actionId: "AjaxPromotionCodeManage",
        url: getAbsoluteURL() + "AjaxRESTPromotionCodeRemove",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();

            /*var params = [];

            params.storeId		= ServicesDeclarationJS.storeId;
            params.catalogId	= ServicesDeclarationJS.catalogId;
            params.langId		= ServicesDeclarationJS.langId;
            params.orderItemId 	= "";
            params.orderId = serviceResponse.orderId;
            if(CheckoutHelperJS.shoppingCartPage){
                params.calculationUsage = "-1,-2,-5,-6,-7";
            }else{
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";

            wcService.invoke("AjaxUpdateOrderItem",params);*/

            /* CHECKOUT 3.0 - mustache obj for checkout summary for OP with promotion form update */
            ajaxCallCart(true);
            /* CHECKOUT 3.0 - mustache obj for checkout summary for OP with promotion form update */

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

  /**
   * This services adds or removes a coupon from the order(s).
   */
    wcService.declare({
        id: "AjaxCouponsAdd",
        actionId: "AjaxCouponsAddRemove",
        url: getAbsoluteURL() + "AjaxRESTCouponsAdd",
        formId: ""

    /**
     * Hides all the messages and the progress bar. It will then called the
     * AjaxRESTOrderItemUpdate service
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
      */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();

            var params = [];

            params.storeId		= ServicesDeclarationJS.storeId;
            params.catalogId	= ServicesDeclarationJS.catalogId;
            params.langId		= ServicesDeclarationJS.langId;
            params.orderItemId	= "";
            params.orderId = serviceResponse.orderId;
            if(CheckoutHelperJS.shoppingCartPage){
                params.calculationUsage = "-1,-2,-5,-6,-7";
            }else{
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";

            wcService.invoke("AjaxUpdateOrderItem",params);

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

  /**
   * This services adds or removes a coupon from the order(s).
   */
    wcService.declare({
        id: "AjaxCouponsRemove",
        actionId: "AjaxCouponsAddRemove",
        url: getAbsoluteURL() + "AjaxRESTCouponsRemove",
        formId: ""

    /**
     * Hides all the messages and the progress bar. It will then called the
     * AjaxRESTOrderItemUpdate service
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
      */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();

            var params = [];

            params.storeId		= ServicesDeclarationJS.storeId;
            params.catalogId	= ServicesDeclarationJS.catalogId;
            params.langId		= ServicesDeclarationJS.langId;
            params.orderItemId	= "";
            params.orderId = serviceResponse.orderId;
            if(CheckoutHelperJS.shoppingCartPage){
                params.calculationUsage = "-1,-2,-5,-6,-7";
            }else{
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";

            wcService.invoke("AjaxUpdateOrderItem",params);

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds a billing address to the order(s).
     */
    wcService.declare({
        id: "AddBillingAddress",
        actionId: "AddBillingAddress",
        url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

/**
 * This service schedules an order based on the input order date and order interval parameters.
 */
wcService.declare({
    id: "ScheduleOrder",
    actionId: "ScheduleOrder",
    url: getAbsoluteURL() + "AjaxRESTScheduleOrder",
    formId: ""

    /**
     * Hides all the messages and the progress bar.
     * Constructs a URL that deletes the current order and forward to the order confirmation page.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
     */
    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        var originalOrderId = document.getElementById("orderIdToSchedule").value;
        var newOrderId = serviceResponse.orderId;
        nullCartTotalCookie(serviceResponse.orderId);
        var shipmentTypeId = CheckoutHelperJS.getShipmentTypeId();
        var purchaseOrderNumber = "";
        if(document.forms["purchaseOrderNumberInfo"].purchase_order_number.value != null){
            purchaseOrderNumber = document.forms["purchaseOrderNumberInfo"].purchase_order_number.value;
        }
        var url = "RESTOrderCancel?orderId=" + originalOrderId + "&storeId="  + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&URL=OrderShippingBillingConfirmationView%3ForderId%3D" + newOrderId + "%26originalOrderId%3D" + originalOrderId + "%26shipmentTypeId%3D" + shipmentTypeId + "%26purchaseOrderNumber%3D" + purchaseOrderNumber;
        document.location.href = appendWcCommonRequestParameters(url);
    }

    /**
     * Displays an error message if the the service call failed.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }
}),

/**
 * This service schedules an order based on the input order date and order interval parameters.
 */
wcService.declare({
    id: "SubmitRecurringOrder",
    actionId: "SubmitRecurringOrder",
    url: getAbsoluteURL() + "AjaxRESTSubmitRecurringOrSubscription",
    formId: ""

    /**
     * Hides all the messages and the progress bar.
     * Constructs a URL that deletes the current order and forward to the order confirmation page.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
     */
    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        nullCartTotalCookie(serviceResponse.orderId);
        var shipmentTypeId = CheckoutHelperJS.getShipmentTypeId();
        var url = "OrderShippingBillingConfirmationView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&orderId=" + serviceResponse.orderId + "&shipmentTypeId=" + shipmentTypeId;
        document.location.href = appendWcCommonRequestParameters(url);
        cursor_clear();
    }

    /**
     * Displays an error message if the the service call failed.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }
}),

/**
 * This service updates the free gift choices made by the shopper for the
 * promotion.
 */
wcService.declare({
    id: "AjaxUpdateRewardOption",
    actionId: "AjaxUpdateRewardOption",
    url: getAbsoluteURL() + "AjaxRESTOrderRewardOptionUpdate",
    formId: ""

/**
 * Hides all the messages and the progress bar.
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        cursor_clear();

    }
 /**
 * Display an error message.
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
    ,failureHandler: function(serviceResponse) {

        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        }
        else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }

}),

    /**
     * Create a new saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderCreate",
        actionId: "AjaxOrderCreate",
        url: getAbsoluteURL() + "AjaxOrderCreate",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_CREATED"]);

            cursor_clear();

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {

                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_CREATED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),

    /**
     * Cancel a single saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxSingleOrderCancel",
        actionId: "AjaxSingleOrderCancel",
        url: getAbsoluteURL() + "AjaxRESTOrderCancel",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDERS_CANCELLED"]);
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_CANCELLED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),

    /**
     * Cancel a saved order. This service is used to delete multiple saved orders one at a time.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderCancel",
        actionId: "AjaxOrderCancel",
        url: getAbsoluteURL() + "AjaxRESTOrderCancel",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            // Call again to delete any other orders in the list.
            savedOrdersJS.cancelSavedOrder(false);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_CANCELLED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),

    /**
     * Update the description of a saved order. This service is used to update the description of multiple saved orders one at a time.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderSave",
        actionId: "AjaxOrderSave",
        url: getAbsoluteURL() + "AjaxOrderCopy",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            // Call again to delete any other orders in the list.
            savedOrdersJS.saveOrder(false);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_SAVED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),

    /**
     * Set the current order to be that of a saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxSetPendingOrder",
        actionId: "AjaxSetPendingOrder",
        url: getAbsoluteURL() + "AjaxRESTSetPendingOrder",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            MessageHelper.hideAndClearMessage();

            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_SET_CURRENT"]);

            savedOrdersJS.determinePageForward("AjaxSetPendingOrder");

            cursor_clear();

        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E" || serviceResponse.errorCode == "CMN1024E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_SET_CURRENT"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),


    /**
     * Updates the current pending order setting it to the current shopping cart.
     * This service does not cause a refresh of the ListOrdersDisplay_Controller registered widgets.
     * The main function of this service is to keep the cpendorder database table in line with the current shopping cart.
     * Perform the service or command call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdatePendingOrder",
        actionId: "AjaxUpdatePendingOrder",
        url: getAbsoluteURL() + "AjaxRESTSetPendingOrder",
        formId: ""

     /**
     * There is nothing to do in the event of a success of this service since it is executed in the background.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            savedOrdersJS.determinePageForward("AjaxUpdatePendingOrder");
            cursor_clear();

        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_SET_CURRENT"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Copy a saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxSingleOrderCopy",
        actionId: "AjaxSingleOrderCopy",
        url: getAbsoluteURL() + "AjaxOrderCopy",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

        var params = [];

        params.storeId		= ServicesDeclarationJS.storeId;
        params.catalogId	= ServicesDeclarationJS.catalogId;
        params.langId		= ServicesDeclarationJS.langId;
        params.URL="";
        params.updatePrices = "1";

        params.orderId = serviceResponse.orderId;
        params.calculationUsageId = "-1";

        wcService.invoke("AjaxSingleOrderCalculate", params);
            MessageHelper.hideAndClearMessage();

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Copy a saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderCopy",
        actionId: "AjaxOrderCopy",
        url: getAbsoluteURL() + "AjaxOrderCopy",
        formId: ""

    /**
    * display a success message
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation
    */

        ,successHandler: function(serviceResponse) {

        var params = [];

        params.storeId		= ServicesDeclarationJS.storeId;
        params.catalogId	= ServicesDeclarationJS.catalogId;
        params.langId		= ServicesDeclarationJS.langId;
        params.URL="";
        params.updatePrices = "1";

        params.orderId = serviceResponse.orderId;
        params.calculationUsageId = "-1";

        wcService.invoke("AjaxOrderCalculate", params);
            MessageHelper.hideAndClearMessage();

        }

    /**
    * display an error message
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation
    */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Perform the order calculation operations to compute the contract prices for the order items in an order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxSingleOrderCalculate",
        actionId: "AjaxSingleOrderCalculate",
        url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_COPIED"]);
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Perform the order calculation operations to compute the contract prices for the order items in an order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxCurrentOrderCalculate",
        actionId: "AjaxCurrentOrderCalculate",
        url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_SET_CURRENT"]);
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Perform the order calculation operations to compute the contract prices for the order items in an order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderCalculate",
        actionId: "AjaxOrderCalculate",
        url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            MessageHelper.hideAndClearMessage();
            // Call again to copy any other orders in the list.
            savedOrdersJS.copyOrder(false);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),


    /**
     * Processes a punchout payment request.
     */
    wcService.declare({
        id: "AjaxPunchoutPay",
        actionId: "AjaxPunchoutPay",
        url: "AjaxRESTOrderRePay",
        formId: ""

        /**
         * Calls PunchoutJS.handleResponse to render the punchout payment section on the page.
         * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
         */
        ,successHandler: function(serviceResponse) {
            PunchoutJS.handleResponse(serviceResponse.orderId);
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }

        /**
         * Displays an error message on the page if the request failed.
         * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
         */
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
            }
            cursor_clear();
        }
    }),


    /**
     * Subscribes to or unsubscribes from receiving information related to a particular category in the store.
     */
    wcService.declare({
        id: "AjaxCategorySubscribe",
        actionId: "AjaxCategorySubscribe",
        url: "AjaxRESTMarketingTriggerProcessServiceEvaluate",
        formId: ""

        /**
         * Clear messages on the page.
         * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
         */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["SUBSCRIPTION_UPDATED"]);
        }

        /**
         * Displays an error message on the page if the request failed.
         * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
         */
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
            }
            cursor_clear();
        }
    })

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2015 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript contains declarations of AJAX services used within
 * WebSphere Commerce.
 */

/**
 * @class This class stores common parameters needed to make the service call.
 */
MyAccountServicesDeclarationJS = {
	/* The common parameters used in service calls */
	langId: "-1",
	storeId: "",
	catalogId: "",
	/**
	 * This function initializes common parameters used in all service calls.
	 * @param {int} langId The language id to use.
	 * @param {int} storeId The store id to use.
	 * @param {int} catalogId The catalog id to use.
	 */

	setCommonParameters:function(langId,storeId,catalogId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
	}
}

	/**
	 *  Removes an item from the customer wishlist in Ajax mode.
	 *  @constructor
	 */
	wcService.declare({
		id: "InterestItemDelete",
		actionId: "InterestItemDelete",
		url: "AjaxInterestItemDelete",
		formId: ""

	/**
	 * display a success message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.displayStatusMessage(MessageHelper.messages["WISHLIST_REMOVEITEM"]);
			for (var prop in serviceResponse) {
				console.debug(prop + "=" + serviceResponse[prop]);
			}
			cursor_clear();
		}
	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 *  Adds an item to the customer wishlist in Ajax mode.
	 *  @constructor
	 */
	wcService.declare({
		id: "AjaxInterestItemAdd",
		actionId: "AjaxInterestItemAdd",
		url: "AjaxInterestItemAdd",
		formId: ""
	/**
	 * display a success message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
			MessageHelper.displayStatusMessage(MessageHelper.messages["WISHLIST_ADDED"]);
            if(categoryDisplayJS)
                categoryDisplayJS.selectedAttributes = [];
		}
	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 *  This service enables the customer to email his/her wishlist.
	 *  @constructor
	 */
	wcService.declare({
		id: "InterestItemListMessage",
		actionId: "InterestItemListMessage",
		url: "AjaxInterestItemListMessage",
		formId: ""

	/**
	 * hdes the progress bar and displays a success message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
			for (var prop in serviceResponse) {
				console.debug(prop + "=" + serviceResponse[prop]);
			}
			cursor_clear();
		}
	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * This service adds a billing address to the order(s).
	 * @constructor
	 */
	wcService.declare({
		id: "AddBillingAddress",
		actionId: "AddBillingAddress",
		url: "AjaxPersonChangeServiceAddressAdd",
		formId: ""

	 /**
	  *	 calls the saveAddress function defined in the AddressHelper class.
	  *  @param (object) serviceResponse The service response object, which is the
	  *  JSON object returned by the service invocation.
	  */
		,successHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::AddBillingAddress::successHandler");
			resetRequest();
			javascript:AddressHelper.saveAddress('AddShippingAddress','shippingAddressCreateEditFormDiv_1');
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::AddBillingAddress::failureHandler");
			if (serviceResponse.errorMessage) {
						 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				  } else {
						 if (serviceResponse.errorMessageKey) {
								MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
						 }
				  }
		}

	}),

	/**
	 *  This service adds a shipping address to the order(s).
	 *  @constructor
	 */
	wcService.declare({
		id: "AddShippingAddress",
		actionId: "AddShippingAddress",
		url: "AjaxPersonChangeServiceAddressAdd",
		formId: ""

	/**
	 *  redirects to the Shipping and Billing Method page.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::AddShippingAddress::successHandler");
			//document.location.href=appendWcCommonRequestParameters("OrderShippingBillingView?langId="+MyAccountServicesDeclarationJS.langId+"&storeId="+MyAccountServicesDeclarationJS.storeId+"&catalogId="+MyAccountServicesDeclarationJS.catalogId+"&shipmentType=single&orderPrepare=true");
			CheckoutHelperJS.updateAddressIdForOrderItem(serviceResponse.addressId);
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::AddShippingAddress::failureHandler");
			if (serviceResponse.errorMessage) {
						 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				  } else {
						 if (serviceResponse.errorMessageKey) {
								MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
						 }
				  }
		}

	}),

	/**
	 * This service updates a billing address to the order(s).
	 * @constructor
	 */
	wcService.declare({
		id: "UpdateBillingAddress",
		actionId: "UpdateBillingAddress",
		url: "AjaxPersonChangeServiceAddressUpdate",
		formId: ""

	 /**
	  *	 calls the saveAddress function defined in the AddressHelper class.
	  *  @param (object) serviceResponse The service response object, which is the
	  *  JSON object returned by the service invocation.
	  */
		,successHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::UpdateBillingAddress::successHandler");
			resetRequest();
			javascript:AddressHelper.saveAddress('UpdateShippingAddress','shippingAddressCreateEditFormDiv_1');
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::UpdateBillingAddress::failureHandler");
			if (serviceResponse.errorMessage) {
						 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				  } else {
						 if (serviceResponse.errorMessageKey) {
								MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
						 }
				  }
		}

	}),

	/**
	 *  This service adds a shipping address to the order(s).
	 *  @constructor
	 */
	wcService.declare({
		id: "UpdateShippingAddress",
		actionId: "UpdateShippingAddress",
		url: "AjaxPersonChangeServiceAddressUpdate",
		formId: ""

	/**
	 *  redirects to the Shipping and Billing Method page.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::UpdateShippingAddress::successHandler");
			CheckoutHelperJS.updateAddressIdForOrderItem(serviceResponse.addressId);
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
		    console.log("PSL::MyAccountServicesDeclaration.js::UpdateShippingAddress::failureHandler");
			if (serviceResponse.errorMessage) {
						 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				  } else {
						 if (serviceResponse.errorMessageKey) {
								MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
						 }
				  }
		}

	}),

  /**
   * This services adds or removes a coupon from the order(s).
   * @constructor
   */
	wcService.declare({
		id: "AjaxCouponsAddRemove",
		actionId: "AjaxCouponsAddRemove",
		url: "AjaxCouponsAddRemove",
		formId: ""

   /**
	 * Hides all the messages and the progress bar.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),
	

	/**
	 * This services deletes a coupon from the wallet.
	 * 
	 * @constructor
	 */
	wcService.declare({
		id : "AjaxRESTWalletCouponsDelete",
		actionId : "AjaxCouponsAddRemove",
		url : "AjaxRESTWalletCouponsDelete",
		formId : ""

		/**
		 * Hides all the messages and the progress bar.
		 * 
		 * @param (object)
		 *            serviceResponse The service response object,
		 *            which is the JSON object returned by the
		 *            service invocation.
		 */
		,
		successHandler : function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
		}

		/**
		 * display an error message.
		 * 
		 * @param (object)
		 *            serviceResponse The service response object,
		 *            which is the JSON object returned by the
		 *            service invocation.
		 */
		,
		failureHandler : function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			} else {
				if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				}
			}
			cursor_clear();
		}

	}),

	/**
	 * This service adds or removes a wallet item.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxWalletItemProcessServiceDelete",
		actionId: "AjaxWalletItemProcessServiceDelete",
		url: "AjaxWalletItemProcessServiceDelete",
		formId: ""

	/**
	 * Hides all messages and the progress bar.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
	}

	/**
	 * Displays an error message in case of a failure.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
		}

	}),

	/**
	 * This service cancels a subscription.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxCancelSubscription",
		actionId: "AjaxCancelSubscription",
		url: "AjaxRESTRecurringOrSubscriptionCancel",
		formId: ""

		/**
		 * Clear messages on the page.
		 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
		 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
            closeAllDialogs();
			if(serviceResponse.subscriptionType == "RecurringOrder"){
				if(serviceResponse.state == "PendingCancel"){
					MessageHelper.displayStatusMessage(MessageHelper.messages["SCHEDULE_ORDER_PENDING_CANCEL_MSG"]);
				}
				else{
					MessageHelper.displayStatusMessage(MessageHelper.messages["SCHEDULE_ORDER_CANCEL_MSG"]);
				}
			}
			else{
				if(serviceResponse.state == "PendingCancel"){
					MessageHelper.displayStatusMessage(MessageHelper.messages["SUBSCRIPTION_PENDING_CANCEL_MSG"]);
				}
				else{
					MessageHelper.displayStatusMessage(MessageHelper.messages["SUBSCRIPTION_CANCEL_MSG"]);
				}
			}
		}

		/**
		 * Displays an error message on the page if the request failed.
		 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
		 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			} else {
				if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				}
			}
			cursor_clear();
		}
	}),


	/**
	 *  This service enables customer to Reorder an already existing order.
	 *  @constructor
	 */
	wcService.declare({
		id: "OrderCopy",
		actionId: "OrderCopy",
		url: "AjaxRESTOrderCopy",
		formId: ""

	 /**
	  *  Copies all the items from the existing order to the shopping cart and redirects to the shopping cart page.
	  *  @param (object) serviceResponse The service response object, which is the
	  *  JSON object returned by the service invocation.
	  */
		,successHandler: function(serviceResponse) {
			for (var prop in serviceResponse) {
				console.debug(prop + "=" + serviceResponse[prop]);
			}
			if (serviceResponse.newOrderItemsCount != null && serviceResponse.newOrderItemsCount<=0){
				MessageHelper.displayErrorMessage(MessageHelper.messages["CANNOT_REORDER_ANY_MSG"]);
			}
			else {
				setDeleteCartCookie();

				var postRefreshHandlerParameters = [];
				var initialURL = "AjaxRESTOrderPrepare";
				var urlRequestParams = [];
				urlRequestParams["orderId"] = serviceResponse.orderId;

				postRefreshHandlerParameters.push({"URL":"AjaxCheckoutDisplayView","requestType":"GET", "requestParams":{}}); 
				var service = getCustomServiceForURLChaining(initialURL,postRefreshHandlerParameters,null);
				wcService.invoke(service.getParam("id"), urlRequestParams);

			}
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessageKey == "_ERR_PROD_NOT_ORDERABLE") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["PRODUCT_NOT_BUYABLE"]);
			} else if (serviceResponse.errorMessageKey == "_ERR_INVALID_ADDR") {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}else {
				if (serviceResponse.errorMessage) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
				else {
					 if (serviceResponse.errorMessageKey) {
						MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
					 }
				}
			}
			cursor_clear();
		}

	}),

	/**
	 *  This service enables customer to Reorder an already existing order in external system.
	 *  @constructor
	 */
	wcService.declare({
		id: "SSFSOrderCopy",
		actionId: "SSFSOrderCopy",
		url: "AjaxSSFSOrderCopy",
		formId: ""

		 /**
		  *  Copies all the items from the existing order to the shopping cart and redirects to the shopping cart page.
		  *  @param (object) serviceResponse The service response object, which is the
		  *  JSON object returned by the service invocation.
		  */
		,successHandler: function(serviceResponse) {
			for (var prop in serviceResponse) {
				console.debug(prop + "=" + serviceResponse[prop]);
			}

			setDeleteCartCookie();
			document.location.href=appendWcCommonRequestParameters("AjaxCheckoutDisplayView?langId="+MyAccountServicesDeclarationJS.langId+"&storeId="+MyAccountServicesDeclarationJS.storeId+"&catalogId="+MyAccountServicesDeclarationJS.catalogId);
		}

		/**
		* display an error message.
		* @param (object) serviceResponse The service response object, which is the
		* JSON object returned by the service invocation.
		*/
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessageKey == "_ERR_PROD_NOT_ORDERABLE") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["PRODUCT_NOT_BUYABLE"]);
			} else if (serviceResponse.errorMessageKey == "_ERR_INVALID_ADDR") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["INVALID_CONTRACT"]);
			}else {
				if (serviceResponse.errorMessage) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
				else {
					 if (serviceResponse.errorMessageKey) {
						MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
					 }
				}
			}
			cursor_clear();
		}

	}),


	/**
	 *  This service enables customer to Renew a subscription.
	 *  @constructor
	 */
	wcService.declare({
		id: "SubscriptionRenew",
		actionId: "SubscriptionRenew",
		url: "AjaxRESTOrderCopy",
		formId: ""

	 /**
	  *  Copies all the items from the existing subscription to the shopping cart and calls service to update requested shipping date.
	  *  @param (object) serviceResponse The service response object, which is the
	  *  JSON object returned by the service invocation.
	  */
		,successHandler: function(serviceResponse) {
			for (var prop in serviceResponse) {
				console.debug(prop + "=" + serviceResponse[prop]);
			}

			var params = [];

			params.storeId		= MyAccountServicesDeclarationJS.storeId;
			params.catalogId	= MyAccountServicesDeclarationJS.catalogId;
			params.langId		= MyAccountServicesDeclarationJS.langId;
			params.orderId      = serviceResponse.orderId;
			params.calculationUsage  = "-1,-2,-3,-4,-5,-6,-7";
			params.requestedShipDate = MyAccountDisplay.getSubscriptionDate();

			MyAccountDisplay.subscriptionOrderId = serviceResponse.orderId;
			MyAccountDisplay.subscriptionOrderItemId = serviceResponse.orderItemId[0];

			wcService.invoke("SetRequestedShippingDate",params);
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessageKey == "_ERR_PROD_NOT_ORDERABLE") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["PRODUCT_NOT_BUYABLE"]);
			} else if (serviceResponse.errorMessageKey == "_ERR_INVALID_ADDR") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["INVALID_CONTRACT"]);
			}else {
				if (serviceResponse.errorMessage) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
				else {
					 if (serviceResponse.errorMessageKey) {
						MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
					 }
				}
			}
			cursor_clear();
		}

	}),


	/**
	 *  This service sets the requested shipping date for a subscription renewal.
	 *  @constructor
	 */
	wcService.declare({
		id: "SetRequestedShippingDate",
		actionId: "SetRequestedShippingDate",
		url: "AjaxRESTOrderShipInfoUpdate",
		formId: ""
	/**
	 * hides all the messages and the progress bar
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			cursor_clear();
			document.location.href=appendWcCommonRequestParameters("RESTOrderPrepare?langId="+MyAccountServicesDeclarationJS.langId+"&storeId="+MyAccountServicesDeclarationJS.storeId+"&catalogId="+MyAccountServicesDeclarationJS.catalogId+"&orderId="+serviceResponse.orderId+"&URL=AjaxCheckoutDisplayView?langId="+MyAccountServicesDeclarationJS.langId+"&storeId="+MyAccountServicesDeclarationJS.storeId+"&catalogId="+MyAccountServicesDeclarationJS.catalogId);
		}

	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessageKey == "_ERR_ORDER_ITEM_FUTURE_SHIP_DATE_OVER_MAXOFFSET") {
				var params = [];

				params.storeId		= MyAccountServicesDeclarationJS.storeId;
				params.catalogId	= MyAccountServicesDeclarationJS.catalogId;
				params.langId		= MyAccountServicesDeclarationJS.langId;
				params.orderId      = MyAccountDisplay.subscriptionOrderId;
				params.orderItemId      = MyAccountDisplay.subscriptionOrderItemId;
				params.calculationUsage  = "-1,-2,-3,-4,-5,-6,-7";
				wcService.invoke("RemoveSubscriptionItem",params);

				MessageHelper.displayStatusMessage(MessageHelper.messages["CANNOT_RENEW_NOW_MSG"]);
			}
			else{
				if (serviceResponse.errorMessage) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
				else {
					if (serviceResponse.errorMessageKey) {
						MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
					 }
				}
				cursor_clear();
			}
		}

	}),

	/**
	 * This service removes the subscription item from the shopping cart if renewal fails.
	 * @constructor
	 */
	wcService.declare({
		id: "RemoveSubscriptionItem",
		actionId: "RemoveSubscriptionItem",
		url: "AjaxRESTOrderItemDelete",
		formId: ""

		/**
		 * @param (object) serviceResponse The service response object, which is the
		 * JSON object returned by the service invocation.
		 */
		,successHandler: function(serviceResponse) {
				cursor_clear();
		}

		 /**
		 * display an error message
		 * @param (object) serviceResponse The service response object, which is the
		 * JSON object returned by the service invocation
		 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			if(serviceResponse.errorCode){
				wcTopic.publish("OrderError",serviceResponse);
			}
			cursor_clear();
		}

	}),

/**
 *  This service enables customer to cancel a scheduled order or an order waiting for approval.
 *  @constructor
 */
wcService.declare({
	id: "AjaxScheduledOrderCancel",
	actionId: "AjaxScheduledOrderCancel",
	url: "AjaxRESTRecurringOrSubscriptionCancel",
	formId: ""

	/**
	 * Displays a success message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		MessageHelper.displayStatusMessage(MessageHelper.messages["MO_ORDER_CANCELED_MSG"]);
	}

	/**
	 * Displays an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		}
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}
})

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This file provides utility functions for the order check-out pages.
 */

/**
 * The functions defined in this class are used for managing order information update during check-out.
 *
 * @class This CheckoutHelperJS class defines all the variables and functions for the page(s) used in the check-out process to udpate order related information, such as address, shipping method, shipping instruction, etc.
 *
 */
CheckoutHelperJS = {
    /* Global variable declarations */

    /**
     * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
     * @private
     */
    langId: "-1",

    /**
     * This variable stores the ID of the current store. Its default value is empty.
     * @private
     */

    storeId: "",

    /**
     * This variable stores the ID of the catalog. Its default value is empty.
     * @private
     */
    catalogId: "",

    /**
     * This variable stores the ID of the order, in case the current shopping cart is not being used. Its default value is empty.
     */
    orderId: "",

    /**
     * This variable stores the shipment type, either 1 for single shipment or 2 for multiple shipment. Its default value is set to empty.
     * @private
     */
    shipmentTypeId: "",


    /**
     * This array stores the item IDs in an order. It is used to save the item IDs before an address is edited or created during the order check-out.
     * @private
     */
    orderItemIds: [],

    /**
     * This constant stores the amount of time in milliseconds that the <code>updateCartWait</code> function needs to wait before updating the shopping cart.
     * @private
     * @constant
     * @see CheckoutHelperJS.updateCartWait
     */
    updateWaitTimeOut: 1500,

    /**
     * This array stores the number of key press events after a shopper has modified the quantity of an item in the shopping cart.
     * @private
     * @see CheckoutHelperJS.updateCartWait
     */
    keyPressCount: {},

    /**
     * This variable stores the true/false value that indicates if the 'SinglePageCheckout' feature is enabled/disabled.
     * When it is true, both shipping and billing information are captured in a single page. If it is false, checkout will
     * be a two step process where shipping is captured in first step and billing in second step.
     * It is set to true by default.
     *
     * @private
     */
    singlePageCheckout: true,

    /**
     * This array stores the address ID before it is updated by the user during the order check-out.
     * @private
     */
    selectedAddressesArray: {},

    /**
     * This array stores the values that indicate if the payment method input in a payment area has been changed by the user.
     *
     * @private
     */
    dataDirty: {},

    /**
     * This variable stores a value that indicates if the value of a shipping information related input field or the quantity of an item has been changed by the user.
     * Its default value is set to false.
     *
     * @private
     */
    fieldDirtyFlag: false,

    /**
     * This constant stores the String value representing a date that the service understands to reset a requested shipping date.
     * @private
     * @constant
     */
    resetRequestedShipDateValue: "1970-01-01T00:00:00.000Z",

    /**
     * This variable stores the value that indicates if the current page is the Shopping Cart page. It is used to determine what page to redirect to after a service call has been successfully performed.
     *
     * @private
     */
    shoppingCartPage: false,

    /**
     * This variable stores the value that indicates if the current page is the pending order details page. It is used to determine what page to redirect to after a service call has been successfully performed.
     *
     * @private
     */
    pendingOrderDetailsPage: false,

    /**
     * This variable stores the value that indicates if the requested shipping date has recently been updated. It is used to determine if certain area of the page needs to be refreshed.
     */
    RequestShippingDateAction: false,

    /**
     * Indicates whether the ShippingChargeType flexflow is enabled.
     */
    shipChargeEnabled: false,

    /**
     * The order ID.
     */
    tempOrderId: "",
    /**
     * The type of the current user.
     */
    tempUserType: "",
    /**
     * The list of emails spearated by space. Order confirmation will be sent to these emails.
     */
    tempEmailAddresses: "",
    /**
     * Indicates whether it is a Quote that is being checked out.
     */
    tempIsQuote: false,

    /**
     * The current order total.
     */
    tempOrderTotal: "0",

    /**
     * used to check if the zip code is changed
     */
    zipCountShoppingCart : 0,

    /**
     * The payment instructions allocated in the order.
     */
    tempPaymentInstructions: {},
    lastAddressLinkIdToFocus: "",
    lastFocusId: "",
    setLastFocus: function (id) {
        this.lastFocusId = id;
    },
    getLastFocus: function () {
        return this.lastFocusId;
    },
    tabPressed: function (event) {
        if (event.keyCode == 9) {
            tabPressed = true;
        }
    },
    setLastAddressLinkIdToFocus: function (lastLinkId) {
        this.lastAddressLinkIdToFocus = lastLinkId;
    },
    getLastAddressLinkIdToFocus: function () {
        return this.lastAddressLinkIdToFocus;
    },

    /**
     * Indicates whether the order is prepared already or not.
     */
    orderPrepared: "false",

    /**
     * Sets the orderPrepared variable to indicate whether the order has been through the OrderPrepare command or not. An order must be prepared before it can be submitted.
     *
     * @param {Boolean} inPrepareIndicator Whether or not the order has been prepared.
     */
    setOrderPrepared: function (inPrepareIndicator) {
        this.orderPrepared = inPrepareIndicator;
    },

    /**
     * Returns whether or not the order is prepared.
     */
    isOrderPrepared: function () {
        return this.orderPrepared;
    },

    /**
     * Save some variables needed for re-calling checkoutOrder method after a service call.
     *
     * @param {Integer} orderId The order ID.
     * @param {String} userType The type of the current user.
     * @param {String} addressListForMailNotification The list of emails spearated by space. Order confirmation will be sent to these emails.
     * @param {boolean} isQuote Optional parameter which indicates whether it is a Quote that is being checked out. If this parameter is not passed then it defaults to false.
     */
    saveCheckoutOrderParameters: function (orderId, userType, addressListForMailNotification, isQuote) {
        this.tempOrderId = orderId;
        this.tempUserType = userType;
        this.tempEmailAddresses = addressListForMailNotification;
        this.tempIsQuote = isQuote;
    },

    /**
     * Sets some internal variables needed for verifying order totals.
     *
     * @param {Object} orderTotal The current order total.
     * @param {Object} paymentInstructions The currently allocated payment instructions for the order.
     */
    setOrderPayments: function (orderTotal, paymentInstructions) {
        this.tempOrderTotal = orderTotal + 0;
        this.tempPaymentInstructions = paymentInstructions;
    },

    /**
     * Returns whether or not the order total amount has been fully allocated with payment instructions.
     */
    isOrderPaymentFullyAllocated: function () {
        var allocatedAmount = 0;
        if (this.tempPaymentInstructions.paymentInstruction != null && this.tempPaymentInstructions.paymentInstruction.length >= 1) {
            for (var i = 0; i < this.tempPaymentInstructions.paymentInstruction.length; i++) {
                allocatedAmount = allocatedAmount + parseFloat(this.tempPaymentInstructions.paymentInstruction[i].piAmount);
            }
        }

        if (allocatedAmount == this.tempOrderTotal) {
            return true;
        } else {
            var roundedAllocatedAmount = allocatedAmount.toFixed(2);
            var roundedTempOrderTotal = this.tempOrderTotal.toFixed(2);
            if (roundedAllocatedAmount == roundedTempOrderTotal) {
                return true;
            } else {
                if (allocatedAmount < this.tempOrderTotal) {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["EDPPaymentMethods_CANNOT_RECONCILE_PAYMENT_AMT"]);
                    return false;
                } else if (allocatedAmount > this.tempOrderTotal) {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["EDPPaymentMethods_PAYMENT_AMOUNT_LARGER_THAN_ORDER_AMOUNT"]);
                    return false;
                } else {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["EDPPaymentMethods_PAYMENT_AMOUNT_PROBLEM"]);
                    return false;
                }
            }
        }
    },

    /**
     * Returns the value of the internal variable with that name.
     *
     * @param {Object} paramName The value of the internal parameter.
     */
    getSavedParameter: function (paramName) {
        return this[paramName];
    },

    /**
     * Sets the ShipChargeEnabled variable to indicate whether the ShippingChargeType feature is enabled.
     *
     * @param {Boolean} enabled This parameter is set to true if the ShippingChargeType feature is enabled.
     */
    setShipChargeEnabled: function (enabled) {
        this.shipChargeEnabled = enabled;
    },

    /**
     * This function updates the input associative array params with the input key-value pair.
     * If the toArray value is true, this function creates an associative array for duplicate entries; otherwise it overwrites the existing array.
     * The function is used for updating input parameters before passing them to a service call.
     *
     * @param {Array} params The associative array to update.
     * @param {String} key The key to search for in the array.
     * @param {String} value The new value to update with when the key has been found in the array.
     * @param {Boolean} toArray If the value is true, then the function creates a new array for duplicate entries. If the value is false, no new array will be created, the existing array will be overwritten.
     * @param {Integer} index The index in the array in which the value should be updated.
     *
     * @returns {Array} params The updated associative array.
     */
    updateParamObject: function (params, key, value, toArray, index) {
        if (params == null) {
            params = [];
        }

        if (params[key] != null && toArray) {
            if ($.isArrayLike(params[key])) {
                //3rd time onwards
                if (index != null && index != "") {
                    //overwrite the old value at specified index
                    params[key][index] = value;
                } else {
                    params[key].push(value);
                }
            } else {
                //2nd time
                var tmpValue = params[key];
                params[key] = [];
                params[key].push(tmpValue);
                params[key].push(value);
            }
        } else {
            //1st time
            if (index != null && index != "" && index != -1) {
                //overwrite the old value at specified index
                params[key + "_" + index] = value;
            } else if (index == -1) {
                var i = 1;
                while (params[key + "_" + i] != null) {
                    i++;
                }
                params[key + "_" + i] = value;
            } else {
                params[key] = value;
            }
        }
        return params;
    },


    /**
     * This function shows or hides the request shipping date input field depending on the state of the corresponding checkbox.
     * If the checkbox is unchecked, the <code>OrderItemAddressShipMethodUpdate</code> service will be called to update the shipping information.
     *
     * @param {String} checkBoxName The ID of the request shipping date checkbox.
     * @param {String} divName The name of the div element that contains the request shipping date input field.
     * @param {String} suffix The suffix that is appended after the divName. It is usually the order item ID.
     */
    checkRequestShippingDateBox: function (checkBoxName, divName, suffix) {
        var thisCheckBoxName;
        var thisDivName;

        if (suffix != null && suffix != "") {
            checkBoxName = checkBoxName + "_" + suffix;
            divName = divName + "_" + suffix;
        }

        var checkBox = $("#" + checkBoxName)[0];

        if (checkBox.checked) {
            $("#" + divName).css("visibility", "visible");
            $("#" + divName).css("display", "block");
        } else {
            // If the checkbox is unchecked, hide the input field
            $("#" + divName).css("visibility", "hidden");
            $("#" + divName).css("display", "none");
            if (this.shipmentTypeId == "1") {
                $("#requestedShippingDate").blur();
            } else if (this.shipmentTypeId == "2") {
                $("#MS_requestedShippingDate_" + suffix).blur();
            }
        }

        var addressId, shipModeId = "";
        if (this.shipmentTypeId == "1") {
            addressId = document.getElementById("singleShipmentAddress").value;
            shipModeId = document.getElementById("singleShipmentShippingMode").value;
        } else if (this.shipmentTypeId == "2") {
            addressId = document.getElementById("MS_ShipmentAddress_" + suffix).value;
            shipModeId = document.getElementById("MS_ShippingMode_" + suffix).value;
        } else {
            console.debug("shipmentTypeId is undefined. Single shipment has Id 1; multiple shipment has Id 2.");
        }

        // Delete the requestedShippingDate if the checkBox is unchecked
        if (!checkBox.checked) {
            var params = [];
            params["storeId"] = this.storeId;
            params["catalogId"] = this.catalogId;
            params["langId"] = this.langId;
            params.orderId = ".";

            this.updateParamObject(params, "addressId", addressId, false, -1);
            this.updateParamObject(params, "shipModeId", shipModeId, false, -1);

           if($("#requestedShippingDate") != null || $("#MS_requestedShippingDate_" + suffix) != null){
                if(this.shipmentTypeId == "1") {
                    params["requestedShipDate"] = this.resetRequestedShipDateValue;
                } else {
                    this.updateParamObject(params, "requestedShipDate", this.resetRequestedShipDateValue, false, -1);
                }
            }

            var orderItemId = null;
            var qty = -1;
            var totalItems = document.getElementById("totalNumberOfItems").value;
            for (var i = 0; i < totalItems; i++) {
                if (document.getElementById("qty_" + (i + 1)) != null) {
                    qty = document.getElementById("qty_" + (i + 1)).value;
                }
                orderItemId = document.getElementById("orderItem_" + (i + 1)).value;
                // we need atleast one orderItemId..this is the limitation of order service..
                if (qty != -1) {
                    if (this.shipmentTypeId == "1") {
                        // Single Shipment
                        this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
                        break;
                    } else if (this.shipmentTypeId == "2") {
                        // Multiple Shipment
                        if (suffix != null && suffix != "" && orderItemId == suffix) {
                            this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
                            break;
                        }
                    } else {
                        console.debug("shipmentTypeId is undefined. Single shipment has Id 1; multiple shipment has Id 2.");
                    }
                }
            }

            //For handling multiple clicks
            if (!submitRequest()) {
                return;
            }
            cursor_wait();
            CheckoutHelperJS.RequestShippingDateAction = true;
            wcService.invoke("OrderItemAddressShipMethodUpdate", params);
        }
    },


    /**
     * This function shows or hides the shipping instruction input field depending on the state of the corresponding checkbox.
     * If the checkbox is unchecked, the <code>OrderShippingInfoUpdate</code> service will be called to update the shipping information.
     * Note that order items that have the same ship-to address and shipping method will share the same shipping instruction.
     *
     * @param {String} checkBoxName The ID of the shipping instruction checkbox.
     * @param {String} divName The name of the div element that contains the shipping instruction input field.
     * @param {String} suffix The suffix that is appended after the divName. It is usually the order item ID.
     */
    checkShippingInstructionsBox: function (checkBoxName, divName, suffix) {
        //var divName = "shippingInstructionsDiv";
        var thisCheckBoxName;
        var thisDivName;

        if (suffix != null && suffix != "") {
            thisCheckBoxName = checkBoxName + "_" + suffix;
            thisDivName = divName + "_" + suffix;
        } else {
            thisCheckBoxName = checkBoxName;
            thisDivName = divName;
        }

        var thisCheckBox = $("#" + thisCheckBoxName)[0];

        if (thisCheckBox.checked) {
            $("#" + thisDivName).css("visibility", "visible");
            $("#" + thisDivName).css("display", "block");
        } else {
            // If the checkbox is unchecked, hide the input field
            $("#" + thisDivName).css("visibility", "hidden");
            $("#" + thisDivName).css("display", "none");
        }

        // Update other shipping instructions div with same addressId and shipModeId..
        var addressId, shipModeId = "";
        if (this.shipmentTypeId == "1") {
            addressId = document.getElementById("singleShipmentAddress").value;
            shipModeId = document.getElementById("singleShipmentShippingMode").value;
        } else if (this.shipmentTypeId == "2") {
            var orderItemId, tempAddressId, tempShipModeId = "";

            //get current div's shipModeId and addressId..
            addressId = document.getElementById("MS_ShipmentAddress_" + suffix).value;
            shipModeId = document.getElementById("MS_ShippingMode_" + suffix).value;

            var totalItems = document.getElementById("totalNumberOfItems").value;
            for (var i = 0; i < totalItems; i++) {
                if (document.getElementById("qty_" + (i + 1)) != null && document.getElementById("qty_" + (i + 1)).value != -1) {
                    orderItemId = document.getElementById("orderItem_" + (i + 1)).value;
                    tempAddressId = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
                    tempShipModeId = document.getElementById("MS_ShippingMode_" + orderItemId).value;
                    if (tempShipModeId == shipModeId && tempAddressId == addressId) {
                        var tempDivName = divName + "_" + orderItemId;
                        var tempCheckBoxName = checkBoxName + "_" + orderItemId;
                        if (thisCheckBox.checked) {
                            $(tempDivName).css("visibility", "visible");
                            $(tempDivName).css("display", "block");
                            $(tempCheckBoxName).attr("checked", "checked");
                }
                        else {
                            //User doesnt want to specify shipping instructions and requested ship date..hide this div..
                            $("#" + tempDivName).css("visibility", "hidden");
                            $("#" + tempDivName).css("display", "none");
                            $("#" + tempCheckBoxName).attr("checked", "");
                        }
                    }
                }
            }
        } else {
            console.debug("shipmentTypeId is undefined. Single shipment has Id 1; multiple shipment has Id 2.");
        }

        // Delete shippingInstructions if the checkBox is unchecked
        if (!thisCheckBox.checked) {
            var params = [];
            params["storeId"] = this.storeId;
            params["catalogId"] = this.catalogId;
            params["langId"] = this.langId;
            params.orderId = ".";

            var orderItemId = null;
            if (this.shipmentTypeId == "1") {
                if (document.getElementById("shipInstructions") != null) {
                    this.updateParamObject(params, "shipInstructions", "", false);
                    document.getElementById("shipInstructions").value = "";
                }
                orderItemId = document.getElementById("orderItem_1").value;
                this.updateParamObject(params, "addressId", addressId, false);
                this.updateParamObject(params, "orderItemId", orderItemId, false);

            } else if (this.shipmentTypeId == "2") {
                if (suffix != null && suffix != "") {
                    if (document.getElementById("MS_shipInstructions_" + suffix) != null) {
                        this.updateParamObject(params, "shipInstructions", "", false);
                        document.getElementById("MS_shipInstructions_" + suffix).value = "";
                    }
                    this.updateParamObject(params, "addressId", addressId, false, -1);
                    this.updateParamObject(params, "orderItemId", suffix, false);
                    this.setShippingInstuctionsForAllOtherItems(addressId, shipModeId, "");
                }
            } else {
                console.debug("shipmentTypeId is undefined. Single shipment has Id 1; multiple shipment has Id 2.");
            }

            //For handling multiple clicks
            if (!submitRequest()) {
                return;
            }
            cursor_wait();
            wcService.invoke("OrderShippingInfoUpdate", params);
        }
    },


    /**
     * This function sets the shipment type for the current page.
     *
     * @param {Integer} shipmentTypeId The shipment type ID, 1 for single shipment or 2 for multiple shipment.
     *
     * @see CheckoutHelperJS.getShipmentTypeId
     */
    initializeShipmentPage: function (shipmentTypeId) {
        this.shipmentTypeId = shipmentTypeId;
    },


    /**
     * This function sets the common parameters for the current page, i.e. language ID, store ID and catalog ID.
     *
     * @param {Integer} langId The ID of the language that the store currently uses.
     * @param {Integer} storeId The ID of the current store.
     * @param {Integer} catalogId The ID of the catalog.
     */
    setCommonParameters: function (langId, storeId, catalogId) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
    },


    /**
     * This function deletes an order item from the shopping cart.
     * If forWishlist is true, then the item is added to the wish list subsequently by calling the <code>AjaxDeleteOrderItemFromCart</code> service.
     *
     * @param {Integer} orderItemId The ID of the order item to delete.
     * @param {Boolean} forWishlist If the value is true, then the item is added to the wish list.
     */
    deleteFromCart: function (orderItemId, forWishlist) {

        var params = [];
        params.storeId = this.storeId;
        params.catalogId = this.catalogId;
        params.langId = this.langId;
        params.orderId = (this.orderId != null && this.orderId != 'undefined' && this.orderId != "") ? this.orderId : ".";
        params.orderItemId = orderItemId;
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.check = "*n";
        params.calculateOrder = "1";

        var x = document.getElementById("totalNumberOfItems").value;
        var y = x;
        //Now remove free items from this total number of items count..
        //x = total items and y = totalItems - totalFreeItems
        for (var i = 0; i < x; i++) {
            var qtyObj = document.getElementById("freeGift_qty_" + (i + 1));
            if (qtyObj != null || qtyObj != undefined) {
                qty = qtyObj.value;
                if (qty != null && qty != undefined && qty == -1) {
                    y = y - 1;
                }
            }

        }

        if(sessionStorage.barberiniOrderItem == orderItemId)
            sessionStorage.removeItem('barberiniOrderItem');
        
        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        if (isOliver || isCarol){

            if (forWishlist) {
                wcService.invoke("AjaxDeleteOrderItemFromCart", params);
            } else {
                if (this.shoppingCartPage || this.pendingOrderDetailsPage) {
                    wcService.invoke("AjaxDeleteOrderItem", params);
                } else {
                    // HB-3398 : avoid timeout on iphone when vpn is connected.
                    /*$.ajaxSetup({
                        timeout: 2000 //Time in milliseconds
                    });*/ 
                    wcService.invoke("AjaxDeleteOrderItemForShippingBillingPage", params);
                }
            }
            // HB-1050 :: workaround
            //setTimeout(function() { window.location.href = window.location.href; }, 500);

        } else {

            if (y == 1) {
                wcService.invoke("AjaxDeleteOrderItem1", params);
            } else {
                if (forWishlist) {
                    wcService.invoke("AjaxDeleteOrderItemFromCart", params);
                } else {
                    if (this.shoppingCartPage || this.pendingOrderDetailsPage) {
                        wcService.invoke("AjaxDeleteOrderItem", params);
                    } else {
                        wcService.invoke("AjaxDeleteOrderItemForShippingBillingPage", params);
                    }
                }
            }
        }
    },

    /**
     * Only for Persol
     */
    updateDeletePresc: function () {
        var countPrescription = parseInt($("#countPresc").val());
        if (countPrescription <= 2){
            $(".prescription__wrapper-error-msg").hide();
            $("#WC_CheckoutLogonf_div_3").show();
            $(".checkout_or_seperator").show();
            $(".paypal_button_container").show();
        }
    },


    /**
     * This function is used to update the ship-to address ID of all items in the current order when the user chooses to add a new address during order check-out.
     * This function calls the <code>AjaxUpdateOrderItemsAddressId</code> service.
     *
     * @param {Integer} addressId The ID of the newly created address.
     */
    updateAddressIdOFItemsOnCreateEditAddress: function (addressId) {
        if (this.shipmentTypeId == "2" && this.orderItemIds.length == 0) {
            // If this is multiple shipment and none of the orderItems addressId is same as modified addressId, then no need make a service call.
            return;
        }
        var params = [];
        params.orderId = ".";
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";
        if (this.shipmentTypeId == "1") {
            params.addressId = addressId;
        } else {
            var orderItemId = null;
            for (var i = 0; i < this.orderItemIds.length; i++) {
                orderItemId = this.orderItemIds[i];
                this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
                this.updateParamObject(params, "addressId", addressId, false, -1);
            }
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("AjaxUpdateOrderItemsAddressId", params);
    },


    /**
     * This function is used to save the current order items list when the user edits an existing address or creates a new address during order check-out.
     *
     * @param {Integer} orderItemId The order item ID.
     * @param {String} addressId The ID of the address.
     *
     * @private
     */
    saveOrderItemsList: function (orderItemId, addressId) {
        if (orderItemId == '-1') {
            //Creating or editing shipping address for single shipment, get all the orderItemIds in the order..

            var totalItems = document.getElementById("totalNumberOfItems").value;
            // if order item section is collapsed, we only have data for the first order item. And this is the case for single shipment so it
            // is ok just to update orderItem_1
            this.orderItemIds[0] = document.getElementById("orderItem_1").value;

        } else if (orderItemId == 0 && this.shipmentTypeId == "1") {
            // Editing or creating billing address.. If it's single shipment type, then we need to save all orderItem Id's.
            // If the shipping address is same as this billing address which is edited, then after editing this addressId will change, so we need to update the orderItemIds.

            if (document.getElementById("singleShipmentAddress")) {
                if (addressId == document.getElementById("singleShipmentAddress").value) {
                    var totalItems = document.getElementById("totalNumberOfItems").value;
                    for (var i = 0; i < totalItems; i++) {
                        this.orderItemIds[i] = document.getElementById("orderItem_" + (i + 1)).value;
                    }
                } else {
                    this.orderItemIds = [];
                }
            } else {
                this.orderItemIds = [];
            }
            return;
        } else {
            // OrderItemId is passed..so it's multiple shipment, get all the orderItemIds with the same address...
            // This section is for multiple shipment and create/edit both shipping/billing address...
            var totalItems = document.getElementById("totalNumberOfItems").value;
            var temp = null;
            var orderItemId = null;
            var j = 0;

            //saving orderItemIds (used by this.updateAddressIdOFItemsOnCreateEditAddress) for  the'edit address' link
            for (var i = 0; i < totalItems; i++) {
                orderItemId = document.getElementById("orderItem_" + (i + 1)).value;
                if (document.getElementById("MS_ShipmentAddress_" + orderItemId)) {
                    temp = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
                    //addressId is -1 if 'create address' is clicked. The following if will always return false in that case.
                    if (temp == addressId) {
                        //Add this to our list..
                        this.orderItemIds[j++] = orderItemId;
                    }
                }
            }
        }
    },


    /**
     * By convention, all items in an order that have the same shipping address and shipping mode share the same shipping instruction.
     * This function is used to update the shipping instruction of all items that have the same shipping address and shipping mode.
     *
     * @param {Integer} addressId The shipping address ID.
     * @param {Integer} shipModeId The shipping mode ID.
     * @param {String} shipInstructions The shipping instruction.
     */
    setShippingInstuctionsForAllOtherItems: function (addressId, shipModeId, shipInstructions) {

        var orderItemId, addressId1, shipModeId1 = "";
        var totalItems = document.getElementById("totalNumberOfItems").value;
        for (var i = 0; i < totalItems; i++) {
            if (document.getElementById("qty_" + (i + 1)) != null && document.getElementById("qty_" + (i + 1)).value != -1) {
                orderItemId = document.getElementById("orderItem_" + (i + 1)).value;
                addressId1 = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
                shipModeId1 = document.getElementById("MS_ShippingMode_" + orderItemId).value;
                if (shipModeId1 == shipModeId && addressId1 == addressId) {
                    document.getElementById("MS_shipInstructions_" + orderItemId).value = shipInstructions;
                }
            }
        }
    },


    /**
     * When a user toggles the 'ship as complete' checkbox, the same will be updated at the server side by invoking the <code>OrderShippingInfoUpdate</code> service.
     *
     * @param {DOM Element} checkBox The 'ship as complete' checkbox object.
     */
    shipAsComplete: function (checkBox) {
        var params = [];
        params.orderId = ".";
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.calculateOrder = "1";
        if (checkBox.checked) {
            this.updateParamObject(params, "ShipAsComplete", "true", true);
        } else {
            this.updateParamObject(params, "ShipAsComplete", "false", true);
        }
        orderItemId = document.getElementById("orderItem_1").value;
        this.updateParamObject(params, "orderItemId", orderItemId, false);

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderShippingInfoUpdate", params);
    },


    /**
     * When there is an invalid address ID in an order, this function updates all items to use the valid address ID by invoking the <code>AjaxSetAddressIdOfOrderItems</code> service.
     *
     * @param {Integer} addressId A valid address ID.
     */
    updateAddressIdForOrderItem: function (addressId) {
        if (addressId == null || addressId.length == 0) {
            return true;
        }

        var params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        this.updateParamObject(params, "addressId", addressId, false);
        wcService.invoke("AjaxSetAddressIdOfOrderItems", params);
    },


    /**
     * When there is an invalid shipping mode ID in an order, this function updates all items to use the valid shipping mode ID by invoking the <code>AjaxSetShipModeIdForOrder</code> service.
     *
     * @param {Integer} shipModeId A valid shipping mode ID.
     */
    updateShipModeIdForOrder: function (shipModeId) {
        var params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params["shipModeId"] = shipModeId;
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";
        wcService.invoke("AjaxSetShipModeIdForOrder", params);
    },

    /**
     * When there is an inconsistent requested ship date in an order when multiple shipment is disabled,
     * this function updates all items to use the the same date by invoking the <code>AjaxSetRequestedShipDateForOrder</code> service.
     *
     * @param {String} date The String representation of the requested ship date
     */
    updateRequestedShipDateForOrder: function (date) {
        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        if (date != "") {
            this.updateParamObject(params, "requestedShipDate", date, false);
        } else {
            this.updateParamObject(params, "requestedShipDate", this.resetRequestedShipDateValue, false);
        }

        wcService.invoke("AjaxSetRequestedShipDateForOrder", params);
    },



    /**
     * This function is used to apply a promotion code to the order.
     *
     * @param {String} formName The name of the promotion code entry form.
     * @param {String} returnView   The name of the view that the server should redirect the browser to after a promotion code is applied.
     */
    applyPromotionCode: function (formName, orderId) {

        var form = document.forms[formName];
        form.promoCode.value = trim(form.promoCode.value);
        
        /* START - Early Access */
        if((isVogue || isPersol) && document.cookie.includes('X_WC_PR_SEGMENTS')){
        	var eaPromoCodeFlag=true;
           /* if (form.promoCode.value == 'NL-EA21-11' || form.promoCode.value == 'WCL-EA21-11' || form.promoCode.value == 'PFM-EA21-11'){
            	eaPromoCodeFlag = true;
            } else eaPromoCodeFlag = false;
        	*/
        	errorMessage = (eaPromoCodeFlag == true) ? $('#early_access_text').attr('value') : $('#generic_error_text').attr('value');
        	$(form.promoCode).addClass("error");
        	addErrorMessageToElement(document.forms.PromotionCodeForm, errorMessage);
        	if (eaPromoCodeFlag == true){
	        	$('#PromotionCodeForm input#promoCode.error, #PromotionCodeForm input#coupon-value.error').addClass('ea_input');
	        	$('#PromotionCodeForm .error-message').addClass('ea_message');
        	}
            restoreAjaxButton("WC_PromotionCodeDisplay_links_1");
            return;
        }else{
        /* END - Early Access */
        //TODO Commonize this 'if'
        
        if (isCarol){
            if (form.promoCode.value == "") {
                MessageHelper.formErrorHandleClient(form.promoCode.id, MessageHelper.messages["PROMOTION_CODE_EMPTY"]);
                return;
            }
        } else {
            var promoCodeValue = form.promoCode.value;
            $(form.promoCode).removeClass("error");
            removeErrorMessagesFromElement(document.forms.PromotionCodeForm);

            var errorMessage = "";

            if (promoCodeValue == ""){
                errorMessage = MessageHelper.messages["PROMOTION_CODE_EMPTY"];
            } else if (promoCodeValue.toUpperCase().includes("IDME_")){
                // Avoid users to manualy insert promocodes that could be valid IDME promocodes
                errorMessage = "Code not allowed";
            }

            if (errorMessage != "") {
                $(form.promoCode).addClass("error");
                addErrorMessageToElement(document.forms.PromotionCodeForm, errorMessage);
                restoreAjaxButton("WC_PromotionCodeDisplay_links_1");
                return;
            }
        }

        service = wcService.getServiceById('AjaxPromotionCodeManage');

        var params = [];
        params["taskType"] = "A";
        params["promoCode"] = trim(form.promoCode.value);
        params["storeId"] = WCParamJS.storeId;
        params["catalogId"] = WCParamJS.catalogId;
        params["langId"] = WCParamJS.langId;
        params["orderId"] = orderId;

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke('AjaxPromotionCodeManage', params);
    	}
    },


    /**
     * This function is used to remove a promotion code from the order.
     *
     * @param {String} promoCode    The promotion code to remove.
     */
    removePromotionCode: function (promoCode, orderId) {
        sessionStorage.removeItem('Order_DiscountCode');
        sessionStorage.removeItem('Order_DiscountName');
        var params = [];
        params["taskType"] = "R";
        params["promoCode"] = promoCode;
        params["storeId"] = WCParamJS.storeId;
        params["catalogId"] = WCParamJS.catalogId;
        params["langId"] = WCParamJS.langId;
        params["orderId"] = orderId;

       //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke('AjaxPromotionCodeDelete',params);

    },


    /**
     * If a customer has a coupon in his/her coupon wallet that has not been applied to an order then this function can be used to apply that coupon to the current order.
     *
     * @param {String} formName The name of the form that performs the action to apply the coupon, and holds the parameters to pass to the service.
     * @param {String} returnView The view to return to after the request has been processed.
     * @param {Integer} couponId The unique ID of the coupon. This is set into the form to be sent to the service.
     */
    applyCoupon: function (formName, returnView, couponId) {
        var form = document.forms[formName];
        form.setAttribute('action', 'CouponsAddRemove');
        form.couponId.value = couponId;
        form.taskType.value = "A";

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }

        service = wcService.getServiceById('AjaxCouponsAdd');
        service.setFormId(formName);
        cursor_wait();
        wcService.invoke('AjaxCouponsAdd');
    },


    /**
     * If a customer has a coupon in his/her coupon wallet that has been applied to an order then this function can be used to remove that coupon from the current order.
     *
     * @param {String} formName The name of the form that performs the action to remove the coupon from the order, and holds the parameters to pass to the service.
     * @param {String} returnView The view to return to after the request has been processed.
     * @param {Integer} couponId The unique ID of the coupon. This is set into the form to be sent to the service.
     */
    removeCouponFromOrder: function (formName, returnView, couponId) {
        var form = document.forms[formName];
        form.setAttribute('action', 'CouponsAddRemove');
        form.couponId.value = couponId;
        form.taskType.value = "R";

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }

        service = wcService.getServiceById('AjaxCouponsRemove');
        service.setFormId(formName);
        cursor_wait();
        wcService.invoke('AjaxCouponsRemove');
    },


    /**
     * Sets the SinglePageCheckout variable to indicate if the 'SinglePageCheckout' feature is enabled or disabled.
     *
     * @param {Boolean} singlePageCheckout. A true/false value that indicates if the 'SinglePageCheckout' feature is enabled.
     *
     * @see CheckoutHelperJS.isSinglePageCheckout
     */
    setSinglePageCheckout: function (singlePageCheckout) {
        this.singlePageCheckout = singlePageCheckout;
    },


    /**
     * Returns the singlePageCheckout variable that indicates if the 'SinglePageCheckout' feature is enabled/disabled.
     *
     * @returns {Boolean} singlePageCheckout A true/false value that indicates if the 'SinglePageCheckout' feature is
     * enabled/disabled.
     *
     * @see CheckoutHelperJS.setSinglePageCheckout
     */
    isSinglePageCheckout: function () {
        return this.singlePageCheckout;
    },


    /**
     * This function is used to submit the order by invoking the <code>AjaxSubmitOrder</code> service.
     *
     * @param {Integer} orderId The order ID.
     * @param {String} userType The type of the current user.
     * @param {String} addressListForMailNotification The list of emails separated by space. Order confirmation will be sent to these emails.
     * @param {boolean} isQuote Optional parameter which indicates whether it is a Quote that is being checked out. If this parameter is not passed then it defaults to false.
     */
    checkoutOrder: function (orderId, userType, addressListForMailNotification, isQuote) {
        if (isQuote == undefined || isQuote == null) {
            isQuote = false;
        }

        if (!this.isOrderPaymentFullyAllocated()) {
            return;
        }

        if (this.isOrderPrepared() == "false") {
            this.saveCheckoutOrderParameters(orderId, userType, addressListForMailNotification, isQuote);
            wcService.invoke("AjaxPrepareOrderForSubmit");
            return;
        }

        params = [];
        params["orderId"] = orderId;
        params["notifyMerchant"] = 1;
        params["notifyShopper"] = 1;
        params["notifyOrderSubmitted"] = 1;
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;

    var authToken = $("#PaymentsAndBill_authToken").val();
        params["authToken"] = authToken;
        var purchaseOrderForm = document.forms["purchaseOrderNumberInfo"];
        if (purchaseOrderForm) {
            var purchaseOrderNumber = purchaseOrderForm.purchase_order_number.value;
            if (purchaseOrderForm.purchaseOrderNumberRequired.value == 'true' && purchaseOrderForm.purchase_order_number.value == "") {
                MessageHelper.formErrorHandleClient(purchaseOrderForm.purchase_order_number, MessageHelper.messages["ERROR_PONumberEmpty"]);
                return;
        }
            else if (!MessageHelper.isValidUTF8length(purchaseOrderForm.purchase_order_number.value, 128)) {
                MessageHelper.formErrorHandleClient(purchaseOrderForm.purchase_order_number, MessageHelper.messages["ERROR_PONumberTooLong"]);
                return;
            }
        }
        params["purchaseorder_id"] = purchaseOrderNumber;
        if (userType == 'G') {
            //addressListForMailNotification contains list of emailId's spearated by space.. remove leading or trailing spaces..
            addressListForMailNotification = trim(addressListForMailNotification);

            //Get the space separated email list in an array...
            var emailList = [];
            emailList = addressListForMailNotification.split(" ");

            //Now from this array, remove repeated email Id's.. keep only unique email Id's
            var uniqueList = [];
            for (var j = 0; j < emailList.length; j++) {
                uniqueList[emailList[j]] = emailList[j];
            }

            //Get the total length of unique email id's list..
            var totalLength = 0;
            for (i in uniqueList) {
                totalLength = totalLength + 1;
            }

            //Convert the unique List array into comma separated values...
            var temp = "";
            var k = 0;
            for (i in uniqueList) {
                k = k + 1;
                temp = temp + uniqueList[i];
                if (k < totalLength) {
                    //If not last value, add , before next value..
                    temp = temp + ",";
                }
            }
            //For guest user send the email list..
            params["notify_EMailSender_recipient"] = temp;

            //setup sms phone for service
            var smsOrderNotificationCheckbox = document.getElementById("sendMeSMSNotification");
            if (smsOrderNotificationCheckbox != null && smsOrderNotificationCheckbox != "undefined") {
                if (smsOrderNotificationCheckbox.checked) {
                    var mobileCountryCode = document.getElementById("mobileCountryCode");
                    var mobilePhone1 = document.getElementById("mobilePhone1");
                    if (mobileCountryCode != null && mobileCountryCode != "undefined" && mobilePhone1 != null && mobilePhone1 != "undefined") {
                        params["SMS"] = mobileCountryCode.value + mobilePhone1.value;
                    }
                }
            }
        }


        //For handling multiple clicks
        /*
        if (!submitRequest()) {
            return;
        }
        */
        cursor_wait();

        if (!isQuote) {
            wcService.invoke("AjaxSubmitOrder", params);
        } else {
            params["URL"] = "";
            this.setOrderId(orderId);
            wcService.invoke("AjaxSubmitQuote", params);
        }
    },


    /**
     * Validates the scheduled start date and sets the cookies that are used to retrieve the start date and interval of a scheduled order.
     */
    prepareOrderSchedule: function () {
        if (document.getElementById("scheduleOrderInputSection") != null) {
            var scheduleOrderStartDateObj = $("#ScheduleOrderStartDate")[0];
            if (!this.validateDate(scheduleOrderStartDateObj, 'ScheduleOrderStartDate')) {
                return;
            }

            var interval = $("#ScheduleOrderFrequency").val();

            var key1 = "WC_ScheduleOrder_" + document.getElementById("orderIdToSchedule").value + "_strStartDate";
            var key2 = "WC_ScheduleOrder_" + document.getElementById("orderIdToSchedule").value + "_interval";

            if ((interval == "undefined") && (scheduleOrderStartDateObj.value == null)) {
                // if the order interval is '' and the specified start date is empty, remove the cookies
                   setCookie(key1, null, {expires: -1});
                   setCookie(key2, null, {expires: -1});
            } else {
                var t = $(scheduleOrderStartDateObj).datepicker("getDate");
                var now = new Date();

                t.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());

                // set start date in zulu time
                t = t.toISOString();
                setCookie(key1, t, {
                    path: "/",
                    domain: cookieDomain
                });
                setCookie(key2, interval, {
                    path: "/",
                    domain: cookieDomain
                });
            }
        }
    },


    /**
     * Schedules an order.
     *
     * @param {Integer} orderId The order ID of the scheduled order.
     * @param {String} isRecurring The flag to identify a recurring order.
     * @param {String} userType The type of the user.
     */
    scheduleOrder: function (orderId, isRecurring, userType) {
        if (!this.isOrderPaymentFullyAllocated()) {
            return;
        }
        if (userType === "G" && isRecurring) {
            MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_GUEST_USER_SUBMIT_RECURRING_ORDER"]);
            return;
        }
        var params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params["orderId"] = orderId;

    var authToken = $("#PaymentsAndBill_authToken").val();
        params["authToken"] = authToken;
        if (isRecurring != undefined && isRecurring == true) {
            params["startDate"] = getCookie("WC_ScheduleOrder_" + orderId + "_strStartDate");
            if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '1') {
                params["fulfillmentInterval"] = '1';
                params["fulfillmentIntervalUOM"] = 'DAY';
                params["timePeriod"] = '1';
                params["timePeriodUOM"] = 'DAY';
            } else if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '2') {
                params["fulfillmentInterval"] = '1';
                params["fulfillmentIntervalUOM"] = 'DAY';
            } else if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '3') {
                params["fulfillmentInterval"] = '1';
                params["fulfillmentIntervalUOM"] = 'WEE';
            } else if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '4') {
                params["fulfillmentInterval"] = '2';
                params["fulfillmentIntervalUOM"] = 'WEE';
            } else if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '5') {
                params["fulfillmentInterval"] = '3';
                params["fulfillmentIntervalUOM"] = 'WEE';
            } else if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '6') {
                params["fulfillmentInterval"] = '4';
                params["fulfillmentIntervalUOM"] = 'WEE';
            }
        }
         else {
            params["strStartDate"] = getCookie("WC_ScheduleOrder_" + orderId + "_strStartDate");
            params["interval"] = getCookie("WC_ScheduleOrder_" + orderId + "_interval");
        }


        var purchaseOrderForm = document.forms["purchaseOrderNumberInfo"];
        if (purchaseOrderForm) {
            var purchaseOrderNumber = purchaseOrderForm.purchase_order_number.value;
            if (purchaseOrderForm.purchaseOrderNumberRequired.value == 'true' && purchaseOrderForm.purchase_order_number.value == "") {
                MessageHelper.formErrorHandleClient(purchaseOrderForm.purchase_order_number, MessageHelper.messages["ERROR_PONumberEmpty"]);
                return;
            } else if (!MessageHelper.isValidUTF8length(purchaseOrderForm.purchase_order_number.value, 128)) {
                MessageHelper.formErrorHandleClient(purchaseOrderForm.purchase_order_number, MessageHelper.messages["ERROR_PONumberTooLong"]);
                return;
            }
            params["purchaseorder_id"] = purchaseOrderNumber;
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        if (isRecurring != undefined && isRecurring == true) {
            wcService.invoke("SubmitRecurringOrder", params);
        } else {
            wcService.invoke("ScheduleOrder", params);
        }
    },


    /**
     * Checks if a date occurred in the past.
     *
     * @param {Object} dateObj The date object to be validated.
     * @param {String} elementId The ID of the element that an error message would be attached to.
     */
    validateDate: function (dateObj, elementId) {
        var now = new Date();
        if ($(dateObj).datepicker("getDate") != null && ($(dateObj).datepicker("getDate") - now < 0)) {
            //if the date is the current date, then it is valid
            if (now.toDateString() === $(dateObj).datepicker("getDate").toDateString()) {
                return true;
            }

            if ((elementId != null) && (document.getElementById(elementId) != null)) {
                MessageHelper.formErrorHandleClient(document.getElementById(elementId).id, MessageHelper.messages["PAST_DATE_ERROR"]);
            } else {
                MessageHelper.displayErrorMessage(MessageHelper.messages["PAST_DATE_ERROR"]);
            }
            return false;
        } else {
            return true;
        }
    },

    /**
     * Creates a new address during order check-out.
     *
     * @param {Integer} orderItemId The order item ID for a multiple shipment scenario, or 0 to indicate a shipping address needs to be created, or 1 to indicate a billing address needs to be created.
     * @param {String} addressType The type of the address to be created.
     */
    createAddress: function (orderItemId, addressType) {
        this.saveOrderItemsList(orderItemId, "-1");

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        var checkForOpera = true; //require a check of whether the browser is opera or not
        cursor_wait(checkForOpera);
        wcRenderContext.updateRenderContext('editShippingAddressContext', {
            'shippingAddress': '-1',
            'addressType': addressType
        });
        //Hide the mainContents (contains shipping/billing details, shop cart details, promotion details, orderDetails)
        this.showHideDivs('editAddressContents', 'mainContents');
    },


    /**
     * This function is used to show an area and hide an area on the current page.
     *
     * @param {String} showArea The ID of the area to show.
     * @param {String} hideArea The ID of the area to hide.
     *
     * @private
     */
    showHideDivs: function (showArea, hideArea) {
        document.getElementById(hideArea).style.display = "none";
        document.getElementById(showArea).style.display = "block";
    },


    /**
     * Restores the previous address details when a user cancels editing an existing address or cancels creating a new address.
     *
     * @see CheckoutHelperJS.cancelEditAddress
     */
    restorePreviousAddressDetails: function () {

        //For Ajax flow when the previous shipping address is not available in the array
        //Save the addresses present on server side only.. on change of address the server will be updated in ajax checkout..so can use
        //the address from server side only..
        if (this.shipmentTypeId == "2") {
            for (var i = 0; i < this.orderItemIds.length; i++) {
                //Get the orderItemId
                var orderItemId = this.orderItemIds[i];
                var element = document.getElementById("MS_ShipmentAddress_" + orderItemId);

                if (element != null && element.value == -1) {
                    //IF createAddress is selected in this box, then restore it to previously selected value..
                    element.value = document.getElementById("addressId_" + orderItemId).value;
                }
            }
        } else if (this.shipmentTypeId == "1") {
            var element = document.getElementById("singleShipmentAddress");
            if (element != null && document.getElementById("addressId_all")) {
                element.value = document.getElementById("addressId_all").value;
            }
        }

        //Restore the original billing address(es) that was updated on the server
        for (var i = 1; i < 4; i++) {
            //Find the payment forms that are present on the page
            if (document.getElementById("PaymentForm" + i) != null) {
                var paymentForm = document.getElementById("PaymentForm" + i);
                //Restore the selected billing address if it "create address" was selected
                if (paymentForm.billing_address_id.value == -1) {
                    paymentForm.billing_address_id.value = document.getElementById("selectedAddressId_" + i).value;
                }
                if (wcRenderContext.getRenderContextProperties("billingAddressDropDownBoxContext")["billingAddress" + i] == -1) {
                    wcRenderContext.getRenderContextProperties("billingAddressDropDownBoxContext")["billingAddress" + i] = paymentForm.billing_address_id.value;
                }
            }
        }
    },


    /**
     * This function is used when a user edits an existing shipping address during check-out.
     *
     * @param {String} addressSelectBoxName The ID of the address drop-down object.
     * @param {Integer} orderItemId The item ID. It is required in the a multiple shipment scenario.
     * @param {String} profileshipping The name of the quick checkout profile shipping address.
     * @param {String} profilebilling The name of the quick checkout profile billing address.
     */
    editAddress: function (addressSelectBoxName, orderItemId, profileshipping, profilebilling) {
        var addressBox = document.getElementById(addressSelectBoxName);

        //We need to save order Items having this addressId..bcs if user edits this address then the id of this address changes..
        //so all order items needs to be updated with new id.
        this.saveOrderItemsList(orderItemId, addressBox.value);

        // the quick checkout address nick name is hardcoded here..it should be same as that used in quick checkout profile page..
        if (addressBox.options[addressBox.selectedIndex].text == profileshipping || addressBox.options[addressBox.selectedIndex].text == profilebilling) {
            if (addressSelectBoxName != null) {
                MessageHelper.formErrorHandleClient(addressSelectBoxName, MessageHelper.messages["ERROR_QUICKCHECKOUT_ADDRESS_CHANGE"]);
            } else {
                MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_QUICKCHECKOUT_ADDRESS_CHANGE"]);
            }
            return;
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        //Update the display area context..
        cursor_wait();
        wcRenderContext.updateRenderContext('editShippingAddressContext', {
            'shippingAddress': addressBox.value,
            'addressType': 'Shipping'
        });

        //Hide the mainContents (contains shipping/billing details, shop cart details, promotion details, orderDetails)
        this.showHideDivs('editAddressContents', 'mainContents');
    },


    /**
     * This function is used when a user edits an existing billing address during check-out.
     *
     * @param {Integer} orderItemId The item ID.
     * @param {Integer} paymentArea The payment area number that this billing address belongs to.
     * @param {String} profileshipping The name of the quick checkout profile shipping address.
     * @param {String} profilebilling The name of the quick checkout profile billing address.
     */
    editBillingAddress: function (orderItemId, paymentArea, profileshipping, profilebilling) {
        var form = document.forms["PaymentForm" + paymentArea];
        var addressBox = form.billing_address_id;
        //We need to save order Items having this addressId..bcs if user edits this address then the id of this address changes..
        //so all order items needs to be updated with new id..
        this.saveOrderItemsList(orderItemId, addressBox.value);
        // the quick checkout address nick name is hardcoded here..it should be same as that used in quick checkout profile page..
        if (addressBox.options[addressBox.selectedIndex].text == profileshipping || addressBox.options[addressBox.selectedIndex].text == profilebilling) {
            if (addressBox != null) {
                MessageHelper.formErrorHandleClient(addressBox, MessageHelper.messages["ERROR_QUICKCHECKOUT_ADDRESS_CHANGE"]);
            } else {
                MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_QUICKCHECKOUT_ADDRESS_CHANGE"]);
            }
            return;
        }

        var billingAddressId = addressBox.value;
        var shippingAddressId = (document.getElementById("singleShipmentAddress")) ? document.getElementById("singleShipmentAddress").value : "noAddress";
        var addressType = (billingAddressId == shippingAddressId) ? "ShippingAndBilling" : "Billing";
        /*
        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        */
        //Update the display area context..
        cursor_wait();
        wcRenderContext.updateRenderContext('editShippingAddressContext', {
            'shippingAddress': addressBox.value,
            'addressType': addressType
        });
        //Hide the mainContents (contains shipping/billing details, shop cart details, promotion details, orderDetails)
        this.showHideDivs('editAddressContents', 'mainContents');
    },

    /**
     * When a user cancels editing an address, this function is called to hide the address entry form and show the original main content of the page, then calls restorePreviousAddressDetails to restore the previous address.
     *
     * @see CheckoutHelperJS.restorePreviousAddressDetails
     */
    cancelEditAddress: function () {
        this.showHideDivs('mainContents', 'editAddressContents');
        this.restorePreviousAddressDetails();
        if (this.getLastAddressLinkIdToFocus() != null && this.getLastAddressLinkIdToFocus() != 'undefined' && this.getLastAddressLinkIdToFocus() != '') {
            document.getElementById(this.getLastAddressLinkIdToFocus()).focus();
            this.setLastAddressLinkIdToFocus('');
        }
    },

    /**
     * This function gets the shipment type Id for the order. Shipment type Id 1 is for single shipment, 2 for multiple shipment.
     *
     * @see CheckoutHelperJS.initializeShipmentPage
     */
    getShipmentTypeId: function () {
        return this.shipmentTypeId;
    },


    /**
     * Sets the dataDiry flag to indicate if payment information in the specified payment form area has been changed by the user.
     * This method should be used for payment methods involving credit card.
     * @param {Integer} paymentAreaNumber The unique payment area number.
     * @param {Boolean} flag A true/false value to indicate if the payment method input has been changed.
     *
     * @see CheckoutHelperJS.isPaymentDataDirty
     */
    paymentDataDirty: function (paymentAreaNumber, flag) {
        this.dataDirty[paymentAreaNumber] = flag;
        console.debug("Information in payment area " + paymentAreaNumber + " has been modified.");
    },

    /**
     * Returns the dataDiry flag that indicates if payment information in the specified payment form area has been changed by the user.
     *
     * @param {Integer} paymentAreaNumber The unique payment area number.
     *
     * @see CheckoutHelperJS.paymentDataDirty
     */
    isPaymentDataDirty: function (paymentAreaNumber) {
        return this.dataDirty[paymentAreaNumber];
    },


    /**
     * Sets fieldDirtyFlag to indicates if the value of a shipping information related input field or the quantity of an item has been changed by the user.
     *
     * @param {Boolean} value A true/false value that indicates if the value of a shipping information related input field or the quantity of an item has been changed by the user.
     *
     * @see CheckoutHelperJS.getFieldDirtyFlag
     */
    setFieldDirtyFlag: function (value) {
        this.fieldDirtyFlag = value;
    },


    /**
     * Returns fieldDirtyFlag that indicates if the value of a shipping information related input field or the quantity of an item has been changed by the user.
     *
     * @returns {Boolean} fieldDirtyFlag A true/false value that indicates if the value of a shipping information related input field or the quantity of an item has been changed by the user.
     *
     * @see CheckoutHelperJS.setFieldDirtyFlag
     */
    getFieldDirtyFlag: function () {
        return this.fieldDirtyFlag;
    },


    /**
     * Verifies if the dirty flag is set to true, such as when a customer changes shipping information. If the dirty
     * flag is set to true, a message displays prompting the customer to update their current order before they continue
     * to checkout. This function is used in a non-AJAX checkout flow.
     *
     * @return {Boolean} Return true if the dirty flag is set to true.
     */
    checkForDirtyFlag: function () {
        if (this.getFieldDirtyFlag()) {
            if (document.getElementById("ShoppingCart_NonAjaxUpdate") != null) {
                MessageHelper.formErrorHandleClient(document.getElementById("ShoppingCart_NonAjaxUpdate"), MessageHelper.messages["ERROR_UPDATE_FIRST_SHOPPING_CART"]);
                return true;
            } else if (document.getElementById("MultipleShipment_NonAjaxShipInfoUpdate") != null) {
                MessageHelper.formErrorHandleClient(document.getElementById("MultipleShipment_NonAjaxShipInfoUpdate"), MessageHelper.messages["ERROR_UPDATE_FIRST"]);
                return true;
            } else if (document.getElementById("SingleShipment_NonAjaxShipInfoUpdate") != null) {
                MessageHelper.formErrorHandleClient(document.getElementById("SingleShipment_NonAjaxShipInfoUpdate"), MessageHelper.messages["ERROR_UPDATE_FIRST"]);
                return true;
            } else {
                MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_UPDATE_FIRST"]);
                return true;
            }
        }
        return false;
    },


    /**
     * This function is used to show or hide the SMS phone number field section for guest shoppers in the
     * order summary page.
     * @param {DOM Element Id} checkboxElementId The id of the checkbox for getting SMS order notifications.
     * @param {DOM Element Id} smsElementId The id of the element that contains the SMS phone number field.
     */
    showHideCheckoutSMS: function (checkboxElementId, smsElementId) {
        var smsOrderNotificationCheckbox = document.getElementById(checkboxElementId);
        if (smsOrderNotificationCheckbox != null && smsOrderNotificationCheckbox != "undefined") {
            if (smsOrderNotificationCheckbox.checked) {
                showElementById(smsElementId);
            } else {
                hideElementById(smsElementId);
            }
        }

    },

    /**
     * This function return an array of countries from a global variable called countries.
     * If that variable does not already exist then it will be created and populated from a JSON of country objects which should
     * have been loaded into a div on the page prior to calling this function.
     *
     * @returns {Array} countries An array of countries.
     **/
    getCountryArray: function () {
        //If the countries array does not already exist then create it.
        if (document["countries"] == null) {
            countries = new Array();
            var theDiv = document.getElementById("countryListSelectionHelper");

            if (typeof theDiv == 'undefined') return null;
            var divJSON = eval('(' + theDiv.innerHTML + ')');
            var countriesObject = divJSON.countries;

            for (var i = 0; i < countriesObject.length; i++) {
                var countryObject = countriesObject[i];
                countries[countryObject.code] = new Object();
                countries[countryObject.code].name = countryObject.displayName;
                countries[countryObject.code].countryCallingCode = countryObject.callingCode;

                if (countryObject.states.length > 0) {
                    countries[countryObject.code].states = new Object();
                    for (var j = 0; j < countryObject.states.length; j++) {
                        var state = countryObject.states[j];
                        countries[countryObject.code].states[state.code] = state.displayName;
                    }
                }
            }
        }

        return countries;
    },

    /**
     *  This function populates the country code to mobile phone based on the selected country.
     *  @param {string} countryDropDownId The id of the mobile country drop down list
     *  @param {string} countryCallingCodeId The id of the mobile country calling code text box.
     */
    loadCountryCode: function (countryDropDownId, countryCallingCodeId) {
        this.getCountryArray();
        var countryCode = document.getElementById(countryDropDownId).value;
        document.getElementById(countryCallingCodeId).value = countries[countryCode].countryCallingCode;
    },


    /**
     * Invokes the OrderShippingInfoUpdate service to expedite shipping for the selected order item.
     *
     * @param {DOM Element} checkBox The Expedite Shipping check-box object.
     * @param {String} inputOrderItemId The ID of the order item for which you want to expedite shipping.
     */
    expediteShipping: function (checkBox, inputOrderItemId) {

        var params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;

        if (checkBox.checked) {
            this.updateParamObject(params, "isExpedited", "true", true);
        } else {
            this.updateParamObject(params, "isExpedited", "false", true);
        }
        if (inputOrderItemId != null) {
            this.updateParamObject(params, "orderItemId", inputOrderItemId, false);
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderShippingInfoUpdate", params);
    },


    /************************************************************
     * The following methods are used on the Shopping Cart page
     ************************************************************/

    /**
     * This function updates the total on the shopping cart page when the quantity of an item has been changed.
     * It updates the total by calling <code>updateCart</code> after <code>updateWaitTimeOut</code> milliseconds have passed.
     *
     * @param {DOM Element} quantityBox The quantity input text field.
     * @param {Integer} orderItemId The ID of the order item to update.
     * @param {Object} event A keyboard event object.
     *
     * @see CheckoutHelperJS.updateCart
     */
    updateCartWait: function (quantityBox, orderItemId, event) {
        //Arrows are escaped for keyboard accesibility of table
        if (event.keyCode == KeyCodes.TAB ||
            event.keyCode == KeyCodes.DOWN_ARROW ||
            event.keyCode == KeyCodes.UP_ARROW ||
            event.keyCode == KeyCodes.LEFT_ARROW ||
            event.keyCode == KeyCodes.RIGHT_ARROW
        ) return;

        //Key pressed.. update the flag
        if (this.keyPressCount[orderItemId] == null && isNaN(this.keyPressCount[orderItemId])) {
            this.keyPressCount[orderItemId] = 0;
        }
        this.keyPressCount[orderItemId] = parseInt(this.keyPressCount[orderItemId]) + 1;
        setTimeout($.proxy(this, "updateCart", quantityBox, orderItemId, this.keyPressCount[orderItemId]), this.updateWaitTimeOut);
    },


    /**
     * This function updates the total on the shopping cart page when the quantity of an item has been changed.
     * It updates the shopping cart by calling the <code>AjaxUpdateOrderItem</code> service.
     *
     * @param {DOM Element} quantityBox The quantity input text field.
     * @param {Integer} orderItemId The ID of the order item to update.
     * @param {Integer} keyPressCountValue The count of keyPress events. If there are more keyPress events after this event was fired, then this function just returns without doing anything.
     */
    updateCart: function (quantityBox, orderItemId, keyPressCountValue) {
        if (keyPressCountValue < this.keyPressCount[orderItemId]) {
            //User has pressed one more key..that key press call will update the server..no work for me..
            return;
        }

        var quantity = (quantityBox.value);
        if (!isNonNegativeInteger(quantity)) {
            TealeafWCJS.createExplicitChangeEvent(quantityBox.id);
            MessageHelper.formErrorHandleClient(quantityBox, MessageHelper.messages["QUANTITY_INPUT_ERROR"]);
        } else {
            //Its a positive valid number > 0...Update the qty at server side..
            if (!isChrome()) {
                TealeafWCJS.createExplicitChangeEvent(quantityBox.id);
            }
            var params = [];
            params.orderId = ".";
            params["storeId"] = this.storeId;
            params["catalogId"] = this.catalogId;
            params["langId"] = this.langId;
            if (this.shoppingCartPage) {
                params.calculationUsage = "-1,-2,-5,-6,-7";
                params.inventoryValidation = "true";
            } else {
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";
            this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
            this.updateParamObject(params, "quantity", quantity, false, -1);

            //For handling multiple clicks
            if (!submitRequest()) {
                return;
            }
            cursor_wait();

            if (quantity == 0) {
                var x = document.getElementById("totalNumberOfItems").value;
                var y = x;
                //Now remove free items from this total number of items count..
                //x = total items and y = totalItems - totalFreeItems
                for (var i = 0; i < x; i++) {
                    var qtyObj = document.getElementById("freeGift_qty_" + (i + 1));
                    if (qtyObj != null || qtyObj != undefined) {
                        qty = qtyObj.value;
                        if (qty != null && qty != undefined && qty == -1) {
                            y = y - 1;
                        }
                    }

                }

                if (y == 1) {
                    wcService.invoke("AjaxUpdateOrderItem1", params);
                } else {
                    wcService.invoke("AjaxUpdateOrderItem", params);
                }
            } else {
                wcService.invoke("AjaxUpdateOrderItem", params);
            }
        }
    },


    /**
     * Validates the quantity of all items on the 'Shopping Cart' page.
     * @param {DOM Element} form The form object that contains the table of order items.
     */
    updateShoppingCart: function (form) {

        MessageHelper.hideAndClearMessage();
        var totalItems = document.getElementById("totalNumberOfItems").value;
        if (totalItems != null) {
            for (var i = 0; i < totalItems; i++) {
                var quantity = null;
                if (form != undefined) {
                    quantity = form["quantity_" + (i + 1)];
                } else if (document.getElementById("qty_" + (i + 1)) != null) {
                    quantity = document.getElementById("qty_" + (i + 1));
                }
                //Update qty for all items
                if (quantity != null || quantity != undefined) {
                    var v = quantity.value;
                    if (!isNonNegativeInteger(v)) {
                        MessageHelper.formErrorHandleClient(quantity.id, MessageHelper.messages["QUANTITY_INPUT_ERROR"]);
                        return;
                    }
                }

            }
            return true;
        } else {
            console.debug("error: element 'totalNumberOfItems' was expected but undefined.");
            return;
        }
    },

    /**
     * If the shopper has selected to perform a recurring order in the shopping cart page, this function is used to
     * validate that all conditions for creating a recurring order are met:
     * - make sure it is a registered shopper
     * - make sure that the order does not have order items that are non-recurring (i.e disallowRecurringOrder flag set to 1)
     *
     * @param {String} userType The user type of the current user, either G (guest shopper) or R (registered shopper).
     */
    canCheckoutContinue: function (userType) {
        if ( (document.getElementById("recurringOrder") && document.getElementById("recurringOrder").checked) && ((document.getElementById("shipTypeOnline") && document.getElementById("shipTypeOnline").checked) || document.getElementById("shipTypeOnline") == null)) {
            if (document.getElementById("nonRecurringOrderItems") && document.getElementById("nonRecurringOrderItems").value != "") {
                MessageHelper.displayErrorMessage(MessageHelper.messages["RECURRINGORDER_ERROR"]);
                return false;
            } else if (userType != undefined && userType === "G") {
                MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_GUEST_USER_SUBMIT_RECURRING_ORDER"]);
                return false;
            }
        }
        return true;
    },

    /**
     *
     * validate the login fields
     *
     */
    validateLoginFields: function(){
        function validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        }
        var emailField = $("#WC_CheckoutLogon_FormInput_logonId")
            , passwordField = $("#WC_CheckoutLogon_FormInput_logonPassword")
            , hasError = false;

        //TODO Commonize this 'if'
        if (isOliver){

            emailField.parent().removeClass("field-error-message");
            passwordField.parent().removeClass("field-error-message");
            if(emailField.val() == "" && passwordField.val() == ""){
                emailField.parent().addClass("field-error-message");
                passwordField.parent().addClass("field-error-message");
                hasError = true;
            }
            if(emailField.val() == ""){
                emailField.parent().addClass("field-error-message");
                hasError = true;
            }
            if(passwordField.val() == ""){
                passwordField.parent().addClass("field-error-message");
                hasError = true;
            }
            if(!validateEmail(emailField.val().trim())){
                emailField.parent().addClass("field-error-message");
                hasError = true;
            }

        } else {

            if(emailField.val() == "" && passwordField.val() == ""){
                emailField.addClass("field-error-message");
                passwordField.addClass("field-error-message");
                hasError = true;
            }
            if(emailField.val() == ""){
                emailField.addClass("field-error-message");
                hasError = true;
            }
            if(passwordField.val() == ""){
                passwordField.addClass("field-error-message");
                hasError = true;
            }
            if(!validateEmail(emailField.val())){
                emailField.addClass("field-error-message");
                hasError = true;
            }
        }

        if(hasError){
            return false;
        }
        return true;
    },
    /**
     * Updates the shopping cart in a 'quick check-out' scenario by invoking the <code>QuickCheckOutOrderCopy</code> service.
     *
     * @param {Integer} quickOrderId The ID of the quick check-out order.
     */
    updateCartWithQuickCheckoutProfile: function (quickOrderId) {
        var postRefreshHandlerParameters = [];
        var initialURL = "AjaxRESTOrderCopy";
        var urlRequestParams = [];
        urlRequestParams["storeId"] = this.storeId;
        urlRequestParams["catalogId"] = this.catalogId;
        urlRequestParams["langId"] = this.langId;
        urlRequestParams.toOrderId = ".";
        urlRequestParams["shippingAddressFromOrderProfile"] = "1";
        urlRequestParams["shippingModeFromOrderProfile"] = "1";
        urlRequestParams["URL"] = "dummy";
        urlRequestParams["payInfoFrom"] = quickOrderId;

        postRefreshHandlerParameters.push({"URL":"AjaxRESTOrderPrepare", "requestParams":{"orderId":"."}});
        postRefreshHandlerParameters.push({"URL":"OrderShippingBillingView","requestType":"GET", "requestParams":{"quickCheckoutProfileForPayment":"true"}});
        var service = getCustomServiceForURLChaining(initialURL,postRefreshHandlerParameters,null);

        //For handling multiple clicks
        if(!submitRequest()){
            return;
        }
        cursor_wait();

        wcService.invoke(service.getParam("id"), urlRequestParams);
    },


    /************************************************************
     * End Shopping Cart page specific functions
     ************************************************************/



    /**************************************************************
     * The following methods are used on the Single Shipment page
     **************************************************************/

    /**
     * Helper function used for adding a new shipping address in a single shipment scenario.
     *
     * @param {String} addressType The type of the selected address.
     */
    addNewShippingAddress: function (addressType) {
        this.displayAddressDetails(-1, addressType);
    },

    /**
     * This function is used to update the address of all order items in a single shipment checkout-out scenario.
     *
     * @param {DOM Element} addressSelectBox The select drop-down object that contains all available addresses.
     */
    updateAddressForAllItems: function (addressSelectBox) {
        //Save it in local array..
        if (addressSelectBox.value != -1) {
            this.selectedAddressesArray[addressSelectBox.name] = addressSelectBox.value;
        }

        var addressId = addressSelectBox.value;
        if (addressId == -1) {
            return;
        }
        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        var addressId = document.getElementById("singleShipmentAddress").value;
        this.updateParamObject(params, "addressId", addressId, false);
        if (typeof updateGiftRegistrantAddressForItemsExt != "undefined" && typeof updateGiftRegistrantAddressForItemsExt != null) {
            params = updateGiftRegistrantAddressForItemsExt(params, addressId);
        }

        var enabledShipInstructions = false;
        var shipInstructions;

        //Check if Shipping Instructions is enabled
        if (document.getElementById("shipInstructions") != null) {
            shipInstructions = document.getElementById("shipInstructions").value;

            reWhiteSpace = new RegExp(/^\s+$/);
            if (reWhiteSpace.test(shipInstructions)) {
                shipInstructions = "";
            }
            enabledShipInstructions = true;
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        //If Shipping Instructions is enabled & there are some shipping instructions entered
        //Update both the shipping address and shipping instructions
        //Else only update shipping address
        if (!enabledShipInstructions || shipInstructions == undefined || shipInstructions == "") {
            wcService.invoke("OrderItemAddressShipMethodUpdate", params);
        } else {
            wcService.invoke("OrderItemAddressShipInstructionsUpdate", params);
        }
    },


    /**
     * This function is used to update the shipping mode of all order items in a single shipment checkout-out scenario.
     *
     * @param {DOM Element} addressSelectBox The select drop-down object that contains all available shipping modes.
     */
    updateShipModeForAllItems: function (shipmentSelectBox) {

        var shipModeId = shipmentSelectBox.value;
        if (shipModeId == -1) {
            return;
        }
        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        this.updateParamObject(params, "shipModeId", shipModeId, false);

        if (isCarol && typeof addressId !== 'undefined') {
            this.updateParamObject(params, "addressId", addressId, false);
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderItemAddressShipMethodUpdate", params);
    },


    /**
     * This function updates the shipping instruction for items in the order. It is used in a single shipment check-out scenario.
     * It calls the <code>OrderShippingInfoUpdate</code> service.
     */
    updateShippingInstructionsForAllItems: function () {

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";

        var orderItemId = null;
        var shipInstructions = document.getElementById("shipInstructions").value;

        reWhiteSpace = new RegExp(/^\s+$/);
        if (reWhiteSpace.test(shipInstructions)) {
            shipInstructions = "";
        }

        //Validate the length of the shipping instructions
        if (!MessageHelper.isValidUTF8length(shipInstructions, 4000)) {
            MessageHelper.formErrorHandleClient(document.getElementById("shipInstructions").id, MessageHelper.messages["ERROR_ShippingInstructions_TooLong"]);
            return;
        }

        orderItemId = document.getElementById("orderItem_1").value;
        this.updateParamObject(params, "orderItemId", orderItemId, false);
        this.updateParamObject(params, "shipInstructions", shipInstructions, false);

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderShippingInfoUpdate", params);
    },

    /**
     * Updates the shipping charge type and account number for items in the order. This method calls the
     * <code>OrderShippingInfoUpdate</code> service and is used in both single and multiple shipment checkout scenarios.
     *
     * @param {Integer} curOrderId The order ID of the current order.
     * @param {Integer} shipModeId The ID of the shipping mode to which shipping charge applies.
     * @param {String} shipChargeType Shipping charge type selected for the shipmode.
     * @param {Integer} shipAcctNum The account number that is used when the selected shipping charge type is Charge by Carrier.
     */
    updateShippingChargeForShipModeAjax: function (curOrderId, shipModeId, shipChargeType, shipAcctNum) {

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = curOrderId;
        params.URL = "";
        params["shipModeId"] = shipModeId;
        params["shipChargTypeId"] = shipChargeType;

        // ship account number is optional field for shipping charge, if it is not specified, pass in empty
        if (shipAcctNum != null && typeof shipAcctNum !== 'undefined') {
            params["shipCarrAccntNum"] = shipAcctNum;
        } else {
            params["shipCarrAccntNum"] = "";
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("AjaxOrderShipChargeUpdate", params);
    },


    /**
     * Hides the account number field for the selected in shipping charge. If the charge by seller charge
     * type is selected, account field should not be shown.
     * @param {object} selectValue The HTML element of the shipping charge type selection
     * @param {object} acctFieldId The HTML element of the account number field
     */
    hideShipChargeAccountField: function (selectValue, acctFieldId) {

        if (document.getElementById(selectValue).value.indexOf("ByCarrier") > -1) {
            document.getElementById(acctFieldId).style.display = 'block';
        } else {
            document.getElementById(acctFieldId).style.display = 'none';
        }
    },

    /**
     * This function validates the specified requested shipping date then calls {@link CheckoutHelperJS.updateShippingDateForAllItems}
     * to update the date for all items in the current order in a single shipment scenario.
     *
     * @param {datepicker} jsDate The jQuery datepicker object containing the requested shipping date specified by the user.
     *
     * @see CheckoutHelperJS.updateRequestedShipDateForThisItem
     */

    updateRequestedShipDate: function (jsDate) {
        if (jsDate == null || jsDate.value == "")
            return;

        var t = "";
        if (jsDate.value != "") {
            t = this.formatRequestedShipDate(jsDate);
        } else {
            t = this.resetRequestedShipDateValue;
        }

        this.updateShippingDateForAllItems(t);
    },


    /**
     * This function updates the requested shipping date for all items in the order. It is called by {@link CheckoutHelperJS.updateRequestedShipDate}.
     * It calls the <code>OrderItemAddressShipMethodUpdate</code> service.
     *
     * @param {String} date The String representation of the date object, see {@link CheckoutHelperJS.updateRequestedShipDate}.
     */
    updateShippingDateForAllItems: function (date) {
        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        this.updateParamObject(params, "requestedShipDate", date, false);

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderItemAddressShipMethodUpdate", params);
    },


    /**
     * Displays the details of an address in a single shipment check-out scenario.
     *
     * @param {String} addressSelectBoxValue The value, i.e. address ID, of the input address select drop-down object.
     * @param {String} addressType The type of the selected address.
     */
    displayAddressDetails: function (addressSelectBoxValue, addressType) {
        //Display selected address details..
        if (addressSelectBoxValue != -1) {
            //For handling multiple clicks
            if (!submitRequest()) {
                return;
            }
            var checkForOpera = true; //require a check of whether the browser is opera or not
            cursor_wait(checkForOpera);
            wcRenderContext.updateRenderContext('shippingAddressContext', {
                'shippingAddress': addressSelectBoxValue
            });
        } else {
            this.createAddress(-1, addressType);
        }
    },


    /************************************************************
     * End Single Shipment page specific functions
     ************************************************************/


    /****************************************************************
     * The following methods are used on the Multiple Shipment page
     ****************************************************************/

    /**
     * This function is used to move all order items into a single shipment when a shopper changes the order from multiple shipment check-out to single shipment.
     * The shipping information of the first item in the order will be used for all items after this update.
     * It calls the <code>OrderItemAddressShipMethodUpdate1</code> service to update the order.
     */
    moveAllItemsToSingleShipment: function () {
        //Get the first orderItem id..
        var orderItemId = document.getElementById("orderItem_1").value;
        //Now get the addressId and shipModeId of this orderItemId...
        var addressId = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
        //Update the shipModeId and addressId of all the items present in currentOrder...

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.calculateOrder = "1";

      // FIX LATER TODO
        var requestedShipDate = $("#MS_requestedShippingDate_" + orderItemId);
        if (requestedShipDate == undefined) {
            requestedShipDate = document.getElementById("MS_requestedShippingDate_" + orderItemId);
            if (requestedShipDate != null && requestedShipDate != 'undefined') {
                if (requestedShipDate.value != "") {
                    params.requestedShipDate = requestedShipDate.value;
                } else {
                    params.requestedShipDate = this.resetRequestedShipDateValue;
                }
            }
        }

        var requestedShipDateCheckbox = document.getElementById("MS_requestShippingDateCheckbox_" + orderItemId);
        if (requestedShipDateCheckbox != null && requestedShipDateCheckbox != 'undefined') {
            if (requestedShipDateCheckbox.checked) {
                if (requestedShipDate.value != "") {
                    params.requestedShipDate = this.formatRequestedShipDate(requestedShipDate);
                } else {
                    params.requestedShipDate = this.resetRequestedShipDateValue;
                }
            } else {
                params.requestedShipDate = this.resetRequestedShipDateValue;
            }
        }

        //addressId -3 is reserved for gift registry "Registrant" address.
        if (addressId == -3) {
            var totalItems = document.getElementById("totalNumberOfItems").value;
            for (var i = 2; i <= totalItems; i++) {
                if (document.getElementById("orderItem_" + i) != null && document.getElementById("orderItem_" + i) != 'undefined') {
                    var giftOrderItemId = document.getElementById("orderItem_" + i).value;
                    var validAddressId = document.getElementById("MS_ShipmentAddress_" + giftOrderItemId).value;
                    if (validAddressId != -3) {
                        this.updateParamObject(params, "addressId", validAddressId, false);
                        break;
                    }
                } else {
                    break;
                }
            }
        } else {
            this.updateParamObject(params, "addressId", addressId, false);
        }
        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderItemAddressShipMethodUpdate1", params);
    },


    /**
     * Helper function for adding an address on the multiple shipment 'Shipping & Billing' page.
     * @param (Integer) orderItemId The ID of the order item.
     */
    addNewShippingAddressForMS: function (orderItemId) {
        this.updateAddressIdForThisItem(-1, orderItemId);

        this.orderItemIds = []; //Reset this.orderItemIds. So that previous edit/create address doesn't have effect on the new create/edit address
        //now save the orderItemId, so we can update that orderItem with the newly created addressId

        //now save the orderItemId, so we can update that orderItem with the newly created addressId
        this.orderItemIds.push(orderItemId);
    },


    /**
     * Updates the address ID for an order item in a multiple shipment check-out scenario.
     * It is used when a different address is selected from the drop down.
     * It calls the <code>OrderItemAddressShipMethodUpdate</code> service to update.
     *
     * @param {String} addressBoxValue The value, i.e. address ID, of the input select drop-down object that contains all available addresses.
     * @param {Integer} orderItemId The order item ID.
     */
    updateAddressIdForThisItem: function (addressBoxValue, orderItemId) {
        //Save it in local array..
        if (addressBoxValue != -1) {
            var addressBox = document.getElementById("MS_ShipmentAddress_" + orderItemId);
            this.selectedAddressesArray[addressBox.name] = addressBoxValue;
        }
        if (addressBoxValue == -1) return;

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";
        var addressId = addressBoxValue;
        this.updateParamObject(params, "shipToRegistrant", "0", false, -1)
        this.updateParamObject(params, "addressId", addressId, false, -1);
        this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
        if (typeof updateGiftRegistrantAddressForThisItemExt != "undefined" && typeof updateGiftRegistrantAddressForThisItemExt != null) {
            params = updateGiftRegistrantAddressForThisItemExt(params, addressId);
        }
        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderItemAddressShipMethodUpdate", params);
    },


    /**
     * Updates the shipping mode for an item in the order. It is used in a multiple shipment scenario.
     * It calls the <code>OrderItemAddressShipMethodUpdate</code> service.
     *
     * @param {DOM Element} shipModeBox The select drop-down object that contains all available shipping modes.
     * @param {Integer} orderItemId The ID of the order item to update.
     */
    updateShipModeForThisItem: function (shipModeBox, orderItemId) {
        var shipModeId = shipModeBox.value;
        if (shipModeId == -1) {
            return;
        }
        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
        this.updateParamObject(params, "shipModeId", shipModeId, false, -1);
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.calculateOrder = "1";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderItemAddressShipMethodUpdate", params);
    },


    /**
     * Updates the shipping instruction for an item. It is used in a multiple shipment scenario.
     * It calls the <code>OrderShippingInfoUpdate</code> service.
     *
     * @param {DOM Element} textArea The input text area for shipping instruction.
     * @param {Integer} orderItemId The ID of the order item to update.
     */
    updateShippingInstructionsForThisItem: function (textArea, orderItemId) {
        var addressId = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
        var shipModeId = document.getElementById("MS_ShippingMode_" + orderItemId).value;
        var shipInstructions = textArea.value;

        reWhiteSpace = new RegExp(/^\s+$/);
        if (reWhiteSpace.test(shipInstructions)) {
            shipInstructions = "";
        }

        //Validate the length of the shipping instructions
        if (!MessageHelper.isValidUTF8length(shipInstructions, 4000)) {
            MessageHelper.formErrorHandleClient(textArea.id, MessageHelper.messages["ERROR_ShippingInstructions_TooLong"]);
            return;
        }

        this.setShippingInstuctionsForAllOtherItems(addressId, shipModeId, shipInstructions);

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.calculateOrder = "1";

        this.updateParamObject(params, "addressId", addressId, false, -1);
        this.updateParamObject(params, "shipModeId", shipModeId, false, -1);
        this.updateParamObject(params, "shipInstructions", shipInstructions, false, -1);
        this.updateParamObject(params, "orderItemId", orderItemId, false, -1);

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderShippingInfoUpdate", params);
    },


    /**
     * This function updates the requested shipping date for the current item in a multiple shipment check-out scenario.
     * It invokes the <code>OrderItemAddressShipMethodUpdate</code> service.
     *
     * @param {datepicker} jsDate The jQuery datepicker object containing the requested shipping date specified by the user.
     * @param {Integer} orderItemId The ID of the order item to update.
     */
    updateRequestedShipDateForThisItem: function (jsDate, orderItemId) {
        if (jsDate == null || jsDate.value == "")
            return;

        var t = "";
        if (jsDate.value != "") {
            t = this.formatRequestedShipDate(jsDate);
        } else if (jsDate.value == "") {
            t = this.resetRequestedShipDateValue;
        }

        var addressId = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
        var shipModeId = document.getElementById("MS_ShippingMode_" + orderItemId).value;

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
        this.updateParamObject(params, "requestedShipDate", t, false, -1);
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        CheckoutHelperJS.RequestShippingDateAction = true;
        wcService.invoke("OrderItemAddressShipMethodUpdate", params);
    },

    /**
     * This function formats the requested shipping date from the jQuery datepicker object into a GMT date string.
     *
     * @param {datepicker object} jsDate The jQuery datepicker object containing the requested shipping date specified by the user.
     * @return {string} String representation of the requested ship date in GMT.
     */
    formatRequestedShipDate: function (jsDate) {
        var date = $(jsDate).datepicker("getDate");
        //Set the time to 12pm to handle cases where daylight savings cause a date shift
        date.setHours(12);
        return date.toISOString();
    },


    /**
     * This function is used to bring up the address entry form when a user wants to create a new address for an item in a multiple shipment scenario.
     *
     * @param {Integer} orderItemId The ID of the order item to update.
     * @param {String} addressType The type of address to create.
     *
     * @private
     */
    createAddressForMS: function (orderItemId, addressType) {
        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }

        cursor_wait();
        wcRenderContext.updateRenderContext('editShippingAddressContext', {
            'shippingAddress': '-1',
            'addressType': addressType
        });
        //Hide the mainContents (contains shipping/billing details, shop cart details, promotion details, orderDetails)
        this.showHideDivs('editAddressContents', 'mainContents');
    },


    /**
     * Helper function for adding a new address in a multiple shipment scenario.
     *
     * @param (Integer) orderItemId The ID of the item.
     * @param (String) addressType The type of the selected address.
     */
    displayAddressDetailsForMSHelper: function (orderItemId, addressType) {
        this.displayAddressDetailsForMS(-1, orderItemId, addressType);
    },


    /**
     * Displays the details of an address in a multiple shipment check-out scenario.
     *
     * @param {String} addressSelectBoxValue The value, i.e. address ID, of the input address select drop-down object.
     * @param {Integer} orderItemId The order item ID.
     * @param {String} addressType The type of the selected address.
     */
    displayAddressDetailsForMS: function (addressSelectBoxValue, orderItemId, addressType) {
        if (addressSelectBoxValue == -1) {
            this.createAddressForMS(orderItemId, addressType);
        }
    },


    /**
     * This function is used to show or hide the edit address link in multiple and single shipment page.
     * @param {DOM Element} addressSelectBox The select drop-down object that contains all available addresses.
     * @param {String} orderItemId The id of the orderItem for which the edit address link is displayed/hidden.
     */

    showHideEditAddressLink: function (addressSelectBox, orderItemId) {
        if (addressSelectBox.value == '-3') {
            if ($("#editAddressLink_" + orderItemId).length) {
                $("#editAddressLink_" + orderItemId).css("display", "none");
            }
            return;
        }
        var orgAddressList = document.getElementById("shippingOrganizationAddressList");
        if (orgAddressList) {
            var orgAddressArray = [];
            orgAddressArray = orgAddressList.value.toString().split(",");
            for (var i = 0; i < orgAddressArray.length; i++) {
                if ($("#editAddressLink_" + orderItemId).length) {

                    if (addressSelectBox.value == orgAddressArray[i]) {
                        $("#editAddressLink_" + orderItemId).css("display", "none");
                        break;
                    } else {
                        $("#editAddressLink_" + orderItemId).css("display", "block");
                    }
                }
            }
        } else {
            if ($("#editAddressLink_" + orderItemId).length) {
                $("#editAddressLink_" + orderItemId).css("display", "block");
            }
        }
    },

    /**
     * This function is used to show or hide the dialog for estemated tax in shopping cart.
     */

    showHideEstematedTaxDialog: function (flag) {
        //TODO Commonize this 'if'
        if (!isOliver && !isCarol){
            var position = $('#wcs-calculate-tax').offset();
            var yOffset = position.top  + 20;
            var xOffset = position.left - 180;
            if ($( window ).width() < 650) {
                yOffset = position.top -60;
                xOffset = 0;
            }
            $("#wcs_calTax_notification").css({top: yOffset, left: xOffset});
        }
        $(".enter-zipcode").css("display","table-row");
        

        if (flag){
            $("#wcs_calTax_notification").show();
            if(isOliver || isPersol){
                $("#wcs-calculate-tax-close").show();
                $("#wcs-calculate-tax").hide();
            }
        }
        else{
            $("#wcs_calTax_notification").hide();
            
            if(isOliver || isPersol){
                $("#tax-calculation-form").hide();
                $("#wcs-calculate-tax-close").hide();
                $("#wcs-calculate-tax").show();
            }
        }
    },

    /**
     * calls google service to autofill city provence by zip code
     */
    calculateEstematedTax : function(zipCode, country, lang, isCheckOut, isZipCodeChange, strName) {
        if (isCarol){
            if ($("#WC_UnregisteredCheckout_links_4").length>0){
                showLoadingInternal(true,'WC_UnregisteredCheckout_links_4');
            }
        }

        var zipcode = "";
        var langId = "";
        var countryCode = null;
        var isZipChange = false;
        var storeName = "";

        if(isCheckOut){
            zipcode = zipCode;
            langId = lang;
            countryCode = country;
            isZipChange = isZipCodeChange;
            storeName = strName;
        } else {
            zipcode = $('#wcs_calTax_notification #zip_code').val();
            langId = $('#wcs_calTax_notification #langId').val();
            countryCode = $('#wcs_calTax_notification #country_value').val();

            //TODO Commonize this 'if'
            if (isOliver || isCarol){
                $("#zipCodeDiv").removeClass('error');
                $("#zipCodeDiv .input-style").removeClass('error');
                if (!zipcode.match($('#wcs_calTax_notification #zip_code').attr('data-pattern')) ) {
                    // display error message
                    $("#zipCodeDiv").addClass('error');
                    $("#zipCodeDiv .input-style").addClass('error');
                    restoreAjaxButtons();
                    return false;
                }
            } else {
                $("#wcs_calTax_notification .wcs-error-message").hide();
                if (zipcode.length <5 ) {
                    // display error message.
                    $("#wcs_calTax_notification .wcs-error-message").show();
                    restoreAjaxButtons();
                    return false;
                }
            }

            /* START - Checkout 3.0 */
            //  Force recalculation of taxes when coming back from Shipping Page (it was not possible in previous checkout)
            if ((isOliver || isPersol) && this.zipCountShoppingCart < 1 && $('.tax .total_figures .amount').text().trim() != null && $('.tax .total_figures .amount').text().trim() != '') {
                this.zipCountShoppingCart++;
            }
            /* END - Checkout 3.0 */

            if(this.zipCountShoppingCart >= 1){
                isZipChange = true;
            }else{
                this.zipCountShoppingCart++;
            }

            if (!isOliver && !isCarol){
                setCurrentId('wcs-tax-button_a');
            }
        }

        //HB-2302 BEGIN Use google address common interface
        getGoogleAddress(countryCode, zipcode, langId, function(result){
            if (result.status == "error"){
                console.log("PSL::CheckoutHelper.js::calculateEstematedTax function ajax error (GoogleAPI)");
                MessageHelper.displayErrorMessage("There was a problem while retrieving data from Google Maps API");
                if(isCheckOut){
                    CheckoutHelperJS.updateOrderSummary(isCheckOut);
                } else {
                    /* CHECKOUT 3.0 - mustache obj for checkout summary for PO/OP */
                    if (isPersol || isOliver) {
                        ajaxCallCart();
                    } else {
                        CheckoutHelperJS.showHideEstematedTaxDialog(false);
                        CheckoutHelperJS.updateOrderSummary();
                    }  
                }

            } else {
                var city = result.address.city;
                var state = result.address.prov_state_short;
                var zipcode = result.address.zipcode;
                var country = result.address.country_short;

                // submit AjaxOrderCalculate request
                var params = [];

                params.storeId      = ServicesDeclarationJS.storeId;
                params.catalogId    = ServicesDeclarationJS.catalogId;
                params.langId       = ServicesDeclarationJS.langId;

                params.updatePrices = "0";
                if(isCheckOut){
                    params.orderId = ".";
                } else {
                    params.orderId = $('#wcs_calTax_notification #orderId').val();
                }

                params.addressFlag = true;
                params.isDeliveryAddressAdded = false;
                params.zipCode = zipcode != null ? zipcode : "";
                params.city = city != null ? city : "";
                params.state = state != null ? state : "";
                params.country = country;
                params.isZipChange = isZipChange;

                var url = getAbsoluteURL() + "AjaxOrderCalculate?";
                for (var param  in params) {
                    url += param + "=" + params[param] + "&";
                }
                url += "calculationUsageId=-1&";
                url += "calculationUsageId=-2&";
                url += "calculationUsageId=-3&";
                url += "calculationUsageId=-4";

                //Make the call to AjaxOrderCalculate
                $.ajax({
                    url: url,
                    type: 'POST',
                    success: function (data) {
                        // refresh the area.
                        if(isCheckOut){
                            var url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/person/@self/contact";
                            $.ajax({
                                url: url,
                                type: 'GET',
                                headers: {
                                    "Content-Type": "application/json",
                                    "Cache-Control": "no-cache, no-store, must-revalidate"
                                },
                                data: {
                                    "timestamp": Date.now()
                                },
                                success: function (data) {
                                    if(data != undefined && data.contact != undefined){
                                        for(var i = 0; i < data.contact.length; i++){
                                            if(data.contact[i].addressType === "Billing"){
                                                setCookie("addressId_formB_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                            }else if(data.contact[i].addressType === "Shipping"){
                                                setCookie("addressId_formS_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                            }else{
                                                setCookie("addressId_formS_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                                setCookie("addressId_formB_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                            }
                                        }
                                    }
                                },
                                error: function(data){
                                    console.log("PSL::CheckoutHelper.js::calculateEstematedTax function ajax error (contact)");
                                    MessageHelper.displayErrorMessage("There was a problem while retrieving current user contact data.");
                                    console.log(data);
                                },
                                complete: function(){
                                }
                            });
                            CheckoutHelperJS.updateOrderSummary(isCheckOut);
                        } else {
                            CheckoutHelperJS.showHideEstematedTaxDialog(false);
                            /* CHECKOUT 3.0 - mustache obj for checkout summary for PO/OP */
                            if (isPersol || isOliver) {
                                ajaxCallCart();
                            } else {
                                CheckoutHelperJS.updateOrderSummary();
                            }
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        console.log("PSL::CheckoutHelper.js::calculateEstematedTax function ajax error (AjaxOrderCalculate)");
                        MessageHelper.displayErrorMessage("There was a problem while retrieving data from taxes calculation service.");

                        if(isCheckOut){
                            CheckoutHelperJS.updateOrderSummary(isCheckOut);
                        } else {
                            CheckoutHelperJS.showHideEstematedTaxDialog(false);
                            /* CHECKOUT 3.0 - mustache obj for checkout summary for PO/OP */
                            if (isPersol || isOliver) {
                                ajaxCallCart();
                            } else {
                                CheckoutHelperJS.updateOrderSummary();
                            }
                        }
                    }
                });
            }
        });
        //HB-2302 END
    },

    /* NEW */
    calculateTaxesFromZipCode : function(zipCodeFormField) {
        var isCheckOut = (document.querySelectorAll("#page.checkout").length != 0 ||$("#page.checkout-page").length != 0)

        var zipCodeFormFieldId = zipCodeFormField.id;
        /*
        var countryId = zipCodeFormFieldId.replace("_zipCode_","_country_");
        var stateId = zipCodeFormFieldId.replace("_zipCode_","_state_");
        var cityId = zipCodeFormFieldId.replace("_zipCode_","_city_");
        */

        //HB-2302 BEGIN Use google address common interface
        getGoogleAddress(countryCode, zipCodeFormField.value, storeLanguage, function(result){
            if (result.status == "error"){
                console.log("PSL::CheckoutHelper.js::calculateTaxesFromZipCode:: getGoogleAddress error (GoogleAPI): Is the zipCode correct?");
                //MessageHelper.displayErrorMessage("There was a problem while retrieving data from Google Maps API");
                if(isCheckOut){
                    CheckoutHelperJS.updateOrderSummary(isCheckOut);
                } else {
                    CheckoutHelperJS.showHideEstematedTaxDialog(false);
                    CheckoutHelperJS.updateOrderSummary();
                }

            } else {
                var city = result.address.city;
                var state = result.address.prov_state_short;
                var zipcode = result.address.zipcode;

                // submit AjaxOrderCalculate request
                var params = [];

                params.storeId      = ServicesDeclarationJS.storeId;
                params.catalogId    = ServicesDeclarationJS.catalogId;
                params.langId       = ServicesDeclarationJS.langId;

                params.updatePrices = "0";
                if(isCheckOut){
                    params.orderId = ".";
                } else {
                    params.orderId = $('#wcs_calTax_notification #orderId').val();
                }

                params.addressFlag = true;
                params.isDeliveryAddressAdded = false;
                params.zipCode = zipcode != null ? zipcode : "";
                params.city = city != null ? city : "";
                params.state = state != null ? state : "";
                params.country = "us";
                params.isZipChange = true;//isZipChange;

                var url = getAbsoluteURL() + "AjaxOrderCalculate?";
                for (var param  in params) {
                    url += param + "=" + params[param] + "&";
                }
                url += "calculationUsageId=-1&";
                url += "calculationUsageId=-2&";
                url += "calculationUsageId=-3&";
                url += "calculationUsageId=-4";

                //Make the call to AjaxOrderCalculate
                $.ajax({
                    url: url,
                    type: 'POST',
                    success: function (data) {
                        // refresh the area.
                        if(isCheckOut){
                            var url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/person/@self/contact";
                            $.ajax({
                                url: url,
                                type: 'GET',
                                headers: {
                                    "Content-Type": "application/json",
                                    "Cache-Control": "no-cache, no-store, must-revalidate"
                                },
                                data: {
                                    "timestamp": Date.now()
                                },
                                success: function (data) {
                                    if(data != undefined && data.contact != undefined){
                                        for(var i = 0; i < data.contact.length; i++){
                                            if(data.contact[i].addressType === "Billing"){
                                                setCookie("addressId_formB_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                            }else if(data.contact[i].addressType === "Shipping"){
                                                setCookie("addressId_formS_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                            }else{
                                                setCookie("addressId_formS_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                                setCookie("addressId_formB_"+storeDirectory,data.contact[i].addressId,{path: "/", domain: cookieDomain});
                                            }
                                        }
                                    }
                                },
                                error: function(data){
                                    console.log("PSL::CheckoutHelper.js::calculateEstematedTax function ajax error (contact)");
                                    MessageHelper.displayErrorMessage("There was a problem while retrieving current user contact data.");
                                    console.log(data);
                                },
                                complete: function(){
                                }
                            });
                            CheckoutHelperJS.updateOrderSummary(isCheckOut);
                        } else {
                            CheckoutHelperJS.showHideEstematedTaxDialog(false);
                            CheckoutHelperJS.updateOrderSummary();
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        console.log("PSL::CheckoutHelper.js::calculateEstematedTax function ajax error (AjaxOrderCalculate)");
                        MessageHelper.displayErrorMessage("There was a problem while retrieving data from taxes calculation service.");

                        if(isCheckOut){
                            CheckoutHelperJS.updateOrderSummary(isCheckOut);
                        } else {
                            CheckoutHelperJS.showHideEstematedTaxDialog(false);
                            CheckoutHelperJS.updateOrderSummary();
                        }
                    }
                });
            }
        });
        //HB-2302 END
    },


    /**
     * This method updates current cart orderitems address' to the last valid shipping address
     */
    updateCurrentOrderItemsAddressToLastValidOne: function(){
        var METHODNAME = "CheckoutHelperJS.updateCurrentOrderItemsAddressToLastValidOne()";
        var shippingAddressId = getCookie("addressId_formS_" + storeDirectory);
        if (typeof shippingAddressId !== 'undefined'){
            var data = {};
            data.addressId = shippingAddressId;
            data.orderId = ".";
            data.x_calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            data.orderItem = [];
            data.orderItem[0] = {};
            data.orderItem[0].addressId = shippingAddressId;

            var stringifiedData = JSON.stringify(data);

            var url = "/wcs/resources/store/" + WCParamJS.storeId + "/cart/@self/shipping_info";
            $.ajax({
                url: url,
                type: 'PUT',
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache, no-store, must-revalidate"
                },
                dataType: 'json',
                data: stringifiedData,

                success: function (data) {
                    plog(METHODNAME + "::Order items shipping address updated OK");
                },
                error: function(jqXHR, exception){
                    plog(METHODNAME + "::Ajax error: " + getAjaxErrorMessage(jqXHR, exception));
                },
                complete: function(){
                }
            });
        }
    },

    updateOrderSummary: function(isCheckOut) {
        var countryCode = $("#countryCode").val() || $("#country").val();
        $.ajax({
            url: "CalculateView",
            type: "GET",
            async: false,
            data: "fromPage=CalculateView&storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId,
            success: function (data){

                //TODO Commonize this 'if'
                if (isOliver){

                    if(isCheckOut){
                        /*var str1 = $(data).find(".amount").text().trim();
                        str1 = str1.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                        $('.tax .total_figures').html(str1);

                        var str2 = $(data).find("#WC_SingleShipmentOrderTotalsSummary_td_10").text().trim();
                        var total = str2.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                        $('#order_total .total-amounth.total').html(total);*/
                        ajaxCallCart();//checkout 3.0
                    } else {
                        $('#order_total').html(data);
                    }

                } else if (isCarol){

                    if(isCheckOut){
                        var str1 = $(data).find(".amount").text().trim();
                        str1 = str1.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                        $('.tax .total_figures').html(str1);

                        if ($('.order-summary__total-amount--shipping') != undefined) {
                            var str2 = $(data).find(".order-summary__total-amount--shipping").text().trim();
                            str2 = str2.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                            $('.order-summary__total-amount--shipping').html(str2);
                        }

                        if ($('#order_total .total-amounth.total') != undefined) {
                            var str3 = $(data).find("#WC_SingleShipmentOrderTotalsSummary_td_10").text().trim();
                            var total = str3.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                            $('#order_total .total-amounth.total').html(total);
                        }

                        if ($('.order-summary__total-amount--total') != undefined) {
                            var str5 = $(data).find(".order-summary__total-amount--total").text().trim();
                            str5 = str5.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                            $('.order-summary__total-amount--total').html(str5);
                        }

                        if ($('.order-summary__installment-total') != undefined) {
                            var str4 = $(data).find(".order-summary__installment-total").text().trim();
                            str4 = str4.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                            $('.order-summary__installment-total').html(str4);
                        }
                    } else {
                        restoreAjaxButtons();
                        $('#order_total').html(data);
                    }

                } else {

                    if(isCheckOut){
                        // var str1 = $(data).find("#WC_SingleShipmentOrderTotalsSummary_td_6").html();
                        // var pos = str1.lastIndexOf(">");
                        // str1 = str1.substring(str1.length,pos +1);
                        // str1 = str1.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                        // $('.tax .total_figures').html(str1);

                        // var str2 = $(data).find("#WC_SingleShipmentOrderTotalsSummary_td_10").text().trim();
                        // var total = str2.replace(/([\ \t]+(?=[\ \t])|^\s+|\s+$)|([\n\r])/g, '');
                        // $('.orderTotal .total_figures').html(total);
                        
                        // if (affirmEnabled == 'true') {
                        //     $('.affirm-as-low-as').attr('data-amount', WCCurrencyJS.unformat(total) * 100);
                        // }
                        ajaxCallCart();// checkout3.0
                    } else {
                        $('#total_breakdown').html(data);
                    }

                }

                if (affirmEnabled == 'true') {
                    affirm.ui.refresh();
                }
            },
             error: function (xhr, ajaxOptions, thrownError) {
                console.log("PSL::CheckoutHelper.js::updateOrderSummary()::"+thrownError);
             }
        });
    },

    /**
     * This function is used to show or hide the edit billing address link in multiple and single shipment page.
     * @param {DOM Element} addressSelectBox The select drop-down object that contains all available addresses.
     * @param {String} paymentAreaNumber The area number of the payment section.
     */

    showHideEditBillingAddressLink: function (addressSelectBox, paymentAreaNumber) {

        // If the value is "Please Select Billing Method first", then don't display the edit link on load.
        if ( typeof addressSelectBox !== 'undefined' && addressSelectBox !== null ){
            if (addressSelectBox.value == '-2') {
                $("#editBillingAddressLink_" + paymentAreaNumber).css("display", "none");
                return;
            }
        }

        // Gets the address Ids of all the organization addresses
        var orgAddressList = document.getElementById("shippingOrganizationAddressList");

        //if there exists organization addresses
        if (orgAddressList) {
            var orgAddressArray = [];
            orgAddressArray = orgAddressList.value.toString().split(",");

            //loops through all the organization address Ids
            for (var i = 0; i < orgAddressArray.length; i++) {

                //checks to see if the edit link divs exists
                if ($("#editBillingAddressLink_" + paymentAreaNumber).length) {

                    //compares the selected value address Id in the drop down to the organization address id
                    if (addressSelectBox.value == orgAddressArray[i]) {

                        //hides the link if a match is found and then exits the loop (exit is for the case where there might be a different org address id)
                        $("#editBillingAddressLink_" + paymentAreaNumber).css("display", "none");
                        break;
                    } else {
                        //displays it in all other cases
                        $("#editBillingAddressLink_" + paymentAreaNumber).css("display", "block");
                    }
                }
            }

        } else {

            // if no organization addresses exists, show the valid edit divs.
            if ($("#editBillingAddressLink_" + paymentAreaNumber).length) {
                $("#editBillingAddressLink_" + paymentAreaNumber).css("display", "block");
            }
        }
    },

    /**
     * Sets the order ID when it is not called form the current order.
     * The order ID is used to determine which order to act upon such as in the case of deleting an order item from an order.
     * @param {String} orderId The orderID to use.
     */
    setOrderId: function (orderId) {
        this.orderId = orderId;
    },

    /**
     * Returns the orderId.
     */
    getOrderId: function () {
        return this.orderId;
    },

    /************************************************************
     * End Multiple Shipment page specific functions
     ************************************************************/

    _toggleOrderItemDetails: function (div) {
        if (div.css("display") == "none") {
            div.css("display", "block");
            $("#orderExpandAreaBottom").css("display", "none");
            $("#OrderItemDetailsPlus").css("display", "none");
            $("#OrderItemDetailsShowPrompt").css("display", "none");
            $("#OrderItemDetailsMinus").css("display", "inline");
            $("#OrderItemDetailsHidePrompt").css("display", "inline");
            $("#OrderItemDetails_plusImage_link").css("display", "none");
            $("#OrderItemDetails_minusImage_link").css("display", "");
        } else {
            div.css("display", "none");
            $("#orderExpandAreaBottom").css("display", "block");
            $("#OrderItemDetailsPlus").css("display", "inline");
            $("#OrderItemDetailsShowPrompt").css("display", "inline");
            $("#OrderItemDetailsMinus").css("display", "none");
            $("#OrderItemDetailsHidePrompt").css("display", "none");
            $("#OrderItemDetails_plusImage_link").css("display", "");
            $("#OrderItemDetails_minusImage_link").css("display", "none");
        }
    },
    toggleOrderItemDetailsShipping: function (orderItemDetailsDiv, contextId, initializeJS) {
        var div = $("#" + orderItemDetailsDiv);
        if (div.css("display") == "none") {
            if (!div.hasClass('orderRetrieved')) {
                cursor_wait();
                wcRenderContext.updateRenderContext(contextId, {
                    'beginIndex': 0,
                    'storeId': this.storeId,
                    'catalogId': this.catalogId,
                    'langId': this.langId,
                    'initializeJS': initializeJS
                });
                div.addClass('orderRetrieved');
            }
        }
        this._toggleOrderItemDetails(div);
    },

    toggleOrderItemDetailsSummary: function (orderItemDetailsDiv, contextId, beginIndex, pageSize, exOrderId, exQuoteId, fromOrderDetails, analytics) {
        var div = $("#" + orderItemDetailsDiv);
        if (div.css("display") == "none") {
            if (!div.hasClass('orderRetrieved')) {
                cursor_wait();
                wcRenderContext.updateRenderContext(contextId, {
                    'beginIndex': '',
                    'pageSize': pageSize,
                    'externalOrderId': exOrderId,
                    'externalQuoteId': exQuoteId,
                    'isFromOrderDetailsPage': 'false',
                    'analytics': analytics
                });
                div.addClass('orderRetrieved');
            }
        }
        this._toggleOrderItemDetails(div);
    },

    /**
     * Redirect Guest User to Login/Registration Custom Checkout Step
     */
    redirectToLoginRegisterStep : function(registerLogonURL){
        window.location.href = registerLogonURL;
    },

    /**
     * Redirect Guest User to Login/Registration Custom Checkout Step
     */
     ajaxRedirectToLoginRegisterStep : function(registerLogonURL){
        window.location.href = registerLogonURL;
    },

    /**
     * Redirect PayPal checkout
     */
    redirectToPayPalCheckout : function(paypalURL){
        sessionStorage.setItem("isStepPayPalExpress", true);
        paypalURL += "&piAmount=" + $('#totalAmountForPPshortcut').val().trim();
        paypalURL += "&customerWebId=" + window.forterWebId;
        paypalURL += "&customerIPAddress=" + window.ipaddress;
        paypalURL += "&forterToken=" + window.forterToken;
        window.location.href = paypalURL;
        tealiumPushCheckoutStep('PayPalExpressCheckout');
    },

     /**
     * Only for Carol. Update and display shipping methods area passed on zipCode.
     */
    updateShippingMethodsArea : function() {
        var zipcode = $('#zipCodeField').val();
        if (zipcode.length < 9) {
            if (zipcode.length == 0) {
                $('.shipping-method__block').addClass('nodisplay');
                $('#datepicker').addClass('nodisplay');
            }
            return;
        }

        if (addressId === undefined
                || addressId === "" ||
                (oldZipCode != zipcode && storeUserType != undefined && storeUserType === "G")) {
            var addressURL = "/wcs/resources/store/"+ WCParamJS.storeId +"/customAddressValidation/byZipCode/" + zipcode;
            $.ajax({
                url: addressURL,
                dataType: 'json',
                type: 'GET',
                success: function (data) {
                    var city = null;
                    var state = null;
                    var zipcode = null;
                    //getting data
                   if (data != null && data.addressInfo[0] != null) {
                       if ( data.addressInfo[0].country == null) {
                           console.error("Zip code invalid / NOT FOUND, ZERO_RESULTS");
                       } else {
                           if (data.addressInfo[0].city != null) {
                               city = data.addressInfo[0].city;
                           }
                           if (data.addressInfo[0].state != null) {
                               state = data.addressInfo[0].state;
                           }
                           if (data.addressInfo[0].zipcode != null) {
                               zipcode = data.addressInfo[0].zipcode;
                           }
                       }

                        // submit AjaxPersonChangeServiceAddressAdd request to create new address to calculate shipping when no address
                        // assigned to the order.
                        var params = [];

                        params.storeId      = ServicesDeclarationJS.storeId;
                        params.catalogId    = ServicesDeclarationJS.catalogId;
                        params.langId       = ServicesDeclarationJS.langId;

                        params.zipCode = zipcode != null ? zipcode : "";
                        params.city = city != null ? city : "";
                        params.state = state != null ? state : "";
                        params.country = countryCode;
                        params.nickName = (nickName != null && nickName != "")? nickName : "MyAddress_Shipping";
                        if (addressId != null && addressId != '') {
                            params.addressId = addressId;
                            var url = getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate?";
                        } else {
                            var url = getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd?";
                        }

                        for (var param  in params) {
                            url += param + "=" + params[param] + "&";
                        }
                        $.ajax({
                            url: url,
                            type: 'POST',
                            success: function (data) {
                                var url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/person/@self/contact";
                                $.ajax({
                                    url: url,
                                    type: 'GET',
                                    headers: {
                                       "Content-Type": "application/json",
                                       "Cache-Control": "no-cache, no-store, must-revalidate"
                                   },
                                   data: {
                                       "timestamp": Date.now()
                                   },
                                    success: function (data) {
                                        if(data != undefined && data.contact != undefined){
                                            for(var i = 0; i < data.contact.length; i++){
                                                if((data.contact[i].addressType === "Shipping" || data.contact[i].addressType === "ShippingAndBilling") && (addressId == null || addressId == "" ||  addressId == data.contact[i].addressId)){
                                                    addressId = data.contact[i].addressId;
                                                    oldZipCode = data.contact[i].zipCode;
                                                    nickName = data.contact[i].nickName;
                                                }
                                            }
                                            wcRenderContext.getRenderContextProperties('ShippingMethodsSelectContext')['orderId']=orderId;
                                            wcRenderContext.getRenderContextProperties('ShippingMethodsSelectContext')['zipCode']=zipcode;
                                            wcRenderContext.getRenderContextProperties('ShippingMethodsSelectContext')['addressId']=addressId;

                                            $("#shippingMethodDisplayArea").refreshWidget("refresh", wcRenderContext.getRenderContextProperties("ShippingMethodsSelectContext"));
                                        }
                                    },
                                    error: function(data){
                                        console.log("PSL::CheckoutHelper.js::calculateEstematedTax function ajax error (contact)");
                                        console.log(data);
                                    }
                                });
                                CheckoutHelperJS.updateOrderSummary(true);
                            },
                            error: function (xhr, ajaxOptions, thrownError) {
                                CheckoutHelperJS.updateOrderSummary(true);
                            }
                        });

                    }
                },
                error: function (xhr, ajaxOptions, thrownError) {

                }
            });
        } else {
            wcRenderContext.getRenderContextProperties('ShippingMethodsSelectContext')['orderId']=orderId;
            wcRenderContext.getRenderContextProperties('ShippingMethodsSelectContext')['zipCode']=zipcode;

            $("#shippingMethodDisplayArea").refreshWidget("refresh", wcRenderContext.getRenderContextProperties("ShippingMethodsSelectContext"));
        }

    },

    /**
     * Only for Carol. Show/hide elements inside shipping methods
     */

   showHideGreyShippingMethodsElements : function(hasCEP) {
       var isCheckout = ($('.checkout-page').length > 0);
       if(isCheckout) {
           if(hasCEP == 'true'){
               $('.shipping-method').removeClass('shipping-method--grey');
               $('.physical-stores').removeClass('shipping-method--grey');
               $('#physicalStoresTitle').hide();
               $('.physical-stores > h3').hide();
               $('#shippingMethodTitle').show();
           } else {
               $('.shipping-method').addClass('shipping-method--grey');
               $('.physical-stores').addClass('shipping-method--grey');
               $('#physicalStoresTitle').show();
               $('.physical-stores > h3').show();
               $('#shippingMethodTitle').hide();
           }
       } else {
           $('#physical-stores__title').hide();
       }
     },

     /**
      * Only for Carol. Refresh controller declaration for the Shippong Method display area.
      * @constructor
      */
     declareShippingAddressesDisplayAreaController : function(widgetId) {
          wcRenderContext.declare("shippingAddressDropDownBoxContext", [], {selectedAddressId: ""});
         if(typeof widgetId == "object" || typeof widgetId == "array") {
             widgetId = widgetId[0];
         }
         var myWidgetObj = $("#" + widgetId);

         wcRenderContext.addRefreshAreaId("shippingAddressDropDownBoxContext", widgetId);
         var myRCProperties = wcRenderContext.getRenderContextProperties("shippingAddressDropDownBoxContext");

         myWidgetObj.refreshWidget({
             renderContextChangedHandler: function() {
                 var areaNumber = myRCProperties["areaNumber"];
                 var objectId = widgetId;
                     myWidgetObj.refreshWidget("refresh", {});
             },

             postRefreshHandler: function() {
                 CheckoutHelperJS.updateAddressIdOFItemsOnCreateEditAddress(selectedAddressId);
                 AddressHelper.updatePhysicalStoresArea(addressToZipCodeMap[selectedAddressId]);
             }
         });

     },
    /**
     * Only for Carol. Refresh controller declaration for the Shippong Method display area. This function to be deleted after making the grunt build.
     * @constructor
     */
    declareShippingMethodDisplayAreaController : function(widgetId, orderId, addDeclaration) {
        if (typeof addDeclaration == "undefined" || addDeclaration == true) {
            wcRenderContext.declare("ShippingMethodsSelectContext", [], {orderId:orderId,zipCode: ""});
        }
        if(typeof widgetId == "object" || typeof widgetId == "array") {
            widgetId = widgetId[0];
        }
        var myWidgetObj = $("#" + widgetId);

        wcRenderContext.addRefreshAreaId("ShippingMethodsSelectContext", widgetId);
        var myRCProperties = wcRenderContext.getRenderContextProperties("ShippingMethodsSelectContext");

        myWidgetObj.refreshWidget({
            renderContextChangedHandler: function() {
                var areaNumber = myRCProperties["areaNumber"];
                var objectId = widgetId;
                    var orderId = myRCProperties["orderId"+areaNumber];
                    myWidgetObj.refreshWidget("refresh", {"orderId": orderId,"ZipCode":""});
            },

            postRefreshHandler: function() {
                if (typeof hasValidAddress == "undefined") {
                    var forceClick = true;
                } else {
                    var forceClick = hasValidAddress;
                }
                if ($("[name=singleShipmentShippingMode]:checked")!= undefined && forceClick) {
                    $("[name=singleShipmentShippingMode]:checked").trigger('click');
                }
                //clears the progress bar set from billingdropdowndisplay.jsp
                cursor_clear();
                var params = [];

                params.storeId      = this.storeId;
                params.catalogId    = this.catalogId;
                params.langId       = this.langId;
                params.requestType = "get";
                cursor_wait();
                wcService.invoke("AjaxShippingDateUpdate", params);
            }
        });

    },

    /**
    * Only for Carol. Update shipping date then redirect.
    */
    updateShippingDateAndRedirect : function(redirectURL) {
        if (document.querySelector('input[name="singleShipmentShippingMode"]:checked') != undefined &&
                document.querySelector('input[name="singleShipmentShippingMode"]:checked').getAttribute("shipmodecode") == 'Scheduled delivery') {
            redirectToURL = redirectURL;
            var params = [];

            params.storeId      = this.storeId;
            params.catalogId    = this.catalogId;
            params.langId       = this.langId;
            params.orderId      = ".";
            params.requestType = "update";
            var time = "0700";
            if (document.querySelector('input[name="shippingSelectTime"]:checked').value == "noon") {
              time = "1200";
            } else if (document.querySelector('input[name="shippingSelectTime"]:checked').value == "night") {
              time = "1800";
            }
            var date = $("#datepicker-holder").datepicker('getDate');
            var formattedDate = $.datepicker.formatDate("yymmdd", date);
            params.shippingDate = formattedDate + time;
            cursor_wait();
            wcService.invoke("AjaxShippingDateUpdate", params);
        } else {
            CheckoutHelperJS.redirectToLoginRegisterStep(redirectURL);
        }
    }
}
//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2007, 2015 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript is used by UserRegistrationAddForm.jsp and CheckoutLogon.jsp.
 * @version 1.0
 */

/**
 *  The functions defined in the class helps the customer to register with the store. Another function enables a returning
 *  customer to Sign in for quickcheckout from the shopping cart page.
 *
 *  @class This LogonForm class defines all the functions and variables used to validate the information provided by the
 *  customer to register with the store.To register, a customer creates a logon ID and password. Then, the customer provides their first name,
 *  last name, street address, city, country/region, state/province, ZIP/postal code, e-mail address and phone number. Other registration options
 *  include promotional e-mails, preferred language and currency, age, gender, and the remember me option.
 */
LogonForm ={

    /**
     * This function validates the logon ID and password for returning customers to sign in and complete the checkout process.
     * @param {string} form The name of the form containing logon ID and password fields.
     */
    SubmitAjaxLogin:function(form){

        if(!this.validateAjaxLogin(form)){
            return;
        };
        setDeleteCartCookie();

        form.submit();

    },

    validateAjaxLogin:function(form){
        reWhiteSpace = new RegExp(/^\s+$/);

        if(form.logonId != null && reWhiteSpace.test(form.logonId.value) || form.logonId.value == ""){
            MessageHelper.formErrorHandleClient(form.logonId.id,MessageHelper.messages["LOGON_REQUIRED_FIELD_ENTER"]); return false;}

        if(form.logonPassword != null && reWhiteSpace.test(form.logonPassword.value) || form.logonPassword.value == ""){
            MessageHelper.formErrorHandleClient(form.logonPassword.id,MessageHelper.messages["PASSWORD_REQUIRED_FIELD_ENTER"]); return false;}

        return true;
    },

    /**
     * This function is called when the Submit button is clicked on the Registration page. 
     * Ensures that the newsletter check exists and perform the submit.
     * 
     * @param {string} form The name of the registration form containing all the customer information.
     */
    performRegistration:function(form){

        //HB-2946 - All registration an newsletter should be performed on lower case
        form.elements.email1.value = form.elements.email1.value.toLowerCase();

        var newsletterCheck = $("#gdpr-checkbox-newsletter").is(":checked");
        if(isPersol){
        	var profiling = $("#gdpr-checkbox-personal").is(":checked");
        }else{
        	var profiling = $("#gdpr-checkbox-profiling").is(":checked");
        }
        
        
        
        var emailRegistration = form.elements.email1.value;
        var fName = form.elements.firstName.value;
        var lName = form.elements.lastName.value;

        //Validate just in case that isChecked the newsletter only for Persol or is a non GDPR store
        if (typeof isGDPR !== 'undefined' && (!isGDPR && !isPersol) || newsletterCheck || profiling) {
            wcService.declare({
                id: "JoinNewsletterServiceRegistration",
                actionId: "JoinNewsletterService",
                url: "JoinNewsletterService",
                formId: ""
            
                ,successHandler: function(serviceResponse) {
                    form.submit();
                    localStorage.setItem('chekoutUserOptin',serviceResponse.userOptin);
                    /* START Early Access */
                    if (isPersol || isVogue) assignCustomerSegment();
                    /* END Early Access */
                    cursor_clear();
                }
                ,failureHandler: function(serviceResponse) {
                    form.submit();
                    cursor_clear();
                }
            
            });
            var cidCookie = null;
            
            if(document.cookie.includes('X_WC_CID')){
            	cidCookie = $.cookie("X_WC_CID");
            }
            
            var params = {
                    storeId: WCParamJS.storeId,
                    langId : WCParamJS.langId,
                    email: emailRegistration,
                    firstName: fName,
                    lastName: lName,
                    profiling: profiling,
                    subscription: newsletterCheck,
                    isFormRegistration:true,  
                    cid: cidCookie
                }
            cursor_wait();
            wcService.invoke("JoinNewsletterServiceRegistration", params);

        } else {
            /* START Early Access */
            if (isPersol || isVogue) assignCustomerSegment();
            /* END Early Access */
            form.submit();
        }
        
    },
    /**
     * This function is called when the Submit button is clicked on the Registration page. All the fields containing customer
     * information are validated and PersonProcessServicePersonRegistration is called.
     * @param {string} form The name of the registration form containing all the customer information.
     */
    prepareSubmit:function (form) {
        //cursor_clear();
        if(CSRWCParamJS.env_shopOnBehalfSessionEstablished == 'true' || CSRWCParamJS.env_shopOnBehalfEnabled_CSR == 'true') {
            var random = Math.random();
            var randomPassword = random.toString(36).slice(-7); // Get last 7 chars. Will add one numeric char to make it 8 char long...
            var randomInt = Math.floor((random * 9) + 1);
            randomPassword += randomInt; //Password should contain atleast one numeric character...
            if ($("#logonPassword").val() == null || $("#logonPassword").val() == "") {
                $('<input>').attr({
                    type: 'hidden',
                    value: randomPassword,
                    name: "logonPassword",
                    id: "logonPassword",
                }).appendTo('form');
            }

            if ($("#logonPasswordVerify").val() == null || $("#logonPasswordVerify").val() == "") {
                $('<input>').attr({
                    type: 'hidden',
                    value: randomPassword,
                    name: "logonPasswordVerify",
                    id: "logonPasswordVerify"
                }).appendTo('form');
            }

            if ($("#passwordExpired").val() == null || $("#passwordExpired").val() == "") {
                $("#passwordExpired").val("1");
            }
        }

        if (!this.validatePrepareForm(form)) {
            moveToError();
            console.log("There is something wrong with in register form");
            restoreAjaxButtons();
             /* TEALIUM BEGIN Logon fail */
            if(typeof tealium_data2track !== 'undefined'){
            	var message =  $('.password-policies-title-error').text();
	             var trackData = {};
	             trackData['id'] = "Event";
                 trackData['Events_Error'] = "1";
	             trackData['Error_Code'] = 'Form Filling Error';
	             trackData['Error_Source'] = "User";
	             trackData['Error_Message'] = this.tealiumValidateError;
	             trackData['Error_Details'] = this.tealiumValidateError;
	             tealium_data2track.push(trackData);
            }
            /* TEALIUM END */
            console.log("TEALIUM::Create user fail.");
            
            return;
        }

        setCookie("WC_SHOW_USER_ACTIVATION_" + WCParamJS.storeId, "true", {path:'/', domain:cookieDomain});
        if(CSRWCParamJS.env_shopOnBehalfEnabled_CSR == 'true' ||
                (CSRWCParamJS.env_shopOnBehalfSessionEstablished == 'true' &&  form.userId != null && form.userId.value != null)){
            // CSR is creating the user OR
            // OnBehalf session is started and CSR is registering existing guestUser.
            // Uses UserRegistrationAdminAddCmd
            if(registeredCustomersJS != null) {
                registeredCustomersJS.createRegisteredUser(form.landingURL_CSR.value);
            }
        } else {
            this.performRegistration(form);
        }
    },

    /**
     * The function is called to validate and prepare the form.
     * @param {string} form The name of the registration form containing all the customer information.
     * @return (Boolean) true if the form is ready to submit, false otherwise.
     */
    validatePrepareForm: function(form) {
        var isValid = true;
        reWhiteSpace = new RegExp(/^\s+$/);
        if (form.logonId != null && reWhiteSpace.test(form.logonId.value) || form.logonId.value == "") {
            this.manageMultipleErrorFields(form.logonId,MessageHelper.messages["ERROR_LogonIdEmpty"], false);
            isValid = false;
        } else if (!AddressHelper.validateEmail(form.logonId)) {
            this.manageMultipleErrorFields(form.logonId,MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"], false);
            isValid = false;
        } else if (typeof this.validateLoginId == "function") {
            if (!this.validateLoginId(form.logonId)) {
                isValid = false;
            }
        } else {
            this.manageMultipleErrorFields(form.logonId, "", true);
        }

        $('#emailError').css('display', 'none');

        if (form.ancestorOrgs != null) {
            if (form.ancestorOrgs.value == "") {
            	validateError = MessageHelper.messages["ERROR_OrgNameEmpty"];
                this.manageMultipleErrorFields(form.ancestorOrgs,MessageHelper.messages["ERROR_OrgNameEmpty"], false);
                this.tealiumValidateError = validateError;
                isValid = false;
            } else if (form.ancestorOrgs.value == "Default Organization") {
            	validateError = MessageHelper.messages["ERROR_DefaultOrgRegistration"];
                this.manageMultipleErrorFields(form.ancestorOrgs,MessageHelper.messages["ERROR_DefaultOrgRegistration"], false);
                this.tealiumValidateError = validateError;
                isValid = false;
            }
        }

        if (form.logonPassword != null && reWhiteSpace.test(form.logonPassword.value) || form.logonPassword.value == "") {
	        validateError = MessageHelper.messages["ERROR_PasswordEmpty"];
            this.manageMultipleErrorFields(form.logonPassword,MessageHelper.messages["ERROR_PasswordEmpty"], false);
            this.tealiumValidateError = validateError;
            isValid = false;
        } else {
            this.manageMultipleErrorFields(form.logonPassword, "", true);
        }

        if (form.logonPasswordVerify != null && reWhiteSpace.test(form.logonPasswordVerify.value) || form.logonPasswordVerify.value == "") {
	        validateError = MessageHelper.messages["ERROR_VerifyPasswordEmpty"];
            this.manageMultipleErrorFields(form.logonPasswordVerify,MessageHelper.messages["ERROR_VerifyPasswordEmpty"], false);
            this.tealiumValidateError = validateError;
            isValid = false;
        } else {
            this.manageMultipleErrorFields(form.logonPasswordVerify, "", true);
        }

        if (form.logonPassword.value != form.logonPasswordVerify.value) {
	        validateError = MessageHelper.messages["PWDREENTER_DO_NOT_MATCH"];
            this.manageMultipleErrorFields(form.logonPasswordVerify,MessageHelper.messages["PWDREENTER_DO_NOT_MATCH"], false);
            this.tealiumValidateError = validateError;
            isValid = false;
        } else if (!(reWhiteSpace.test(form.logonPasswordVerify.value) || form.logonPasswordVerify.value == "")) {
            this.manageMultipleErrorFields(form.logonPasswordVerify, "", true);
        }

        if(!checkPasswordStrenght(form.logonPassword)) {
            $('.password-policies-title').addClass('hidden');
            $('.password-policies-title-error').removeClass('hidden');
            $('.input-style--password').addClass('error');
            this.tealiumValidateError =  $('.password-policies-title-error').text();
            isValid = false;
            var trackData = {};
            trackData['id'] = "Error"
            trackData['Error_Code'] = 'Form Filling Error' ;
            trackData['Error_Source'] = "User";
            trackData['Error_Message'] = this.tealiumValidateError;
            trackData['Error_Details'] = this.tealiumValidateError;
            pushDataToTealium(trackData);
        }
        else {
            $('.password-policies-title').removeClass('hidden');
            $('.password-policies-title-error').addClass('hidden');
            $('.input-style--password').removeClass('error');
            this.tealiumValidateError =  $('.password-policies-title-error').text();
        }
        

        /** Uses the common validation function defined in AddressHelper class for validating first name,
         *  last name, street address, city, country/region, state/province, ZIP/postal code, e-mail address and phone number.
         */
        if (!AddressHelper.validateAddressForm(form)) {
            isValid = false;
        }

        /* Checks whether the customer has registered for promotional e-mails. */
        if (form.sendMeEmail && form.sendMeEmail.checked) {
            form.receiveEmail.value = true;
        } else if (form["gdpr-checkbox-newsletter"] && form["gdpr-checkbox-newsletter"].checked) {
            form.receiveEmail.value = true;
        } else {
            form.receiveEmail.value = false;
        }

        if (form.sendMeSMSNotification &&  form.sendMeSMSNotification.checked) {
            form.receiveSMSNotification.value = true;
        } else {
            form.receiveSMSNotification.value = false;
        }

        if (form.sendMeSMSPreference && form.sendMeSMSPreference.checked) {
            form.receiveSMS.value = true;
        } else {
            form.receiveSMS.value = false;
        }

        if (form.mobileDeviceEnabled != null && form.mobileDeviceEnabled.value == "true") {
            if (!MyAccountDisplay.validateMobileDevice(form)) {
                isValid = false;
            }
        }
        if (form.birthdayEnabled != null && form.birthdayEnabled.value == "true") {
            if (!MyAccountDisplay.validateBirthday(form)) {
                isValid =  false;
            }
        }
        return isValid;
    },
    
    /**
     * Manage multiple address form error messages for each concerned field.
    */
    manageMultipleErrorFields: function (field, errorMsg, isNotEmpty) {
        var mandatoryErrorFieldId = 'mandatoryField_' + field.id;
        // var mandatoryErrorFieldId = 'mandatoryField_' + field.id;

        // Deletes the error message if the field is not empty anymore.
        if (isNotEmpty) {
            var currentField = document.getElementById(mandatoryErrorFieldId);
            if (currentField != null) {
                $(field).removeClass("field-error-message");
                currentField.remove();
            }
        } else {
            if (!document.getElementById(mandatoryErrorFieldId)) {
                var mandatoryField = this.getMandatoryField(field.id, errorMsg, isNotEmpty);
                if (field != null && field.parentNode != null) {
                    $(field).addClass("field-error-message");
                    // if (field.name != undefined && field.name.indexOf('logonPassword') >= 0) {
                    //     field.after(mandatoryField);
                    // } else {
                    //     field.parentNode.appendChild(mandatoryField);
                    // }
                    if(isVogue && field.name == 'logonPassword') {
                        field.insertAdjacentElement('afterend', mandatoryField);
                    } else {
                        field.parentNode.insertAdjacentElement('beforeend', mandatoryField);
                    }
                }
            }
        }
    },
   
   /**
    * mandatory field shown when one or multiple empty fields in forms
    */
   getMandatoryField: function (parentID, errorMsg, isNotEmpty) {
       //showing specific message per field
       if (typeof errorMsg === 'undefined' || errorMsg == null || errorMsg == "") {
           errorMsg = MessageHelper.messages["ADDR_MANDATORY_FIELD"];
       }

       var mandatoryField = document.createElement('div');
       mandatoryField.setAttribute("class", "address-erros-message-cont");
       mandatoryField.innerHTML = '<span tabindex="0" id="mandatoryField_' + parentID + '" class="error-message wcag__error">' + errorMsg + '</span>';
/* <div class="address-erros-message-cont"><span id="mandatoryField_+ parentID" +  class="error-message"> errorMsg </span></div> */
       return mandatoryField;
   }
}

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript is used by the Global Login widget to handle the services
 * @version 1.10
 */

/* global document, window, $, wc, Utils, WCParamJS, MessageHelper, cursor_clear, getAbsoluteURL */


/**
 * This service allows customer to sign in
 * @constructor
 */
wcService.declare({
    id: "globalLoginAjaxLogon", 
    actionId: "globalLoginAjaxLogon",
    url: getAbsoluteURL() + "AjaxLogon",
    formId: "",

    /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    successHandler: function (serviceResponse) {
        cursor_clear();
        var errorMessage = "";
        
        // START - HB-16650
        if(localStorage.getItem('trackMyOrder')){
        	localStorage.removeItem('trackMyOrder');
        }
        // END - HB-16650
        
        if (serviceResponse.ErrorCode != null) {
            var errorCode = Number(serviceResponse.ErrorCode);
            switch (errorCode) {
            case 2000:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2000"];
                break;
            case 2010:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2010"];
                break;
            case 2020:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2020"];
                break;
            case 2030:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2030"];
                break;
            case 2110:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2110"];
                break;
            case 2300:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2300"];
                break;
            case 2340:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2340"];
                break;
            case 2400:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2400"];
                break;
            case 2410:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2410"];
                break;
            case 2420:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2420"];
                break;
            case 2430:
                document.location.href = "ResetPasswordForm?storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&langId=" + WCParamJS.langId + "&errorCode=" + errorCode;
                break;
            case 2490:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2110"];
                break;
            case 2170:
                document.location.href = "ChangePassword?storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&langId=" + WCParamJS.langId + "&errorCode=" + errorCode + "&logonId=" + serviceResponse.logonId;
                break;
            case 2570:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2570"];
                break;
            case 2440:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2440"];
                break;
            case 2450:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2450"];
                break;
            case 2711 : 
                GlobalLoginJS.InitHTTPSecureFromPolicy();
                GlobalLoginJS.showPolicyPopup();
                	
            }
            if (document.getElementById(serviceResponse.widgetId + "_logonErrorMessage_GL") != null) {
                document.getElementById(serviceResponse.widgetId + "_logonErrorMessage_GL").innerHTML = errorMessage;
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonId_In_Logon_1").setAttribute("aria-invalid", "true");
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonId_In_Logon_1").setAttribute("aria-describedby", "logonErrorMessage_GL_alt");
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonPassword_In_Logon_1").setAttribute("aria-invalid", "true");
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonPassword_In_Logon_1").setAttribute("aria-describedby", "logonErrorMessage_GL_alt");
                document.querySelectorAll(".form-group .myaccount_error").forEach((el) => {
                    el.classList.add("active");
                });
            }

            /*--- WCAG Begin MCB --*/
            var attr = $('.myaccount_error').attr('tabindex');
            if(!(typeof attr !== typeof undefined && attr !== false)) {
                $('.myaccount_error').attr('tabindex', '0');
            }
            //this if prevents js error if WCAG.js are not imported
            if(typeof moveToError === 'function'){
                moveToError();
            }
            /*--- WCAG Begin MCB --*/

            /* TEALIUM BEGIN Logon fail */
            if(typeof tealium_data2track !== 'undefined'){
	            var code = 'Error while trying to login user';
	            pushErrorToTealium('Server', '', code, errorMessage);
            }
            /* TEALIUM END */

        } else {
        	sessionStorage.setItem('logged', 'true');
            var url = serviceResponse.URL[0].replace(/&amp;/g, '&'),
                languageId = serviceResponse.langId;
            if (languageId != null && document.getElementById('langSEO' + languageId) != null) { // Need to switch language.

                var browserURL = document.location.href,
                    currentLangSEO = '/' + $('#currentLanguageSEO').val() + '/';

                if (browserURL.indexOf(currentLangSEO) !== -1) {
                    // If it's SEO URL.
                    var preferLangSEO = '/' + $('#langSEO' + languageId).val() + '/';

                    var query = url.substring(url.indexOf('?') + 1, url.length),
                        parameters = Utils.queryToObject(query);
                    if (parameters["URL"] != null) {
                        var redirectURL = parameters["URL"],
                            query2 = redirectURL.substring(redirectURL.indexOf('?') + 1, redirectURL.length),
                            parameters2 = Utils.queryToObject(query2);
                        // No redirect URL
                        if (parameters2["URL"] != null) {
                            var finalRedirectURL = parameters2["URL"];
                            if (finalRedirectURL.indexOf(currentLangSEO) != -1) {
                                // Get the prefer language, and replace with prefer language.
                                finalRedirectURL = finalRedirectURL.replace(currentLangSEO, preferLangSEO);
                                parameters2["URL"] = finalRedirectURL;
                            }
                            query2 = $.param(parameters2);
                            redirectURL = redirectURL.substring(0, redirectURL.indexOf('?')) + '?' + query2;
                        } else {
                            //Current URL is the final redirect URL.
                            redirectURL = redirectURL.toString().replace(currentLangSEO, preferLangSEO);
                        }
                        parameters["URL"] = redirectURL;
                    }
                    query = $.param(parameters);
                    url = url.substring(0, url.indexOf('?')) + '?' + query;

                } else {
                    // Not SEO URL.
                    // Parse the parameter and check whether if have langId parameter.
                    if (url.contains('?')) {
                        var query = url.substring(url.indexOf('?') + 1, url.length),
                            parameters = Utils.queryToObject(query);
                        if (parameters["langId"] != null) {
                            parameters["langId"] = languageId;
                            var query2 = $.param(parameters);
                            url = url.substring(0, url.indexOf('?')) + '?' + query2;
                        } else {
                            url = url + "&langId=" + languageId;
                        }
                    } else {
                        url = url + "?langId=" + languageId;
                    }
                }
            }

            if (isPersol && $("#page").hasClass("checkout")){
                var physicalStoreSelectionURL = $("#GLPhysicalStoreSelectionURL").val();
                var billingShippingPageURLForOnline = $("#GLRegisteredUserOrderCalculateURL").val();
		
                if (ShipmodeSelectionExtJS.isBOPISEnabled() && ShipmodeSelectionExtJS.isPickUpInStore()) {
                    url = physicalStoreSelectionURL;
                } else {
                    url = billingShippingPageURLForOnline;
                }
            }

            if (serviceResponse["MERGE_CART_FAILED_SHOPCART_THRESHOLD"] == "1") {
                setCookie("MERGE_CART_FAILED_SHOPCART_THRESHOLD", "1", {path: "/", domain: cookieDomain});
            }

            /* START Early Access */
            if (isPersol || isVogue) assignCustomerSegment();
            /* END Early Access */

            /* START - Wishlist */
            if (isPersol || isOliver) {
                sessionStorage.removeItem("defaultWishlistExternalId");
                sessionStorage.removeItem("wishlistObj");
            }
            /* END - Wishlist */

            window.location = url;

             /*--- WCAG Begin MCB --*/
             var attr = $('.myaccount_error').attr('tabindex');
             if(typeof attr !== typeof undefined && attr !== false) {
                 $('.myaccount_error'). removeAttr('tabindex');
             }
             /*--- WCAG Begin MCB --*/
            
            /* TEALIUM BEGIN Login success */
            /* HB-11904 BEGIN*/
            /*if(typeof tealium_data2track !== 'undefined'){
                tealium_data2track.push({
             	   'id' : 'X-X-CheckoutDelivery-Login',
             	   'User_Email_MD5' : serviceResponse.userEmail
             	});
            }*/
            /* HB-11904 END*/
            /* TEALIUM END */
        }
    },

    /**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    failureHandler: function (serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
            if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        }
        cursor_clear();
    }
});
//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2015 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This file provides all the functions and variables to manage Global Login panel.
 */

/* global document, window, $, setCookie, getCookie, cookieDomain, WCParamJS, GlobalLoginJS, Utils, cursor_clear, cursor_wait, submitRequest, wc, processAndSubmitForm, invokeItemAdd, invokeOtherService, isOnPasswordUpdateForm, service */

/**
* Constant key in activePanel
*/
var KEY_ACTIVE = 'active',

    /**
    * Constant key in activePanel
    */
    KEY_SELECTED = 'selected'; 

GlobalLoginJS = {

    /**
     * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
     * @private
     */
    langId: "-1",

    /**
     * This variable stores the ID of the current store. Its default value is empty.
     * @private
     */
    storeId: "",

    /**
     * This variable stores the ID of the catalog. Its default value is empty.
     * @private
     */
    catalogId: "",

    /**
     * This variable stores the ID of active panels. Its default value is empty.
     * @private
     */
    activePanel: {},

    widgetsLoadedOnPage: [],

    /**
     * This variable stores the ID of active panels. Its default value is empty.
     * @private
     */
    isPanelVisible: true,

    /**
     * True if mouse down event registered, false otherwise (prevents registering
     * event more than once).
     */
    mouseDownConnectHandle: null,
          
    logonId:null,
        
    reLogonURL : null,
       
    URL:null,
    
    /**
     * Sets the common parameters for the current page.
     * For example, the language ID, store ID, and catalog ID.
     *
     * @param {Integer} langId The ID of the language that the store currently uses.
     * @param {Integer} storeId The ID of the current store.
     * @param {Integer} catalogId The ID of the catalog.
     */
    setCommonParameters: function (langId, storeId, catalogId) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
        cursor_clear();
    },

    hideGLPanel: function (isPanelVisible) {
        this.isPanelVisible = isPanelVisible;
    },

    registerWidget: function (widgetId) {
        this.widgetsLoadedOnPage.push(widgetId);
    },
    
       
      /**
       * 
       */
     InitHTTPSecureFromPolicy : function(){
        	
        	 var href = document.location.href;
             var index = href.lastIndexOf("s", 4);
        	
             if(index == -1){
             	// Loaded with HTTP. Change it to HTTPS along with appropriate port.
         		if (WCParamJS.urlPrefixForHTTP) {
         			var newHref = href.substring(WCParamJS.urlPrefixForHTTP.length);
         			index = newHref.indexOf("/");
         			newHref = WCParamJS.urlPrefixForHTTPS + newHref.substring(index);
         		} else {
         			var newHref = href.substring(0,4) + "s" + (href.substring(4));
        		}
                 setCookie("WC_DisplaySignInPanel_" + WCParamJS.storeId, "true", {
                     path: '/',
                     domain: cookieDomain
                 });
                 window.location = newHref;
             }
    
            
            return;
        	
     },

    InitHTTPSecure: function (widgetId) {
        var href = document.location.href;
        var index = href.lastIndexOf("s", 4);

        if (index != -1) {
            // Open sign in panel if loaded with HTTPS.
            GlobalLoginJS.displayPanel(widgetId);

        } else {
			// Loaded with HTTP. Change it to HTTPS along with appropriate port.
			if (WCParamJS.urlPrefixForHTTP) {
				var newHref = href.substring(WCParamJS.urlPrefixForHTTP.length);
				index = newHref.indexOf("/");
				newHref = WCParamJS.urlPrefixForHTTPS + newHref.substring(index);
			} else {
				var newHref = href.substring(0,4) + "s" + (href.substring(4));
			}
            setCookie("WC_DisplaySignInPanel_" + WCParamJS.storeId, "true", {
                path: '/',
                domain: cookieDomain
            });
            window.location = newHref;
            return;
        }
    },

    displayPanel: function (widgetId) {
        //check if the sign in panel is loaded. if loaded, toggle the dropdown. Else, trigger a refresh.
        var widgetNode = $("#" + widgetId);
        if (widgetNode.length > 0) {
            var panelLoaded = widgetNode.attr("panel-loaded");
            if (panelLoaded) {
                this.togglePanel(widgetNode);
            } else if (typeof isOnPasswordUpdateForm === 'undefined' || isOnPasswordUpdateForm == false) {
                if (!submitRequest()) {
                    return;
                }
                cursor_wait();
                wcRenderContext.updateRenderContext("GlobalLogin_context",{"displayContract":"false", "widgetId" : widgetId});
            }
        }
    },

    togglePanel: function (widgetNode) {
        // toggle the current active global login panel
    	 if (this.activePanel[KEY_ACTIVE] != null && this.activePanel[KEY_SELECTED] != null) {
    		 //HB-661
    		 var idPrefix = this.activePanel[KEY_ACTIVE] + "_";
    		 var form_input_user = idPrefix + "WC_AccountDisplay_FormInput_logonId_In_Logon_1";
    		 var form_input_pass = idPrefix + "WC_AccountDisplay_FormInput_logonPassword_In_Logon_1";
    		 if (!$("#" + form_input_user).is(":focus") && !$("#" + form_input_pass).is(":focus")) {
    			 $("#" + this.activePanel[KEY_ACTIVE]).toggleClass("active");
	             $("#" + this.activePanel[KEY_SELECTED]).toggleClass("selected");
	
	             //if the current active panel is not the caller
	             if (this.activePanel[KEY_ACTIVE] != widgetNode.attr("id")) {
	                 var toggleControl = widgetNode.attr("data-toggle-control");
	                 //toggle current widget
	                 widgetNode.toggleClass("active");
	                 toggleControl.toggleClass("selected");
	
	                 //set the current caller as active
	                 this.activePanel[KEY_ACTIVE] = widgetNode.attr("id");
	                 this.activePanel[KEY_SELECTED] = toggleControl;
	             } else {
	                 delete this.activePanel.active;
	                 delete this.activePanel.selected;
	                 widgetNode.attr("panel-loaded", false);
	                 this.unregisterMouseDown();
	             }
    		 }
         } else {
             var toggleControl = widgetNode.attr("data-toggle-control");
             //no panel is active. toggle the current
             widgetNode.toggleClass("active");
             $("#" + toggleControl).toggleClass("selected");

             //set the current caller as active
             this.activePanel[KEY_ACTIVE] = widgetNode.attr("id");
             this.activePanel[KEY_SELECTED] = toggleControl;
             this.registerMouseDown();
         }
    },

    updateGlobalLoginSignInContent: function (widgetId) {
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        var redirectToPageName = getCookie("WC_RedirectToPage_" + WCParamJS.storeId);
        if (redirectToPageName != undefined && redirectToPageName != null) {
            setCookie("WC_RedirectToPage_" + WCParamJS.storeId, null, {
                expires: -1,
                path: '/',
                domain: cookieDomain
            });
        }
        wcRenderContext.updateRenderContext("GlobalLogin_context",{"displayContract":"false", "widgetId": widgetId, "redirectToPageName": redirectToPageName});
    },

    updateGlobalLoginUserDisplay: function (displayName) {
        $("#Header_GlobalLogin_signOutQuickLinkUser").html(displayName);
    },

    updateGlobalLoginContent: function (widgetId) {
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        if($('#'+widgetId).length){
	    	wcRenderContext.updateRenderContext("GlobalLogin_context",{"displayContract":"true", "widgetId": widgetId});
	    }else{
	    	cursor_clear();
	    }
    },

    updateOrganization: function (formName, widgetId) {
        var orgSetInSessionURL = widgetId + '_' + 'orgSetInSessionURL';
        var orgSetInSessionURLEle = document.getElementById(orgSetInSessionURL);
        if (orgSetInSessionURLEle != null) {
            var href = document.location.href;
            orgSetInSessionURLEle.value = href;
        }
        var form = document.forms[widgetId + '_' + formName];
        if (!submitRequest()) {
            return;
        }
        processAndSubmitForm(form);
    },

    prepareSubmit: function (widgetId) {
        var idPrefix = widgetId + "_";
        if (document.getElementById(idPrefix + "signInDropdown") != null && document.getElementById(idPrefix + "signInDropdown").className.indexOf("active") > -1) {
            document.getElementById(idPrefix + "inlinelogonErrorMessage_GL_logonPassword").setAttribute("class", "wcag__error errorLabel");
            document.getElementById(idPrefix + "inlineLogonErrorMessage_GL_logonId").setAttribute("class", "wcag__error errorLabel");
            var form_input_field = document.getElementById(idPrefix + "WC_AccountDisplay_FormInput_logonId_In_Logon_1");
            if (form_input_field != null) {
                if (this.isEmpty(form_input_field.value)) {
                    document.getElementById(idPrefix + "inlineLogonErrorMessage_GL_logonId").className = document.getElementById(idPrefix + "inlineLogonErrorMessage_GL_logonId").className + " active";
                    return false;
                }
            }
            var form_input_field = document.getElementById(idPrefix + "WC_AccountDisplay_FormInput_logonPassword_In_Logon_1");
            if (form_input_field != null) {
                if (this.isEmpty(form_input_field.value)) {
                    document.getElementById(idPrefix + "inlinelogonErrorMessage_GL_logonPassword").className = document.getElementById(idPrefix + "inlinelogonErrorMessage_GL_logonPassword").className + " active";
                    return false;
                }
            }
        }
        return true;
    },

    /**
     * Checks if a string is null or empty.
     * @param (string) str The string to check.
     * @return (boolean) Indicates whether the string is empty.
     */
    isEmpty: function (str) {
        var reWhiteSpace = new RegExp(/^\s+$/);
        if (str == null || str == '' || reWhiteSpace.test(str)) {
            return true;
        }
        return false;
    },

    /**
     * Updates the contract that is available to the current user.
     * @param {string} formName  The name of the form that contains the selected contracts.
     */
    updateContract: function (formName) {
        var form = document.forms[formName];

        /* For Handling multiple clicks. */
        if (!submitRequest()) {
            return;
        }

        form.submit();
    },

    deleteUserLogonIdCookie: function (contractURL) {
        var userLogonIdCookie = getCookie("WC_LogonUserId_" + WCParamJS.storeId);
        sessionStorage.setItem('logged', 'false');
        if (userLogonIdCookie != null) {
            setCookie("WC_LogonUserId_" + WCParamJS.storeId, null, {
                expires: -1,
                path: '/',
                domain: cookieDomain
            });
        }
        /* START - Wishlist */
        if (isPersol || isOliver) {
            sessionStorage.removeItem("defaultWishlistExternalId");
            sessionStorage.removeItem("wishlistObj");
        }
        /* END - Wishlist */
    },

    changeRememberMeState: function (jspStoreImgDir, target) {
        var targetEle = document.getElementById(target);
        if (targetEle.className.indexOf("active") > -1) {
            targetEle.className = targetEle.className.replace('active', '');
            targetEle.setAttribute("aria-checked", "false");
            targetEle.setAttribute("src", jspStoreImgDir + "images/checkbox.png");
            document.getElementById(target.replace("_img", "")).setAttribute("value", "false");
        } else {
            targetEle.className = targetEle.className + " active";
            targetEle.setAttribute("src", jspStoreImgDir + "images/checkbox_checked.png");
            targetEle.setAttribute("aria-checked", "true");
            document.getElementById(target.replace("_img", "")).setAttribute("value", "true");
        }
    },

    deleteLoginCookies: function () {
        this.deleteUserLogonIdCookie();
        setCookie("WC_BuyOnBehalf_" + WCParamJS.storeId, null, {
            path: '/',
            expires: -1,
            domain: cookieDomain
        });
    },

    /**
     * Submit a global login sign in form
     * @param (object) widgetId The form widgetId id.
     */
    submitGLSignInForm: function (formId, widgetId) {
        service = wcService.getServiceById('globalLoginAjaxLogon');
        service.setFormId(formId);
        
        var logonForm = document.getElementById(formId);
        if(logonForm != null){
        	if(logonForm.logonId != null){
                this.logonId = logonForm.logonId.value;
        	}
        	if(logonForm.URL != null){
        		this.URL = logonForm.URL.value
        	}
        	if(logonForm.reLogonURL != null){
        		this.relogonURL = logonForm.reLogonURL.value;
        	}
        }

        
        var params = {
            widgetId: widgetId,
            acceptedPolicyValue: 'false',
            isShopperLogin: 'true'
        };

        /*For Handling multiple clicks. */
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        wcService.invoke('globalLoginAjaxLogon', params);
    },
    
    /**
     * 
     */
    submitGLSignInFormFromPolicyPopup : function(formId,widgetId,reLogonURL){
    	
        var encodedReLogonURI = encodeURI(reLogonURL);
        var acceptedPolicyValue = "";
           	
        //NERD-93 accept policy
        var acceptPolicyCheckBox = document.getElementById('agreeConcent_popup');

        
        if(acceptPolicyCheckBox != null){
        	acceptedPolicyValue = acceptPolicyCheckBox.checked;
        }
                
        service = wcService.getServiceById('globalLoginAjaxLogon');
        service.setFormId(formId);
        
        var params = {
            acceptedPolicyValue:acceptedPolicyValue,
        	reLogonURL : this.relogonURL,
            URL : this.URL,
            isShopperLogin: 'true'
        };

        /*For Handling multiple clicks. */
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        
        wcService.invoke('globalLoginAjaxLogon', params);
    	
    },

    /**
     * After successful login and setting a contract in session, we need to process the action that the shopper
     * was performing before signing in. It will do nothing if shopper was not trying to perform any actions.
     */
    processNextURL: function () {
        var myNextURL = getCookie("WC_nextURL_" + WCParamJS.storeId);
        if (myNextURL != undefined && myNextURL.length > 0) {
            myNextURL = myNextURL.replace(/&amp;/g, "&");
            if (myNextURL.indexOf('AjaxRESTOrderItemAdd') != -1) {
                invokeItemAdd(myNextURL);
            } else {
                invokeOtherService(myNextURL);
            }
        }
    },

    registerMouseDown: function () {
        if (!this.mouseDownConnectHandle) {
            $(document.documentElement).on("mousedown", $.proxy(this.handleMouseDown, this));
            this.mouseDownConnectHandle = true;
        }
    },

    unregisterMouseDown: function () {
        if (this.mouseDownConnectHandle) {
            $(document.documentElement).off("mousedown");
            this.mouseDownConnectHandle = false;
        }
    },

    handleMouseDown: function (evt) {
        if (this.activePanel[KEY_ACTIVE] != null && this.activePanel[KEY_SELECTED] != null) {
            Utils.ifSelectorExists("#" + this.activePanel[KEY_ACTIVE], function(widgetNode) {
                var toggleControl = $("#" + this.activePanel[KEY_SELECTED]);
                var node = evt.target;
                if (node != document.documentElement) {
                    var close = true;
                    while (node && node != document.documentElement) {
                        if (Utils.elementExists("#" + node.id + "_dropdown") && Utils.elementExists("#" + widgetNode.id + "_numEntitledContracts") != null && $("#" + widgetNode.id + "_numEntitledContracts").val() > 0) {
                            var nodePosition = Utils.position(node),
                                windowHeight = window.innerHeight,
                                newHeight;
                            if (windowHeight - nodePosition.y > nodePosition.y) {
                                newHeight = windowHeight - nodePosition.y;
                            } else {
                                newHeight = nodePosition.y;
                            }
                            var dropdownHeight = $("#" + node.id + "_dropdown").get(0).clientHeight;
                            if (dropdownHeight > newHeight) {
                                $("#" + node.id + "_dropdown").css("height", newHeight + "px");
                            }
                        }
                        if (widgetNode.is(node) || toggleControl.is(node) || $(node).hasClass("dijitPopup")) {
                            close = false;
                            break;
                        }
                        node = node.parentNode;
                    }
                    node = null;
                    if (node == null) {
                        widgetNode.children("div").each(function(i, e) {
                            var position = Utils.position(e);
                            if (evt.clientX >= position.x && evt.clientX < position.x + position.w &&
                                evt.clientY >= position.y && evt.clientY < position.y + position.h) {
                                close = false;
                                return false; // breaks
                            }
                        });
                        if (Utils.elementExists("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2_dropdown") &&
                            $("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2_dropdown").css("display") != "none" &&
                            Utils.elementExists("#" + widgetNode.id + "_numEntitledContracts") && $("#" + widgetNode.id + "_numEntitledContracts").val() > 0) {
                            var nodePosition = Utils.position("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2"),
                                windowHeight = window.innerHeight,
                                newHeight;
                            if (windowHeight - nodePosition.y > nodePosition.y) {
                                newHeight = windowHeight - nodePosition.y;
                            } else {
                                newHeight = nodePosition.y;
                            }
                            var dropDown = $("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2_dropdown"),
                                dropdownHeight = dropDown.get(0).clientHeight;
                            if (dropdownHeight > newHeight) {
                                dropDown.css("height", newHeight + "px");
                            }
                        }
                    }
                    if (close) {
                        this.togglePanel(widgetNode);
                    }
                }
            }, this);
        }
    },
    
      /**
        * show store policy popup
        */
       showPolicyPopup : function(){
         var policyPopup = $('#acceptance_policy_popup');
         policyPopup.data("wc-WCDialog").open();
        },
        
        /**
         * hides store policy popup
         */
        hidePolicyPopup : function(){
        	var policyPopup = $('#acceptance_policy_popup');
        	policyPopup.data("wc-WCDialog").close();
         }
};
//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2011, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

////////////////////////////////////////////////////
// MiniShopCartDisplay.js (Common implementation) //
////////////////////////////////////////////////////
//console.log("MiniShopCartDisplay.js (Common implementation) loaded");

function closeMiniShopCartDropDown(){
    var visiblePopup = $("div[aria-describedby=MiniShopCartProductAdded]:visible");
    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;

    //Start HB-12482 
    if((window.mobilecheck() || window.tabletPortraitCheck())){
    	$("html").css("overflow", "auto");	
    }
  //End HB-12482 
    
    if (visiblePopup.length>0){
    	if(isPersol) {
    		if(productDisplayJS.priceSwitched){
                if (!isWishlistPage){
                    document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastPriceSaved;
                    document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastOfferPriceSaved;
                    if(affirmEnabled) {
                        customizeAffirmPrice();
                    }
                } else {
                    var minicartAddedId = $("#cartDropdown .products.added .product").attr("data-minicart-id");
                    document.getElementById('offerPrice_'+ minicartAddedId).innerText = productDisplayJS.lastPriceSaved;
                    document.getElementById('listPrice_'+ minicartAddedId).innerText = productDisplayJS.lastOfferPriceSaved;
                    $('#header').removeClass("mincartOpened")
                }
		    	productDisplayJS.priceSwitched = false;
    		}
            //START Early Access
            window.lastOfferPrice = returnLastOfferPrice();
            //END Early Access
    	}
    	else if(isOliver){
    		if(productDisplayJS.priceSwitched){
                var minicartAddedId = $("#cartDropdown .products .product").attr("data-minicart-id");
    			var elements = !isWishlistPage ? document.querySelectorAll('[id=offerPrice_'+productParent+']') : document.querySelectorAll('[id=offerPrice_'+minicartAddedId+']');
        		var div;
        		for(var i = 0; i<elements.length;i++) {
        			if(elements[i].nodeName == "DIV") {
        				div = elements[i];
        			}
        		}
        		if(div != undefined) {
        			div.getElementsByClassName('price__unity')[0].innerText = productDisplayJS.lastPriceSaved;
        		}
	    	 	
                if (!isWishlistPage){
                    document.getElementById('listPrice_'+productParent).innerText = productDisplayJS.lastOfferPriceSaved;
                } else {
                    document.getElementById('listPrice_'+minicartAddedId).innerText = productDisplayJS.lastOfferPriceSaved;
                }

		    	if(affirmEnabled && !isWishlistPage) {
		    		customizeAffirmPrice();
		    	}
		    	productDisplayJS.priceSwitched = false;
    		}
    		
    		//open Vm if was opened
    		if ($.cookie("isVMOpen") == "1") {
    			moveVMOverProduct();
    			vmTryThemOn();
    		}
    	}
    	productDisplayJS.lastPriceSaved =  "";
    	productDisplayJS.lastOfferPriceSaved = "";
    	if($('#current-clipon-catentry').length > 0 && (isPersol || isOliver)){
    		if($('#current-clipon-catentry').attr('isAdded') == 'true'){
    			$('#current-clipon-catentry').attr('isAdded','');
    		}else{
    			$(visiblePopup).find(".closeButton").click();
    		}
    	}else{
    		$(visiblePopup).find(".closeButton").click();
    	}
    	
    
        /*
        This WHILE has been added because in Oliver more than one #MiniShopCartProductAdded div is being created.
        It seems that the reason of this bug is that some html ids have been renamed/deleted in header_ui.jspf
        */
        while ($("#MiniShopCartProductAdded").length>0){
            $("#MiniShopCartProductAdded").remove();
        }
    }

    visiblePopup = $("div[aria-describedby=quick_cart_container]:visible");

    if (visiblePopup.length>0){
    	if($('#current-clipon-catentry').length > 0 && (isPersol || isOliver)){
    		if($('#current-clipon-catentry').attr('isAdded') == 'true'){
    			$('#current-clipon-catentry').attr('isAdded','');
    		}else{
    			$(visiblePopup).find(".closeButton").click();
    		}
    	}else{
    		$(visiblePopup).find(".closeButton").click();
    	}

        /*
        This WHILE has been added because in Oliver more than one #MiniShopCartProductAdded div is being created.
        It seems that the reason of this bug is that some html ids have been renamed/deleted in header_ui.jspf
        */
        while ($("#MiniShopCartProductAdded").length>0){
            $("#MiniShopCartProductAdded").remove();
        }
    }
    if (isOliver || isPersol) { 
        manageScrollOverlay(false);
    }

    if (isPersol){
        $('.shopperActions--monogram--added--button.remove').click();
    }
    
}

/*
//Extra events for minishopcart buttons
function bindMiniShopCartEvents(){
    $("#continueShoppingButton").on("click touchstart", function(){
        closeMiniShopCartDropDown();
        return false;
    });
}

$(document).ready(bindMiniShopCartEvents);
$(document).ajaxComplete(bindMiniShopCartEvents);
*/
/*
function repositionMiniShopCart(){
    var popup = $("div[aria-describedby=quick_cart_container]:visible, div[aria-describedby=MiniShopCartProductAdded]:visible");
    $(popup).css("top",-($(window).scrollTop())+"px");
}

//Manage minishopcart's position on mobile
function onScrollMiniShopCart(){
    console.log("PSL::onScrollMiniShopCart()");
    var reposition = false;
    var popup = $("div[aria-describedby=quick_cart_container]:visible, div[aria-describedby=MiniShopCartProductAdded]:visible");
    if ($(popup).length>0){
        for (var i = 0; i < $(popup).length; i++) {
            var element = $(popup)[i];
            if (!reposition && element.clientHeight > window.innerHeight){
                reposition = true;
            }
        }
    } else {
        console.log("PSL::onScrollMiniShopCart()::No minishopcart on screen");
    }

    if (reposition){
        console.log("PSL::onScrollMiniShopCart()::Repositioning minishopcart");
        var scrollTop = $(window).scrollTop();
        $(popup).css("top",(scrollTop*(-1))+"px");
    } else {
        console.log("PSL::onScrollMiniShopCart()::No reposition needed");
    }
}

$(document.body).on('touchmove', onScrollMiniShopCart); //mobile
$(window).on('scroll', onScrollMiniShopCart);           //desktop

function repositionMiniShopCartPopup(){
    console.log("Posicionando BEGIN");
    var popup = $("div[aria-describedby=quick_cart_container]:visible, div[aria-describedby=MiniShopCartProductAdded]:visible");
    $(popup).position({
        my: "right top",
        at: "right bottom",
        of: "#miniShopCartPopupPositionReference"
    });
    console.log("Posicionando END");
}
*/

//HB-1816 BEGIN Close MiniShopCart popup when the user clicks outside of it
$(document).click(function(event) {
    //console.log("PSL::MiniShopCartDisplay.js::Document clicked");

    // Ignore this event if preventDefault has been called.
    if (event.defaultPrevented){
        //console.log("PSL::MiniShopCartDisplay.js::event.defaultPrevented");
        return;
    }

    var isFade = ($(event.target).hasClass("quickcart--fade") || $(event.target).hasClass("minishopcartadded--fade"));

    var mouseX = event.pageX;
    var mouseY = event.pageY;

    if (mouseX != undefined && mouseY != undefined){
        //console.log("PSL::MiniShopCartDisplay.js::mouseX: " + mouseX + ", mouseY: " + mouseY);

        var visiblePopup = $("div[aria-describedby=MiniShopCartProductAdded]:visible");

        if (visiblePopup.length>0){
            event.stopPropagation();
            //console.log("PSL::MiniShopCartDisplay.js::Minicart Product Added popup visible");
            var popupX = $(visiblePopup).offset().left;
            var popupY = $(visiblePopup).offset().top;
            var popupW = $(visiblePopup).outerWidth();
            var popupH = $(visiblePopup).outerHeight();
            //console.log("PSL::MiniShopCartDisplay.js::popupOffsetX: " + popupX + ", popupOffsetY: " + popupY);
            //console.log("PSL::MiniShopCartDisplay.js::popupWidth: " + popupW + ", popupHeight: " + popupH);
            if (mouseX >= popupX && mouseX <= popupX + popupW && mouseY >= popupY && mouseY <= popupY + popupH || isFade){
                //console.log("PSL::MiniShopCartDisplay.js::Click inside");
            } else {
                //console.log("PSL::MiniShopCartDisplay.js::Click outside");
                event.preventDefault();
                event.stopPropagation();
                if($('#page').hasClass('pdp') && brandCode == 'PO'){
                    hideHeaderTimeout.setup();
                    $('#header').css('z-index', '5') 
                }
                $(visiblePopup).find(".closeButton").click();

                /*
                This WHILE has been added because in Oliver more than one #MiniShopCartProductAdded div is being created.
                It seems that the reason of this bug is that some html ids have been renamed/deleted in header_ui.jspf
                */
                while ($("#MiniShopCartProductAdded").length>0){
                    $("#MiniShopCartProductAdded").remove();
                }

                return false;
            }
        } else {
            //console.log("PSL::MiniShopCartDisplay.js::No visible Minicart");
        }

        visiblePopup = $("div[aria-describedby=quick_cart_container]:visible");

        if (visiblePopup.length>0){
            //console.log("PSL::MiniShopCartDisplay.js::Minicart Product List popup visible");
            var popupX = $(visiblePopup).offset().left;
            var popupY = $(visiblePopup).offset().top;
            var popupW = $(visiblePopup).outerWidth();
            var popupH = $(visiblePopup).outerHeight();
            //console.log("PSL::MiniShopCartDisplay.js::popupOffsetX: " + popupX + ", popupOffsetY: " + popupY);
            //console.log("PSL::MiniShopCartDisplay.js::popupWidth: " + popupW + ", popupHeight: " + popupH);
            if (mouseX >= popupX && mouseX <= popupX + popupW && mouseY >= popupY && mouseY <= popupY + popupH || isFade){
                //console.log("PSL::MiniShopCartDisplay.js::Click inside");
            } else {
                //console.log("PSL::MiniShopCartDisplay.js::Click outside");
                event.preventDefault();
                event.stopPropagation();
                $(visiblePopup).find(".closeButton").click();
                if(brandCode == 'PO' && $('#page').hasClass('pdp')){
                    hideHeaderTimeout.setup()
                }
                /*
                This WHILE has been added because in Oliver more than one #MiniShopCartProductAdded div is being created.
                It seems that the reason of this bug is that some html ids have been renamed/deleted in header_ui.jspf
                */
                while ($("#MiniShopCartProductAdded").length>0){
                    $("#MiniShopCartProductAdded").remove();
                }

                return false;
            }
        } else {
            //console.log("PSL::MiniShopCartDisplay.js::No visible Minicart");
        }
    }
});
//HB-1816 END

function lockShoppingBagIcon(){
    $("#widget_minishopcart").addClass("isDisabled");
    $("#widget_minishopcart").attr("href-disabled", $("#widget_minishopcart").attr("href") );
    $("#widget_minishopcart").attr("onclick-disabled", $("#widget_minishopcart").attr("onclick") );
    $("#widget_minishopcart").removeAttr("href");
    $("#widget_minishopcart").removeAttr("onclick");
}

function unlockShoppingBagIcon(){
    $("#widget_minishopcart").attr("href", $("#widget_minishopcart").attr("href-disabled") );
    $("#widget_minishopcart").attr("onclick", $("#widget_minishopcart").attr("onclick-disabled") );
    $("#widget_minishopcart").removeAttr("href-disabled");
    $("#widget_minishopcart").removeAttr("onclick-disabled");
    $("#widget_minishopcart").removeClass("isDisabled");
}

$(document).ready(function(){
    unlockShoppingBagIcon();
});


////////////////////////////////////////////////////
// OOTB source code                               //
////////////////////////////////////////////////////
/**
 * @fileOverview This file provides the common functions which are specific to the Mini Shopping cart
 */

/**
 * map order_updated to all the services that result in changes to an order
 * @static
 */

var order_updated = {
    'AjaxAddOrderItem': 'AjaxAddOrderItem',
    'AddOrderItem': 'AddOrderItem',
    'AjaxAddOrderItemWithShipingInfo': 'AjaxAddOrderItemWithShipingInfo',
    'AjaxDeleteOrderItem': 'AjaxDeleteOrderItem',
    'AjaxUpdateOrderItem': 'AjaxUpdateOrderItem',
    'AjaxUpdateOrderShippingInfo': 'AjaxUpdateOrderShippingInfo',
    'AjaxOrderCalculate': 'AjaxOrderCalculate',
    'AjaxLogoff': 'AjaxLogoff',
    'AjaxSetPendingOrder': 'AjaxSetPendingOrder',
    'AjaxUpdatePendingOrder': 'AjaxUpdatePendingOrder',
    'AjaxSingleOrderCancel': 'AjaxSingleOrderCancel',
    'AjaxUpdateRewardOption': 'AjaxUpdateRewardOption'
};

/** This variable indicates whether the mini cart drop down is updated or not. */
var dialogWidget,
    update_content = false,
    dropdownUpdated = false,
    /** This is variable indicates whether the mini cart drop down is being initialized. */
    dropdownInit = false,
    productAddedList = {};

function declareMiniShoppingCartRefreshArea() {
    //console.log("PSL::MiniShopCartDisplay.js::declareMiniShoppingCartRefreshArea()::BEGIN");
    // ============================================
    // initialize refresh area widgets
    // ============================================

    // ============================================
    // div: MiniShoppingCart refresh area
    // Declares a new refresh controller for the Mini Shopping Cart.

    // declare render context
    wcRenderContext.declare("MiniShoppingCartContext", ["MiniShoppingCart"], { status: "init" });

    /*
    /* Refreshes the mini shopping cart.
     * This function is called when a render context changed event is detected.
     */
    var renderContextChangedHandler = function() {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShoppingCartRefreshArea().renderContextChangedHandler()::BEGIN");
        if (wcRenderContext.testForChangedRC("MiniShoppingCartContext", ["status"])) {
            wcRenderContext.getRenderContextProperties("MiniShoppingCartContext").deleteCartCookie = true;
            $("#MiniShoppingCart").refreshWidget("refresh", wcRenderContext.getRenderContextProperties("MiniShoppingCartContext"));
        }
    };

    // model change
    /*
     * Refreshes the mini shopping cart.
     * If a new order item is added via an Ajax service call, set the mini shopping cart to display the new order item in the dropdown.
     * Otherwise, only refresh the contents of mini shopping cart to the updated order information.
     * This function is called when a modelChanged event is detected.
     *
     * @param {string} event The model changed event
     * @param {object} returnData The data returned from the event
     */
    var events = $.extend({}, order_updated, { "AjaxDeleteOrderItemForShippingBillingPage": "AjaxDeleteOrderItemForShippingBillingPage" });
    wcTopic.subscribe(events, function(returnData) {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShoppingCartRefreshArea().wcTopic.subscribe()::BEGIN");
        var param = [];
        if (returnData.actionId == 'AddOrderItem') {
            if (returnData.data.orderItem != null && returnData.data.orderItem[0].orderItemId != null) {
                var addedOrderItemIdString = "";
                for (var i = 0; i < returnData.data.orderItem.length; i++) {
                    if (addedOrderItemIdString !== "") {
                        addedOrderItemIdString += ",";
                    }
                    addedOrderItemIdString += returnData.data.orderItem[i].orderItemId;
                }
                param.addedOrderItemId = addedOrderItemIdString;
                param.catEntryId = returnData.data.catEntryId;
                param.productId = returnData.data.catEntryId;
            } else {
                param.addedOrderItemId = returnData.data.orderItemId + "";
                param.catEntryId = returnData.data.catEntryId;
                param.productId = returnData.data.catEntryId;
            }

            if(productDisplayJS && productDisplayJS.YMALProductFlag) { //se abbiamo aggiunto un prodotto dai prodotti suggeriti a carrello
				productDisplayJS.YMALProductFlag = false;
				showDropdown = false; //no minicart
                window.location.reload();
			} else if (productDisplayJS && productDisplayJS.RMAProductFlag){
                productDisplayJS.RMAProductFlag = false;
				showDropdown = false; //no minicart
            }
            else {
                showDropdown = true;
            }
        }
        param.deleteCartCookie = true;
        if (returnData.data.addedFromSKUList != null && returnData.data.addedFromSKUList[0] != null) {
            param.addedFromSKUList = returnData.data.addedFromSKUList[0];
        }
        if(window.skipMiniCart) {
            getNumberOfItemsInCart(itemsInCartBadge);
            goDirectToCart();
        }
        else
            $("#MiniShoppingCart").refreshWidget("refresh", param);
           
    });

    var postRefreshHandler = function() {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShoppingCartRefreshArea().postRefreshHandler()::BEGIN");
        //The dialog contents has changed..so destroy the old dialog with stale data..
        destroyDialog("MiniShopCartProductAdded");

        if (showDropdown) {
            update_content = true;
            //We have added item to cart..So display the drop down with item added message..
            positionMiniShopCartDropDown("widget_minishopcart", 'MiniShopCartProductAdded', 'orderItemAdded');
            showDropdown = false;
        }

        if (!multiSessionEnabled) {
            setTimeout(() => {
                updateCartCookie();
            }, 0);
        }

        populateProductAddedDropdown();

        if (!multiSessionEnabled) {
            setTimeout(() => {
                resetDeleteCartCookie();
            }, 0);
        }
    };

    // initialize widget
    $("#MiniShoppingCart").refreshWidget({ renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler });
}

function declareMiniShopCartContentsRefreshArea() {
    //console.log("PSL::MiniShopCartDisplay.js::declareMiniShopCartContentsRefreshArea()::BEGIN");
    // ============================================
    // div: MiniShopCartContents refresh area
    // Declares a new refresh controller for the Mini Shopping Cart contents

    // Declares a new render context for the Mini Shopping Cart contents.
    wcRenderContext.declare("MiniShopCartContentsContext", ["MiniShopCartContents"], { status: "init", relativeId: "", contentId: "", contentType: "" });

    /*
     * Refreshes the mini shopping cart contents since it is out of date.
     * This function is called when a render context changed event is detected.
     */
    var renderContextChangedHandler = function(event, data) {
        if (!dropdownUpdated) {
            wcRenderContext.getRenderContextProperties("MiniShopCartContentsContext").fetchCartContents = true;
            dropdownUpdated = true;
            $("#MiniShopCartContents").refreshWidget("refresh", wcRenderContext.getRenderContextProperties("MiniShopCartContentsContext"));
        }
    };

    /*
     * Indicate that the mini cart contents are out of date upon an order change action.
     * This function is called when a modelChanged event is detected.
     */
    var events = $.extend({}, order_updated, { "AjaxDeleteOrderItemForShippingBillingPage": "AjaxDeleteOrderItemForShippingBillingPage", "AjaxRESTOrderLockUnlockOnBehalf": "AjaxRESTOrderLockUnlockOnBehalf" });
    wcTopic.subscribe(events, function() {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShopCartContentsRefreshArea().wcTopic.subscribe()::BEGIN");
        dropdownUpdated = false;
    });

    /*
     * Displays and positions the mini shop cart contents.
     * This function is called after a successful refresh.
     */
    var postRefreshHandler = function() {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShopCartContentsRefreshArea().postRefreshHandler()::BEGIN");
        var renderContextProperties = wcRenderContext.getRenderContextProperties("MiniShopCartContentsContext");
        positionMiniShopCartDropDown(renderContextProperties.relativeId, renderContextProperties.contentId, renderContextProperties.contentType);
        //
        // This is needed for CSR solution. When CSR and shopper are browsing the store in simultaenously in
        // different browsers and if CSR locks/unlocks the shoppers cart, the miniCart in shopper's browser will
        // NOT reflect the change unless shopper takes some order related actions (add/delete from cart).
        // So to update the miniCart status loadMiniCart() function is called here.
        // It doesn't make another server call. The data returned from the MiniCartContentsUI is used
        // to refresh the miniCart summary.
        //
        updateCartCookie();
        loadMiniCart(WCParamJS.commandContextCurrency, WCParamJS.langId);
    };

    // initialize widget
    $("#MiniShopCartContents").refreshWidget({ renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler });

}

/**
 * Displays the dropdown content of the mini shopping cart when the user hovers over the
 * mini shopping cart if the contents are up-to-date or retrieve the latest contents from server.
 *
 * PSL:: This OOTB function can block the minishopcart. The variable dropdownInit is true while the shopcart is loading.
 * If the user clicks the shoppingcart again while it's loading (dropdownInit variable is 'true') sometimes this flag
 * never goes back to false and the user cannot open the MSC anymore until page reload.
 * In order to solve this issue we added a function that prevents extra clicks over the shopping bag icon
 * while the minishoppingcart popup is loading (See lockShoppingBagIcon()/unlockShoppingBagIcon())
 *
 * @param {string} relativeId The id of a placeholder element to position the dropdown relatively
 * @param {string} contentId The id of the content pane containing the mini shopping cart dropdown contents
 * @param {string} contentType The content that will be shown in the expanded mini shopping cart dropdown.
 */
function showMiniShopCartDropDown(relativeId, contentId, contentType) {
    //isOnPasswordUpdateForm flag is set at UpdatePasswordForm.jsp, in other cases the variable type will always be undefined or value equals false.
    // Need this line otherwise it'll throw a isOnPasswordUpdateForm is undefined error
    //console.log("PSL::MiniShopCartDisplay.js::showMiniShopCartDropDown()::BEGIN");
    var isOnPasswordUpdateForm = isOnPasswordUpdateForm;
    if (!dropdownInit && (Utils.isUndefined(isOnPasswordUpdateForm) || isOnPasswordUpdateForm == false)) {
        dropdownInit = true;
        lockShoppingBagIcon();

        if (!dropdownUpdated) {
            //console.log("PSL::MiniShopCartDisplay.js::showMiniShopCartDropDown()::Entro por el IF");
            update_content = true;
            var params = {
                status: "load",
                relativeId: relativeId,
                contentId: contentId,
                contentType: contentType,
                page_view: "dropdown"
            };
            wcRenderContext.updateRenderContext("MiniShopCartContentsContext", params);
        } else {
            //console.log("PSL::MiniShopCartDisplay.js::showMiniShopCartDropDown()::Entro por el ELSE");
            positionMiniShopCartDropDown(relativeId, contentId, contentType);
        }
    }
}

function toggleMiniShopCartDropDown(relativeId, contentId, contentType) {
    if((brandCode == 'PO' || brandCode == 'OP') && $('#page').hasClass('pdp')) {
        // if(!(window.mobilecheck() || window.tabletPortraitCheck()))hideHeaderTimeout.cancel();
        (dialogWidget && dialogWidget._isOpen) ? $("#page-overflow-wrapper").removeClass("overflow-hidden") : $("#page-overflow-wrapper").addClass("overflow-hidden");
    }
    //console.log("PSL::MiniShopCartDisplay.js::toggleMiniShopCartDropDown()::BEGIN");}
    if (dialogWidget && dialogWidget._isOpen) {
        if((brandCode == 'PO' || brandCode == 'OP') && $('#page').hasClass('pdp')){
            hideHeaderTimeout.setup();
        }
        //console.log("PSL::MiniShopCartDisplay.js::toggleMiniShopCartDropDown()::Entro por el IF");
        dialogWidget.close();
    } else {
        //console.log("PSL::MiniShopCartDisplay.js::toggleMiniShopCartDropDown()::Entro por el ELSE");
        showMiniShopCartDropDown(relativeId, contentId, contentType);
        if((brandCode == 'PO' || brandCode == 'OP') && $('#page').hasClass('pdp')){
            hideHeaderTimeout.cancel();
        }
    }
}

/*
 * Displays the dropdown content of the mini shopping cart.
 *
 * @param {string} relativeId The id of a placeholder element to position the dropdown relatively
 * @param {string} contentId The id of the content pane containing the mini shopping cart dropdown contents
 * @param {string} contentType The content that will be shown in the expanded mini shopping cart dropdown.
 */
function positionMiniShopCartDropDown(relativeId, contentId, contentType) {
    //console.log("PSL::MiniShopCartDisplay.js::positionMiniShopCartDropDown()::BEGIN");
    var add_event_handlers = function(contentElement) {
        //console.log("PSL::MiniShopCartDisplay.js::positionMiniShopCartDropDown().add_event_handlers()::BEGIN");
        contentElement.on("wcdialogopen", function(event) {
            //deactivate(document.getElementById("header"));
            $("#" + relativeId).addClass("selected");
        });

        contentElement.on("wcdialogclose", function(event) {
            $("#" + relativeId).removeClass("selected");
        });
    };

    // Dialog is not yet created..Create one
    if (!dialogWidget /*PSL Force dialog creation */ || true) {
        var content = $("#" + contentId);
        if (contentId === "MiniShopCartProductAdded") {
            // The content may have been hidden so show it
            $("#MiniShopCartProductAddedWrapper").removeAttr("style");
        }
        dialogWidget = content.WCDialog({
            position: {
                my: "right top",
                at: "right bottom",
                of: "#widget_minishopcart"
            },
            autoOpen: false,
            open: function() {
                // Make the element show up on top of the header elements
                dialogWidget.element.parent().css("z-index", 1);

                if (contentType == 'orderItemAdded') {
                    if(isOliver && (window.tabletPortraitCheck() || window.mobilecheck())){
                        $("#MiniShopCartProductAddedWrapper").css("display", "flex");
                    }else{
                        $("#MiniShopCartProductAddedWrapper").css("display", "block");
                    }
                }
            },
            appendTo: "#headerRow1",
            title: $("#" + contentId + "_ACCE_Label").html(),
            show_title: false,
            width: "360px",
            //dialogClass: "no-close",
            modal: false
        }).data("wc-WCDialog");
        add_event_handlers(content);
        update_content = false;

		/* APPLEPAY BEGIN */
		if (typeof(showApplePayButtons) == "function") {
			showApplePayButtons();
		}
        /* APPLEPAY END */

    } else {
        dialogWidget.close();
        if (update_content) {
            if (contentType == 'orderItemAdded') {
                if(isOliver && (window.tabletPortraitCheck() || window.mobilecheck())){
                    $("#MiniShopCartProductAddedWrapper").css("display", "flex");
                }else{
                    $("#MiniShopCartProductAddedWrapper").css("display", "block");
                }
            }
            var newContent = $("#" + contentId);
            dialogWidget.update_content("#" + contentId);
            add_event_handlers(newContent);
            update_content = false;
        }
    }

    if (Utils.get_IE_version() < 7) {
        dialogWidget.css("display", "block");
    }
    
    //Start HB-12482 
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
	    $("html, body").animate({
	        scrollTop: 0
	    }, {
	        duration: 200
	    }).promise().done(function() {
	        dialogWidget.open();
	        dialogWidget.reposition();
	    });
    }else if((window.mobilecheck() || window.tabletPortraitCheck())){
    	$("html").css("overflow", "hidden");
    	$("html, body").animate({
	        //scrollTop: 0
	    }, {
	        duration: 200
	    }).promise().done(function() {
	        dialogWidget.open();
	        dialogWidget.reposition();
	    });
    }
    //End HB-12482 
    
    dropdownInit = false;

    unlockShoppingBagIcon();
}

/*
 * Store the current mini cart information in the mini cart cookie.
 */
function updateCartCookie() {
    //Save current order information into cookie
    if ($("#currentOrderQuantity").length && $("#currentOrderAmount").length && $("#currentOrderCurrency").length && $("#currentOrderId").length && $("#currentOrderLanguage").length) {
        var cartQuantity = $("#currentOrderQuantity").val();
        var cartAmount = $("#currentOrderAmount").val();
        var cartCurrency = $("#currentOrderCurrency").val();
        var cartLanguage = $("#currentOrderLanguage").val();
        var cartOrderId = $("#currentOrderId").val();
        var currentOrderLocked = $("#currentOrderLocked").val();

        //Clear out previous cookies
        var orderIdCookie = getCookie("WC_CartOrderId_" + WCParamJS.storeId);
        if (orderIdCookie != null) {
            setCookie("WC_CartOrderId_" + WCParamJS.storeId, null, {
                expires: -1,
                path: '/',
                domain: cookieDomain
            });
            var cartTotalCookie = getCookie("WC_CartTotal_" + orderIdCookie);
            if (cartTotalCookie != null) {
                setCookie("WC_CartTotal_" + orderIdCookie, null, {
                    expires: -1,
                    path: '/',
                    domain: cookieDomain
                });
            }
        }
        setCookie("WC_CartOrderId_" + WCParamJS.storeId, cartOrderId, {
            path: '/',
            domain: cookieDomain
        });
        if (cartOrderId !== "") {
            setCookie("WC_CartTotal_" + cartOrderId, cartQuantity + ";" + cartAmount + ";" + cartCurrency + ";" + cartLanguage + ";" + currentOrderLocked, {
                path: '/',
                domain: cookieDomain
            });
        }
    } else {
        setCookie("WC_CartOrderId_" + WCParamJS.storeId, "", { path: '/', domain: cookieDomain });
    }
}

function setProductAddedList(newProductAddedList) {
    productAddedList = newProductAddedList;
}

/*
 * Populates the Product Added dropdown upon an add to cart action.
 */
function populateProductAddedDropdown() {


    var search = '"';

    var replaceStr = "'";
    for (productId in productAddedList) {
        var productDetails = productAddedList[productId];

        if ($("#MiniShopCartAddedProdName_" + productId).length && productDetails[0] != null && productDetails[0].length != 0) {
            $("#MiniShopCartAddedProdName_" + productId).html(productDetails[0]);
        }

        /* OOTB - PSL:: We disabled this code because it replaces the thumbnail with the fullimage of the catentry
        if ($("#MiniShopCartAddedProdImgSrc_" + productId).length && productDetails[1] != null && productDetails[1].length != 0) {
            $("#MiniShopCartAddedProdImgSrc_" + productId).attr("src", productDetails[1]);
            document.getElementById('MiniShopCartAddedProdImgSrc_' + productId).alt = productDetails[0];
        }
        */

        if ($("#MiniShopCartAddedProdPrice_" + productId).length && productDetails[2] != null && productDetails[2].length != 0) {
            $("#MiniShopCartAddedProdPrice_" + productId).html(productDetails[2]);
        }
        if ($("#MiniShopCartAddedProdQty_" + productId).length && productDetails[3] != null && productDetails[3].length != 0) {
            $("#MiniShopCartAddedProdQty_" + productId).html(productDetails[3]);
        }

        if ($("#MiniShopCartAddedProdAttr_" + productId).length && productDetails[4] != null && productDetails[4].length != 0) {
            $("#MiniShopCartAddedProdAttr_" + productId).html("");

            for (attrName in productDetails[4]) {
                attrValue = productDetails[4][attrName];
                if (attrValue != null && attrValue != 'undefined') {
                    attrValue = attrValue.replace(/&amp;/g, "&").replace(/&#039;/g, "'").replace(/&#034;/g, '"').replace(replaceStr, search);
                }
                document.getElementById('MiniShopCartAddedProdAttr_' + productId).innerHTML += '<div>' + attrName + ': ' + attrValue + '</div>';
            }
        }
    }
    wcTopic.publish("ProductInfo_Reset");
}

/*
 * Loads mini shop cart info upon page load.
 * @param {String} contextCurrency Current currency selected.
 * @param {String} langId Current language selected.
 */
function loadMiniCart(contextCurrency, langId) {
    var updateCart = false;
    var orderIdCookie = getCookie("WC_CartOrderId_" + WCParamJS.storeId);

      if (orderIdCookie != undefined && orderIdCookie === "") {
        var subtotal = document.getElementById("minishopcart_subtotal");
        var formattedSubtotal = null;
        if ($("#currentOrderAmount").length) {
            formattedSubtotal = Utils.formatCurrency($("#currentOrderAmount").val(), {
                currency: contextCurrency
            });
        }
        if (formattedSubtotal == null && $("#currentOrderAmount").length) {
            formattedSubtotal = $("#currentOrderAmount").val();
        }

        if (subtotal != null) {
            subtotal.innerHTML = "\n " + formattedSubtotal + "\n ";
        }
        var items = document.getElementById("minishopcart_total");
        if (items != null) {
            var itemsMsg = null;
            if ($("#currentOrderQuantity").length) {
                itemMsg = $("#currentOrderQuantity").val();
            }
            if (itemsMsg == null) {
                itemsMsg = "0";
            }
            items.innerHTML = "\n " + itemsMsg + "\n ";
        }
    } else if (orderIdCookie != undefined && orderIdCookie !== "") {
        var cartCookie = getCookie("WC_CartTotal_" + orderIdCookie);

        if (cartCookie != undefined && cartCookie != null && cartCookie !== "") {
            var orderInfo = cartCookie.split(";");

            if (orderInfo != null && orderInfo.length > 3) {
                if (orderInfo[2] == contextCurrency && orderInfo[3] == langId) {
                    var subtotal = document.getElementById("minishopcart_subtotal");
                    if (subtotal != null) {
                        var formattedSubtotal = null;
                        formattedSubtotal = Utils.formatCurrency(orderInfo[1].toString(), {
                            currency: contextCurrency
                        });
                        if (formattedSubtotal == null) {
                            formattedSubtotal = orderInfo[1].toString();
                        }
                        subtotal.innerHTML = "\n " + formattedSubtotal + "\n ";
                    }
                    var currentOrderLocked = false;
                    if (orderInfo[4] != null && orderInfo[4] == 'true') {
                        var currentOrderLocked = true;
                    }
                    var items = document.getElementById("minishopcart_total");
                    var lock = document.getElementById("minishopcart_lock");
                    if (items != null) {
                        var itemsMsg = orderInfo[0].toString();
                        items.innerHTML = "\n " + itemsMsg + "\n ";
                        if (currentOrderLocked) {
                            $(items).addClass("nodisplay");
                            $(lock).removeClass("nodisplay");
                        } else {
                            $(items).removeClass("nodisplay");
                            $(lock).addClass("nodisplay");
                        }
                    }
                } else {
                    updateCart = true;
                }
            } else {
                updateCart = true;
            }
        } else {
            updateCart = true;
        }
    } else {
        updateCart = true; 
    }
    //isOnPasswordUpdateForm flag is set at UpdatePasswordForm.jsp, in other cases the variable type will always be undefined or value equals false.
    // Need this line otherwise it'll throw a isOnPasswordUpdateForm is undefined error
    var isOnPasswordUpdateForm = isOnPasswordUpdateForm;
    if (updateCart == true && (Utils.isUndefined(isOnPasswordUpdateForm) || isOnPasswordUpdateForm == false)) {
        wcRenderContext.updateRenderContext('MiniShoppingCartContext', {
            'status': 'load'
        });
    }
}


/*
 * Turn on the flag to indicate that the mini cart cookies should be refreshed.
 */
function setDeleteCartCookie() {
    setCookie("WC_DeleteCartCookie_" + WCParamJS.storeId, true, {
        path: '/',
        domain: cookieDomain
    });
}

/*
 * Check whether the mini cart cookies need to be updated or not.
 */
function checkDeleteCartCookie() {
    var deleteCartCookieVal = getCookie("WC_DeleteCartCookie_" + WCParamJS.storeId);

    if (deleteCartCookieVal != undefined && deleteCartCookieVal !== "") {
        if (deleteCartCookieVal == 'true') {
            return true;
        }
    }
    return false;
}

/*
 * Delete the flag that indicates the mini cart cookie should be refreshed.
 */
function resetDeleteCartCookie() {
    var deleteCartCookieVal = getCookie("WC_DeleteCartCookie_" + WCParamJS.storeId);

    if (deleteCartCookieVal != null) {
        setCookie("WC_DeleteCartCookie_" + WCParamJS.storeId, null, {
            expires: -1,
            path: '/',
            domain: cookieDomain
        });
    }
}
wcTopic.subscribe("ProductInfo_Added", setProductAddedList);
//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This class contains declarations of AJAX services used by the Madisons store pages.
 */

/**
 * @class This class stores common parameters needed to make the service call.
 */
shoppingActionsServicesDeclarationJS = {
	langId: "-1", /* language of the  store */
	storeId: "", /*numeric unique identifier of the store */
	catalogId: "", /*catalog of the store that is currently in use */

	/**
	 * Sets common parameters used by the services
	 * @param (int) langId The language of the store.
	 * @param (int) storeId The store currently in use.
	 * @param (int) catalogId The catalog of the store currently in use.
	 */
	setCommonParameters:function(langId,storeId,catalogId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
	}
}

	/**
	 * Add an item to a shopping cart in Ajax mode. A message is displayed after
	 * the service call.
	 * @constructor
	 */
	wcService.declare({
		id: "AddOrderItem",
		actionId: "AddOrderItem",
		url: getAbsoluteURL() + "AjaxCustomRESTOrderItemAdd",
		formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

		,successHandler: function(serviceResponse) {
			
			//START Wunderkind
			if(typeof updateWkndCartValue == 'function') {
				updateWkndCartValue();
			}
			//END Wunderkind

			MessageHelper.hideAndClearMessage();
			// Do not show this message. When item is added, we open up mini cart to display the currently added item.
			// MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("SHOPCART_ADDED"));
            cursor_clear();
            
            //HB-1988 BEGIN
            restoreAjaxButtons();
            //HB-1988 END
            
			if(shoppingActionsJS){

				var attributes_container = $('div[id^="attrValue_"]');

				if (($(".definingAttributes")[0]) != null) {
					var attributes_container = $(".definingAttributes");
				}
				else if (($(".product_sizes")[0]) != null) {
					var attributes_container = $(".product_sizes");
				}
				else if (($(".product_info")[0]) != null) {
					var attributes_container = $(".product_info");
				}

				var attributes = new Array();
				for (var i = 0; i < attributes_container.length; i++) {
					var attribute_selectors = attributes_container[i].querySelectorAll(".dijitSelect");
					for (var j = 0; j < attribute_selectors.length; j++) {
						attributes = attributes.concat(attribute_selectors[j]);
					}
				}

				var dijitSelect = new Array();
				for (var i = 0; i < attributes.length; i++) {
					dijitSelect[i] = dijit.registry.byNode(attributes[i]);
				}

				var singleSKU = true;
				for(var i=0; i<dijitSelect.length; i++){
					if (dijitSelect[i].options.length > 2)
					{
						singleSKU = false;
					}
				}

				if (!singleSKU)
				{
					shoppingActionsJS.selectedAttributes = new Object();
					wcTopic.publish('DefiningAttributes_Resolved_'+shoppingActionsJS.baseCatalogEntryId, shoppingActionsJS.baseCatalogEntryId, -1);
					for(var i=0; i<dijitSelect.length; i++){
						if(dijitSelect[i] != null){
							dijitSelect[i].value = "";
						}
					}
				}

			}
			if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
				ShipmodeSelectionExtJS.setOrderItemId((serviceResponse.orderItem != null && serviceResponse.orderItem[0].orderItemId != null) ? serviceResponse.orderItem[0].orderItemId : serviceResponse.orderItemId);
			}


			//BEGIN Lens Configurator
			//update prescription with the generated orderitemsid from cart service
			if(productDisplayJS.prescription === true){
                _prescriptionObject = $.cookie("_prescriptionObject");
				if(_prescriptionObject != undefined){
	
                    $.ajax({
                        url: "/wcs/resources/store/" + WCParamJS.storeId + "/cart/@self",
                        method: "GET",
                        async: false,
						headers: {
							"Content-Type": "application/json",
							"Cache-Control": "no-cache, no-store, must-revalidate"
						},
						data: {
							"timestamp": Date.now()
						},
                        success: function(data) {
                                var maxOrderItemId = 0;
								var roxFrameSelected = $('#roxFrameID').val();
                                //retrieve object with roxframeId in the array orderitem and extract the orderitemsid
                                //in case there are more than one item with same catentry take the greater one
                                $.each(data.orderItem,(index,element) => {
                                    if(element.productId === roxFrameSelected && maxOrderItemId < element.orderItemId){
                                        console.log(element.orderItemId);
                                         maxOrderItemId = element.orderItemId;
                                    }
                                });
                                
                                _prescriptionObject = JSON.parse(_prescriptionObject);
                                parameters = {};
                                parameters.orderItemsId = maxOrderItemId;
                                parameters.prescriptionId = _prescriptionObject.prescriptionId;
                                
                                parameters.type = "S";
                                if (productDisplayJS.lensOptionValue === "Progressive"){
                                    parameters.type = "P";
                                }
                                
                            
                                var docStr = generateXML(parameters);
                                var xmldoc = {};
                                xmldoc.XML = docStr;
                                //asynchronous call: if the prescription hasn't be updated it will not go to the cart
                                AddPrescription(xmldoc).then(function(){
                                    console.log("prescription updated with orderitemsid"  + parameters.orderItemsId);
                                    
                                    /* remove cookie when item have been added to cart so if the same user add a new prescription
                                     both for error (more the one prescription are not allowed) or for replace the old one
                                     it will be treated as new prescription in the configurator */
                                     //$.removeCookie("_prescriptionObject");
									 $.removeCookie("_userId");
                                    goToCart2();

                                }).catch(function(){
                                    console.log("prescription not updated");
                                    console.log("orderitemsId used" + parameters.orderItemsId);
                                });
                        
                        },
                        error: function(err) {
                            console.log("failed to updated the prescription");
                        }
                    });
                }else{
                    //it has choosen the send it later option
                    goToCart2();
                }
			}

			if(productDisplayJS.isFrameOnly){ //this if is necessary because the sunglasses still have add to cart button 
				//it has choose the frame  only option
				goToCart2();
			}

			//END

			wcTopic.publish('ProductAddedToCart');
		}
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
		,failureHandler: function(serviceResponse) {
			if(productDisplayJS && productDisplayJS.YMALProductFlag) //reset flag if add fails
				productDisplayJS.YMALProductFlag = false;
		    var productUPC = $('#parentProductUpc').val();
			if (serviceResponse.errorMessage) {
			 	if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
			 		MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER"));
 				} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
					var tempString = Utils.getLocalizationMessage("GENERICERR_MAINTEXT", {0:Utils.getLocalizationMessage("GENERICERR_CONTACT_US")});
 					MessageHelper.displayErrorMessage(tempString);
                } else if ("_API_CANT_RESOLVE_FFMCENTER" == serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(API_CANT_RESOLVE_FFMCENTER_MSG);
                } else {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
			 	
                if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING" || serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE" 
                    || serviceResponse.errorMessageKey == "_API_CANT_RESOLVE_FFMCENTER" || serviceResponse.errorMessageKey == "_ERR_PROD_NOT_ORDERABLE") {
                   trackAddToCartFailure('Product', serviceResponse.errorMessage, productUPC);
                }
                else{
                   trackAddToCartFailure('Server', serviceResponse.errorMessage, productUPC); 
                }
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
					trackAddToCartFailure('Product', serviceResponse.errorMessageKey, productUPC);
				 }
			}

			if(serviceResponse.errorCode){
				wcTopic.publish("OrderError",serviceResponse);
			}

			cursor_clear();
		}

	}),

	/**
	 * Adds a pre-defined dynamic kit to a shopping cart in Ajax mode. A message is displayed after
	 * the service call.
	 * @constructor
	 */
	wcService.declare({
		id: "AddPreConfigurationToCart",
		actionId: "AddOrderItem",
		url: getAbsoluteURL() + "AjaxRESTOrderAddPreConfigurationToCart",
		formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
			if(shoppingActionsJS){

				var attributes = document.getElementsByName("attrValue");

				var singleSKU = true;

				for(var i=0; i<attributes.length; i++){
					if (attributes[i].options.length > 1)
					{
						singleSKU = false;
					}
				}

				if (!singleSKU)
				{
					shoppingActionsJS.selectedAttributes = new Object();
					for(var i=0; i<attributes.length; i++){
						if(attributes[i] != null){
							attributes[i].value = "";
							attributes[i].onchange();
						}
					}
				}
			}
			if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
				ShipmodeSelectionExtJS.setOrderItemId(serviceResponse.orderItem[0].orderItemId);
			}
		}
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
			 	if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
			 		MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER"));
 				} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
					var tempString = Utils.getLocalizationMessage("GENERICERR_MAINTEXT",{0:Utils.getLocalizationMessage("GENERICERR_CONTACT_US")});
 					MessageHelper.displayErrorMessage(tempString);
 				} else {
 					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
 				}
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	})

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2011, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

shoppingActionsJS = {

    /** The language ID currently in use **/
    langId: "-1",

    /** The store ID currently in use **/
    storeId: "",

    /** The catalog ID currently in use **/
    catalogId: "",

    /** Holds the current user type such as guest or registered user. Allowed values are 'G' for guest and 'R' for registered.**/
    userType: "",

    /** A boolean used in a variety of the add to cart methods to tell whether or not the base item was added to the cart. **/
    baseItemAddedToCart: false,

    /** An array of entitled items which is used in various methods throughout ShoppingActions.js **/
    entitledItems: [],

    /** a JSON object that holds attributes of an entitled item **/
    entitledItemJsonObject: null,

    /** A map of attribute name value pairs for the currently selected attribute values **/
    selectedAttributesList: {},

    /** A variable used to form the url dynamically for the more info link in the Quickinfo popup */
    moreInfoUrl: "",

    /**
     * A boolean used to to determine is it from a Qick info popup or not. 
     **/
    isPopup: false,

    /**
     * A boolean used to to determine whether or not to diplay the price range when the catEntry is selected. 
     **/
    displayPriceRange: true,

    /**
     * This array holds the json object retured from the service, holding the price information of the catEntry.
     **/
    itemPriceJsonOject: [],

    /** 
     * stores all name and value of all swatches 
     * this is a 2 dimension array and each record i contains the following information:
     * allSwatchesArray[i][0] - attribute name of the swatch
     * allSwatchesArray[i][1] - attribute value of the swatch
     * allSwatchesArray[i][2] - image1 of swatch (image to use for enabled state)
     * allSwatchesArray[i][3] - image2 of swatch (image to use for disabled state)
     * allSwatchesArray[i][4] - onclick action of the swatch when enabled
     **/
    allSwatchesArrayList: {},

    /**
     * Holds the ID of the image used for swatch
     **/
    skuImageId: "",

    /**
     * The prefix of the cookie key that is used to store item Ids. 
     */
    cookieKeyPrefix: "CompareItems_",

    /**
     * The delimiter used to separate item Ids in the cookie.
     */
    cookieDelimiter: ";",

    /**
     * The maximum number of items allowed in the compare zone. 
     */
    maxNumberProductsAllowedToCompare: 4,

    /**
     * The minimum number of items allowed in the compare zone. 
     */
    minNumberProductsAllowedToCompare: 2,

    /**
     * Id of the base catalog entry. 
     */
    baseCatalogEntryId: 0,

    /**
     * An map which holds the attributes of a set of products
     */
    selectedProducts: {},

    /**
     * An array to keep the quantity of the products in a list (bundle)
     */
    productList: {},

    /**
     * stores the currency symbol
     */
    currencySymbol: "",

    /**
     * stores the compare return page name
     */
    compareReturnName: "",
    /**
     * stores the search term
     */
    searchTerm: "",

    search01: "'",

    search02: '"',

    replaceStr01: /\\\'/g,

    replaceStr02: /\\\"/g,

    ampersandChar: /&/g,

    ampersandEntityName: "&amp;",

    /**
     * An array to keep the details of the newly added products.
     */
    productAddedList: {},

    setCompareReturnName: function (compareReturnName) {
        this.compareReturnName = compareReturnName;
    },

    setSearchTerm: function (searchTerm) {
        this.searchTerm = searchTerm;
    },

    setCommonParameters: function (langId, storeId, catalogId, userType, currencySymbol) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
        this.userType = userType;
        this.currencySymbol = currencySymbol;
    },

    setEntitledItems: function (entitledItemArray) {
        this.entitledItems = entitledItemArray;
    },

    getCatalogEntryId: function (entitledItemId) {
        var attributeArray = [];
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveSKU(attributeArray);
    },

    /**
     * getCatalogEntryIdforProduct Returns the catalog entry ID for a catalog entry that has the same attribute values as a specified product's selected attributes as passed in via the selectedAttributes parameter.
     *
     * @param {String[]} selectedAttributes The array of selected attributes upon which to resolve the SKU.
     *
     * @return {String} catalog entry ID of the SKU.
     *
     **/
    getCatalogEntryIdforProduct: function (selectedAttributes) {
        var attributeArray = [];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveSKU(attributeArray);
    },

    /**
     * retrieves the entitledItemJsonObject
     */
    getEntitledItemJsonObject: function () {
        return this.entitledItemJsonObject;
    },

    /**
     * resolveSKU Resolves a SKU using an array of defining attributes.
     *
     * @param {String[]} attributeArray An array of defining attributes upon which to resolve a SKU.
     *
     * @return {String} catentry_id The catalog entry ID of the SKU.
     *
     **/
    resolveSKU: function (attributeArray) {

        console.debug("Resolving SKU >> " + attributeArray + ">>" + this.entitledItems);
        var catentry_id = "";
        var attributeArrayCount = attributeArray.length;

        // if there is only one item, no need to check the attributes to resolve the sku
        if (this.entitledItems.length == 1) {
            return this.entitledItems[0].catentry_id;
        }
        for (x in this.entitledItems) {
            var catentry_id = this.entitledItems[x].catentry_id;
            var Attributes = this.entitledItems[x].Attributes;
            var attributeCount = 0;
            for (index in Attributes) {
                attributeCount++;
            }

            // Handle special case where a catalog entry has one sku with no attributes
            if (attributeArrayCount == 0 && attributeCount == 0) {
                return catentry_id;
            }
            if (attributeCount != 0 && attributeArrayCount >= attributeCount) {
                var matchedAttributeCount = 0;

                for (attributeName in attributeArray) {
                    var attributeValue = attributeArray[attributeName];
                    var attributeValue2 = attributeValue.replace(this.search02, this.search01);
                    if (attributeValue in Attributes || attributeValue2 in Attributes) {
                        matchedAttributeCount++;
                    }
                }

                if (attributeCount == matchedAttributeCount) {
                    console.debug("CatEntryId:" + catentry_id + " for Attribute: " + attributeArray);
                    this.disableBuyButtonforUnbuyable(x);
                    return catentry_id;
                }
            }
        }
        return null;
    },

    /**
     * setSelectedAttribute Sets the selected attribute value for a particular attribute not in reference to any catalog entry.
     *					   One place this function is used is on CachedProductOnlyDisplay.jsp where there is a drop down box of attributes.
     *					   When an attribute is selected from that drop down this method is called to update the selected value for that attribute.
     *
     * @param {String} selectedAttributeName The name of the attribute.
     * @param {String} selectedAttributeValue The value of the selected attribute.
     * @param {String} entitledItemId The element id where the json object of the sku is stored
     * @param {String} skuImageId This is optional. The element id of the product image - image element id is different in product page and category list view. Product page need not pass it because it is set separately
     * @param {String} imageField This is optional. The json field from which image should be picked. Pass value if a different size image need to be picked
     *
     **/
    setSelectedAttribute: function (selectedAttributeName, selectedAttributeValue, entitledItemId, skuImageId, imageField) {
        console.debug(selectedAttributeName + " : " + selectedAttributeValue);
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        if (selectedAttributes == null) {
            selectedAttributes = {};
        }
        selectedAttributeValue = selectedAttributeValue.replace(this.replaceStr01, this.search01);
        selectedAttributeValue = selectedAttributeValue.replace(this.replaceStr02, this.search02);
        selectedAttributeValue = selectedAttributeValue.replace(this.ampersandChar, this.ampersandEntityName);
        selectedAttributes[selectedAttributeName] = selectedAttributeValue;
        this.moreInfoUrl = this.moreInfoUrl + '&' + selectedAttributeName + '=' + selectedAttributeValue;
        this.selectedAttributesList[entitledItemId] = selectedAttributes;
        this.changeProdImage(entitledItemId, selectedAttributeName, selectedAttributeValue, skuImageId, imageField);
    },

    /**
     * setSelectedAttributeOfProduct Sets the selected attribute value for an attribute of a specified product.
     *								This function is used to set the assigned value of defining attributes to specific 
     *								products which will be stored in the selectedProducts map.
     *
     * @param {String} productId The catalog entry ID of the catalog entry to use.
     * @param {String} selectedAttributeName The name of the attribute.
     * @param {String} selectedAttributeValue The value of the selected attribute.
     * @param {boolean} true, if it is single SKU
     *
     **/
    setSelectedAttributeOfProduct: function (productId, selectedAttributeName, selectedAttributeValue, isSingleSKU) {

        var selectedAttributesForProduct = null;

        if (this.selectedProducts[productId]) {
            selectedAttributesForProduct = this.selectedProducts[productId];
        } else {
            selectedAttributesForProduct = {};
        }

        // add only if attribute has some name. value can be empty
        if (null != selectedAttributeName && '' != selectedAttributeName) {
            selectedAttributesForProduct[selectedAttributeName] = selectedAttributeValue;
        }
        this.selectedProducts[productId] = selectedAttributesForProduct;

        //the json object for entitled items are already in the HTML. 
        var entitledItemJSON = eval('(' + $("#entitledItem_" + productId).html() + ')');

        this.setEntitledItems(entitledItemJSON);

        var catalogEntryId = this.getCatalogEntryIdforProduct(selectedAttributesForProduct);

        if (catalogEntryId == null) {
            catalogEntryId = 0;
        } else {
            // pass true to display price range
            this.changePrice("entitledItem_" + productId, false, true, productId);

            //Update selected sku in merchandising association array
            if (typeof MerchandisingAssociationJS != 'undefined') {
                if (MerchandisingAssociationJS.baseItemParams != null) {
                    if (MerchandisingAssociationJS.baseItemParams.type == 'BundleBean') {
                        // Update items in the bundle
                        for (idx = 0; idx < MerchandisingAssociationJS.baseItemParams.components.length; idx++) {
                            if (productId == MerchandisingAssociationJS.baseItemParams.components[idx].productId) {
                                MerchandisingAssociationJS.baseItemParams.components[idx].id = catalogEntryId;
                            }
                        }
                    }
                }
            }
        }
        var productDetails = null;
        if (this.productList[productId]) {
            productDetails = this.productList[productId];
        } else {
            productDetails = {};
            this.productList[productId] = productDetails;
            productDetails.baseItemId = productId;
        }

        productDetails.id = catalogEntryId;
        if (productDetails.quantity) {
            wcTopic.publish("Quantity_Changed", JSON.stringify(productDetails));
        }

        if (!isSingleSKU) {
            // publish the attribute change event
            if (catalogEntryId != 0) {
                wcTopic.publish('DefiningAttributes_Resolved_' + productId, catalogEntryId, productId);
            } else {
                wcTopic.publish('DefiningAttributes_Changed_' + productId, catalogEntryId, productId);
            }
        }
    },

    /**
     * Add2ShopCartAjax This function is used to add a catalog entry to the shopping cart using an AJAX call. This will resolve the catentryId using entitledItemId and adds the item to the cart.
     *				This function will resolve the SKU based on the entitledItemId passed in and call {@link this.AddItem2ShopCartAjax}.
     * @param {String} entitledItemId A DIV containing a JSON object which holds information about a catalog entry. You can reference CachedProductOnlyDisplay.jsp to see how that div is constructed.
     * @param {int} quantity The quantity of the item to add to the cart.
     * @param {String} isPopup If the value is true, then this implies that the function was called from a quick info pop-up. 	
     * @param {Object} customParams - Any additional parameters that needs to be passed during service invocation.
     *
     **/
    Add2ShopCartAjax: function (entitledItemId, quantity, isPopup, customParams) {
        var dialog = $('#quick_cart_container').data("wc-WCDialog");
        if (dialog) {
            dialog.close();
        }
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;
        }
        var entitledItemJSON;

        if ($("#" + entitledItemId).length) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        } else {
            //if $("#" +entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object. 
            //in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
            entitledItemJSON = this.getEntitledItemJsonObject();
        }

        this.setEntitledItems(entitledItemJSON);
        var catalogEntryId = this.getCatalogEntryId(entitledItemId);

        if (catalogEntryId != null) {
            var productId = entitledItemId.substring(entitledItemId.indexOf("_") + 1);
            this.AddItem2ShopCartAjax(catalogEntryId, quantity, customParams, productId);
            this.baseItemAddedToCart = true;
        } else if (isPopup == true) {
            $('#second_level_category_popup').css("zIndex", '1');
            MessageHelper.formErrorHandleClient('addToCartLinkAjax', Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
        } else {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
            this.baseItemAddedToCart = false;
        }
    },

    AddItem2ShopCartAjax: function (catEntryIdentifier, quantity, customParams, productId) {
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;
        }
        var params = {storeId: this.storeId,
catalogId: this.catalogId,
langId: this.langId,
orderId: "."};
        // Remove calculations for performance
        // params.calculationUsage = "-1,-2,-5,-6,-7";
        params.inventoryValidation = "true";
        params.calculateOrder = "0";
        var ajaxShopCartService = "AddOrderItem";

        this.productAddedList = {};
        if (Array.isArray(catEntryIdentifier) && Array.isArray(quantity)) {
            for (var i = 0; i < catEntryIdentifier.length; i++) {
                if (!isPositiveInteger(quantity[i])) {
                    MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                    return;
                }
                params["catEntryId_" + (i + 1)] = catEntryIdentifier[i];
                params["quantity_" + (i + 1)] = quantity[i];
            }
        } else {
            if (!isPositiveInteger(quantity)) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                return;
            }
            params.catEntryId = catEntryIdentifier;
            params.quantity = quantity;

            var selectedAttrList = {};
            for (attr in this.selectedAttributesList['entitledItem_' + productId]) {
                selectedAttrList[attr] = this.selectedAttributesList['entitledItem_' + productId][attr];
            }

            if (productId == undefined) {
                this.saveAddedProductInfo(quantity, catEntryIdentifier, catEntryIdentifier, selectedAttrList);
            } else {
                this.saveAddedProductInfo(quantity, productId, catEntryIdentifier, selectedAttrList);
            }
        }

        //Pass any other customParams set by other add on features
        if (customParams != null && customParams != 'undefined') {
            for (i in customParams) {
                params[i] = customParams[i];
            }
            if (customParams['catalogEntryType'] == 'dynamicKit') {
                ajaxShopCartService = "AddPreConfigurationToCart";
            }
        }

        var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
        if (contractIdElements != null && contractIdElements != "undefined") {
            for (i = 0; i < contractIdElements.length; i++) {
                if (contractIdElements[i].checked) {
                    params.contractId = contractIdElements[i].value;
                    break;
                }
            }
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        wcService.invoke(ajaxShopCartService, params);
        this.baseItemAddedToCart = true;

        if (document.getElementById("headerShopCartLink") && document.getElementById("headerShopCartLink").style.display != "none") {
            $("#headerShopCart").focus();
        } else {
            $("#headerShopCart1").focus();
        }
    },

    /**
     * AddBundle2ShopCartAjax This function is used to add a bundle to the shopping cart.
     **/
    AddBundle2ShopCartAjax: function () {
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;
        }
        var ajaxShopCartService = "AddOrderItem";
        var params = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            orderId: ".",
            inventoryValidation: "true",
            calculateOrder: "0"
        };
        // Remove calculations for performance
        // params.calculationUsage = "-1,-2,-5,-6,-7";
        
        var idx = 1;
        this.productAddedList = {};

        for (productId in this.productList) {
            var productDetails = this.productList[productId];
            var quantity = Utils.parseNumber(productDetails.quantity);

            if (quantity == 0) {
                continue;
            }
            if (productDetails.id == 0) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
                return;
            }
            if (isNaN(quantity) || quantity < 0) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                return;
            }

            params["catEntryId_" + idx] = productDetails.id;
            params["quantity_" + idx++] = quantity;
            this.baseItemAddedToCart = true;

            this.saveAddedProductInfo(quantity, productId, productDetails.id, this.selectedProducts[productId]);
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke(ajaxShopCartService, params);

    },

    resetProductAddedList: function () {
        shoppingActionsJS.productAddedList = {};
    },
    /**
     * Save the product information of the newly added product(s) to be used for the mini cart product added popup
     *
     * @param {String} quantity The quantity of the product being purchased.
     * @param {String} productId The id of the product.
     * @param {String} skuId The id of the sku.
     * @param {String} attrList The list of selected attributes for the product, if any.
     **/
    saveAddedProductInfo: function (quantity, productId, skuId, attrList) {

        var productName = "";
        if ($("#ProductInfoName_" + productId).length) {
            productName = document.getElementById("ProductInfoName_" + productId).value;
        } else if ($("#ProductInfoName_" + skuId).length) {
            productName = document.getElementById("ProductInfoName_" + skuId).value;
        }

        var productThumbnail = "";
        if ($("#ProductInfoImage_" + productId).length) {
            productThumbnail = document.getElementById("ProductInfoImage_" + productId).value;
        } else if ($("#ProductInfoImage_" + skuId).length) {
            productThumbnail = document.getElementById("ProductInfoImage_" + skuId).value;
        }

        var productPrice = "";
        if ($("#ProductInfoPrice_" + productId).length) {
            productPrice = document.getElementById('ProductInfoPrice_' + productId).value;
        } else if ($("#ProductInfoPrice_" + skuId).length) {
            productPrice = document.getElementById('ProductInfoPrice_' + skuId).value;
        }

        var productAdded = [productName, productThumbnail, productPrice, quantity, attrList];
        if (productId != skuId) {
            this.productAddedList[skuId] = productAdded;
        } else {
            this.productAddedList[productId] = productAdded;
        }

        wcTopic.publish("ProductInfo_Added", this.productAddedList);
    },

    /* SwatchCode start */

    /**
     *setSKUImageId Sets the ID of the image to use for swatch.
     **/
    setSKUImageId: function (skuImageId) {
        this.skuImageId = skuImageId;
    },

    /**
     * getImageForSKU Returns the full image of the catalog entry with the selected attributes as specified in the {@link this.selectedAttributes} value.
     *					This method uses resolveImageForSKU to find the SKU image with the selected attributes values.
     *
     * @param {String} imageField, the field name from which the image should be picked
     * @return {String} path to the SKU image.
     * 
     *
     **/
    getImageForSKU: function (entitledItemId, imageField) {
        var attributeArray = [];
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveImageForSKU(attributeArray, imageField);
    },

    /**
     * resolveImageForSKU Resolves image of a SKU using an array of defining attributes.
     *
     * @param {String[]} attributeArray An array of defining attributes upon which to resolve a SKU.
     * @param {String} imageField, the field name from which the image should be picked
     *
     * @return {String} imagePath The location of SKU image.
     *
     **/
    resolveImageForSKU: function (attributeArray, imageField) {

        console.debug("Resolving SKU >> " + attributeArray + ">>" + this.entitledItems);
        var imagePath = "";
        var attributeArrayCount = attributeArray.length;

        for (x in this.entitledItems) {
            if (null != imageField) {
                var imagePath = this.entitledItems[x][imageField];
            } else {
                var imagePath = this.entitledItems[x].ItemImage467;
            }

            var Attributes = this.entitledItems[x].Attributes;
            var attributeCount = 0;
            for (index in Attributes) {
                attributeCount++;
            }

            // Handle special case where a catalog entry has one sku with no attributes
            if (attributeArrayCount == 0 && attributeCount == 0) {
                return imagePath;
            }
            if (attributeCount != 0 && attributeArrayCount >= attributeCount) {
                var matchedAttributeCount = 0;

                for (attributeName in attributeArray) {
                    var attributeValue = attributeArray[attributeName];
                    if (attributeValue in Attributes) {
                        matchedAttributeCount++;
                    }
                }

                if (attributeCount == matchedAttributeCount) {
                    console.debug("ItemImage:" + imagePath + " for Attribute: " + attributeArray);
                    this.disableBuyButtonforUnbuyable(x);
                    var imageArray = [];
                    imageArray.push(imagePath);
                    imageArray.push(this.entitledItems[x].ItemThumbnailImage);
                    if (this.entitledItems[x].ItemAngleThumbnail != null && this.entitledItems[x].ItemAngleThumbnail != undefined) {
                        imageArray.push(this.entitledItems[x].ItemAngleThumbnail);
                        imageArray.push(this.entitledItems[x].ItemAngleFullImage);
                    }
                    return imageArray;
                }
            }
        }
        return null;
    },

    disableBuyButtonforUnbuyable: function (entitledItemIndex) {
        var buyableFlag = this.entitledItems[entitledItemIndex].buyable;
        //				disable the add to cart button
        var btn = document.getElementById("listViewAdd2Cart_" + this.entitledItems[entitledItemIndex].productId);
        if (buyableFlag != null && btn != null) {
            if (buyableFlag == 'false') {
                btn.className += " add2CartButtonDisabled";
            } else {
                btn.className = btn.className.replace(" add2CartButtonDisabled", "");
            }
        }
    },

    /**
     * changeViewImages Updates the angle views of the SKU.
     *
     * @param {String[]} itemAngleThumbnail An array of SKU view thumbnails.
     * @param {String[]} itemAngleFullImage An array of SKU view full images.
     **/
    changeViewImages: function (itemAngleThumbnail, itemAngleFullImage) {
        var imageCount = 0;
        for (x in itemAngleThumbnail) {
            var prodAngleCount = imageCount;
            imageCount++;
            $("#WC_CachedProductOnlyDisplay_images_1_" + imageCount).attr('src', itemAngleThumbnail[x]);
            if ($("#WC_CachedProductOnlyDisplay_links_1_" + imageCount).length) {
                $("#WC_CachedProductOnlyDisplay_links_1_" + imageCount).attr('href',
                    "JavaScript:changeThumbNail('productAngleLi" + prodAngleCount + "','" + itemAngleFullImage[x] + "');");
            }

            if ($("#productAngleLi" + prodAngleCount).length && $("#productAngleLi" + prodAngleCount).attr('className') === ('selected')) {
                changeThumbNail("productAngleLi" + prodAngleCount, itemAngleFullImage[x]);
            }
        }
    },


    /**
     * updates the product image from the PDP page to use the selected SKU image
     * @param String swatchAttrName the newly selection attribute name
     * @param String swatchAttrValue the newly selection attribute value
     * @param {String} imageField, the field name from which the image should be picked
     **/
    changeProdImage: function (entitledItemId, swatchAttrName, swatchAttrValue, skuImageId, imageField) {
        if ($("#" + entitledItemId).length) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        }

        this.setEntitledItems(entitledItemJSON);
        var productId = entitledItemId.substring(entitledItemId.indexOf("_") + 1);

        var skuImage = null;
        var imageArr = shoppingActionsJS.getImageForSKU(entitledItemId, imageField);
        if (imageArr != null) {
            skuImage = imageArr[0];
        }

        if (skuImageId != undefined) {
            this.setSKUImageId(skuImageId);
        }

        if (skuImage != null) {
            if ($("#" + this.skuImageId).length) {
                document.getElementById(this.skuImageId).src = skuImage;
                if ($("#ProductInfoImage_" + productId).length) {
                    document.getElementById("ProductInfoImage_" + productId).value = skuImage;
                }

                var itemAngleThumbnail = imageArr[2];
                var itemAngleFullImage = imageArr[3];
                if (itemAngleThumbnail != null && itemAngleThumbnail != undefined) {
                    shoppingActionsJS.changeViewImages(itemAngleThumbnail, itemAngleFullImage);
                }
            }
        } else {
            var imageFound = false;
            for (x in this.entitledItems) {
                var Attributes = this.entitledItems[x].Attributes;
                if (null != imageField) {
                    var itemImage = this.entitledItems[x][imageField];
                } else {
                    var itemImage = this.entitledItems[x].ItemImage467;
                }


                var itemAngleThumbnail = this.entitledItems[x].ItemAngleThumbnail;
                var itemAngleFullImage = this.entitledItems[x].ItemAngleFullImage;

                for (y in Attributes) {
                    var index = y.indexOf("_|_");
                    var entitledSwatchName = y.substring(0, index);
                    var entitledSwatchValue = y.substring(index + 3);

                    if (entitledSwatchName == swatchAttrName && entitledSwatchValue == swatchAttrValue) {
                        // set sku image only if the img element is present
                        if ($("#" + this.skuImageId).length) {
                            $("#" + this.skuImageId).attr('src', itemImage);
                            if (document.getElementById("ProductInfoImage_" + productId) != null) {
                                document.getElementById("ProductInfoImage_" + productId).value = itemImage;
                            }
                        }
                        if (itemAngleThumbnail != null && itemAngleThumbnail != undefined) {
                            shoppingActionsJS.changeViewImages(itemAngleThumbnail, itemAngleFullImage);
                        }
                        imageFound = true;
                        break;
                    }
                }

                if (imageFound) {
                    break;
                }
            }
        }
    },

    /**
     * Updates the swatches selections on list view.
     * Sets up the swatches array and sku images, then selects a default swatch value.
     **/
    updateSwatchListView: function () {
        var swatchArray = $("a[id^='swatch_array_']");
        for (var i = 0; i < swatchArray.length; i++) {
            var swatchArrayElement = swatchArray[i];
            eval($(swatchArrayElement).attr("href"));
        }

        var swatchSkuImage = $("a[id^='swatch_setSkuImage_']");
        for (var i = 0; i < swatchSkuImage.length; i++) {
            var swatchSkuImageElement = swatchSkuImage[i];
            eval($(swatchSkuImageElement).attr("href"));
        }

        var swatchDefault = $("a[id^='swatch_selectDefault_']");
        for (var i = 0; i < swatchDefault.length; i++) {
            var swatchDefaultElement = swatchDefault[i];
            eval($(swatchDefaultElement).attr("href"));
        }
    },

    /**
     * Handles the case when a swatch is selected. Set the border of the selected swatch.
     * @param {String} selectedAttributeName The name of the selected swatch attribute.
     * @param {String} selectedAttributeValue The value of the selected swatch attribute.
     * @param {String} entitledItemId The ID of the SKU
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
     * @param {String} imageField, the field name from which the image should be picked
     * @return boolean Whether the swatch is available for selection
     **/
    selectSwatch: function (selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField) {
        if ($("#swatch_" + entitledItemId + "_" + selectedAttributeValue).hasClass("color_swatch_disabled")) {
            return;
        }
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            if (attribute == selectedAttributeName) {
                // case when the selected swatch is already selected with a value, if the value is different than
                // what's being selected, reset other swatches and deselect the previous value and update selection
                if (selectedAttributes[attribute] != selectedAttributeValue) {
                    // deselect previous value and update swatch selection
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + selectedAttributes[attribute]);
                    swatchElement.className = "color_swatch";
                    swatchElement.src = swatchElement.src.replace("_disabled.png", "_enabled.png");

                    //change the title text of the swatch link
                    document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]).title = swatchElement.alt;
                }
            }
            if (document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]) != null) {
                document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]).setAttribute("aria-checked", "false");
            }
        }
        this.makeSwatchSelection(selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField);
    },

    /**
     * Make swatch selection - add to selectedAttribute, select image, and update other swatches and SKU image based on current selection.
     * @param {String} swatchAttrName The name of the selected swatch attribute.
     * @param {String} swatchAttrValue The value of the selected swatch attribute.
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.	
     * @param {String} skuImageId This is optional. The element id of the product image - image element id is different in product page and category list view. Product page need not pass it because it is set separately
     * @param {String} imageField This is optional. The json field from which image should be picked. Pass value if a different size image need to be picked
     **/
    makeSwatchSelection: function (swatchAttrName, swatchAttrValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField) {
        // setSelectedAttribute internally calls changeProdImage method to change product image.
        this.setSelectedAttribute(swatchAttrName, swatchAttrValue, entitledItemId, skuImageId, imageField);
        document.getElementById("swatch_" + entitledItemId + "_" + swatchAttrValue).className = "color_swatch_selected";
        document.getElementById("swatch_link_" + entitledItemId + "_" + swatchAttrValue).setAttribute("aria-checked", "true");
        document.getElementById("swatch_selection_label_" + entitledItemId + "_" + swatchAttrName).className = "header color_swatch_label";
        if (document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).style.display == "none") {
            document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).style.display = "inline";
        }
        if (selectedAttributeDisplayValue != null) {
            document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).innerHTML = selectedAttributeDisplayValue;
        } else {
            document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).innerHTML = swatchAttrValue;
        }

        this.updateSwatchImages(swatchAttrName, entitledItemId, doNotDisable, imageField);
    },

    /**
     * Constructs record and add to this.allSwatchesArray.
     * @param {String} swatchName The name of the swatch attribute.
     * @param {String} swatchValue The value of the swatch attribute.	
     * @param {String} swatchImg1 The path to the swatch image.
     **/
    addToAllSwatchsArray: function (swatchName, swatchValue, swatchImg1, entitledItemId, swatchDisplayValue) {
        var swatchList = this.allSwatchesArrayList[entitledItemId];
        if (swatchList == null) {
            swatchList = [];;
        }
        if (!this.existInAllSwatchsArray(swatchName, swatchValue, swatchList)) {
            var swatchRecord = [];
            swatchRecord[0] = swatchName;
            swatchRecord[1] = swatchValue;
            swatchRecord[2] = swatchImg1;
            swatchRecord[4] = document.getElementById("swatch_link_" + entitledItemId + "_" + swatchValue).onclick;
            swatchRecord[5] = null;
            swatchRecord[6] = swatchDisplayValue;
            swatchList.push(swatchRecord);
            this.allSwatchesArrayList[entitledItemId] = swatchList;
        }
    },

    /**
     * Checks if a swatch is already exist in this.allSwatchesArray.
     * @param {String} swatchName The name of the swatch attribute.
     * @param {String} swatchValue The value of the swatch attribute.		
     * @return boolean Value indicating whether or not the specified swatch name and value exists in the allSwatchesArray.
     */
    existInAllSwatchsArray: function (swatchName, swatchValue, swatchList) {
        for (var i = 0; i < swatchList.length; i++) {
            var attrName = swatchList[i][0];
            var attrValue = swatchList[i][1];
            if (attrName == swatchName && attrValue == swatchValue) {
                return true;
            }
        }
        return false;
    },

    /**
     * Check the entitledItems array and pre-select the first entited SKU as the default swatch selection.
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.		
     **/
    makeDefaultSwatchSelection: function (entitledItemId, doNotDisable) {
        if (this.entitledItems.length == 0) {
            if ($("#" + entitledItemId).length) {
                entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
            }
            this.setEntitledItems(entitledItemJSON);
        }

        // need to make selection for every single swatch
        for (x in this.entitledItems) {
            var Attributes = this.entitledItems[x].Attributes;
            for (y in Attributes) {
                var index = y.indexOf("_|_");
                var swatchName = y.substring(0, index);
                var swatchValue = y.substring(index + 3);
                this.makeSwatchSelection(swatchName, swatchValue, entitledItemId, doNotDisable, null, imageField);
            }
            break;
        }
    },

    /**
     * Update swatch images - this is called after selection of a swatch is made, and this function checks for
     * entitlement and disable swatches that are not available
     * @param selectedAttrName The attribute that is selected
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.	
     **/
    updateSwatchImages: function (selectedAttrName, entitledItemId, doNotDisable, imageField) {
        var swatchToUpdate = [];
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        var selectedAttrValue = selectedAttributes[selectedAttrName];
        var swatchList = this.allSwatchesArrayList[entitledItemId];

        // finds out which swatch needs to be updated, add to swatchToUpdate array
        for (var i = 0; i < swatchList.length; i++) {
            var attrName = swatchList[i][0];
            var attrValue = swatchList[i][1];
            var attrImg1 = swatchList[i][2];
            var attrImg2 = swatchList[i][3];
            var attrOnclick = swatchList[i][4];
            var attrDisplayValue = swatchList[i][6];

            if (attrName != doNotDisable && attrName != selectedAttrName) {
                var swatchRecord = [];
                swatchRecord[0] = attrName;
                swatchRecord[1] = attrValue;
                swatchRecord[2] = attrImg1;
                swatchRecord[4] = attrOnclick;
                swatchRecord[5] = false;
                swatchRecord[6] = attrDisplayValue;
                swatchToUpdate.push(swatchRecord);
            }
        }

        // finds out which swatch is entitled, if it is, image should be set to enabled
        // go through entitledItems array and find out swatches that are entitled 
        for (x in this.entitledItems) {
            var Attributes = this.entitledItems[x].Attributes;

            for (y in Attributes) {
                var index = y.indexOf("_|_");
                var entitledSwatchName = y.substring(0, index);
                var entitledSwatchValue = y.substring(index + 3);

                //the current entitled item has the selected attribute value
                if (entitledSwatchName == selectedAttrName && entitledSwatchValue == selectedAttrValue) {
                    //go through the other attributes that are available to the selected attribute
                    //exclude the one that is selected
                    for (z in Attributes) {
                        var index2 = z.indexOf("_|_");
                        var entitledSwatchName2 = z.substring(0, index2);
                        var entitledSwatchValue2 = z.substring(index2 + 3);

                        if (y != z) { //only check the attributes that are not the one selected
                            for (i in swatchToUpdate) {
                                var swatchToUpdateName = swatchToUpdate[i][0];
                                var swatchToUpdateValue = swatchToUpdate[i][1];

                                if (entitledSwatchName2 == swatchToUpdateName && entitledSwatchValue2 == swatchToUpdateValue) {
                                    swatchToUpdate[i][5] = true;
                                }
                            }
                        }
                    }
                }
            }
        }

        // Now go through swatchToUpdate array, and update swatch images
        var disabledAttributes = [];
        for (i in swatchToUpdate) {
            var swatchToUpdateName = swatchToUpdate[i][0];
            var swatchToUpdateValue = swatchToUpdate[i][1];
            var swatchToUpdateImg1 = swatchToUpdate[i][2];
            var swatchToUpdateImg2 = swatchToUpdate[i][3];
            var swatchToUpdateOnclick = swatchToUpdate[i][4];
            var swatchToUpdateEnabled = swatchToUpdate[i][5];

            if (swatchToUpdateEnabled) {
                if (document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue).className != "color_swatch_selected") {
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue);
                    swatchElement.className = "color_swatch";
                    swatchElement.src = swatchElement.src.replace("_disabled.png", "_enabled.png");

                    //change the title text of the swatch link
                    document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).title = swatchElement.alt;
                }
                document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).setAttribute("aria-disabled", "false");
                document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).onclick = swatchToUpdateOnclick;
            } else {
                if (swatchToUpdateName != doNotDisable) {
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue);
                    var swatchLinkElement = document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue);
                    swatchElement.className = "color_swatch_disabled";
                    swatchLinkElement.onclick = null;
                    swatchElement.src = swatchElement.src.replace("_enabled.png", "_disabled.png");

                    //change the title text of the swatch link

                    var titleText = Utils.getLocalizationMessage("INV_ATTR_UNAVAILABLE", [swatchElement.alt]);

                    document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).setAttribute("aria-disabled", "true");

                    //The previously selected attribute is now unavailable for the new selection
                    //Need to switch the selection to an available value
                    if (selectedAttributes[swatchToUpdateName] == swatchToUpdateValue) {
                        disabledAttributes.push(swatchToUpdate[i]);
                    }
                }
            }
        }

        //If there were any previously selected attributes that are now unavailable
        //Find another available value for that attribute and update other attributes according to the new selection
        for (i in disabledAttributes) {
            var disabledAttributeName = disabledAttributes[i][0];
            var disabledAttributeValue = disabledAttributes[i][1];

            for (i in swatchToUpdate) {
                var swatchToUpdateName = swatchToUpdate[i][0];
                var swatchToUpdateValue = swatchToUpdate[i][1];
                var swatchToUpdateDisplayValue = swatchToUpdate[i][6];
                var swatchToUpdateEnabled = swatchToUpdate[i][5];

                if (swatchToUpdateName == disabledAttributeName && swatchToUpdateValue != disabledAttributeValue && swatchToUpdateEnabled) {
                    this.makeSwatchSelection(swatchToUpdateName, swatchToUpdateValue, entitledItemId, doNotDisable, swatchToUpdateDisplayValue, imageField);
                    break;
                }
            }
        }
    },
    /* SwatchCode end */

    /**
     * This function is used to change the price displayed in the Product Display Page on change of  a attribute of the product using an AJAX call. 
     * This function will resolve the catentryId using entitledItemId and displays the price of the catentryId.
     *				
     * @param {Object} entitledItemId A DIV containing a JSON object which holds information about a catalog entry. You can reference CachedProductOnlyDisplay.jsp to see how that div is constructed.
     * @param {Boolean} isPopup If the value is true, then this implies that the function was called from a quick info pop-up.
     * @param {Boolean} displayPriceRange If the value is true, then display the price range. If it is false then donot display the price range.
     *
     **/
    changePrice: function (entitledItemId, isPopup, displayPriceRange, productId) {
        this.displayPriceRange = displayPriceRange;
        this.isPopup = isPopup;
        var entitledItemJSON;

        if ($("#" + entitledItemId).length && !this.isPopup) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        } else {
            //if $("#"+ entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object. 
            //in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
            entitledItemJSON = this.getEntitledItemJsonObject();
        }
        var catalogEntryId = null;
        this.setEntitledItems(entitledItemJSON);

        if (this.selectedProducts[productId]) {
            var catalogEntryId = this.getCatalogEntryIdforProduct(this.selectedProducts[productId]);
        } else {
            var catalogEntryId = this.getCatalogEntryId(entitledItemId);
        }

        if (catalogEntryId != null) {
            //check if the json object is already present for the catEntry.
            if (this.itemPriceJsonOject[catalogEntryId] != null && this.itemPriceJsonOject[catalogEntryId] != 'undefined') {
                this.displayPrice(this.itemPriceJsonOject[catalogEntryId].catalogEntry, productId);
                console.debug("ShoppingActions.changePrice: using stored json object.");
            }
            //if json object is not present, call the service to get the details.
            else {
                var parameters = {
                    storeId: this.storeId,
                    langId: this.langId,
                    catalogId: this.catalogId,
                    catalogEntryId: catalogEntryId,
                    productId: productId
                };

                //Declare a service for retrieving catalog entry detailed information for an item...
                wcService.declare({
                    id: "getCatalogEntryDetailsSA",
                    actionId: "getCatalogEntryDetailsSA",
                    url: getAbsoluteURL() + appendWcCommonRequestParameters("GetCatalogEntryDetailsByIDView"),
                    formId: ""

                    ,
                    successHandler: function (serviceResponse, ioArgs) {
                        shoppingActionsJS.displayPriceServiceResponse(serviceResponse, ioArgs);
                    }

                    ,
                    failureHandler: function (serviceResponse, ioArgs) {
                        console.debug("ShoppingActions.changePrice: Unexpected error occurred during an xhrPost request.");
                    }

                });
                wcService.invoke("getCatalogEntryDetailsSA", parameters);
            }
        } else {
            console.debug("ShoppingActions.changePrice: all attributes are not selected.");
        }

    },

    /** 
     * Displays price of the catEntry selected with the JSON objrct returned from the server.
     * 
     * @param {object} serviceRepsonse The JSON response from the service.
     * @param {object} ioArgs The arguments from the service call.
     */
    displayPriceServiceResponse: function (serviceResponse, ioArgs) {
        var productId = ioArgs.productId;
        //stores the json object, so that the service is not called when same catEntry is selected.
        shoppingActionsJS.itemPriceJsonOject[serviceResponse.catalogEntry.catalogEntryIdentifier.uniqueID] = serviceResponse;

        shoppingActionsJS.displayPrice(serviceResponse.catalogEntry, productId);
    },

    /** 
     * Displays price of the attribute selected with the JSON oject.
     * 
     * @param {object} catEntry The JSON object with catalog entry details.
     */
    displayPrice: function (catEntry, productId) {

        var tempString;
        var popup = shoppingActionsJS.isPopup;

        if (popup == true) {
            $("#productPrice").html(catEntry.offerPrice);
            document.getElementById('productName').innerHTML = catEntry.description[0].name;
            document.getElementById('productSKUValue').innerHTML = catEntry.catalogEntryIdentifier.externalIdentifier.partNumber;
        }

        if (popup == false) {
            var innerHTML = "";
            var listPrice = Utils.parseNumber(catEntry.listPrice);
            var offerPrice = Utils.parseNumber(catEntry.offerPrice);

            this.setPriceInProductList(productId, offerPrice);

            if (!catEntry.listPriced || listPrice <= offerPrice) {
                innerHTML = "<span id='offerPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='price'>" + catEntry.offerPrice + "</span>";
            } else {
                innerHTML = "<span id='listPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='old_price'>" + catEntry.listPrice + "</span>" +
                    "<span id='offerPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='price'>" + catEntry.offerPrice + "</span>";
            }
            document.getElementById('price_display_' + productId).innerHTML = innerHTML + "<input type='hidden' id='ProductInfoPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' value='" + catEntry.offerPrice + "'/>";

            innerHTML = "";
            if (shoppingActionsJS.displayPriceRange == true) {
                for (var i in catEntry.priceRange) {
                    if (catEntry.priceRange[i].endingNumberOfUnits == catEntry.priceRange[i].startingNumberOfUnits) {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X', {
                            0: catEntry.priceRange[i].startingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    } else if (catEntry.priceRange[i].endingNumberOfUnits != 'null') {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X_TO_Y', {
                            0: catEntry.priceRange[i].startingNumberOfUnits,
                            1: catEntry.priceRange[i].endingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    } else {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X_OR_MORE', {
                            0: catEntry.priceRange[i].startingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    }
                    innerHTML = innerHTML + " <span class='price'>" + catEntry.priceRange[i].localizedPrice + "</span></p>";
                }
            }
            // Append productId so that element is unique in bundle page, where there can be multiple components
            var quantityDiscount = document.getElementById("productLevelPriceRange_" + productId);
            var itemQuantityDiscount = document.getElementById("itemLevelPriceRange_" + productId);

            // if product level price exists and no section to update item level price
            if (null != quantityDiscount && null == itemQuantityDiscount) {
                quantityDiscount.style.display = ""; //display product level price range
            }
            // if item level price range is present
            else if ("" != innerHTML && null != itemQuantityDiscount) {
                innerHTML = Utils.getLocalizationMessage('PQ_PURCHASE') + innerHTML;
                itemQuantityDiscount.innerHTML = innerHTML;
                itemQuantityDiscount.style.display = "";
                // hide the product level price range
                if (null != quantityDiscount) {
                    quantityDiscount.style.display = "none";
                }
            }
            // if item level price range is not present
            else if ("" == innerHTML) {
                if (null != itemQuantityDiscount) {
                    itemQuantityDiscount.style.display = "none"; //hide item level price range
                }
                if (null != quantityDiscount) {
                    quantityDiscount.style.display = ""; //display product level price range
                }
            }

            /*
             * If the product name is a link, do not replace the link only replace the text in the link.
             * Otherwise, replace the whole text
             */
            var productNameLink = $('#product_name_' + productId + ' > a');
            if (productNameLink.length == 1) {
                $(productNameLink[0]).html(catEntry.description[0].name);
            } else if ($('#product_name_' + productId)) {
                $('#product_name_' + productId).html(catEntry.description[0].name);
            }

            if ($("#widget_product_info_viewer > div[id^='PageHeading_']").length) {
                $("#widget_product_info_viewer > div[id^='PageHeading_']").each(function (i, node) {
                    if (node.childNodes != null && node.childNodes.length == 3) {
                        node.childNodes[1].innerHTML = catEntry.description[0].name;
                    }
                });
            }
            if (document.getElementById("ProductInfoName_" + productId) != null) {
                document.getElementById("ProductInfoName_" + productId).value = catEntry.description[0].name;
            }
            if (document.getElementById('product_shortdescription_' + productId)) {
                document.getElementById('product_shortdescription_' + productId).innerHTML = catEntry.description[0].shortDescription;
            }
            if (document.getElementById('product_SKU_' + productId)) {
                document.getElementById('product_SKU_' + productId).innerHTML = Utils.getLocalizationMessage('SKU') + " " + catEntry.catalogEntryIdentifier.externalIdentifier.partNumber;
            }
        }
    },

    /**
     *This method will show the WC Dialog popup
     *@param{String} widgetId The ID of the WC Dialog which should be shown
     */
    showWCDialogPopup: function (widgetId) {
        var dialog = $("#" + widgetId).data("wc-WCDialog");
        if (dialog) {
            dialog.open();
            $("#" + widgetId).css("display", "block");
        } else {
            console.debug(widgetId + " does not exist");
        }
    },

    /**
     * To notify the change in attribute to other components that is subscribed to DefiningAttributes_Resolved_[productId] event.
     */
    notifyAttributeChange: function (catalogEntryID) {
        this.baseCatalogEntryId = catalogEntryID;
        var selectedAttributes = this.selectedAttributesList["entitledItem_" + catalogEntryID];
        wcTopic.publish('DefiningAttributes_Resolved_' + catalogEntryID, catalogEntryID, -1);
    },

    /**
     * To notify the change in quantity to other components that is subscribed to Quantity_Changed event.
     */
    notifyQuantityChange: function (quantity) {
        wcTopic.publish("Quantity_Changed", quantity);
    },

    /**
     * Initializes the compare check box for all the products added to compare.
     */
    initCompare: function (fromPage) {
        if (fromPage == 'compare' || fromPage == 'catalogEntryList') {
            this.checkForCompare();
        } else {
            var cookieKey = this.cookieKeyPrefix + this.storeId;
            var newCookieValue = "";
            setCookie(cookieKey, newCookieValue, {
                path: '/',
                domain: cookieDomain
            });
        }

    },

    /**
     * Change the compare box status to checked or unchecked
     * @param{String} cbox The ID of the compare check box of the given catentry identifier.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     */
    changeCompareBox: function (cbox, catEntryIdentifier) {
        box = document.getElementById(cbox);
        box.checked = !box.checked;
        this.addOrRemoveFromCompare(catEntryIdentifier, box.checked);
    },

    /**
     * Adds or removes the product from the compare depending on the compare box checked or unchecked.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     * @param{boolean} checked True if the checkbox is checked or False
     */
    addOrRemoveFromCompare: function (catEntryIdentifier, checked) {
        //box = eval(cbox);
        if (checked) {
            this.addToCompare(catEntryIdentifier);
        } else {
            this.removeFromCompare(catEntryIdentifier);
        }
    },

    /**
     * Adds the product to the compare cookie.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     */
    addToCompare: function (catEntryIdentifier) {

        var cookieKey = this.cookieKeyPrefix + this.storeId;
        var cookieValue = getCookie(cookieKey);

        if (cookieValue != null) {
            if (cookieValue.indexOf(catEntryIdentifier) != -1 || catEntryIdentifier == null) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("COMPARE_ITEM_EXISTS"));
                return;
            }
        }

        var currentNumberOfItemsInCompare = 0;
        if (cookieValue != null && cookieValue !== "") {
            currentNumberOfItemsInCompare = cookieValue.split(this.cookieDelimiter).length;
        }

        if (currentNumberOfItemsInCompare < parseInt(this.maxNumberProductsAllowedToCompare)) {
            var newCookieValue = "";
            if (cookieValue == null || cookieValue === "") {
                newCookieValue = catEntryIdentifier;
            } else {
                newCookieValue = cookieValue + this.cookieDelimiter + catEntryIdentifier;
            }
            setCookie(cookieKey, newCookieValue, {
                path: '/',
                domain: cookieDomain
            });
            shoppingActionsJS.checkForCompare();
        } else {
            this.showWCDialogPopup('widget_product_comparison_popup');
            document.getElementById("comparebox_" + catEntryIdentifier).checked = false;
            console.debug("You can only compare up to 4 products");
        }
    },

    /**
     * Removes the product from the compare cookie.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     */
    removeFromCompare: function (catEntryIdentifier) {
        var cookieKey = this.cookieKeyPrefix + this.storeId;
        var cookieValue = getCookie(cookieKey);
        var currentNumberOfItemsInCompare = 0;
        if (cookieValue != null) {
            if (cookieValue.trim() == "") {
                setCookie(cookieKey, null, {
                    expires: -1
                });
            } else {
                var cookieArray = cookieValue.split(this.cookieDelimiter);
                var newCookieValue = "";
                for (index in cookieArray) {
                    if (cookieArray[index] != catEntryIdentifier) {
                        if (newCookieValue === "") {
                            newCookieValue = cookieArray[index];
                        } else {
                            newCookieValue = newCookieValue + this.cookieDelimiter + cookieArray[index];
                        }
                    }
                }
                setCookie(cookieKey, newCookieValue, {
                    path: '/',
                    domain: cookieDomain
                });
                currentNumberOfItemsInCompare = newCookieValue.split(this.cookieDelimiter).length;
            }
            shoppingActionsJS.checkForCompare();
        }
    },

    /**
     * Re-directs the browser to the CompareProductsDisplay page to compare products side-by-side.
     */
    compareProducts: function (categoryIds, manufacturer) {
        var url = appendWcCommonRequestParameters("CompareProductsDisplayView?storeId=" + this.storeId + "&catalogId=" + this.catalogId + "&langId=" + this.langId + "&compareReturnName=" + encodeURIComponent(this.compareReturnName) + "&searchTerm=" + this.searchTerm);
        if ('' != categoryIds.top_category) {
            url = url + "&top_category=" + categoryIds.top_category;
        }
        if ('' != categoryIds.parent_category_rn) {
            url = url + "&parent_category_rn=" + categoryIds.parent_category_rn;
        }
        if ('' != categoryIds.categoryId) {
            url = url + "&categoryId=" + categoryIds.categoryId;
        }
		if (manufacturer != undefined && '' != manufacturer) {
			url = url + "&manufacturer=" + manufacturer;
		}
		
        var cookieKey = this.cookieKeyPrefix + this.storeId;
        var cookieValue = getCookie(cookieKey);
        if (cookieValue != null && cookieValue.trim() != "") {
            url = url + "&catentryId=" + cookieValue;
        }
        var returnUrl = appendWcCommonRequestParameters(location.href);
        if (returnUrl.indexOf("?") === -1) {
            returnUrl = returnUrl + "?fromPage=compare";
        } else if (returnUrl.indexOf("fromPage=compare") === -1) {
            returnUrl = returnUrl + "&fromPage=compare";
        }
        url = url + "&returnUrl=" + encodeURIComponent(returnUrl);
        location.href = getAbsoluteURL() + url;
    },

    /**
     * Sets the quantity of a product in the list (bundle)
     * 
     * @param {String} catalogEntryType, type of catalogEntry (item/product/bundle/package)
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {int} quantity The quantity of current product.
     * @param {float} price The price of current product.
     */
    setProductQuantity: function (catalogEntryType, catalogEntryId, quantity, price) {
        var productDetails = null;
        if (this.productList[catalogEntryId]) {
            productDetails = this.productList[catalogEntryId];
        } else {
            productDetails = {};
            this.productList[catalogEntryId] = productDetails;
            productDetails.baseItemId = catalogEntryId;
            if ("item" == catalogEntryType) {
                productDetails.id = catalogEntryId;
            } else {
                productDetails.id = 0;
            }
        }
        productDetails.quantity = quantity;
        wcTopic.publish("Quantity_Changed", JSON.stringify(productDetails));
        productDetails.price = Utils.parseNumber(price);
    },

    /**
     * Sets the quantity of a product in the list (bundle)
     * 
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {int} quantity The quantity of current product.
     */
    quantityChanged: function (catalogEntryId, quantity) {
        if (this.productList[catalogEntryId]) {
            var productDetails = this.productList[catalogEntryId];
            productDetails.quantity = quantity.trim();
            wcTopic.publish("Quantity_Changed", JSON.stringify(productDetails));

            //Update quantity for catentries in the merchandising association array
            if (MerchandisingAssociationJS != null) {
                if (MerchandisingAssociationJS.baseItemParams != null) {
                    if (MerchandisingAssociationJS.baseItemParams.type == 'BundleBean') {
                        // Update items in the bundle
                        for (idx = 0; idx < MerchandisingAssociationJS.baseItemParams.components.length; idx++) {
                            if (catalogEntryId == MerchandisingAssociationJS.baseItemParams.components[idx].productId || catalogEntryId == MerchandisingAssociationJS.baseItemParams.components[idx].id) {
                                MerchandisingAssociationJS.baseItemParams.components[idx].quantity = productDetails.quantity;
                            }
                        }
                    }
                }
            }
        }
    },

    /**
     * Sets the price of a product in the list (bundle)
     * 
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {int} price The price of current product.
     */
    setPriceInProductList: function (catalogEntryId, price) {
        var productDetails = this.productList[catalogEntryId];
        if (productDetails) {
            productDetails.price = price;
        }
    },

    /**
     * Select bundle item swatch
     * 
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {String} swatchName
     * @param {String} swatchValue
     * @param {String} doNotDisable, the first swatch, that should not be disabled
     */
    selectBundleItemSwatch: function (catalogEntryId, swatchName, swatchValue, doNotDisable) {
        if ($("#swatch_" + catalogEntryId + "_" + swatchName + "_" + swatchValue).hasClass("color_swatch_disabled")) {
            return;
        }
        if ($("#entitledItem_" + catalogEntryId).length) {
            var entitledItemJSON;
            var currentSwatchkey = swatchName + "_" + swatchValue;
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = JSON.stringify($("#entitledItem_" + catalogEntryId).html());
            var validSwatchArr = [];
            for (idx in entitledItemJSON) {
                var validItem = false;
                var entitledItem = entitledItemJSON[idx];
                for (attribute in entitledItem.Attributes) {

                    if (currentSwatchkey == attribute) {
                        validItem = true;
                        break;
                    }
                }
                if (validItem) {
                    for (attribute in entitledItem.Attributes) {
                        var currentSwatch = attribute.substring(0, attribute.lastIndexOf("_|_"));
                        if (currentSwatch != doNotDisable && currentSwatch != swatchName) {
                            validSwatchArr.push(attribute);
                        }
                    }
                }
            }

            var swatchesDisabled = [];
            var selectedSwatches = [];
            for (idx in entitledItemJSON) {
                var entitledItem = entitledItemJSON[idx];
                for (attribute in entitledItem.Attributes) {
                    var currentSwatch = attribute.substring(0, attribute.lastIndexOf("_|_"));
                    if (currentSwatch != doNotDisable && currentSwatch != swatchName) {
                        var swatchId = "swatch_" + catalogEntryId + "_" + attribute;
                        var swatchLinkId = swatchId.replace("swatch_", "swatch_link_");
                        if (validSwatchArr.indexOf(attribute) > -1) {
                            if (!$("#" + swatchId).hasClass("color_swatch_selected")) {
                                document.getElementById(swatchId).className = "color_swatch";
                                document.getElementById(swatchId).src = document.getElementById(swatchId).src.replace("_disabled.png", "_enabled.png");

                                //change the title text of the swatch link
                                document.getElementById(swatchLinkId).title = document.getElementById(swatchId).alt;
                                document.getElementById(swatchLinkId).setAttribute("aria-disabled", "false");
                            }
                        } else if (swatchesDisabled.indexOf(attribute) === -1) {
                            swatchesDisabled.push(attribute);
                            if ($("#" + swatchId).hasClass("color_swatch_selected")) {
                                selectedSwatches.push(swatchId);
                            }
                            document.getElementById(swatchId).className = "color_swatch_disabled";
                            document.getElementById(swatchId).src = document.getElementById(swatchId).src.replace("_enabled.png", "_disabled.png");

                            //change the title text of the swatch link
			    
			    var altText = document.getElementById(swatchId).alt;
                            var titleText = Utils.getLocalizationMessage("INV_ATTR_UNAVAILABLE", [altText]);
                            

                           
                            $("#" + swatchLinkId).attr("aria-disabled", "true");
                        }
                    }
                    if (document.getElementById("swatch_link_" + catalogEntryId + "_" + attribute) != null) {
                        document.getElementById("swatch_link_" + catalogEntryId + "_" + attribute).setAttribute("aria-checked", "false");
                    }
                }
            }

            for (idx in selectedSwatches) {
                var selectedSwatch = selectedSwatches[idx];
                var idSelector = selectedSwatch.substring(0, selectedSwatch.lastIndexOf("_|_"));
                var swatchSelected = false;
                $("[id^='" + idSelector + "']").each(function (index, node, arr) {
                    if (!swatchSelected && $(node).hasClass("color_swatch")) {
                        var values = node.id.split("_");
                        shoppingActionsJS.selectBundleItemSwatch(values[1], values[2], values[3], doNotDisable);
                        shoppingActionsJS.setSelectedAttributeOfProduct(values[1], values[2], values[3], false);
                        swatchSelected = true;
                    }
                });
            }
        }

        if ($("#swatch_selection_" + catalogEntryId + "_" + swatchName).css("display") == ("none")) {
            $("#swatch_selection_" + catalogEntryId + "_" + swatchName).css("display", "inline");
        }
        $("#swatch_selection_" + catalogEntryId + "_" + swatchName).html(swatchValue);

        var swatchItem = "swatch_" + catalogEntryId + "_" + swatchName + "_";
        var swatchItemLink = "swatch_link_" + catalogEntryId + "_" + swatchName + "_";

        $("img[id^='" + swatchItem + "']").each(function (index, node, arr) {
            if ($(node).hasClass("color_swatch_disabled")) {
                $(node).removeClass("color_swatch")
            } else {
                $(node).addClass("color_swatch");
            }
            $(node).removeClass("color_swatch_selected");
        });

        $("#" + swatchItem + swatchValue).attr("className", "color_swatch_selected");
        document.getElementById(swatchItemLink + swatchValue).setAttribute("aria-checked", "true");

        this.setSelectedAttributeOfProduct(catalogEntryId, swatchName, swatchValue, false);
        // select image
        this.changeBundleItemImage(catalogEntryId, swatchName, swatchValue, "productThumbNailImage_" + catalogEntryId);

    },

    changeBundleItemImage: function (catalogEntryId, swatchAttrName, swatchAttrValue, skuImageId) {
        var entitledItemId = "entitledItem_" + catalogEntryId;
        if ($("#" + entitledItemId).length) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        }

        this.setEntitledItems(entitledItemJSON);

        var skuImage = null;
        var imageArr = shoppingActionsJS.getImageForBundleItem(catalogEntryId);
        if (imageArr != null) {
            skuImage = imageArr[1];
        }

        if (skuImageId != undefined) {
            this.setSKUImageId(skuImageId);
        }

        if (skuImage != null) {
            if ($("#" + this.skuImageId) != null) {
                document.getElementById(this.skuImageId).src = skuImage;
                if (document.getElementById("ProductInfoImage_" + catalogEntryId) != null) {
                    document.getElementById("ProductInfoImage_" + catalogEntryId).value = skuImage;
                }
            }
        } else {
            var imageFound = false;
            for (x in this.entitledItems) {
                var Attributes = this.entitledItems[x].Attributes;
                var itemImage = this.entitledItems[x].ItemThumbnailImage;

                for (y in Attributes) {
                    var index = y.indexOf("_|_");
                    var entitledSwatchName = y.substring(0, index);
                    var entitledSwatchValue = y.substring(index + 3);

                    if (entitledSwatchName == swatchAttrName && entitledSwatchValue == swatchAttrValue) {
                        document.getElementById(this.skuImageId).src = itemImage;
                        if (document.getElementById("ProductInfoImage_" + catalogEntryId) != null) {
                            document.getElementById("ProductInfoImage_" + catalogEntryId).value = itemImage;
                        }
                        imageFound = true;
                        break;
                    }
                }

                if (imageFound) {
                    break;
                }
            }
        }
    },

    getImageForBundleItem: function (entitledItemId) {
        var attributeArray = [];
        var selectedAttributes = this.selectedProducts[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveImageForSKU(attributeArray);
    },

    /**
     * Check if any product is already selected for compare in other pages and select them
     */
    checkForCompare: function () {
        var cookieValues = getCookie(shoppingActionsJS.cookieKeyPrefix + shoppingActionsJS.storeId);
        cookieValues = (cookieValues ? cookieValues.split(shoppingActionsJS.cookieDelimiter) : []);
        var labels = $(".compareCheckboxLabels > label");
        $(".compare_target").each(function (i, div) {
            var checkbox = $("input[type=\"checkbox\"]", div)[0];
            checkbox.checked = (cookieValues.indexOf(checkbox.value) !== -1);
            var state = (checkbox.checked ? (cookieValues.length > 1 ? 2 : 1) : 0);
            div.setAttribute("data-state", state.toString());
            var label = $("label[for=\"" + checkbox.id + "\"]", div)[0];
            $(label).html($(labels[state]).html());
        });
    },

    /**
     * replaceItemAjaxHelper This function is used to replace an item in the cart. This will be called from the {@link this.ReplaceItemAjax} method.
     *
     * @param {String} catalogEntryId The catalog entry of the item to replace to the cart.
     * @param {int} qty The quantity of the item to add.
     * @param {String} removeOrderItemId The order item ID of the catalog entry to remove from the cart.
     * @param {String} addressId The address ID of the order item.
     * @param {String} shipModeId The shipModeId of the order item.
     * @param {String} physicalStoreId The physicalStoreId of the order item.
     *
     **/
    replaceItemAjaxHelper: function (catalogEntryId, qty, removeOrderItemId, addressId, shipModeId, physicalStoreId) {

        var params = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            orderItemId: removeOrderItemId,
            orderId: "."
        };
        if (CheckoutHelperJS.shoppingCartPage) {
            params.calculationUsage = "-1,-2,-5,-6,-7";
        } else {
            params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        }

        var params2 = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            catEntryId: catalogEntryId,
            quantity: qty,
            orderId: ".",
	    calculateOrder: "1"
        };
        if (CheckoutHelperJS.shoppingCartPage) {
            params2.calculationUsage = "-1,-2,-5,-6,-7";
        } else {
            params2.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        }

        var params3 = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            orderId: "."
        };
        if (CheckoutHelperJS.shoppingCartPage) {
            params3.calculationUsage = "-1,-2,-5,-6,-7";
        } else {
            params3.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        }

        var shipInfoUpdateNeeded = false;
        var orderItemReqd = true;
        if (addressId != null && addressId !== "") {
            params3.addressId = addressId;
        }
        if (shipModeId != null && shipModeId !== "") {
            params3.shipModeId = shipModeId;
        }
        if (physicalStoreId != null && physicalStoreId !== "") {
            params3.physicalStoreId = physicalStoreId;
            orderItemReqd = false;
        }
        if (params3.shipModeId != null && (params3.addressId != null || params3.physicalStoreId != null)) {
            shipInfoUpdateNeeded = true;
        }

        if (orderItemReqd) {
            params3.allocate = "***";
            params3.backorder = "***";
            params3.remerge = "***";
            params3.check = "*n";
        }

        //Delcare service for deleting item...
        wcService.declare({
            id: "AjaxReplaceItem",
            actionId: "AjaxReplaceItem",
            url: "AjaxRESTOrderItemDelete",
            formId: ""

            ,
            successHandler: function (serviceResponse) {
                //Now add the new item to cart..
                if (!shipInfoUpdateNeeded) {
                    //We dont plan to update addressId and shipMOdeId..so call AjaxAddOrderItem..
                    wcService.invoke("AjaxAddOrderItem", params2);
                } else {
                    //We need to update the adderessId and shipModeId..so call our temp service to add..
                    wcService.invoke("AjaxAddOrderItemTemp", params2);
                }
            }

            ,
            failureHandler: function (serviceResponse) {
                if (serviceResponse.errorMessage) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                } else {
                    if (serviceResponse.errorMessageKey) {
                        MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                    }
                }
                cursor_clear();
            }

        });

        //Delcare service for adding item..
        wcService.declare({
            id: "AjaxAddOrderItemTemp",
            actionId: "AjaxAddOrderItemTemp",
            url: "AjaxRESTOrderItemAdd",
            formId: ""

            ,
            successHandler: function (serviceResponse) {
                // setting the newly created orderItemId
                params3.orderItemId = (serviceResponse.orderItem != null && serviceResponse.orderItem[0].orderItemId != null) ? serviceResponse.orderItem[0].orderItemId : serviceResponse.orderItemId;

                MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_ADDED"]);

                //Now item is added.. call update to set addressId and shipModeId...
                wcService.invoke("OrderItemAddressShipMethodUpdate", params3);
            }

            ,
            failureHandler: function (serviceResponse) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        });

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("AjaxReplaceItem", params);
    },

    /**
     * customizeDynamicKit This function is used to call the configurator page for a dynamic kit.
     * @param {String} catEntryIdentifier A catalog entry ID of the item to add to the cart.
     * @param {int} quantity A quantity of the item to add to the cart.
     * @param {Object} customParams - Any additional parameters that needs to be passed to the configurator page.
     *
     **/
    customizeDynamicKit: function (catEntryIdentifier, quantity, customParams) {
        var params = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            catEntryId: catEntryIdentifier,
            quantity: quantity
        };

        if (!isPositiveInteger(quantity)) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
            return;
        }

        var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
        if (contractIdElements != null && contractIdElements != "undefined") {
            for (i = 0; i < contractIdElements.length; i++) {
                if (contractIdElements[i].checked) {
                    params.contractId = contractIdElements[i].value;
                    break;
                }
            }
        }

        //Pass any other customParams set by other add on features
        if (customParams != null && customParams != 'undefined') {
            for (i in customParams) {
                params[i] = customParams[i];
            }
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        var configureURL = "ConfigureView";
        var i = 0;
        for (param in params) {
            configureURL += ((i++ == 0) ? "?" : "&") + param + "=" + params[param];
        }
        document.location.href = getAbsoluteURL() + appendWcCommonRequestParameters(configureURL);
    }

}

wcTopic.subscribe("ProductInfo_Reset", shoppingActionsJS.resetProductAddedList);

$(document).ready(function () {
    var ie_version = Utils.get_IE_version();
    if (ie_version < 9) {
        $(document).on("click", ".compare_target > input[type=\"checkbox\"]:click", function (event) {
            this.blur();
            this.focus();
        });
    }
});

/*
Copyright © 2013 Adobe Systems Incorporated.
Licensed under the Apache License, Version 2.0 (the “License”);
you may not use this file except in compliance with the License.
You may obtain a copy of the License at
http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an “AS IS” BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

/**
 * See <a href="http://jquery.com">http://jquery.com</a>.
 * @name jquery
 * @class
 * See the jQuery Library  (<a href="http://jquery.com">http://jquery.com</a>) for full details.  This just
 * documents the function and classes that are added to jQuery by this plug-in.
 */

/**
 * See <a href="http://jquery.com">http://jquery.com</a>
 * @name fn
 * @class
 * See the jQuery Library  (<a href="http://jquery.com">http://jquery.com</a>) for full details.  This just
 * documents the function and classes that are added to jQuery by this plug-in.
 * @memberOf jquery
 */

/**
 * @fileOverview accessibleMegaMenu plugin
 *
 *<p>Licensed under the Apache License, Version 2.0 (the “License”)
 *<br />Copyright © 2013 Adobe Systems Incorporated.
 *<br />Project page <a href="https://github.com/adobe-accessibility/Accessible-Mega-Menu">https://github.com/adobe-accessibility/Accessible-Mega-Menu</a>
 * @version 0.1
 * @author Michael Jordan
 * @requires jquery
 */

/*jslint browser: true, devel: true, plusplus: true, nomen: true */
/*global jQuery, window, document */
(function ($, window, document) {
    "use strict";
    var pluginName = "accessibleMegaMenu",
        defaults = {
            uuidPrefix: "accessible-megamenu", // unique ID's are required to indicate aria-owns, aria-controls and aria-labelledby
            menuClass: "accessible-megamenu", // default css class used to define the megamenu styling
            topNavItemClass: "accessible-megamenu-top-nav-item", // default css class for a top-level navigation item in the megamenu
            panelClass: "accessible-megamenu-panel", // default css class for a megamenu panel
            panelGroupClass: "accessible-megamenu-panel-group", // default css class for a group of items within a megamenu panel
            hoverClass: "hover", // default css class for the hover state
            focusClass: "focus", // default css class for the focus state
            openClass: "open", // default css class for the open state,
            toggleButtonClass: "accessible-megamenu-toggle", // default css class responsive toggle button
            openDelay: 0, // default open delay when opening menu via mouseover
            closeDelay: 250, // default open delay when opening menu via mouseover
            openOnMouseover: false // default setting for whether menu should open on mouseover
        },
        Keyboard = {
            BACKSPACE: 8,
            COMMA: 188,
            DELETE: 46,
            DOWN: 40,
            END: 35,
            ENTER: 13,
            ESCAPE: 27,
            HOME: 36,
            LEFT: 37,
            PAGE_DOWN: 34,
            PAGE_UP: 33,
            PERIOD: 190,
            RIGHT: 39,
            SPACE: 32,
            TAB: 9,
            UP: 38,
            keyMap: {
                48: "0",
                49: "1",
                50: "2",
                51: "3",
                52: "4",
                53: "5",
                54: "6",
                55: "7",
                56: "8",
                57: "9",
                59: ";",
                65: "a",
                66: "b",
                67: "c",
                68: "d",
                69: "e",
                70: "f",
                71: "g",
                72: "h",
                73: "i",
                74: "j",
                75: "k",
                76: "l",
                77: "m",
                78: "n",
                79: "o",
                80: "p",
                81: "q",
                82: "r",
                83: "s",
                84: "t",
                85: "u",
                86: "v",
                87: "w",
                88: "x",
                89: "y",
                90: "z",
                96: "0",
                97: "1",
                98: "2",
                99: "3",
                100: "4",
                101: "5",
                102: "6",
                103: "7",
                104: "8",
                105: "9",
                190: "."
            }
        },
        clearTimeout = window.clearTimeout,
        setTimeout = window.setTimeout,
        isOpera = window.opera && window.opera.toString() === '[object Opera]';
    /**
     * @desc Creates a new accessible mega menu instance.
     * @param {jquery} element
     * @param {object} [options] Mega Menu options
     * @param {string} [options.uuidPrefix=accessible-megamenu] - Prefix for generated unique id attributes, which are required to indicate aria-owns, aria-controls and aria-labelledby
     * @param {string} [options.menuClass=accessible-megamenu] - CSS class used to define the megamenu styling
     * @param {string} [options.topNavItemClass=accessible-megamenu-top-nav-item] - CSS class for a top-level navigation item in the megamenu
     * @param {string} [options.panelClass=accessible-megamenu-panel] - CSS class for a megamenu panel
     * @param {string} [options.panelGroupClass=accessible-megamenu-panel-group] - CSS class for a group of items within a megamenu panel
     * @param {string} [options.hoverClass=hover] - CSS class for the hover state
     * @param {string} [options.focusClass=focus] - CSS class for the focus state
     * @param {string} [options.openClass=open] - CSS class for the open state
     * @constructor
     */
    function AccessibleMegaMenu(element, options) {
        this.element = element;

        // merge optional settings and defaults into settings
        this.settings = $.extend({}, defaults, options);

        this._defaults = defaults;
        this._name = pluginName;

        this.mouseTimeoutID = null;
        this.focusTimeoutID = null;
        this.mouseFocused = false;
        this.justFocused = false;

        this.init();
    }

    AccessibleMegaMenu.prototype = (function () {

        /* private attributes and methods ------------------------ */
        var uuid = 0,
            keydownTimeoutDuration = 1000,
            keydownSearchString = "",
            isTouch = 'ontouchstart' in window || window.navigator.msMaxTouchPoints,
            _getPlugin,
            _addUniqueId,
            _togglePanel,
            _clickHandler,
            _touchmoveHandler,
            _clickOutsideHandler,
            _DOMAttrModifiedHandler,
            _focusInHandler,
            _focusOutHandler,
            _keyDownHandler,
            _mouseDownHandler,
            _mouseOverHandler,
            _mouseOutHandler,
            _clickToggleHandler,
            _toggleExpandedEventHandlers,
            _addEventHandlers,
            _removeEventHandlers;

        /**
         * @name jQuery.fn.accessibleMegaMenu~_getPlugin
         * @desc Returns the parent accessibleMegaMenu instance for a given element
         * @param {jQuery} element
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _getPlugin = function (element) {
            return $(element).closest(':data(plugin_' + pluginName + ')').data("plugin_" + pluginName);
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_addUniqueId
         * @desc Adds a unique id and element.
         * The id string starts with the
         * string defined in settings.uuidPrefix.
         * @param {jQuery} element
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _addUniqueId = function (element) {
            element = $(element);
            var settings = this.settings;
            if (!element.attr("id")) {
                element.attr("id", settings.uuidPrefix + "-" + new Date().getTime() + "-" + (++uuid));
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_togglePanel
         * @desc Toggle the display of mega menu panels in response to an event.
         * The optional boolean value 'hide' forces all panels to hide.
         * @param {event} event
         * @param {Boolean} [hide] Hide all mega menu panels when true
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _togglePanel = function (event, hide) {
            var target = $(event.target),
                that = this,
                settings = this.settings,
                menu = this.menu,
                topli = target.closest('.' + settings.topNavItemClass),
                panel = target.hasClass(settings.panelClass) ? target : target.closest('.' + settings.panelClass),
                newfocus;

            _toggleExpandedEventHandlers.call(this, true);

            if (hide) {
                topli = menu.find('.' + settings.topNavItemClass + ' .' + settings.openClass + ':first').closest('.' + settings.topNavItemClass);
                if (!(topli.is(event.relatedTarget) || topli.has(event.relatedTarget).length > 0)) {
                    if ((event.type === 'mouseout' || event.type === 'focusout') && topli.has(document.activeElement).length > 0) {
                        return;
                    }
                    topli.find('[aria-expanded]')
                        .attr('aria-expanded', 'false')
                        .removeClass(settings.openClass)
                        .filter('.' + settings.panelClass)
                        .attr('aria-hidden', 'true');
                    if ((event.type === 'keydown' && event.keyCode === Keyboard.ESCAPE) || event.type === 'DOMAttrModified') {
                        newfocus = topli.find(':tabbable:first');
                        setTimeout(function () {
                            menu.find('[aria-expanded].' + that.settings.panelClass).off('DOMAttrModified.accessible-megamenu');
                            newfocus.focus();
                            that.justFocused = false;
                        }, 99);
                    }
                } else if (topli.length === 0) {
                    menu.find('[aria-expanded=true]')
                        .attr('aria-expanded', 'false')
                        .removeClass(settings.openClass)
                        .filter('.' + settings.panelClass)
                        .attr('aria-hidden', 'true');
                }
            } else {
                clearTimeout(that.focusTimeoutID);
                topli.siblings()
                    .find('[aria-expanded]')
                    .attr('aria-expanded', 'false')
                    .removeClass(settings.openClass)
                    .filter('.' + settings.panelClass)
                    .attr('aria-hidden', 'true');
                topli.find('[aria-expanded]')
                    .attr('aria-expanded', 'true')
                    .addClass(settings.openClass)
                    .filter('.' + settings.panelClass)
                    .attr('aria-hidden', 'false');

                var pageScrollPosition = $('html')[0].scrollTop;
                var openPanelTopPosition = $('.' + settings.panelClass + '.' + settings.openClass).parent().offset().top;

                if(pageScrollPosition > openPanelTopPosition) {
                    $('html')[0].scrollTop = openPanelTopPosition;
                }

                if (event.type === 'mouseover' && target.is(':tabbable') && topli.length === 1 && panel.length === 0 && menu.has(document.activeElement).length > 0) {
                    target.focus();
                    that.justFocused = false;
                }

                _toggleExpandedEventHandlers.call(that);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_clickHandler
         * @desc Handle click event on mega menu item
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _clickHandler = function (event) {
            var target = $(event.target).closest(':tabbable'),
                topli = target.closest('.' + this.settings.topNavItemClass),
                panel = target.closest('.' + this.settings.panelClass);
            if (topli.length === 1
                    && panel.length === 0
                    && topli.find('.' + this.settings.panelClass).length === 1) {
                if (!target.hasClass(this.settings.openClass)) {
                    event.preventDefault();
                    event.stopPropagation();
                    _togglePanel.call(this, event);
                    this.justFocused = false;
                } else {
                    if (this.justFocused) {
                        event.preventDefault();
                        event.stopPropagation();
                        this.justFocused = false;
                    } else if (isTouch || !isTouch && !this.settings.openOnMouseover) {
                        event.preventDefault();
                        event.stopPropagation();
                        _togglePanel.call(this, event, target.hasClass(this.settings.openClass));
                    }
                }
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_touchmoveHandler
         * @desc Handle touch move event on menu
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _touchmoveHandler = function () {
            this.justMoved = true;
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_clickOutsideHandler
         * @desc Handle click event outside of a the megamenu
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _clickOutsideHandler = function (event) {
            if ($(event.target).closest(this.menu).length === 0) {
                event.preventDefault();
                event.stopPropagation();
                _togglePanel.call(this, event, true);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_DOMAttrModifiedHandler
         * @desc Handle DOMAttrModified event on panel to respond to Windows 8 Narrator ExpandCollapse pattern
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _DOMAttrModifiedHandler = function (event) {
            if (event.originalEvent.attrName === 'aria-expanded'
                    && event.originalEvent.newValue === 'false'
                    && $(event.target).hasClass(this.settings.openClass)) {
                event.preventDefault();
                event.stopPropagation();
                _togglePanel.call(this, event, true);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_focusInHandler
         * @desc Handle focusin event on mega menu item.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _focusInHandler = function (event) {
            clearTimeout(this.focusTimeoutID);
            var target = $(event.target),
                panel = target.closest('.' + this.settings.panelClass);
            target
                .addClass(this.settings.focusClass);
            this.justFocused = !this.mouseFocused || (!this.settings.openOnMouseover && this.mouseFocused);
            this.mouseFocused = false;
            if (this.justFocused && this.panels.not(panel).filter('.' + this.settings.openClass).length) {
                _togglePanel.call(this, event);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_focusOutHandler
         * @desc Handle focusout event on mega menu item.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _focusOutHandler = function (event) {
            this.justFocused = false;
            var that = this,
                target = $(event.target),
                topli = target.closest('.' + this.settings.topNavItemClass);
            target
                .removeClass(this.settings.focusClass);

            if (window.cvox) {
                // If ChromeVox is running...
                that.focusTimeoutID = setTimeout(function () {
                    window.cvox.Api.getCurrentNode(function (node) {
                        if (topli.has(node).length) {
                            // and the current node being voiced is in
                            // the mega menu, clearTimeout,
                            // so the panel stays open.
                            clearTimeout(that.focusTimeoutID);
                        } else {
                            that.focusTimeoutID = setTimeout(function (scope, event, hide) {
                                _togglePanel.call(scope, event, hide);
                            }, 275, that, event, true);
                        }
                    });
                }, 25);
            } else {
                that.focusTimeoutID = setTimeout(function () {
                    if (that.mouseFocused && event.relatedTarget === null) {
                        return;
                    }
                    _togglePanel.call(that, event, true);
                }, 300);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_keyDownHandler
         * @desc Handle keydown event on mega menu.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _keyDownHandler = function (event) {
            var that = (this.constructor === AccessibleMegaMenu) ? this : _getPlugin(this), // determine the AccessibleMegaMenu plugin instance
                settings = that.settings,
                target = $($(this).is('.' + settings.hoverClass + ':tabbable') ? this : event.target), // if the element is hovered the target is this, otherwise, its the focused element
                menu = that.menu,
                topnavitems = that.topnavitems,
                topli = target.closest('.' + settings.topNavItemClass),
                tabbables = menu.find(':tabbable'),
                panel = target.hasClass(settings.panelClass) ? target : target.closest('.' + settings.panelClass),
                panelGroups = panel.find('.' + settings.panelGroupClass),
                currentPanelGroup = target.closest('.' + settings.panelGroupClass),
                next,
                keycode = event.keyCode || event.which,
                start,
                i,
                o,
                label,
                found = false,
                newString = Keyboard.keyMap[event.keyCode] || '',
                regex,
                isTopNavItem = (topli.length === 1 && panel.length === 0);

            if (target.is("input:focus, select:focus, textarea:focus, button:focus")) {
                // if the event target is a form element we should handle keydown normally
                return;
            }

            if (target.is('.' + settings.hoverClass + ':tabbable')) {
                $('html').off('keydown.accessible-megamenu');
            }

            switch (keycode) {
            case Keyboard.ESCAPE:
                this.mouseFocused = false;
                _togglePanel.call(that, event, true);
                break;
            case Keyboard.DOWN:
                event.preventDefault();
                this.mouseFocused = false;
                if (isTopNavItem) {
                    _togglePanel.call(that, event);
                    found = (topli.find('.' + settings.panelClass + ' :tabbable:first').focus().length === 1);
                } else {
                    found = (tabbables.filter(':gt(' + tabbables.index(target) + '):first').focus().length === 1);
                }

                if (!found && isOpera && (event.ctrlKey || event.metaKey)) {
                    tabbables = $(':tabbable');
                    i = tabbables.index(target);
                    found = ($(':tabbable:gt(' + $(':tabbable').index(target) + '):first').focus().length === 1);
                }
                break;
            case Keyboard.UP:
                event.preventDefault();
                this.mouseFocused = false;
                if (isTopNavItem && target.hasClass(settings.openClass)) {
                    _togglePanel.call(that, event, true);
                    next = topnavitems.filter(':lt(' + topnavitems.index(topli) + '):last');
                    if (next.children('.' + settings.panelClass).length) {
                        found = (next.find('[aria-expanded]')
                            .attr('aria-expanded', 'true')
                            .addClass(settings.openClass)
                            .filter('.' + settings.panelClass)
                            .attr('aria-hidden', 'false')
                            .find(':tabbable:last')
                            .focus() === 1);
                    }
                } else if (!isTopNavItem) {
                    found = (tabbables.filter(':lt(' + tabbables.index(target) + '):last').focus().length === 1);
                }

                if (!found && isOpera && (event.ctrlKey || event.metaKey)) {
                    tabbables = $(':tabbable');
                    i = tabbables.index(target);
                    found = ($(':tabbable:lt(' + $(':tabbable').index(target) + '):first').focus().length === 1);
                }
                break;
            case Keyboard.RIGHT:
                event.preventDefault();
                this.mouseFocused = false;
                if (isTopNavItem) {
                    found = (topnavitems.filter(':gt(' + topnavitems.index(topli) + '):first').find(':tabbable:first').focus().length === 1);
                } else {
                    if (panelGroups.length && currentPanelGroup.length) {
                        // if the current panel contains panel groups, and we are able to focus the first tabbable element of the next panel group
                        found = (panelGroups.filter(':gt(' + panelGroups.index(currentPanelGroup) + '):first').find(':tabbable:first').focus().length === 1);
                    }

                    if (!found) {
                        found = (topli.find(':tabbable:first').focus().length === 1);
                    }
                }
                break;
            case Keyboard.LEFT:
                event.preventDefault();
                this.mouseFocused = false;
                if (isTopNavItem) {
                    found = (topnavitems.filter(':lt(' + topnavitems.index(topli) + '):last').find(':tabbable:first').focus().length === 1);
                } else {
                    if (panelGroups.length && currentPanelGroup.length) {
                        // if the current panel contains panel groups, and we are able to focus the first tabbable element of the previous panel group
                        found = (panelGroups.filter(':lt(' + panelGroups.index(currentPanelGroup) + '):last').find(':tabbable:first').focus().length === 1);
                    }

                    if (!found) {
                        found = (topli.find(':tabbable:first').focus().length === 1);
                    }
                }
                break;
            case Keyboard.TAB:
                this.mouseFocused = false;
                i = tabbables.index(target);
                if (event.shiftKey && isTopNavItem && target.hasClass(settings.openClass)) {
                    _togglePanel.call(that, event, true);
                    next = topnavitems.filter(':lt(' + topnavitems.index(topli) + '):last');
                    if (next.children('.' + settings.panelClass).length) {
                        found = next.children()
                            .attr('aria-expanded', 'true')
                            .addClass(settings.openClass)
                            .filter('.' + settings.panelClass)
                            .attr('aria-hidden', 'false')
                            .find(':tabbable:last')
                            .focus();
                    }
                } else if (event.shiftKey && i > 0) {
                    found = (tabbables.filter(':lt(' + i + '):last').focus().length === 1);
                } else if (!event.shiftKey && i < tabbables.length - 1) {
                    found = (tabbables.filter(':gt(' + i + '):first').focus().length === 1);
                } else if (isOpera) {
                    tabbables = $(':tabbable');
                    i = tabbables.index(target);
                    if (event.shiftKey) {
                        found = ($(':tabbable:lt(' + $(':tabbable').index(target) + '):last').focus().length === 1);
                    } else {
                        found = ($(':tabbable:gt(' + $(':tabbable').index(target) + '):first').focus().length === 1);
                    }
                }

                if (found) {
                    event.preventDefault();
                }
                break;
            case Keyboard.SPACE:
            case Keyboard.ENTER:
                if (isTopNavItem) {
                    event.preventDefault();
                    _clickHandler.call(that, event);
                } else {
                    return true;
                }
                break;
            default:
                // alphanumeric filter
                clearTimeout(this.keydownTimeoutID);

                keydownSearchString += newString !== keydownSearchString ? newString : '';

                if (keydownSearchString.length === 0) {
                    return;
                }

                this.keydownTimeoutID = setTimeout(function () {
                    keydownSearchString = '';
                }, keydownTimeoutDuration);

                if (isTopNavItem && !target.hasClass(settings.openClass)) {
                    tabbables = tabbables.filter(':not(.' + settings.panelClass + ' :tabbable)');
                } else {
                    tabbables = topli.find(':tabbable');
                }

                if (event.shiftKey) {
                    tabbables = $(tabbables.get()
                        .reverse());
                }

                for (i = 0; i < tabbables.length; i++) {
                    o = tabbables.eq(i);
                    if (o.is(target)) {
                        start = (keydownSearchString.length === 1) ? i + 1 : i;
                        break;
                    }
                }

                regex = new RegExp('^' + keydownSearchString.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&'), 'i');

                for (i = start; i < tabbables.length; i++) {
                    o = tabbables.eq(i);
                    label = $.trim(o.text());
                    if (regex.test(label)) {
                        found = true;
                        o.focus();
                        break;
                    }
                }
                if (!found) {
                    for (i = 0; i < start; i++) {
                        o = tabbables.eq(i);
                        label = $.trim(o.text());
                        if (regex.test(label)) {
                            o.focus();
                            break;
                        }
                    }
                }
                break;
            }
            that.justFocused = false;
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_mouseDownHandler
         * @desc Handle mousedown event on mega menu.
         * @param {event} Event object
         * @memberof accessibleMegaMenu
         * @inner
         * @private
         */
        _mouseDownHandler = function (event) {
            if ($(event.target).closest(this.settings.panelClass) || $(event.target).closest(":focusable").length) {
                this.mouseFocused = true;
                if ($(event.target).closest(this.settings.menuClass)) {
                    $('html').on('keydown.accessible-megamenu', $.proxy(_keyDownHandler, event.target));
                }
            }
            clearTimeout(this.mouseTimeoutID);
            this.mouseTimeoutID = setTimeout(function () {
                clearTimeout(this.focusTimeoutID);
            }, 1);
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_mouseOverHandler
         * @desc Handle mouseover event on mega menu.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _mouseOverHandler = function (event) {
            clearTimeout(this.mouseTimeoutID);
            var that = this;

            if (!that.settings.openOnMouseover) {
                return;
            }

            this.mouseTimeoutID = setTimeout(function () {
                $(event.target).addClass(that.settings.hoverClass);
                _togglePanel.call(that, event);
                if ($(event.target).closest(that.settings.menuClass)) {
                    $('html').on('keydown.accessible-megamenu', $.proxy(_keyDownHandler, event.target));
                }
            }, this.settings.openDelay);
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_mouseOutHandler
         * @desc Handle mouseout event on mega menu.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _mouseOutHandler = function (event) {
            clearTimeout(this.mouseTimeoutID);
            var that = this;

            if (!that.settings.openOnMouseover) {
                return;
            }

            $(event.target)
                .removeClass(that.settings.hoverClass);

            that.mouseTimeoutID = setTimeout(function () {
                _togglePanel.call(that, event, true);
            }, this.settings.closeDelay);
            if ($(event.target).is(':tabbable')) {
                $('html').off('keydown.accessible-megamenu');
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_clickToggleHandler
         * @desc Handle click event on menu toggle button.
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _clickToggleHandler = function () {
            var isExpanded = this.toggleButton.attr('aria-expanded') === 'true';
            this.toggleButton.attr({'aria-expanded': !isExpanded, 'aria-pressed': !isExpanded});
        };

        _toggleExpandedEventHandlers = function (hide) {
            var menu = this.menu;
            if (hide) {
                $('html').off('mouseup.outside-accessible-megamenu, touchend.outside-accessible-megamenu, mspointerup.outside-accessible-megamenu,  pointerup.outside-accessible-megamenu');

                menu.find('[aria-expanded].' + this.settings.panelClass).off('DOMAttrModified.accessible-megamenu');
            } else {
                $('html').on('mouseup.outside-accessible-megamenu, touchend.outside-accessible-megamenu, mspointerup.outside-accessible-megamenu,  pointerup.outside-accessible-megamenu', $.proxy(_clickOutsideHandler, this));

                /* Narrator in Windows 8 automatically toggles the aria-expanded property on double tap or click.
                   To respond to the change to collapse the panel, we must add a listener for a DOMAttrModified event. */
                menu.find('[aria-expanded=true].' + this.settings.panelClass).on('DOMAttrModified.accessible-megamenu', $.proxy(_DOMAttrModifiedHandler, this));
            }
        };

        _addEventHandlers = function() {
            var menu = this.menu,
                toggleButton = this.toggleButton;
            menu.on("focusin.accessible-megamenu", ":focusable, ." + this.settings.panelClass, $.proxy(_focusInHandler, this))
                .on("focusout.accessible-megamenu", ":focusable, ." + this.settings.panelClass, $.proxy(_focusOutHandler, this))
                .on("keydown.accessible-megamenu", $.proxy(_keyDownHandler, this))
                .on("mouseover.accessible-megamenu", $.proxy(_mouseOverHandler, this))
                .on("mouseout.accessible-megamenu", $.proxy(_mouseOutHandler, this))
                .on("mousedown.accessible-megamenu", $.proxy(_mouseDownHandler, this))
                .on("click.accessible-megamenu", $.proxy(_clickHandler, this));

            toggleButton.on('click.accessible-megamenu', $.proxy(_clickToggleHandler, this));

            if (isTouch) {
                menu.on("touchmove.accessible-megamenu", $.proxy(_touchmoveHandler, this));
            }

            if ($(document.activeElement).closest(menu).length) {
              $(document.activeElement).trigger("focusin.accessible-megamenu");
            }
        };

        _removeEventHandlers = function () {
            var menu = this.menu,
                toggleButton = this.toggleButton;
            menu.off('.accessible-megamenu');
            if (menu.find('[aria-expanded=true].' + this.settings.panelClass).length) {
                _toggleExpandedEventHandlers.call(this, true);
            }

            toggleButton.off('.accessible-megamenu');
        };

        /* public attributes and methods ------------------------- */
        return {
            constructor: AccessibleMegaMenu,

            /**
             * @lends jQuery.fn.accessibleMegaMenu
             * @desc Initializes an instance of the accessibleMegaMenu plugins
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            init: function () {
                var settings = this.settings,
                    nav = $(this.element),
                    menu = nav.children('ol,ul').first(),
                    topnavitems = menu.children(),
                    toggleButton = nav.children('button').first();
                this.start(settings, nav, menu, topnavitems, toggleButton);
            },

            start: function(settings, nav, menu, topnavitems, toggleButton) {
                var that = this;
                this.settings = settings;
                this.menu = menu;
                this.topnavitems = topnavitems;
                this.toggleButton = toggleButton;

                nav.attr("role", "navigation");
                _addUniqueId.call(that, menu);
                menu.addClass(settings.menuClass);
                menu.addClass(['js', settings.menuClass].join('-'));
                topnavitems.each(function (i, topnavitem) {
                    var topnavitemlink, topnavitempanel;
                    topnavitem = $(topnavitem);
                    topnavitem.addClass(settings.topNavItemClass);
                    topnavitemlink = topnavitem.find(":tabbable:first");
                    topnavitempanel = topnavitem.children(":not(:tabbable):last");
                    _addUniqueId.call(that, topnavitemlink);
                    if (topnavitempanel.length) {
                        _addUniqueId.call(that, topnavitempanel);
                        topnavitemlink.attr({
                            "role": "button",
                            "aria-controls": topnavitempanel.attr("id"),
                            "aria-expanded": false,
                            "tabindex": 0
                        });

                        topnavitempanel.attr({
                            "role": "region",
                            "aria-expanded": false,
                            "aria-hidden": true
                        })
                            .addClass(settings.panelClass)
                            .not("[aria-labelledby]")
                            .attr("aria-labelledby", topnavitemlink.attr("id"));
                    }
                });

                this.panels = menu.find("." + settings.panelClass);

                menu.find("hr").attr("role", "separator");

                toggleButton.addClass(settings.toggleButtonClass);
                toggleButton.attr({'aria-expanded': false, 'aria-pressed': false, 'aria-controls': menu.attr('id')});

                _addEventHandlers.call(this);
            },

            /**
             * @desc Removes maga menu javascript behavior
             * @example $(selector).accessibleMegaMenu("destroy");
             * @return {object}
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            destroy: function () {
                this.menu.removeClass(['js', this.settings.menuClass].join('-'));
                _removeEventHandlers.call(this, true);
            },

            /**
             * @desc Get default values
             * @example $(selector).accessibleMegaMenu("getDefaults");
             * @return {object}
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            getDefaults: function () {
                return this._defaults;
            },

            /**
             * @desc Get any option set to plugin using its name (as string)
             * @example $(selector).accessibleMegaMenu("getOption", some_option);
             * @param {string} opt
             * @return {string}
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            getOption: function (opt) {
                return this.settings[opt];
            },

            /**
             * @desc Get all options
             * @example $(selector).accessibleMegaMenu("getAllOptions");
             * @return {object}
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            getAllOptions: function () {
                return this.settings;
            },

            /**
             * @desc Set option
             * @example $(selector).accessibleMegaMenu("setOption", "option_name",  "option_value",  reinitialize);
             * @param {string} opt - Option name
             * @param {string} val - Option value
             * @param {boolean} [reinitialize] - boolean to re-initialize the menu.
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            setOption: function (opt, value, reinitialize) {
                this.settings[opt] = value;
                if (reinitialize) {
                    this.init();
                }
            }
        };
    }());

    /* lightweight plugin wrapper around the constructor,
       to prevent against multiple instantiations */

    /**
     * @class accessibleMegaMenu
     * @memberOf jQuery.fn
     * @classdesc Implements an accessible mega menu as a jQuery plugin.
     * <p>The mega-menu It is modeled after the mega menu on {@link http://adobe.com|adobe.com} but has been simplified for use by others. A brief description of the interaction design choices can be found in a blog post at {@link http://blogs.adobe.com/accessibility/2013/05/adobe-com.html|Mega menu accessibility on adobe.com}.</p>
     * <h3>Keyboard Accessibility</h3>
     * <p>The accessible mega menu supports keyboard interaction modeled after the behavior described in the {@link http://www.w3.org/TR/wai-aria-practices/#menu|WAI-ARIA Menu or Menu bar (widget) design pattern}, however we also try to respect users' general expectations for the behavior of links in a global navigation. To this end, the accessible mega menu implementation permits tab focus on each of the six top-level menu items. When one of the menu items has focus, pressing the Enter key, Spacebar or Down arrow will open the submenu panel, and pressing the Left or Right arrow key will shift focus to the adjacent menu item. Links within the submenu panels are included in the tab order when the panel is open. They can also be navigated with the arrow keys or by typing the first character in the link name, which speeds up keyboard navigation considerably. Pressing the Escape key closes the submenu and restores focus to the parent menu item.</p>
     * <h3>Screen Reader Accessibility</h3>
     * <p>The accessible mega menu models its use of WAI-ARIA Roles, States, and Properties after those described in the {@link http://www.w3.org/TR/wai-aria-practices/#menu|WAI-ARIA Menu or Menu bar (widget) design pattern} with some notable exceptions, so that it behaves better with screen reader user expectations for global navigation. We don't use <code class="prettyprint prettyprinted" style=""><span class="pln">role</span><span class="pun">=</span><span class="str">"menu"</span></code> for the menu container and <code class="prettyprint prettyprinted" style=""><span class="pln">role</span><span class="pun">=</span><span class="str">"menuitem"</span></code> for each of the links therein, because if we do, assistive technology will no longer interpret the links as links, but instead, as menu items, and the links in our global navigation will no longer show up when a screen reader user executes a shortcut command to bring up a list of links in the page.</p>
     * @example <h4>HTML</h4><hr/>
&lt;nav&gt;
    &lt;ul class=&quot;nav-menu&quot;&gt;
        &lt;li class=&quot;nav-item&quot;&gt;
            &lt;a href=&quot;?movie&quot;&gt;Movies&lt;/a&gt;
            &lt;div class=&quot;sub-nav&quot;&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=0&quot;&gt;Action &amp;amp; Adventure&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=2&quot;&gt;Children &amp;amp; Family&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=7&quot;&gt;Dramas&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=9&quot;&gt;Foreign&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=14&quot;&gt;Musicals&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=15&quot;&gt;Romance&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
            &lt;/div&gt;
        &lt;/li&gt;
        &lt;li class=&quot;nav-item&quot;&gt;
            &lt;a href=&quot;?tv&quot;&gt;TV Shows&lt;/a&gt;
            &lt;div class=&quot;sub-nav&quot;&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=20&quot;&gt;Classic TV&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=21&quot;&gt;Crime TV&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=27&quot;&gt;Reality TV&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=30&quot;&gt;TV Action&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=33&quot;&gt;TV Dramas&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=34&quot;&gt;TV Horror&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
            &lt;/div&gt;
        &lt;/li&gt;
    &lt;/ul&gt;
&lt;/nav&gt;
     * @example <h4>CSS</h4><hr/>
&#47;* Rudimentary mega menu CSS for demonstration *&#47;
&#47;* mega menu list *&#47;
.nav-menu {
    display: block;
    position: relative;
    list-style: none;
    margin: 0;
    padding: 0;
    z-index: 15;
}
&#47;* a top level navigation item in the mega menu *&#47;
.nav-item {
    list-style: none;
    display: inline-block;
    padding: 0;
    margin: 0;
}
&#47;* first descendant link within a top level navigation item *&#47;
.nav-item &gt; a {
    position: relative;
    display: inline-block;
    padding: 0.5em 1em;
    margin: 0 0 -1px 0;
    border: 1px solid transparent;
}
&#47;* focus/open states of first descendant link within a top level
   navigation item *&#47;
.nav-item &gt; a:focus,
.nav-item &gt; a.open {
    border: 1px solid #dedede;
}
&#47;* open state of first descendant link within a top level
   navigation item *&#47;
.nav-item &gt; a.open {
    background-color: #fff;
    border-bottom: none;
    z-index: 1;
}
&#47;* sub-navigation panel *&#47;
.sub-nav {
    position: absolute;
    display: none;
    top: 2.2em;
    margin-top: -1px;
    padding: 0.5em 1em;
    border: 1px solid #dedede;
    background-color: #fff;
}
&#47;* sub-navigation panel open state *&#47;
.sub-nav.open {
    display: block;
}
&#47;* list of items within sub-navigation panel *&#47;
.sub-nav ul {
    display: inline-block;
    vertical-align: top;
    margin: 0 1em 0 0;
    padding: 0;
}
&#47;* list item within sub-navigation panel *&#47;
.sub-nav li {
    display: block;
    list-style-type: none;
    margin: 0;
    padding: 0;
}
     * @example <h4>JavaScript</h4><hr/>
&lt;!-- include jquery --&gt;
&lt;script src=&quot;http://code.jquery.com/jquery-1.10.1.min.js&quot;&gt;&lt;/script&gt;
&lt;!-- include the jquery-accessibleMegaMenu plugin script --&gt;
&lt;script src=&quot;js/jquery-accessibleMegaMenu.js&quot;&gt;&lt;/script&gt;
&lt;!-- initialize a selector as an accessibleMegaMenu --&gt;
&lt;script&gt;
    $(&quot;nav:first&quot;).accessibleMegaMenu({
        &#47;* prefix for generated unique id attributes, which are required to indicate aria-owns, aria-controls and aria-labelledby *&#47;
        uuidPrefix: &quot;accessible-megamenu&quot;,
        &#47;* css class used to define the megamenu styling *&#47;
        menuClass: &quot;nav-menu&quot;,
        &#47;* css class for a top-level navigation item in the megamenu *&#47;
        topNavItemClass: &quot;nav-item&quot;,
        &#47;* css class for a megamenu panel *&#47;
        panelClass: &quot;sub-nav&quot;,
        &#47;* css class for a group of items within a megamenu panel *&#47;
        panelGroupClass: &quot;sub-nav-group&quot;,
        &#47;* css class for the hover state *&#47;
        hoverClass: &quot;hover&quot;,
        &#47;* css class for the focus state *&#47;
        focusClass: &quot;focus&quot;,
        &#47;* css class for the open state *&#47;
        openClass: &quot;open&quot;
    });
&lt;/script&gt;
     * @param {object} [options] Mega Menu options
     * @param {string} [options.uuidPrefix=accessible-megamenu] - Prefix for generated unique id attributes, which are required to indicate aria-owns, aria-controls and aria-labelledby
     * @param {string} [options.menuClass=accessible-megamenu] - CSS class used to define the megamenu styling
     * @param {string} [options.topNavItemClass=accessible-megamenu-top-nav-item] - CSS class for a top-level navigation item in the megamenu
     * @param {string} [options.panelClass=accessible-megamenu-panel] - CSS class for a megamenu panel
     * @param {string} [options.panelGroupClass=accessible-megamenu-panel-group] - CSS class for a group of items within a megamenu panel
     * @param {string} [options.hoverClass=hover] - CSS class for the hover state
     * @param {string} [options.focusClass=focus] - CSS class for the focus state
     * @param {string} [options.openClass=open] - CSS class for the open state
     * @param {string} [options.openDelay=0] - Open delay when opening menu via mouseover
     * @param {string} [options.closeDelay=250] - Open delay when opening menu via mouseover
     * @param {boolean} [options.openOnMouseover=false] - Should menu open on mouseover
     */
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            var pluginInstance = $.data(this, "plugin_" + pluginName);
            if (!pluginInstance) {
                $.data(this, "plugin_" + pluginName, new $.fn[pluginName].AccessibleMegaMenu(this, options));
            } else if (typeof pluginInstance[options] === 'function') {
                pluginInstance[options].apply(pluginInstance, Array.prototype.slice.call(arguments, 1));
            }
        });
    };

    $.fn[pluginName].AccessibleMegaMenu = AccessibleMegaMenu;

    /* :focusable and :tabbable selectors from
       https://raw.github.com/jquery/jquery-ui/master/ui/jquery.ui.core.js */

    /**
     * @private
     */
    function visible(element) {
        return $.expr.filters.visible(element) && !$(element).parents().addBack().filter(function () {
            return $.css(this, "visibility") === "hidden";
        }).length;
    }

    /**
     * @private
     */
    function focusable(element, isTabIndexNotNaN) {
        var map, mapName, img,
            nodeName = element.nodeName.toLowerCase();
        if ("area" === nodeName) {
            map = element.parentNode;
            mapName = map.name;
            if (!element.href || !mapName || map.nodeName.toLowerCase() !== "map") {
                return false;
            }
            img = $("img[usemap=#" + mapName + "]")[0];
            return !!img && visible(img);
        }
        return (/input|select|textarea|button|object/.test(nodeName) ? !element.disabled :
                "a" === nodeName ?
                        element.href || isTabIndexNotNaN :
                        isTabIndexNotNaN) &&
                            // the element and all of its ancestors must be visible
                            visible(element);
    }

    $.extend($.expr[":"], {
        data: $.expr.createPseudo ? $.expr.createPseudo(function (dataName) {
            return function (elem) {
                return !!$.data(elem, dataName);
            };
        }) : // support: jQuery <1.8
                function (elem, i, match) {
                    return !!$.data(elem, match[3]);
                },

        focusable: function (element) {
            return focusable(element, !isNaN($.attr(element, "tabindex")));
        },

        tabbable: function (element) {
            var tabIndex = $.attr(element, "tabindex"),
                isTabIndexNaN = isNaN(tabIndex);
            return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
        }
    });
}(jQuery, window, document));
/*
 *  jQuery screen skeleton - scheletrone - v1.0.6
 *  A jQuery plugin to make a skeleton loading of your html elements.
 *
 *  GitHub: https://github.com/enbifa/jquery.skeleton.loader
 *  Copyright (c) 2017 - Vincenzo Bifano
 */


;(function ( $, window, document ) {
'use strict';

    var debugLog = false;
    var IdElement = "";
    var Name = 'scheletrone';
    var ReplaceText;
    var Words = [
        "lorem", "ipsum", "dolor", "sit", "amet,", "consectetur", "adipiscing", "elit", "ut", "aliquam,", "purus", "sit", "amet", "luctus", "venenatis,", "lectus", "magna", "fringilla", "urna,", "porttitor", "rhoncus", "dolor", "purus", "non", "enim", "praesent", "elementum", "facilisis", "leo,", "vel", "fringilla", "est", "ullamcorper", "eget", "nulla", "facilisi", "etiam", "dignissim", "diam", "quis", "enim", "lobortis", "scelerisque", "fermentum", "dui", "faucibus", "in", "ornare", "quam", "viverra", "orci", "sagittis", "eu", "volutpat", "odio", "facilisis", "mauris", "sit", "amet", "massa", "vitae", "tortor", "condimentum", "lacinia", "quis", "vel", "eros", "donec", "ac", "odio", "tempor", "orci", "dapibus", "ultrices", "in", "iaculis", "nunc", "sed", "augue", "lacus,", "viverra", "vitae", "congue", "eu,", "consequat", "ac", "felis", "donec", "et", "odio", "pellentesque", "diam", "volutpat", "commodo", "sed", "egestas", "egestas", "fringilla", "phasellus", "faucibus", "scelerisque", "eleifend", "donec", "pretium", "vulputate", "sapien", "nec", "sagittis", "aliquam", "malesuada", "bibendum", "arcu", "vitae", "elementum",
        "curabitur", "vitae", "nunc", "sed", "velit", "dignissim", "sodales", "ut", "eu", "sem", "integer", "vitae", "justo", "eget", "magna", "fermentum", "iaculis", "eu", "non", "diam", "phasellus", "vestibulum", "lorem", "sed", "risus", "ultricies", "tristique", "nulla", "aliquet", "enim", "tortor,", "at", "auctor", "urna", "nunc", "id", "cursus", "metus", "aliquam", "eleifend", "mi", "in", "nulla", "posuere", "sollicitudin", "aliquam", "ultrices", "sagittis", "orci,", "a", "scelerisque", "purus", "semper", "eget", "duis", "at", "tellus", "at", "urna", "condimentum", "mattis", "pellentesque", "id", "nibh", "tortor,", "id", "aliquet", "lectus", "proin", "nibh", "nisl,", "condimentum", "id", "venenatis", "a,", "condimentum", "vitae", "sapien", "pellentesque", "habitant", "morbi", "tristique", "senectus", "et", "netus", "et", "malesuada", "fames", "ac", "turpis", "egestas", "sed", "tempus,", "urna", "et", "pharetra", "pharetra,", "massa", "massa", "ultricies", "mi,", "quis", "hendrerit", "dolor", "magna", "eget", "est", "lorem", "ipsum", "dolor", "sit", "amet,", "consectetur", "adipiscing", "elit", "pellentesque", "habitant", "morbi", "tristique", "senectus", "et", "netus", "et", "malesuada", "fames", "ac", "turpis", "egestas", "integer", "eget", "aliquet", "nibh", "praesent", "tristique", "magna", "sit", "amet", "purus", "gravida", "quis", "blandit", "turpis", "cursus", "in", "hac", "habitasse", "platea", "dictumst", "quisque", "sagittis,", "purus", "sit", "amet", "volutpat", "consequat,", "mauris", "nunc", "congue", "nisi,", "vitae", "suscipit", "tellus", "mauris", "a", "diam",
        "maecenas", "sed", "enim", "ut", "sem", "viverra", "aliquet", "eget", "sit", "amet", "tellus", "cras", "adipiscing", "enim", "eu", "turpis", "egestas", "pretium", "aenean", "pharetra,", "magna", "ac", "placerat", "vestibulum,", "lectus", "mauris", "ultrices", "eros,", "in", "cursus", "turpis", "massa", "tincidunt", "dui", "ut", "ornare", "lectus", "sit", "amet", "est", "placerat", "in", "egestas", "erat", "imperdiet", "sed", "euismod", "nisi", "porta", "lorem", "mollis", "aliquam", "ut", "porttitor", "leo", "a", "diam", "sollicitudin", "tempor", "id", "eu", "nisl", "nunc", "mi", "ipsum,", "faucibus", "vitae", "aliquet", "nec,", "ullamcorper", "sit", "amet", "risus", "nullam", "eget", "felis", "eget", "nunc", "lobortis", "mattis", "aliquam", "faucibus", "purus", "in", "massa", "tempor", "nec", "feugiat", "nisl", "pretium", "fusce", "id", "velit", "ut", "tortor", "pretium", "viverra", "suspendisse", "potenti", "nullam", "ac", "tortor", "vitae", "purus", "faucibus", "ornare", "suspendisse", "sed", "nisi", "lacus,", "sed", "viverra", "tellus", "in", "hac", "habitasse", "platea", "dictumst", "vestibulum", "rhoncus", "est", "pellentesque", "elit", "ullamcorper", "dignissim", "cras", "tincidunt", "lobortis", "feugiat", "vivamus", "at", "augue", "eget", "arcu", "dictum", "varius", "duis", "at", "consectetur", "lorem",
        "donec", "massa", "sapien,", "faucibus", "et", "molestie", "ac,", "feugiat", "sed", "lectus", "vestibulum", "mattis", "ullamcorper", "velit", "sed", "ullamcorper", "morbi", "tincidunt", "ornare", "massa,", "eget", "egestas", "purus", "viverra", "accumsan", "in", "nisl", "nisi,", "scelerisque", "eu", "ultrices", "vitae,", "auctor", "eu", "augue", "ut", "lectus", "arcu,", "bibendum", "at", "varius", "vel,", "pharetra", "vel", "turpis", "nunc", "eget", "lorem", "dolor,", "sed", "viverra", "ipsum", "nunc", "aliquet", "bibendum", "enim,", "facilisis", "gravida", "neque", "convallis", "a", "cras", "semper", "auctor", "neque,", "vitae", "tempus", "quam", "pellentesque", "nec", "nam", "aliquam", "sem", "et", "tortor", "consequat", "id", "porta", "nibh", "venenatis", "cras", "sed", "felis", "eget", "velit", "aliquet", "sagittis", "id", "consectetur", "purus", "ut", "faucibus", "pulvinar", "elementum", "integer", "enim", "neque,", "volutpat", "ac", "tincidunt", "vitae,", "semper", "quis", "lectus", "nulla", "at", "volutpat", "diam", "ut", "venenatis", "tellus", "in", "metus", "vulputate", "eu", "scelerisque", "felis", "imperdiet", "proin", "fermentum", "leo", "vel", "orci", "porta", "non", "pulvinar", "neque", "laoreet", "suspendisse", "interdum", "consectetur", "libero,", "id", "faucibus", "nisl", "tincidunt", "eget", "nullam", "non", "nisi", "est,", "sit", "amet", "facilisis", "magna",
        "etiam", "tempor,", "orci", "eu", "lobortis", "elementum,", "nibh", "tellus", "molestie", "nunc,", "non", "blandit", "massa", "enim", "nec", "dui", "nunc", "mattis", "enim", "ut", "tellus", "elementum", "sagittis", "vitae", "et", "leo", "duis", "ut", "diam", "quam", "nulla", "porttitor", "massa", "id", "neque", "aliquam", "vestibulum", "morbi", "blandit", "cursus", "risus,", "at", "ultrices", "mi", "tempus", "imperdiet", "nulla", "malesuada", "pellentesque", "elit", "eget", "gravida", "cum", "sociis", "natoque", "penatibus", "et", "magnis", "dis", "parturient", "montes,", "nascetur", "ridiculus", "mus", "mauris", "vitae", "ultricies", "leo", "integer", "malesuada", "nunc", "vel", "risus", "commodo", "viverra", "maecenas", "accumsan,", "lacus", "vel", "facilisis", "volutpat,", "est", "velit", "egestas", "dui,", "id", "ornare", "arcu", "odio", "ut", "sem", "nulla", "pharetra", "diam", "sit", "amet", "nisl", "suscipit", "adipiscing", "bibendum", "est", "ultricies", "integer", "quis", "auctor", "elit",
        "sed", "vulputate", "mi", "sit", "amet", "mauris", "commodo", "quis", "imperdiet", "massa", "tincidunt", "nunc", "pulvinar", "sapien", "et", "ligula", "ullamcorper", "malesuada", "proin", "libero", "nunc,", "consequat", "interdum", "varius", "sit", "amet,", "mattis", "vulputate", "enim", "nulla", "aliquet", "porttitor", "lacus,", "luctus", "accumsan", "tortor", "posuere", "ac", "ut", "consequat", "semper", "viverra", "nam", "libero", "justo,", "laoreet", "sit", "amet", "cursus", "sit", "amet,", "dictum", "sit", "amet", "justo", "donec", "enim", "diam,", "vulputate", "ut", "pharetra", "sit", "amet,", "aliquam", "id", "diam", "maecenas", "ultricies", "mi", "eget", "mauris", "pharetra", "et", "ultrices", "neque", "ornare", "aenean", "euismod", "elementum", "nisi,", "quis", "eleifend", "quam", "adipiscing", "vitae", "proin", "sagittis,", "nisl", "rhoncus", "mattis", "rhoncus,", "urna", "neque", "viverra", "justo,", "nec", "ultrices", "dui", "sapien", "eget", "mi", "proin", "sed", "libero", "enim,", "sed", "faucibus", "turpis", "in", "eu", "mi", "bibendum", "neque", "egestas", "congue", "quisque", "egestas", "diam", "in", "arcu", "cursus", "euismod", "quis", "viverra", "nibh", "cras", "pulvinar", "mattis", "nunc,", "sed", "blandit", "libero", "volutpat", "sed", "cras", "ornare", "arcu", "dui", "vivamus", "arcu", "felis,", "bibendum", "ut", "tristique", "et,", "egestas", "quis", "ipsum", "suspendisse", "ultrices", "gravida", "dictum",
        "fusce", "ut", "placerat", "orci", "nulla", "pellentesque", "dignissim", "enim,", "sit", "amet", "venenatis", "urna", "cursus", "eget", "nunc", "scelerisque", "viverra", "mauris,", "in", "aliquam", "sem", "fringilla", "ut", "morbi", "tincidunt", "augue", "interdum", "velit", "euismod", "in", "pellentesque", "massa", "placerat", "duis", "ultricies", "lacus", "sed", "turpis", "tincidunt", "id", "aliquet", "risus", "feugiat", "in", "ante", "metus,", "dictum", "at", "tempor", "commodo,", "ullamcorper", "a", "lacus", "vestibulum", "sed", "arcu", "non", "odio", "euismod", "lacinia", "at", "quis", "risus", "sed", "vulputate", "odio", "ut", "enim", "blandit", "volutpat", "maecenas", "volutpat", "blandit", "aliquam", "etiam", "erat", "velit,", "scelerisque", "in", "dictum", "non,", "consectetur", "a", "erat", "nam", "at", "lectus", "urna", "duis", "convallis", "convallis", "tellus,", "id", "interdum", "velit", "laoreet", "id", "donec", "ultrices", "tincidunt", "arcu,", "non", "sodales", "neque", "sodales", "ut", "etiam", "sit", "amet", "nisl", "purus,", "in", "mollis", "nunc",
        "sed", "id", "semper", "risus", "in", "hendrerit", "gravida", "rutrum", "quisque", "non", "tellus", "orci,", "ac", "auctor", "augue", "mauris", "augue", "neque,", "gravida", "in", "fermentum", "et,", "sollicitudin", "ac", "orci", "phasellus", "egestas", "tellus", "rutrum", "tellus", "pellentesque", "eu", "tincidunt", "tortor", "aliquam", "nulla", "facilisi", "cras", "fermentum,", "odio", "eu", "feugiat", "pretium,", "nibh", "ipsum", "consequat", "nisl,", "vel", "pretium", "lectus", "quam", "id", "leo", "in", "vitae", "turpis", "massa", "sed", "elementum", "tempus", "egestas", "sed", "sed", "risus", "pretium", "quam", "vulputate", "dignissim", "suspendisse", "in", "est", "ante", "in", "nibh", "mauris,", "cursus", "mattis", "molestie", "a,", "iaculis", "at", "erat",
        "pellentesque", "adipiscing", "commodo", "elit,", "at", "imperdiet", "dui", "accumsan", "sit", "amet", "nulla", "facilisi", "morbi", "tempus", "iaculis", "urna,", "id", "volutpat", "lacus", "laoreet", "non", "curabitur", "gravida", "arcu", "ac", "tortor", "dignissim", "convallis", "aenean", "et", "tortor", "at", "risus", "viverra", "adipiscing", "at", "in", "tellus", "integer", "feugiat", "scelerisque", "varius", "morbi", "enim", "nunc,", "faucibus", "a", "pellentesque", "sit", "amet,", "porttitor", "eget", "dolor", "morbi", "non", "arcu", "risus,", "quis", "varius", "quam", "quisque", "id", "diam", "vel", "quam", "elementum", "pulvinar", "etiam", "non", "quam", "lacus", "suspendisse", "faucibus", "interdum", "posuere", "lorem", "ipsum", "dolor", "sit", "amet,", "consectetur", "adipiscing", "elit", "duis", "tristique", "sollicitudin", "nibh", "sit", "amet", "commodo", "nulla", "facilisi",
        "nullam", "vehicula", "ipsum", "a", "arcu", "cursus", "vitae", "congue", "mauris", "rhoncus", "aenean", "vel", "elit", "scelerisque", "mauris", "pellentesque", "pulvinar", "pellentesque", "habitant", "morbi", "tristique", "senectus", "et", "netus", "et", "malesuada", "fames", "ac", "turpis", "egestas", "maecenas", "pharetra", "convallis", "posuere", "morbi", "leo", "urna,", "molestie", "at", "elementum", "eu,", "facilisis", "sed", "odio", "morbi", "quis", "commodo", "odio", "aenean", "sed", "adipiscing", "diam", "donec", "adipiscing", "tristique", "risus", "nec", "feugiat", "in", "fermentum", "posuere", "urna", "nec", "tincidunt", "praesent", "semper", "feugiat", "nibh", "sed", "pulvinar", "proin", "gravida", "hendrerit", "lectus", "a", "molestie"
    ];
        
    var  dataPlugin = 'plugin_' + Name,

            // default options, used for instantion, if not explicitly set
            defaults = {
			url         : '',
            ajaxData    : {},
            debug        : {
                log: false,
                latency: 0
            },
            maskText: false,
            skelParentText: false,
            removeIframe: false,
            backgroundImage: true,
            replaceImageWith: '',
            selector: '',
            incache : false,
            onComplete     : function() {
                _logger('default onComplete() event');
            }
		};


    /**
     *  jQuery screen skeleton - scheletrone
     *
     *  @alias scheletrone
     *  @constructor
     *
     *  @author   Vincenzo Bifano
     *
     *  @requires jquery.js
     *
     *  @param   {Object}        [options]                 - a set of options, to override the defaults
     *  @param   {Function}      [options.onComplete]      - the event is triggered after plugin is complete
     *
     *  @example 
     // minimal setup
        var instance = $('#element').square();

     // customized setup
        var instance = $('#skeleton').skeleton({
                url   : "index2.html",
                debug		: {
                    latency: 3000
                },
                incache: false,
                onComplete	: function() { _logger('plugin complete!'); }
           });

     */



    var Scheletrone  = function(element, options) {
        
        IdElement = $(element).attr('id');

        // This is the plugin's constructor
        // It is instantiated for each matched DOM element
        // The huge comment block above is JSDoc syntax, for generated documentation
        // The name of the constructor is used ONLY internally
        // As a general best-practise, constructors should be Capitalized

        // store the element element
        this.element = $(element);

        // override default options
        // create a new object, with all default settings, overridden only by the init options
        this.options = $.extend( {}, defaults, options );
        debugLog = this.options.debug.log;

        //element to skeletrize
        this.element    = element;
	    this.$container = $( element );


        //this.init();
        this.init();



    };
    /////////////////////////////////////
    //         Private methods         //
    /////////////////////////////////////
    /**
     *  Make the skeleton of a passed element 
     *
     *  @param   {Object}  objToSkeletrize  the element
     */
    var _makeitSkeleton = function (objToSkeletrize) {

                objToSkeletrize.addClass("pending_el ");

    }
    /**
     *  Make a text log 
     *
     *  @param   {string}  message text to log
     */
    var _logger = function (message) {
             
             if (debugLog)
             {
               console.log(message);
             }
    }

    var _replaceBackgroundImage = function (replaceImageWith,element)
    {
        _logger("*** _replaceBackgroundImage ***");
        var bgimage_url = $( element ).css('background-image');
        
        // ^ Either "none" or url("...urlhere..")
        bgimage_url = /^url\((['"]?)(.*)\1\)$/.exec(bgimage_url);
        bgimage_url = bgimage_url ? bgimage_url[2] : ""; // If matched, retrieve url, otherwise ""
        
        var bg_url = $( element ).css('background');
      
        // ^ Either "none" or url("...urlhere..")
        bg_url = /^url\((['"]?)(.*)\1\)$/.exec(bg_url);
        bg_url = bg_url ? bg_url[2] : ""; // If matched, retrieve url, otherwise ""
            

        

  

        if ((bgimage_url != '') || (bg_url != '') ) {
          
            $( element ).replaceWith("<div class='pending_el "+replaceImageWith+"' style='width:"+$( element ).width()+"px;height:"+$( element ).height()+"px;'></div>")
        
        }
        _logger("*** End _replaceBackgroundImage ***");
    }

    var _getAllStyles = function (elem) {
        if (!elem) return []; // Element does not exist, empty list.
        var win = document.defaultView || window, style, styleNode = [];
        if (win.getComputedStyle) { /* Modern browsers */
            
            style = win.getComputedStyle(elem, '');
            for (var i=0; i<style.length; i++) {
                styleNode.push( style[i] + ':' + style.getPropertyValue(style[i]) );
                //               ^name ^           ^ value ^
            }
        } else if (elem.currentStyle) { /* IE */
            style = elem.currentStyle;
            for (var name in style) {
                styleNode.push( name + ':' + style[name] );
            }
        } else { /* Ancient browser..*/
            style = elem.style;
            for (var i=0; i<style.length; i++) {
                styleNode.push( style[i] + ':' + style[style[i]] );
            }
        }
        return styleNode;
    }



    /**
     *  Delete node without data attribute
     *
     *  @param   {Object}  objToSkeletrize  the element
     *  @return  {Object}
     */

    var _retrieveOnlyToCache = function(data)
    {
        _logger("_retrieveOnlyToCache");
        _logger(data);
        var div = document.createElement('div');
        div.innerHTML = data;
        $( div ).children().each(function( index ) {
             _logger('a');
             _logger($(this).data("scheletrone") );
            if ( $(this).data("scheletrone") ) 
            {

            }
            else
            {
                 $( this ).remove();
                //IE11 compatibility issue #2
                //A small Element.remove() polyfill for IE 
                //https://stackoverflow.com/questions/20428877/javascript-remove-doesnt-work-in-ie
                //
                if (!('remove' in Element.prototype)) {
                    Element.prototype['remove'] = function () {
                    if (this.parentNode) {
                        this.parentNode.removeChild(this);
                    }
                    };
                }
            }
         });
        
         _logger("*** Cache Data ***");
         _logger(div.innerHTML);
         return div.innerHTML;
    }

    /**
     *  For an integer randomly
     *
     *  @param   {integer}  min  minimum
     *  @param   {integer}  max  maximum
     *  @return  {integer}
     */
    var _randomInt = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    /**
     *  Count number of words in a text
     *
     *  @param   {string}  s  Text
     *  @return  {integer}
     */

    var _countWords =  function(s){
        s = s.replace(/(^\s*)|(\s*$)/gi,"");//exclude  start and end white-space
        s = s.replace(/[ ]{2,}/gi," ");//2 or more space to 1
        s = s.replace(/\n /,"\n"); // exclude newline with a start spacing
        return s.split(' ').length; 
    }


    /**
     *  Create text with Lore Ipsum words
     *
     *  @param   {integer}  count  number of words
     *  @param   {integer}  lenght  maximum lenght of the sentence
     *  @return  {string}
     */
    //text creator method with parameters: how many, what
    var _createText = function(count, length) {
        
          var wordIndex = _randomInt(0, Words.length - count - 1);
          var newWord = Words.slice(wordIndex, wordIndex + count).join(' ').replace(/[\.\,]/g,'');

         while (length - newWord.length > 0){
            newWord = _addWord(newWord  );
        }
        return newWord;
    
          
        
    }

    var _addWord = function(string) {
          
          var wordIndex = _randomInt(0, Words.length - 1);
          return string + " " +  Words[wordIndex];
    }



    ////////////////////////////////////
    //         Public methods         //
    ////////////////////////////////////
    Scheletrone.prototype = {

        /**
         *  Initializes the scheletrone.
         *  This is automatically called when the plugin is called.
         *
         *  @private
         */
        init: function () {
            var _this  = this.element;
            var __this = this;


            _logger(this);
            // iterate all children in element to make a skeleton
            
            if(this.options.removeIframe)
                jQuery('html').find('iframe').remove();


            if (this.options.incache)
            {
                _logger(this.getCache());
                 
                    this.element.innerHTML = this.getCache();
                   
            }

            

            $( _this ).find('*').each(function( index ) {
              
               

                $( this )
                .contents()
                    .filter(function() {
                        
                        return this.nodeType === 3;
                    })
                    .each(function(  ) {
                       if(typeof this.nodeValue != 'undefined'){ 
                        if(this.nodeValue.trim() != '')
                        {
                            _logger(this,"-- " + this.nodeValue.trim() + '--');

                            if (__this.options.maskText)
                            {
                                var numberOfWords = _countWords(this.nodeValue.trim());
                                var newText = _createText(numberOfWords,this.nodeValue.trim().length);
                                
                                this.nodeValue = newText;
                            }
                            if (__this.options.skelParentText)
                            {
                               var color = $( this ).parent().css( {"background-color" : "#ccc"} );
                             _logger(this,color);
                            }
                            return this
                        }
                       }
                        else
                        {
                            this.remove();
                              //IE11 compatibility issue #2
                            //A small Element.remove() polyfill for IE 
                            //https://stackoverflow.com/questions/20428877/javascript-remove-doesnt-work-in-ie
                            //
                            if (!('remove' in Element.prototype)) {
                                Element.prototype['remove'] = function () {
                                if (this.parentNode) {
                                    this.parentNode.removeChild(this);
                                }
                                };
                            }
                        }
                            
                    })
                    .wrap( "<div class='nodeType3' ></div>" )
                    .end()
                   
            });

             $( _this ).find('*').each(function( index ) {
                    var skeletizza = true;
                    //search for children
 
                    if (!__this.options.backgroundImage)
                         _replaceBackgroundImage(__this.options.replaceImageWith,this);

                    $( this ).css('color', '#ccc');

                    
                    
                    if($( this ).children().length == 0)
                    {
                                
                                if($( this ).is("BR"))
                                {
                                    skeletizza = false;
                                }

                                if($( this ).is("IMG"))
                                {
                                   
                                    var width = this.width;
                                    var height = this.height;
                                    var tempThis = this;
                                    var replaced = "<div class='pending_el " + __this.options.replaceImageWith + " ' style='width:"+width+"px;height:"+height+"px;)'></div>"
                                    $( this ).replaceWith(replaced);
                          
                                   
                                 
                                    skeletizza = false;
                                }

                                if (skeletizza)
                                {
                                    
                                    _makeitSkeleton($( this ));
                                
                                }
                    }
             });

            
            
     



            if (this.options.url != '')
            {
                _logger('prova');
                this.retrieveData();
            }
            // trigger onComplete callback
            if (this.options.onComplete && typeof(this.options.onComplete) == "function")
                this.options.onComplete();
        },
        retrieveData: function () {
        var obj = this;
 
       
                if (this.options.debug.latency > 0)
                {
                    
                setTimeout(function(){
                 
                            $.ajax({
                                url: obj.options.url,
                                dataType: "html",
                                data: obj.options.ajaxData,
                                success: function(data) {
                                    
                                    _logger(obj.options.debug.log,"obj.element " + obj.element);
                                   
                                      
                                        if (obj.options.selector != '')
                                        {
                                            var parsedResponse = $.parseHTML(data);
                                      
                                            var result = $(parsedResponse).filter(obj.options.selector);
                                            _logger("*** Selector *** ");
                                            _logger(obj.options.selector);
                                            _logger(result.html());
                                            _logger("*** End Selector *** ");
                                            $( obj.element ).html('').append((result));
                                        }
                                        else
                                        {
                                            $( obj.element ).html('').append((data));
                                        }



                                        if (obj.options.incache)
                                        {
                                            _logger(obj.options.debug.log,'setcache');
                                            var cacheData = _retrieveOnlyToCache(data);
                                            obj.setCache(cacheData);
                                        }
                                }
                            });
                    }, obj.options.debug.latency);
                }
                else{
                    
                    $.ajax({
                                url: obj.options.url,
                                dataType: "html",
                                data: obj.options.ajaxData,
                                success: function(data) {
                                    
                                    _logger(obj.options.debug.log,obj);
                                  
                                    if (obj.options.selector != '')
                                    {
                                        //Populate with only a specific content Issue #4
                                        var parsedResponse = $.parseHTML(data);
                                        var result = $(parsedResponse).filter(obj.options.selector);
                                        _logger("*** Selector *** ");
                                        _logger(obj.options.selector);
                                        _logger(result.html());
                                        _logger("*** End Selector *** ");
                                        $( obj.element ).html('').append((result));
                                    }
                                    else
                                    {
                                        $( obj.element ).html('').append((data));
                                    }


                                }
                            });
                }

        },
        /**
         *  Stop loading on div - pass it on construction
         *
         * @example this.stopLoader();
         */
        stopLoader: function () {
            var obj = this;
            $(obj.element).html('');
            
        },
        /**
         *  Store the asynchronus data in localstorage
         *
         *  @example this.setCache(data);
         */
        setCache : function ( result_data ) {
            // Cache data
           
            if ( window.localStorage ) {
                var url = window.location.pathname;
                var filename = url.substring(url.lastIndexOf('/')+1);


                window.localStorage.setItem( filename + "-" + "div-"+IdElement+"-skeleton:" ,  result_data  );
            }
        },
        /**
         *  Retrieve stored scheletrone in localstorage
         *
         *  @example this.getCache();
         */
        getCache : function() {

            if ( window.localStorage ) {
                var url = window.location.pathname;
                var filename = url.substring(url.lastIndexOf('/')+1);
                return window.localStorage.getItem( filename + "-" + "div-"+IdElement+"-skeleton:" );
            }
            else {
                return false;
            }
        },
        
    };



  
    







   //////////////////////////////////////////////////
    //         Plugin wrapper                       //
    //////////////////////////////////////////////////


    // A plugin wrapper around the constructor, preventing against multiple instantiations
    $.fn[Name] = function ( options ) {
        var instance;

        // If the first parameter is an object (options), or was omitted,
        // call Plugin.init()
        if ( typeof options === 'undefined' || typeof options === 'object' ) {
            return this.each(function () {
                // prevent multiple instantiations
                if ( !$.data(this, dataPlugin )) {
                    $.data(
                        this, 
                        dataPlugin, 
                        new Scheletrone( this, options )
                    );
                }

                instance = $(this).data( dataPlugin );

                if ( typeof instance['init'] === 'function' ) {
                    instance.init();
                }
            });

        // checks that the requested public method exists
        } else if ( typeof options === 'string' ) {
            var methodName = arguments[0],
                args = Array.prototype.slice.call(arguments, 1),
                returnVal;

            this.each(function() {
                var instance = $(this).data( dataPlugin );

                // Check that the element has a plugin instance, and that
                // the requested public method exists.
                if ( $.data(this, dataPlugin) && typeof $.data(this, dataPlugin)[methodName] === 'function' ) {
                    // Call the method of the Plugin instance, and Pass it
                    // the supplied arguments.
                    returnVal = $.data(this, dataPlugin)[methodName].apply(instance, args);
                } else {
                    console.info('Method ' + options + ' does not exist on jQuery.' + Name);
                }
            });

            if ( typeof returnVal !== 'undefined' ){
                // If the method returned a value, return the value
                return returnVal;
            } else {
                // Otherwise, returning 'this' preserves chainability
                return this;
            }
        } else {
            console.info('Method ' + options + ' does not exist on jQuery.' + Name);
        }
    };
})( jQuery, window, document );
/********************************************************************
*-------------------------------------------------------------------
* Licensed Materials - Property of IBM
*
* WebSphere Commerce
*
* (c) Copyright IBM Corp. 2000
*
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*
*-------------------------------------------------------------------*/

/** XBUtil **********************************************************
*
* Cross Browser API
*
*********************************************************************/

// Global browser flags
// isIE (Internet Explorer 5.5+)
// isNS (Netscape 6+)
// isDHTML (DHTML cross-browser support)
var isIE = (document.all) ? true : false;
var isNS = (document.getElementById && !isIE) ? true : false;
var isDHTML = (isIE || isNS) ? true : false;

/**********************************************************
* XBElement Class
*
* Read-Only Attributes:
* element       : The original DOM element.
* id            : ID of the element.
* type          : "XBElement"
* tagName       : Tag name of this element.
* class         : Currrent class applies to it. 
* style         : The style object of the DOM element.
* left          : The left position obtained from style.
* top           : The top position obtained from style.
* pageX         : Horizontal coordinate relative to the page.
* pageY         : Vertical coordinate relative to the page.
* offsetLeft    : Position relative to the left of the parent element.
* offsetTop     : Position relative to the top of the parent element.
* offsetWidth   : Width relative to the parent element.
* offsetHeight  : Height relative to the parent element.
* offsetParent  : A reference to the object in which the current element is offset.
*
* Methods:
* getAttribute          : Retrieves an attribute of the DOM element.
* setAttribute          : Sets an attribute value to the DOM element.
* getParentElement      : Returns the parent element in XBElement type.
* getFirstChild         : Returns the first child element in XBElement type.
* getLastChild          : Returns the last child element in XBElement type.
* getPreviousSibling    : Returns the previous sibling element in XBElement type.
* getNextSibling        : Returns the next sibling element in XBElement type.
* getChildElements      : Returns an array of children elemtns in XBElement types.
* getStyleClass         : Returns the current style class name.
* setStyleClass         : Sets the style class name.
* getStylePropertyValue : Returns a style property value.
* setStylePropertyValue : Sets a style property value.
* getInnerHTML          : Returns the innerHTML of the element.
* setInnerHTML          : Sets the innerHTML of the element.
* addEventListener      : Attaches an event to the element.
* removeEventListener   : Detaches an event to the element.
**********************************************************/
function XBElement(obj) {
	if (typeof(obj) == "string")
		obj = document.getElementById(obj);

	if (obj == document)
		return;

	this.element = obj;
	this.id = obj.id;
	this.type = "XBElement";
	this.tagName = obj.tagName;
	this.className = obj.className;
	this.style = obj.style;
	this.left = getObjStylePropertyValue(obj, "left");	
	this.top = getObjStylePropertyValue(obj, "top");
	this.pageX = getObjPageX(obj);
	this.pageY = getObjPageY(obj);
	this.offsetLeft = obj.offsetLeft;
	this.offsetTop = obj.offsetTop;
	this.offsetWidth = obj.offsetWidth;
	this.offsetHeight = obj.offsetHeight;
	this.offsetParent = obj.offsetParent;
	this.setAttribute = function(attr, val) { eval("this." + attr + " = val"); }
	this.getAttribute = function(attr) { return eval("this." + attr); }
	this.getParentElement = function() { return (obj.parentNode != null)?(new XBElement(obj.parentNode)):(null); }
	this.getFirstChild = function() { return (obj.firstChild != null)?(new XBElement(obj.firstChild)):(null); }
	this.getLastChild = function() { return (obj.lastChild != null)?(new XBElement(obj.lastChild)):(null); }
	this.getPreviousSibling = function() { return (obj.previousSibling != null)?(new XBElement(obj.previousSibling)):(null); }
	this.getNextSibling = function() { return (obj.nextSibling != null)?(new XBElement(obj.nextSibling)):(null); }
	this.getChildElements = function() {
		var childrenElements = new Array();

		for (var i = 0; i < obj.childNodes.length; i++) {
			childrenElements[i] = new XBElement(obj.childNodes[i]);
		}

		return childrenElements;
	}
	this.getStyleClass = function() { return obj.className; }
	this.setStyleClass = function(newClass) { obj.className = newClass; }
	this.getStylePropertyValue = function(property) {
		return getObjStylePropertyValue(this.element, property);
	}
	this.setStylePropertyValue = function(property, value) {
		setObjStylePropertyValue(this.element, property, value);
	}
	this.getInnerHTML = function() { return obj.innerHTML; }
	this.setInnerHTML = function(html) { obj.innerHTML = html; }
	this.addEventListener = function(eventType, eventListener) {
		addObjEventListener(this.element, eventType, eventListener);
	}
	this.removeEventListener = function(eventType, eventListener) {
		removeObjEventListener(this.element, eventType, eventListener);
	}
}

/**********************************************************
* XBEvent Class
*
* Read-Only Attributes:
* event         : The original event object.
* type          : The event type.
* target        : A reference to the target object to which the event was originally dispatched.
* currentTarget : A reference to the currently registered target element.
* relatedTarget : A reference to indentify a secondary target element.
* eventPhase    : Indicates the current event phase.
* bubbles       : Boolean value to indicate if the event is bubbling.
* cancelable    : Boolean value to indicate if the default action can be prevented.
* timeStamp     : Timstamp at which the event was created.
* screenX       : Horizontal coordinate relative to the screen.
* screenY       : Vertical coordinate relative to the screen.
* clientX       : Horizontal coordinate relative to the client/browser visible area.
* clientY       : Vertical coordinate relative to the client/browser visible area.
* pageX         : Horizontal coordinate relative to the page.
* pageY         : Vertical coordinate relative to the page.
* ctrlKey       : Boolean value to indicate if <ctrl> key was pressed.
* shiftKey      : Boolean value to indicate if <shift> key was pressed.
* altKey        : Boolean value to indicate if <alt> key was pressed.
* metaKey       : Boolean value to indicate if meta key was pressed.
* keyCode       : A numeric value to represent the key tha was pressed.
*
* Methods:
* button          : Indicates which mouse button was pressed during the event.
* stopPropagation : Stops the event from propagating along the DOM.
* preventDefault  : Cancels the default action of the event, only if it is cancelable.
**********************************************************/
function XBEvent(e) {
	this.AT_TARGET = 1;
	this.BUBBLING_PHASE = 2;
	this.CAPTURING_PHASE = 3;
	this.LEFT = 0;
	this.MIDDLE = 1;
	this.RIGHT = 2;
	this.event = e;

	// DOM2 InterfaceEvent
	this.type = (isIE)?(e.type):(e.type);
	this.target = XBEvent_getTarget(e);
	this.currentTarget = XBEvent_getCurrentTarget(e);
	this.eventPhase = (isIE)?(0):(e.eventPhase);
	this.bubbles = (isIE)?(e.cancelBubble):(e.bubbles);
	this.cancelable = (isIE)?((e.returnValue)?(e.returnValue):(false)):(e.cancelable);
	this.timeStamp = (isIE)?(new Date().getTime()):(e.timeStamp);
	this.stopPropagation = function() {
		if (isIE)
			e.cancelBubble = true;
		else
			e.stopPropagation();
	}
	this.preventCapture = function() {
		if (isIE)
			e.returnValue = false;
		else
			e.preventCapture();
	}
	this.preventDefault = function() {
		if (this.cancelable) {
			if (isIE)
				e.returnValue = false;
			else
				e.preventDefault();
		}
	}

	// DOM2 MouseEvent
	this.screenX = e.screenX;
	this.screenY = e.screenY;
	this.clientX = e.clientX;
	this.clientY = e.clientY;
	this.pageX = e.clientX + getPageXOffset();
	this.pageY = e.clientY + getPageYOffset();
	this.ctrlKey = e.ctrlKey;
	this.shiftKey = e.shiftKey;
 	this.altKey = e.altKey;
 	this.metaKey = (isIE)?(0):(e.metaKey);
 	if (this.type.indexOf("mouse") != -1) {
 		this.button = function() {
 			if (isIE) {
 				switch(e.button) {
 					case 1:
 						return this.LEFT;
 					case 2:
 						return this.RIGHT;
 					case 4:
 						return this.MIDDLE;
 					default:
 						return -1;
 				}
 			}
 			else {
				return e.button;
 			}
 		}
 	}
 	else if (this.type.indexOf("click") != -1) {
 		this.button = function() { return this.LEFT; }
 	}
 	this.relatedTarget = XBEvent_getRelatedTarget(e);

 	// IE Specific AddOn
 	this.keyCode = (isIE)?(parseInt(e.keyCode)):(parseInt(e.which));
}

function XBEvent_getTarget(e) {
	var result = null;

	if (isIE) {
		result = e.srcElement;
	}
	else {
		var node = e.target;
		if (node) {
		    while (node.nodeType != 1)
		        node = node.parentNode;
		    result = node;
	    }
	}

	if (result != null)
		return result;
	else
		return null;
}

function XBEvent_getCurrentTarget(e) {
	var result = null;

	if (isIE) {
		if (e.type.indexOf("mouseover") != -1)
			result = e.toElement;
		else if (e.type.indexOf("mouseout") != -1)
			result = e.fromElement;
	}
	else {
		result = e.currentTarget;
	}

	if (result != null)
		return result;
	else
		return null;

}

function XBEvent_getRelatedTarget(e) {
	var result = null;

	if (isIE) {
		if (e.type.indexOf("mouseover") != -1)
			result = e.fromElement;
		else if (e.type.indexOf("mouseout") != -1)
			result = e.toElement;
	}
	else {
		result = e.relatedTarget;
	}

	if (result != null)
		return result;
	else
		return null;
}

/**********************************************************
* Event Utils
**********************************************************/

function addObjEventListener(obj, eventType, eventListener) {
	// Disable event capturing, since IE doesn't support event capture
	var useCapture = false;
	var eventStart = "obj.on" + eventType.toLowerCase() + " = eventListener";

	if (obj.addEventListener) {
		obj.addEventListener(eventType, eventListener, useCapture);
	}
	else if (obj.attachEvent) {
		obj.attachEvent("on" + eventType, eventListener);
	}
	else {
		eval(eventStart);
	}
}

function removeObjEventListener(obj, eventType, eventListener) {
	// Disable event capturing, since IE doesn't support event capture
	var useCapture = false;
	var eventStop = "obj.on" + eventType.toLowerCase() + " = null";

	if (obj.removeEventListener) {
		obj.removeEventListener(eventType, eventListener, useCapture);
	}
	else if (obj.detachEvent) {
		obj.detachEvent(eventType, eventListener);
  	}
	else {
		eval(eventStop);
	}
}

/**********************************************************
* CSS Style Utils
**********************************************************/

///////////////////////////////////////////////////////////
// Given a DOM element and one of its style properties,
// returns the current style property value.
///////////////////////////////////////////////////////////
function getObjStylePropertyValue(obj, property) {
	var result = null;

	if (obj != null && obj != document) {
		if (isIE) {
			property = toJSPropertyName(property);
			result = obj.currentStyle.getAttribute(property);
		}
		else if (isNS) {
			if (obj.nodeName.indexOf("text") == -1) {
				result = obj.ownerDocument.defaultView.getComputedStyle(obj, "").getPropertyValue(property);
			}
		}
	}

	return result;
}

///////////////////////////////////////////////////////////
// Sets a style property value to a given DOM element.
///////////////////////////////////////////////////////////
function setObjStylePropertyValue(obj, property, value) {
	property = toJSPropertyName(property);
	eval("obj.style." + property + " = value");
}

///////////////////////////////////////////////////////////
// Returns the horizontal position of a given DOM element 
// relative to the page.
///////////////////////////////////////////////////////////
function getObjPageX(obj) {
	var num = 0;

	if (obj != document) {
		for (var p = obj; p && p.tagName != "BODY"; p = p.offsetParent)
			num += p.offsetLeft;
	}

	return num;
}

///////////////////////////////////////////////////////////
// Returns the vertical position of a given DOM element 
// relative to the page.
///////////////////////////////////////////////////////////
function getObjPageY(obj) {
	var num = 0;

	if (obj != document) {
		for (var p = obj; p && p.tagName != "BODY"; p = p.offsetParent)
			num += p.offsetTop;
	}
	return num;
}

///////////////////////////////////////////////////////////
// Returns the client/browser visible width in pixels.
///////////////////////////////////////////////////////////
function getClientWidth(winRef) {
	if (arguments.length == 0)
		winRef = window;

	var doc = winRef.document;
	var width = 0;

	if (isIE)
		width = doc.documentElement.clientWidth;
	else if (isNS)
		width = winRef.innerWidth;

	return width;
}

///////////////////////////////////////////////////////////
// Returns the client/browser visible height in pixels.
///////////////////////////////////////////////////////////
function getClientHeight(winRef) {
	if (arguments.length == 0)
		winRef = window;

	var doc = winRef.document;
	var height = 0;

	if (isIE)
		height = doc.documentElement.clientHeight;
	else if (isNS)
		height = winRef.innerHeight;

	return height;
}

///////////////////////////////////////////////////////////
// Returns the page width in pixels.
///////////////////////////////////////////////////////////
function getPageWidth(winRef) {
	if (arguments.length == 0)
		winRef = window;

	var doc = winRef.document;
	var width = 0;

	if (isIE)
		width = doc.body.scrollWidth;
	else if (isNS)
		width = doc.width;

	return width;
}

///////////////////////////////////////////////////////////
// Returns the page height in pixels.
///////////////////////////////////////////////////////////
function getPageHeight(winRef) {
	if (arguments.length == 0)
		winRef = window;

	var doc = winRef.document;
	var height = 0;

	if (isIE)
		height = doc.body.scrollHeight;
	else if (isNS)
		height = doc.height;

	return height;
}

///////////////////////////////////////////////////////////
// Returns the amount of content that has been hidden 
// by scrolling to the right.
///////////////////////////////////////////////////////////
function getPageXOffset(winRef) {
	if (arguments.length == 0)
		winRef = window;

	var doc = winRef.document;
	var offset = 0;

	if (isIE)
		offset = doc.documentElement.scrollLeft;
	else if (isNS)
		offset = winRef.pageXOffset;

	return offset;
}

///////////////////////////////////////////////////////////
// Returns the amount of content that has been hidden 
// by scrolling down.
///////////////////////////////////////////////////////////
function getPageYOffset(winRef) {
	if (arguments.length == 0)
		winRef = window;

	var doc = winRef.document;
	var offset = 0;

	if (isIE)
		offset = doc.documentElement.scrollTop;
	else if (isNS)
		offset = winRef.pageYOffset;

	return offset;
}

///////////////////////////////////////////////////////////
// Converts a style property in CSS format to JavaScript
// format. (e.g. background-color  --> backgroundColor)
///////////////////////////////////////////////////////////
function toJSPropertyName(property) {
	while (property.lastIndexOf("-") != -1) {
		var dashPos = property.lastIndexOf("-");
		var upChar = property.charAt(dashPos + 1).toUpperCase();
		property = property.substring(0, dashPos) + upChar + property.substring(dashPos + 2);
	}
	return property;
}

/**********************************************************
* IFrame Utils
**********************************************************/

///////////////////////////////////////////////////////////
// Returns the window reference of an IFRAME by its ID.
// IE handles the content in an IFRAME in a special 
// attribute called "contentWindow".
///////////////////////////////////////////////////////////
function getIFrameById(iframeID, winRef) {
	if (arguments.length == 1)
		winRef = window;

	var doc = winRef.document;	
	var iframeElement = doc.getElementById(iframeID);

	if (iframeElement != null && iframeElement.contentWindow)
		return iframeElement.contentWindow;
	else
		return iframeElement;
}

///////////////////////////////////////////////////////////
// Returns the document reference of an IFRAME by its ID.
// IE handles the document in an IFRAME in a special 
// attribute called "contentDocument".
///////////////////////////////////////////////////////////
function getIFrameDocumentById(iframeID, winRef) {
	if (arguments.length == 1)
		winRef = window;
	
	var iframeDoc = null;
	var iframeObj = getIFrameById(iframeID, winRef);

	if (iframeObj != null && iframeObj.contentDocument) {
		iframeDoc = iframeObj.contentDocument;
	}
	else if (iframeObj != null && iframeObj.document) {
		iframeDoc = iframeObj.document;
	}

	return iframeDoc;
}

/**********************************************************
* Debug Utils
**********************************************************/

///////////////////////////////////////////////////////////
// Given any object, output its content in the following
// format:
//    attribute:::value<end>
///////////////////////////////////////////////////////////
function inspect(obj) {
	var output = "";

	if (obj == null) {
		return null;
	}
	else if (typeof(obj) == "string") {
		return obj;	
	}
	else {
		for (var i in obj) {
			if (typeof(obj[i]) != "unknown" && typeof(obj[i]) != "undefined")
				output += i + " ::: " + obj[i] + "<end>\n";
			else if (typeof(obj[i]) == "unknown")
				output += i + " ::: unknown<end>\n";
			else
				output += i + " ::: undefined<end>\n";
		}
		return output;
	}
}

///////////////////////////////////////////////////////////
// Given a DOM element, output its style properties and
// values in the following format:
//    attribute:::value<end>
// Can be used in conjunction with debugDialog:
//    debugDialog(insepect(obj));
///////////////////////////////////////////////////////////
function inspectStyle(obj) {
	var output = "";

	if (obj.style) {
		for (var i in obj.style) {
			if (typeof(obj.style[i]) != "unknown" && typeof(obj.style[i]) != "undefined")
				output += i + " ::: " + obj.style[i] + "<end>\n";
			else if (typeof(obj[i]) == "unknown")
				output += i + " ::: unknown<end>\n";
			else
				output += i + " ::: undefined<end>\n";
		}
	}
	else {
		output += "Error: style is undefined in this object.";
	}

	return output;
}

///////////////////////////////////////////////////////////
// Shows the mouse status information in window status bar.
///////////////////////////////////////////////////////////
function showMouseMoveStatus(isEnable) {
	if (isEnable) {
		addObjEventListener(document, "mousemove", XBDebug_mouseMoveListener);
	}
	else {
		removeObjEventListener(document, "mousemove", XBDebug_mouseMoveListener);
	}
}

///////////////////////////////////////////////////////////
// Event handler of showMouseMoveStatus.
// For internal use only.
///////////////////////////////////////////////////////////
function XBDebug_mouseMoveListener(evt) {
	var e = new XBEvent(evt);
	var mouseStatus = "Mouse Status:";
	mouseStatus += " ClientX: " + e.clientX;
	mouseStatus += " ClientY: " + e.clientY;
	mouseStatus += " PageX: " + e.pageX;
	mouseStatus += " PageY: " + e.pageY;
	mouseStatus += " ScreenX: " + e.screenX;
	mouseStatus += " ScreenY: " + e.screenY;
	window.status = mouseStatus;
}

/**********************************************************
* Modal Dialog Utils
**********************************************************/

///////////////////////////////////////////////////////////
// Open an UTF-8 modal dialog
///////////////////////////////////////////////////////////
function openModalDialog(url, width, height, scrolling, args) {
	var features = "";
	var dialogName = (new Date()).getMilliseconds().toString();
	var dialogWidth = width;
	var dialogHeight = height;
	var dialogArgs = new Object();
	var returnValue = null;

	for (i in args) {
		dialogArgs[i] = args[i];
	}

	dialogArgs.timeout = false;
	if (isIE) {
		features = "dialogWidth: " + dialogWidth + "px; dialogHeight: " + dialogHeight + "px; center; status: no; help: no;";
		features += (scrolling)?(" scroll: yes;"):(" scroll: no;");
		returnValue = window.showModalDialog(url, dialogArgs, features);
		if (dialogArgs.timeout == true) {
			top.close();
		}
		return returnValue;
	}
	else {
		dialogWidth = (dialogWidth - 20 <= 0)?(dialogWidth):(dialogWidth - 20);
		dialogHeight = (dialogHeight - 20 <= 0)?(dialogHeight):(dialogHeight - 20);
		var posX = window.screenX + ((window.outerWidth - parseInt(dialogWidth)) / 2);
		var posY = window.screenY + ((window.outerHeight - parseInt(dialogHeight)) / 2);
		window.dialogArguments = dialogArgs;
		features = "screenX=" + posX + ", screenY=" + posY + ", width=" + dialogWidth + "px, height=" + dialogHeight + "px, modal=yes, sidebars=no, menubars=no";
		features += (scrolling)?(", scrollbars=yes"):(", scrollbars=no");
		window.returnValue = null;
		window.open(url, dialogName, features);

		if (window.returnValue != null)
			return window.returnValue;
	}
}

///////////////////////////////////////////////////////////
// Adjusts the size of the modal dialog to fit the content.
///////////////////////////////////////////////////////////
function autoResizeModalDialog() {
	var hiddenWidth = getPageWidth() - getClientWidth();
	var hiddenHeight = getPageHeight() - getClientHeight();

	if (isIE) {
		window.dialogWidth = parseInt(window.dialogWidth) + hiddenWidth + 18 + "px";
		window.dialogHeight = parseInt(window.dialogHeight) + hiddenHeight + 18 + "px";
	}
	else if (isNS) {
		window.sizeToContent();
	}
}

/** END OF XBUtil **********************************************************/


/****************************************************************************
* Open a new window.
*
* url - The URL of the help file.
* windowName - The title of the window.
* offset     - The offset in pixels from the parent window
* features   - The various attributes of the window to be created.
*
* Returns the opened window
****************************************************************************/
function openWindow(url, windowName, offset, features)
{
  if (features == null)
    features = "resizable=yes,scrollbars=yes,menubar=yes, copyhistory=no";

  if (offset == null)
    offset = 0;

  offset += 20;

  if(navigator.appName == "Netscape")
  {
    if(parseInt(navigator.appVersion) > 3)
    {
      // set width and height
      if (features.indexOf(",width=") < 0)
        features += ",width=" + top.innerWidth + ",height=" + top.innerHeight;

      // set window position
      features += ",screenX=" + (top.screenX+offset) + ",screenY=" + (top.screenY+offset);
    }
    else
    {
      // set width and height
      if (features.indexOf(",width=") < 0)
        features += ",width=" + top.width + ",height=" + top.height;

      // set window position not available in version 3 and less
    }
  }// END if

  else
  {
    // set width and height
    if (features.indexOf(",width=") < 0)
    {
      var width=",width=", height=",height=";

      if (screen.width < 750)
        width += screen.availWidth;
      else
        width += "750";

      if (screen.height < 500)
        height += screen.availHeight;
      else
        height += "500";
      features += width + height;
    }

    // No way to query current window position in IE...
    // features += ",left=" + (screen.availLeft+offset) + ",top=" + (screen.availTop+offset);
    features += ",screenLeft=" + (screen.availLeft+offset) + ",screenTop=" + (screen.availTop+offset);

  }// END else

  var target = window.open( "", windowName, features);

  target.location.href = url;
  // focus function is not working under IE4 with Service pack 2
  // it will crash, we need to detect the specific IE version 'MSIE 4.01' - d48999
  // we only use focus() function for all browser except IE 4.01
  var navVersion = navigator.appVersion
  if ( navVersion.indexOf("MSIE 4.01") == -1 )
  {
    target.focus();
  }

  return target;

}// END openWindow

/****************************************************************************
* Determines whether an object has been assigned a value.
*
* Returns TRUE if it has been assigned a value; FALSE otherwise
****************************************************************************/
function defined(obj)
{
  var str = typeof obj;

  if((str == "undefined") || (obj == null))
    return false;
  else
    return true;
}// END defined

/****************************************************************************
* Returns the type of object.
****************************************************************************/
function objectType(obj)
{
 //
 // alert( "The function Util::objectType() is deprecated!"
 //      + "It fails in IE and thus must not be used.\n\n"
 //      + "If you see this message open a defect immediately.");

  var constructor = (String)(obj.constructor);
  var tokens = constructor.split(" ");

  for(var i=0; i<tokens.length; i++)
  {
    if(tokens[i].indexOf("function") != -1)
    {
      var end = tokens[i+1].indexOf("(");

      if(end == -1)
        return(tokens[i+1]);
      else
        return(tokens[i+1].substring(0, end));
    }
  }

}// END objectType

/****************************************************************************
* Trim the leading and trailing blank of the input string 'word'
*
* Returns a string
****************************************************************************/
function trim(inword)
{
   word = inword.toString();
   var i=0;
   var j=word.length-1;
   while(word.charAt(i) == " ") i++;
   while(word.charAt(j) == " ") j--;
   if (i > j) {
		return word.substring(i,i);
	} else {
		return word.substring(i,j+1);
	}
}

/****************************************************************************
* Check if the input string 'id' is empty
*
* Returns true or false
****************************************************************************/
function isInputStringEmpty(id)
{
  return !id.match(/[^\s]/);
}


/****************************************************************************
* This will alert the user with the error/warning message 'message' and
* highlight the text field 'field'.
*
*
****************************************************************************/
function reprompt(field, message) {
    window.status = "";
    alertDialog(message);
    field.focus();
    field.select();

}

/****************************************************************************
* This will remove the Return \r \n chars from a string and
* replace them by " " char.
*
*
****************************************************************************/
function removeReturnChar(word)
{
   var i=0;
   var j=word.length;
   var result="";

   for (i=0; i<j; ++i) {
      if((word.charAt(i) == "\r") || (word.charAt(i) == "\n" )) {
         result += " ";
      } else {
         result += word.charAt(i);
      }
   }

   return result;
}


/**************************************************************************
* This will return the index position that a char in a given string
* return "false" if couldn't found, otherwise it returns the first invalid
* character.
*
***************************************************************************/
function find(givenString, searchChars)
{
  for ( var i=0; i< searchChars.length; i++)
  {
   var achar = searchChars.substring(i, i+1);

   if ( givenString.indexOf(achar) != -1 )
     return achar;
  }
   return "false";
}

/*********************************************************************
* Return the number of occurrence of a given char
**********************************************************************/
function numOfOccur(givenString, searchChars)
{
  var count = 0;

  for (var i=0; i< givenString.length; i++)
  {
     if ( givenString.charAt(i) == searchChars.charAt(0) )
       count ++;
  }

  return count;
}


function convertFromTextToHTML(obj)
{
   var string = new String(obj);
   var result = "";

   for (var i=0; i < string.length; i++ ) {
      if (string.charAt(i) == "<")       result += "&lt;";
      else if (string.charAt(i) == ">")  result += "&gt;";
      else result += string.charAt(i);
   }
   return result;
}

function convertFromHTMLToText(obj)
{
   /* add some padding to the string so we don't
      require bounds checking */
   var string = new String(obj + "_____");
   var result = "";

   for (var i=0; i < string.length; ) {
      if (string.charAt(i) == "&") {
         if (string.substring(i, i+4) == "&lt;") {
            result += "<";
            i += 4;
         }
         else if (string.substring(i, i+4) == "&gt;") {
            result += ">";
            i += 4;
         }
         else {
            result += string.charAt(i);
            i++;
         }
      }
      else {
         result += string.charAt(i);
         i++;
      }
   }
   return result.substring(0, result.length-5);
}


function isEmpty(id) {
	if (typeof(id) == "string") {
		return !id.match(/[^\s]/);
	}
	else {
		return (id)?(false):(true);
	}
}


//////////////////////////////////////////////////////////
// This function will check whether or not the time has
// a valid format. hh:mm
//
// by Tony Mao
// Input: time
// Return code = "true", time has a right format
// Return code = "false", time format is wrong
//
//////////////////////////////////////////////////////////
function validTime(time1) {
   var delimiter = ":";
   var hh, mm;
   var time1Length;
   var hhlength;
   var mmlength;

   time1Length = time1.length;

   if (time1 == "" || time1.indexOf(delimiter) == -1 ||  time1Length > 5 ) return false;

   hh = time1.substring(0,time1.indexOf(delimiter));
   mm = time1.substring(time1.indexOf(delimiter) + 1);

   hhlength = hh.length;
   mmlength = mm.length;

   if (hhlength <1 || hhlength >2 || mmlength <1 || mmlength >2) return false;
   if (hh=="" || mm == "" ) return false;
   if (isNaN(hh) || isNaN(mm) ) return false;

   if ( parseInt(hh) > 23 || parseInt(hh) < 0 ) return false;
   if ( parseInt(mm) > 59 || parseInt(mm) < 0 ) return false;

   return true;
}


//////////////////////////////////////////////////////////
// This function will limit a text area input box to a
// specified size.  just use the onKeyUp and onKeyDown events
// with the text area box.
// call with ::
//    arg1=this.form.<myTextAreaName>
//    arg2=<maximumSizeForTextArea>
// by Glen Shortliffe
//////////////////////////////////////////////////////////
function limitTextArea(field, maxlimit) {
    if (field.value.length > maxlimit) {
       //  field is too long... chop it down
       field.value = field.value.substring(0, maxlimit);
    }
}


//////////////////////////////////////////////////////////
// This function will validate a typical name field
// and restrict it to pretty much alphanumerics.
// All special characters are invalid with some exceptions
// " ", "-", "_", and "." are all valid
// The string can also not start with a leading number
// The string can also not be empty
// call with ::
//    arg1=<myInputString>
//
// return true is name is valid, false otherwise
// by Glen Shortliffe
//////////////////////////////////////////////////////////
function isValidName(myString) {
    var invalidChars = "~!@#$%^&*()+=[]{};:,<>?/|`"; // invalid chars
    invalidChars += "\t\'\"\\"; // escape sequences
    var invalidStartChars = "0123456789";

    // if the string is empty it is not a valid name
    if (isEmpty(myString)) return false;

    // look for presence of invalid characters.  if one is
    // found return false.  otherwise return true
    for (var i=0; i<myString.length; i++) {
      if (invalidChars.indexOf(myString.substring(i, i+1)) >= 0) {
        return false;
      }
    }

    // look for a leading number... and disallow it.
    var startChar = myString.substring(0,1);
    for (var i=0; i<invalidStartChars.length; i++) {
      if (invalidStartChars.indexOf(startChar) >= 0) {
        return false;
      }
    }

    return true;
}

//////////////////////////////////////////////////////////
// This function will dump out the content of a javascript object
// This is useful for debugging purposes.
// In your code you can do this:
// alert(dumpObject(myBigFatObject));
//
// This will dump out the objects contents
// arg1 = the object you want info on...
// return a string which you can send to alert()
// by Glen Shortliffe
//////////////////////////////////////////////////////////
function dumpObject(what) {
   var output = '';
   for (i in what) {
       if (typeof what[i] == 'object') {
           output += dumpObject(what[i]);
       }
       else
           output += i + ' = ' + what[i] + '\n';
   }
   return output;
}

// function to clone a javascript object
function cloneObject(what) {
    for (i in what) {
       if (typeof i == 'object') {
          this[i] = new cloneObject(what[i]);
       }
       else {
          this[i] = what[i];
       }
    }
}

//////////////////////////////////////////////////////////
// This function will validate a positive integer quantity (including 0)
//
// arg1 = the object you want info on...
// Return true is this input arg is a valid positive int,
// otherwise return false...
//
//////////////////////////////////////////////////////////
function isValidPositiveInteger(myString) {
    var validChars = "0123456789";

    // if the string is empty it is not a valid integer
    if (isEmpty(myString)) return false;

    // look for non numeric characters in the input string
    for (var i=0; i<myString.length; i++) {
      if (validChars.indexOf(myString.substring(i, i+1)) == "-1") {
        return false;
      }
    }
    // look for bad leading zeroes in the input string
    if (myString.length > 1 && myString.substring(0,1) == "0") {
       return false;
    }

    return true;
}

//////////////////////////////////////////////////////////
// This function will validate a positive integer quantity (excluding 0)
//
// arg1 = the object you want info on...
// Return true is this input arg is a valid positive int,
// otherwise return false...
//
//////////////////////////////////////////////////////////
function isValidNZPosInt(myString) {
    var validChars = "0123456789";

    // if the string is empty it is not a valid integer
    if (isEmpty(myString)) return false;

    // look for non numeric characters in the input string
    for (var i=0; i<myString.length; i++) {
      if (validChars.indexOf(myString.substring(i, i+1)) == "-1") {
        return false;
      }
    }
    // look for bad leading zeroes in the input string
    if (myString.substring(0,1) == "0") {
       return false;
    }

    return true;
}

//////////////////////////////////////////////////////////
// This function will count the number of bytes
// represented in a UTF-8 string
//
// arg1 = the UTF-8 string
// arg2 = the maximum number of bytes allowed in your input field
// Return false is this UTF-8 string is larger then arg2
// Otherwise return true...
//////////////////////////////////////////////////////////
function isValidUTF8length(UTF8String, maxlength) {
    // alert('UTF8String='+UTF8String+'\nUTF-8 length='+utf8StringByteLength(UTF8String)+'\nmaxlength='+maxlength);
    if (utf8StringByteLength(UTF8String) > maxlength) return false;
    else return true;
}

//////////////////////////////////////////////////////////
// This function will count the number of bytes
// represented in a UTF-8 string
//
// arg1 = the UTF-8 string you want a byte count of...
// Return the integer number of bytes represented by the string
//////////////////////////////////////////////////////////
function utf8StringByteLength(UTF8String) {
  if (UTF8String === null) return 0;
  var str = String(UTF8String);
  var oneByteMax = 0x007F;
  var twoByteMax = 0x07FF;
  var byteSize = str.length;

  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    if (chr > oneByteMax) byteSize = byteSize + 1;
    if (chr > twoByteMax) byteSize = byteSize + 1;
  }
  return byteSize;
}

/**********************************************************
* Globalized Modal Dialogs
**********************************************************/
function debugDialog(sMsg)
{
	if (typeof(sMsg) == "undefined")
		sMsg = "undefined";
	
	if (top.webappPath)
		openWindow(top.webappPath + 'tools/common/Debug.jsp', "Debug", 5);
	else
		openWindow('tools/common/Debug.jsp', "Debug", 5);

	window.debugMessage = sMsg;
}

function alertDialog(sMsg)
{
	if (typeof(sMsg) == "undefined")
		sMsg = "undefined";

	var dialogArgs = new Array();
	dialogArgs.message = sMsg;

	if (top.webappPath)
		openModalDialog(top.webappPath + 'AlertDialogView', 500, 145, true, dialogArgs);
	else
		openModalDialog('AlertDialogView', 480, 150, true, dialogArgs);		
}

function confirmDialog(sMsg)
{
	if (sMsg == null)
		sMsg = "";

	dialogArgs = new Array();
	dialogArgs.message = sMsg;

	if (top.webappPath)
		returnValue = openModalDialog(top.webappPath + 'ConfirmDialogView', 500, 145, true, dialogArgs);
	else
		returnValue = openModalDialog('ConfirmDialogView', 500, 145, true, dialogArgs);

	if (returnValue == null)
		returnValue = false;

	return returnValue;
}

function promptDialog(sMsg, sDefaultValue, iLength, bPasswordInput)
{
	if (sMsg == null)
		sMsg = "";

	dialogArgs = new Array();
	dialogArgs.message = sMsg;
	dialogArgs.defaultValue = (sDefaultValue != null)?(sDefaultValue):("");

	if (iLength == null)
		dialogArgs.iLength = 256;   // default length
	else
		dialogArgs.iLength = iLength;

	if (bPasswordInput == null)
		dialogArgs.passwordInput = false;
	else
		dialogArgs.passwordInput = bPasswordInput;

	if (top.webappPath)
		returnValue = openModalDialog(top.webappPath + 'PromptDialogView', 500, 145, true, dialogArgs);
	else
		returnValue = openModalDialog('PromptDialogView', 500, 150, true, dialogArgs);

	if (typeof(returnValue) == "undefined")
		returnValue = null;

	return returnValue;
}

function infoDialog(sMsg)
{
	if (typeof(sMsg) == "undefined")
		sMsg = "undefined";

	var dialogArgs = new Array();
	dialogArgs.message = sMsg;

	if (top.webappPath)
		openModalDialog(top.webappPath + 'tools/common/Information.jsp', 500, 145, true, dialogArgs);
	else
		openModalDialog('tools/common/Information.jsp', 480, 150, true, dialogArgs);		
}


var OPStoriesOwlData;

$(document).ready(function(){
    var op_stories_owl = $("#owl-op-stories");
    op_stories_owl.owlCarousel({
        items : 4, //4 items above 1000px browser width
        itemsDesktop : [1000,5], //5 items between 1000px and 901px
        itemsDesktopSmall : [900,3], // betweem 900px and 601px
        itemsTablet: [600,2], //2 items between 600 and 0
        itemsMobile : false, // itemsMobile disabled - inherit from itemsTablet option
        addClassActive: true,
        lazyLoad: true,
        //navigation: true,
        //navigationText : [$('.header__nav-menu__opstories__arrow.left'),$('.header__nav-menu__opstories__arrow.right')]
    });
    OPStoriesOwlData = $("#owl-op-stories").data('owlCarousel');

    $(".header__nav-menu__opstories__arrow.left").click(function() {
        op_stories_owl.trigger('owl.next');

        if ($('#owl-op-stories .owl-item').first().hasClass('active')) {
            $(".header__nav-menu__opstories__arrow.left").prop("disabled", true);
            $(".header__nav-menu__opstories__arrow.right").prop("disabled", false);
        } else {
            $(".header__nav-menu__opstories__arrow.left").prop("disabled", false);
        }
    });
    $(".header__nav-menu__opstories__arrow.right").click(function() {
        op_stories_owl.trigger('owl.prev');

        if ($('#owl-op-stories .owl-item').last().hasClass('active')) {
            $(".header__nav-menu__opstories__arrow.right").prop("disabled", true);
            $(".header__nav-menu__opstories__arrow.left").prop("disabled", false);
        } else {
            $(".header__nav-menu__opstories__arrow.right").prop("disabled", false);
        }
    });
     
});


function destroyCarousel() {
    OPStoriesOwlData.destroyControls();
}

function buildCarousel() {
    OPStoriesOwlData.buildControls();
}

function goToCarouselCard(cardNumber) {
    OPStoriesOwlData.goTo(cardNumber);
}

